/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var Defaults, Framer, _;
	
	_ = __webpack_require__(1)._;
	
	Framer = {};
	
	Framer._ = _;
	
	Framer.Utils = __webpack_require__(4);
	
	Framer.Color = (__webpack_require__(10)).Color;
	
	Framer.Layer = (__webpack_require__(13)).Layer;
	
	Framer._Layer = Framer.Layer;
	
	Framer.BackgroundLayer = (__webpack_require__(37)).BackgroundLayer;
	
	Framer.VideoLayer = (__webpack_require__(38)).VideoLayer;
	
	Framer.SVGLayer = (__webpack_require__(39)).SVGLayer;
	
	Framer.Events = (__webpack_require__(15)).Events;
	
	Framer.Gestures = (__webpack_require__(16)).Gestures;
	
	Framer.Animation = (__webpack_require__(18)).Animation;
	
	Framer.AnimationGroup = (__webpack_require__(40)).AnimationGroup;
	
	Framer.AnimationStateGroup = (__webpack_require__(40)).AnimationStateGroup;
	
	Framer.Screen = (__webpack_require__(5)).Screen;
	
	Framer.Align = (__webpack_require__(41)).Align;
	
	Framer.print = (__webpack_require__(42)).print;
	
	Framer.ScrollComponent = (__webpack_require__(45)).ScrollComponent;
	
	Framer.PageComponent = (__webpack_require__(46)).PageComponent;
	
	Framer.SliderComponent = (__webpack_require__(47)).SliderComponent;
	
	Framer.DeviceComponent = (__webpack_require__(48)).DeviceComponent;
	
	Framer.GridComponent = (__webpack_require__(49)).GridComponent;
	
	Framer.FlowComponent = (__webpack_require__(50)).FlowComponent;
	
	Framer.CircularProgressComponent = (__webpack_require__(51)).CircularProgressComponent;
	
	Framer.MIDIComponent = (__webpack_require__(52)).MIDIComponent;
	
	Framer.DeviceView = Framer.DeviceComponent;
	
	if (window) {
	  _.extend(window, Framer);
	}
	
	Framer.Context = (__webpack_require__(43)).Context;
	
	Framer.Config = (__webpack_require__(14)).Config;
	
	Framer.EventEmitter = (__webpack_require__(7)).EventEmitter;
	
	Framer.BaseClass = (__webpack_require__(6)).BaseClass;
	
	Framer.LayerStyle = (__webpack_require__(26)).LayerStyle;
	
	Framer.AnimationLoop = (__webpack_require__(54)).AnimationLoop;
	
	Framer.LinearAnimator = (__webpack_require__(20)).LinearAnimator;
	
	Framer.BezierCurveAnimator = (__webpack_require__(22)).BezierCurveAnimator;
	
	Framer.SpringDHOAnimator = (__webpack_require__(55)).SpringDHOAnimator;
	
	Framer.SpringRK4Animator = (__webpack_require__(24)).SpringRK4Animator;
	
	Framer.LayerDraggable = (__webpack_require__(29)).LayerDraggable;
	
	Framer.Curves = __webpack_require__(21);
	
	window.Bezier = Framer.Curves.Bezier;
	
	window.Spring = Framer.Curves.Spring;
	
	Framer.Importer = (__webpack_require__(56)).Importer;
	
	Framer.Extras = __webpack_require__(57);
	
	Framer.GestureInputRecognizer = new (__webpack_require__(66)).GestureInputRecognizer;
	
	Framer.Version = __webpack_require__(67);
	
	Framer.Loop = new Framer.AnimationLoop();
	
	Framer.Info = {};
	
	if (window) {
	  window.Framer = Framer;
	}
	
	Defaults = (__webpack_require__(17)).Defaults;
	
	Defaults.setup();
	
	Framer.resetDefaults = Defaults.reset;
	
	Framer.DefaultContext = new Framer.Context({
	  name: "Default"
	});
	
	Framer.DefaultContext.backgroundColor = "white";
	
	Framer.DefaultContext.visible = false;
	
	Framer.CurrentContext = Framer.DefaultContext;
	
	window.Canvas = new (__webpack_require__(68)).Canvas;
	
	if (Utils.isMobile()) {
	  Framer.Extras.MobileScrollFix.enable();
	}
	
	if (!Utils.isTouch()) {
	  Framer.Extras.TouchEmulator.enable();
	}
	
	if (!Utils.isFramerStudio()) {
	  Framer.Extras.ErrorDisplay.enable();
	}
	
	if (!Utils.isFramerStudio()) {
	  Framer.Extras.Preloader.enable();
	}
	
	if (!Utils.isFramerStudio()) {
	  Framer.Extras.Hints.enable();
	}
	
	if (!Framer.Preloader) {
	  Framer.DefaultContext.visible = true;
	}
	
	Utils.domComplete(Framer.Loop.start);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	exports._ = __webpack_require__(2);
	
	_.pluck = _.map;


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(3)(module)))

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var Matrix, Screen, Utils, _, __domComplete, __domCompleteState, __domReady, _textSizeNode,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
	  slice = [].slice;
	
	_ = __webpack_require__(1)._;
	
	Screen = __webpack_require__(5).Screen;
	
	Matrix = __webpack_require__(9).Matrix;
	
	Utils = {};
	
	Utils.reset = function() {
	  return Framer.CurrentContext.reset();
	};
	
	Utils.getValue = function(value) {
	  if (_.isFunction(value)) {
	    return value();
	  }
	  return value;
	};
	
	Utils.getValueForKeyPath = function(obj, key) {
	  var len, o, ref, ref1, result;
	  result = obj;
	  if (ref = !".", indexOf.call(key, ref) >= 0) {
	    return obj[key];
	  }
	  ref1 = key.split(".");
	  for (o = 0, len = ref1.length; o < len; o++) {
	    key = ref1[o];
	    result = result[key];
	  }
	  return result;
	};
	
	Utils.setValueForKeyPath = function(obj, path, val) {
	  var field, fields, i, n, result;
	  fields = path.split(".");
	  result = obj;
	  i = 0;
	  n = fields.length;
	  while (i < n && result !== void 0) {
	    field = fields[i];
	    if (i === n - 1) {
	      result[field] = val;
	    } else {
	      if (typeof result[field] === "undefined" || !_.isObject(result[field])) {
	        result[field] = {};
	      }
	      result = result[field];
	    }
	    i++;
	  }
	};
	
	Utils.valueOrDefault = function(value, defaultValue) {
	  if (value === (void 0) || value === null) {
	    value = defaultValue;
	  }
	  return value;
	};
	
	Utils.arrayNext = function(arr, item) {
	  return arr[arr.indexOf(item) + 1] || _.head(arr);
	};
	
	Utils.arrayPrev = function(arr, item) {
	  return arr[arr.indexOf(item) - 1] || _.last(arr);
	};
	
	Utils.sum = function(arr) {
	  return _.reduce(arr, function(a, b) {
	    return a + b;
	  });
	};
	
	Utils.average = function(arr) {
	  return Utils.sum(arr) / arr.length;
	};
	
	Utils.mean = Utils.average;
	
	Utils.median = function(x) {
	  var sorted;
	  if (x.length === 0) {
	    return null;
	  }
	  sorted = x.slice().sort(function(a, b) {
	    return a - b;
	  });
	  if (sorted.length % 2 === 1) {
	    return sorted[(sorted.length - 1) / 2];
	  } else {
	    return (sorted[(sorted.length / 2) - 1] + sorted[sorted.length / 2]) / 2;
	  }
	};
	
	Utils.nearestIncrement = function(x, increment) {
	  if (!increment) {
	    return x;
	  }
	  return Math.round(x * (1 / increment)) / (1 / increment);
	};
	
	if (window.requestAnimationFrame == null) {
	  window.requestAnimationFrame = window.webkitRequestAnimationFrame;
	}
	
	if (window.requestAnimationFrame == null) {
	  window.requestAnimationFrame = function(f) {
	    return Utils.delay(1 / 60, f);
	  };
	}
	
	if (window.performance) {
	  Utils.getTime = function() {
	    return window.performance.now() / 1000;
	  };
	} else {
	  Utils.getTime = function() {
	    return Date.now() / 1000;
	  };
	}
	
	Utils.delay = function(time, f) {
	  var timer;
	  timer = setTimeout(f, time * 1000);
	  Framer.CurrentContext.addTimer(timer);
	  return timer;
	};
	
	Utils.interval = function(time, f) {
	  var timer;
	  timer = setInterval(f, time * 1000);
	  Framer.CurrentContext.addInterval(timer);
	  return timer;
	};
	
	Utils.debounce = function(threshold, fn, immediate) {
	  var timeout;
	  if (threshold == null) {
	    threshold = 0.1;
	  }
	  timeout = null;
	  threshold *= 1000;
	  return function() {
	    var args, delayed, obj;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    obj = this;
	    delayed = function() {
	      if (!immediate) {
	        fn.apply(obj, args);
	      }
	      return timeout = null;
	    };
	    if (timeout) {
	      clearTimeout(timeout);
	    } else if (immediate) {
	      fn.apply(obj, args);
	    }
	    return timeout = setTimeout(delayed, threshold);
	  };
	};
	
	Utils.throttle = function(delay, fn) {
	  var timer;
	  if (delay === 0) {
	    return fn;
	  }
	  delay *= 1000;
	  timer = false;
	  return function() {
	    if (timer) {
	      return;
	    }
	    timer = true;
	    if (delay !== -1) {
	      setTimeout((function() {
	        return timer = false;
	      }), delay);
	    }
	    return fn.apply(null, arguments);
	  };
	};
	
	Utils.memoize = function(fn) {
	  return function() {
	    var args, currentArg, hash, i;
	    args = Array.prototype.slice.call(arguments);
	    hash = "";
	    i = args.length;
	    currentArg = null;
	    while (i--) {
	      currentArg = args[i];
	      hash += (currentArg === Object(currentArg) ? JSON.stringify(currentArg) : currentArg);
	      fn.memoize || (fn.memoize = {});
	    }
	    if (hash in fn.memoize) {
	      return fn.memoize[hash];
	    } else {
	      return fn.memoize[hash] = fn.apply(this, args);
	    }
	  };
	};
	
	Utils.randomColor = function(alpha) {
	  if (alpha == null) {
	    alpha = 1.0;
	  }
	  return Color.random(alpha);
	};
	
	Utils.randomChoice = function(arr) {
	  return arr[Math.floor(Math.random() * arr.length)];
	};
	
	Utils.randomNumber = function(a, b) {
	  if (a == null) {
	    a = 0;
	  }
	  if (b == null) {
	    b = 1;
	  }
	  return Utils.mapRange(Math.random(), 0, 1, a, b);
	};
	
	Utils.randomImage = function(layer, offset) {
	  var increment, photo, photos, size;
	  if (offset == null) {
	    offset = 50;
	  }
	  if (_.isNumber(layer)) {
	    layer = {
	      id: layer
	    };
	  }
	  photos = ["1417733403748-83bbc7c05140", "1423841265803-dfac59ebf718", "1433689056001-018e493576bc", "1430812411929-de4cf1d1fe73", "1457269449834-928af64c684d", "1443616839562-036bb2afd9a2", "1461535676131-2de1f7054d3f", "1462393582935-1ac76b85dcf1", "1414589530802-cb54ce0575d9", "1422908132590-117a051fc5cd", "1438522014717-d7ce32b9bab9", "1451650804883-52fb86cc5b18", "1462058164249-2dcdcda67ce7", "1456757014009-0614a080ff7f", "1434238255348-4fb0d9caa0a4", "1448071792026-7064a01897e7", "1458681842652-019f4eeda5e5", "1460919920543-d8c45f4bd621", "1447767961238-038617b84a2b", "1449089299624-89ce41e8306c", "1414777410116-81e404502b52", "1433994349623-0a18966ee9c0", "1452567772283-91d67178f409", "1458245229726-a8ba04cb5969", "1422246719650-cb30d19825e3", "1417392639864-2c88dd07f460", "1442328166075-47fe7153c128", "1448467258552-6b3982373a13", "1447023362548-250f3a7b80ed", "1451486242265-24b0c0ef9a51", "1414339372428-797ec111646d"];
	  photo = Utils.randomChoice(photos);
	  if (layer != null ? layer.id : void 0) {
	    photo = photos[layer.id % photos.length];
	  }
	  increment = 100;
	  size = 1024;
	  if (layer) {
	    size = Math.max(layer.width, layer.height);
	    size = Math.ceil(size / increment) * increment;
	    if (size < increment) {
	      size = increment;
	    }
	    size = Utils.devicePixelRatio() * size;
	    size = parseInt(size);
	  }
	  return "https://images.unsplash.com/photo-" + photo + "?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&w=" + size + "&h=" + size + "&fit=max";
	};
	
	Utils.defineEnum = function(names, offset, geometric) {
	  var Enum, i, j, len, name, o;
	  if (names == null) {
	    names = [];
	  }
	  if (offset == null) {
	    offset = 0;
	  }
	  if (geometric == null) {
	    geometric = 0;
	  }
	  Enum = {};
	  for (i = o = 0, len = names.length; o < len; i = ++o) {
	    name = names[i];
	    j = i;
	    j = !offset ? j : j + offset;
	    j = !geometric ? j : Math.pow(geometric, j);
	    Enum[Enum[name] = j] = name;
	  }
	  return Enum;
	};
	
	Utils.labelLayer = function(layer, text, style) {
	  var fontSize;
	  if (style == null) {
	    style = {};
	  }
	  if (!text) {
	    return;
	  }
	  if (text === "") {
	    return;
	  }
	  if (typeof text !== "string") {
	    return;
	  }
	  fontSize = Math.max(Math.min(48, parseInt(layer.height / 3.2)), 14);
	  style = _.extend({
	    font: fontSize + "px/1em " + (Utils.deviceFont()),
	    lineHeight: layer.height + "px",
	    textAlign: "center",
	    color: "#fff"
	  }, style);
	  layer.style = style;
	  return layer.html = text;
	};
	
	Utils.stringify = function(obj) {
	  try {
	    if (_.isObject(obj)) {
	      return JSON.stringify(obj);
	    }
	  } catch (error) {
	    "";
	  }
	  if (obj === null) {
	    return "null";
	  }
	  if (obj === void 0) {
	    return "undefined";
	  }
	  if (obj.toString) {
	    return obj.toString();
	  }
	  return obj;
	};
	
	Utils.inspectObjectType = function(item) {
	  var className, extract, ref, ref1, ref2, ref3;
	  if ((((ref = item.constructor) != null ? ref.name : void 0) != null) && ((ref1 = item.constructor) != null ? ref1.name : void 0) !== "Object") {
	    return item.constructor.name;
	  }
	  extract = function(str) {
	    var match, regex;
	    if (!str) {
	      return null;
	    }
	    regex = /\[object (\w+)\]/;
	    match = regex.exec(str);
	    if (match) {
	      return match[1];
	    }
	    return null;
	  };
	  if (item.toString) {
	    className = extract(item.toString());
	    if (className) {
	      return className;
	    }
	  }
	  if ((ref2 = item.constructor) != null ? ref2.toString : void 0) {
	    className = extract((ref3 = item.constructor) != null ? ref3.toString() : void 0);
	    if (className) {
	      return className.replace("Constructor", "");
	    }
	  }
	  return "Object";
	};
	
	Utils.inspect = function(item, max, l) {
	  var code, limit, objectInfo, objectType;
	  if (max == null) {
	    max = 5;
	  }
	  if (l == null) {
	    l = 0;
	  }
	  if (item === null) {
	    return "null";
	  }
	  if (item === void 0) {
	    return "undefined";
	  }
	  if (_.isFunction(item.toInspect)) {
	    return item.toInspect();
	  }
	  if (_.isString(item)) {
	    return "\"" + item + "\"";
	  }
	  if (_.isNumber(item)) {
	    return "" + item;
	  }
	  if (_.isFunction(item)) {
	    code = item.toString().slice("function ".length).replace(/\n/g, "").replace(/\s+/g, " ");
	    limit = 50;
	    if (code.length > limit && l > 0) {
	      code = (_.trimEnd(code.slice(0, +limit + 1 || 9e9))) + "… }";
	    }
	    return "<Function " + code + ">";
	  }
	  if (_.isArray(item)) {
	    if (l > max) {
	      return "[...]";
	    }
	    return "[" + _.map(item, function(i) {
	      return Utils.inspect(i, max, l + 1);
	    }).join(", ") + "]";
	  }
	  if (_.isObject(item)) {
	    objectType = Utils.inspectObjectType(item);
	    if (/HTML\w+?Element/.test(objectType)) {
	      return "<" + objectType + ">";
	    }
	    if (l > max) {
	      objectInfo = "{...}";
	    } else {
	      objectInfo = "{" + _.map(item, function(v, k) {
	        return k + ":" + (Utils.inspect(v, max, l + 1));
	      }).join(", ") + "}";
	    }
	    if (objectType === "Object") {
	      return objectInfo;
	    }
	    return "<" + objectType + " " + objectInfo + ">";
	  }
	  return "" + item;
	};
	
	Utils.uuid = function() {
	  var chars, digit, o, output, r, random;
	  chars = "0123456789abcdefghijklmnopqrstuvwxyz".split("");
	  output = new Array(36);
	  random = 0;
	  for (digit = o = 1; o <= 32; digit = ++o) {
	    if (random <= 0x02) {
	      random = 0x2000000 + (Math.random() * 0x1000000) | 0;
	    }
	    r = random & 0xf;
	    random = random >> 4;
	    output[digit] = chars[digit === 19 ? (r & 0x3) | 0x8 : r];
	  }
	  return output.join("");
	};
	
	Utils.arrayFromArguments = function(args) {
	  if (_.isArray(args[0])) {
	    return args[0];
	  }
	  return Array.prototype.slice.call(args);
	};
	
	Utils.cycle = function() {
	  var args, curr;
	  args = Utils.arrayFromArguments(arguments);
	  curr = -1;
	  return function() {
	    curr++;
	    if (curr >= args.length) {
	      curr = 0;
	    }
	    return args[curr];
	  };
	};
	
	Utils.toggle = Utils.cycle;
	
	Utils.callAfterCount = function(total, callback) {
	  var callAfterCount, count;
	  count = 0;
	  return callAfterCount = function() {
	    count += 1;
	    if (count === total) {
	      return typeof callback === "function" ? callback() : void 0;
	    }
	  };
	};
	
	Utils.isWebKit = function() {
	  return window.WebKitCSSMatrix !== void 0;
	};
	
	Utils.webkitVersion = function() {
	  var regexp, result, version;
	  version = -1;
	  regexp = /AppleWebKit\/([\d.]+)/;
	  result = regexp.exec(navigator.userAgent);
	  if (result) {
	    version = parseFloat(result[1]);
	  }
	  return version;
	};
	
	Utils.isChrome = function() {
	  return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
	};
	
	Utils.isSafari = function() {
	  return /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
	};
	
	Utils.isAndroid = function() {
	  return /(android)/i.test(navigator.userAgent);
	};
	
	Utils.isIOS = function() {
	  return /(iPhone|iPod|iPad)/i.test(navigator.platform);
	};
	
	Utils.isMacOS = function() {
	  return /Mac/.test(navigator.platform);
	};
	
	Utils.isWindows = function() {
	  return /Win/.test(navigator.platform);
	};
	
	Utils.isTouch = function() {
	  return window.ontouchstart === null && window.ontouchmove === null && window.ontouchend === null;
	};
	
	Utils.isDesktop = function() {
	  return Utils.deviceType() === "desktop";
	};
	
	Utils.isPhone = function() {
	  return Utils.deviceType() === "phone";
	};
	
	Utils.isTablet = function() {
	  return Utils.deviceType() === "tablet";
	};
	
	Utils.isMobile = function() {
	  return Utils.isPhone() || Utils.isTablet();
	};
	
	Utils.isFileUrl = function(url) {
	  return _.startsWith(url, "file://");
	};
	
	Utils.isDataUrl = function(url) {
	  return _.startsWith(url, "data:");
	};
	
	Utils.isRelativeUrl = function(url) {
	  return !/^([a-zA-Z]{1,8}:\/\/).*$/.test(url);
	};
	
	Utils.isLocalServerUrl = function(url) {
	  return url.indexOf("127.0.0.1") !== -1 || url.indexOf("localhost") !== -1;
	};
	
	Utils.isLocalUrl = function(url) {
	  if (Utils.isFileUrl(url)) {
	    return true;
	  }
	  if (Utils.isLocalServerUrl(url)) {
	    return true;
	  }
	  return false;
	};
	
	Utils.isLocalAssetUrl = function(url, baseUrl) {
	  if (baseUrl == null) {
	    baseUrl = window.location.href;
	  }
	  if (Utils.isDataUrl(url)) {
	    return false;
	  }
	  if (Utils.isLocalUrl(url)) {
	    return true;
	  }
	  if (Utils.isRelativeUrl(url) && Utils.isLocalUrl(baseUrl)) {
	    return true;
	  }
	  return false;
	};
	
	Utils.isFramerStudio = function() {
	  return navigator.userAgent.indexOf("FramerStudio") !== -1;
	};
	
	Utils.framerStudioVersion = function() {
	  var isBeta, isFuture, isLocal, matches, version;
	  if (Utils.isFramerStudio()) {
	    isBeta = navigator.userAgent.indexOf("FramerStudio/beta") >= 0;
	    isLocal = navigator.userAgent.indexOf("FramerStudio/local") >= 0;
	    isFuture = navigator.userAgent.indexOf("FramerStudio/future") >= 0;
	    if (isBeta || isLocal || isFuture) {
	      return Number.MAX_VALUE;
	    }
	    matches = navigator.userAgent.match(/\d+$/);
	    if (matches && matches.length > 0) {
	      version = parseInt(matches[0]);
	    }
	    if (_.isNumber(version)) {
	      return version;
	    }
	  }
	  return Number.MAX_VALUE;
	};
	
	Utils.devicePixelRatio = function() {
	  return window.devicePixelRatio;
	};
	
	Utils.isJP2Supported = function() {
	  return Utils.isWebKit() && !Utils.isChrome();
	};
	
	Utils.isWebPSupported = function() {
	  return Utils.isChrome();
	};
	
	Utils.deviceType = function() {
	  if (/(tablet)|(iPad)|(Nexus 9)/i.test(navigator.userAgent)) {
	    return "tablet";
	  }
	  if (/(mobi)/i.test(navigator.userAgent)) {
	    return "phone";
	  }
	  return "desktop";
	};
	
	Utils.pathJoin = function() {
	  return Utils.arrayFromArguments(arguments).join("/");
	};
	
	Utils.deviceFont = function(os) {
	  if (!os) {
	    if (Utils.isMacOS()) {
	      os = "macos";
	    }
	    if (Utils.isIOS()) {
	      os = "ios";
	    }
	    if (Utils.isAndroid()) {
	      os = "android";
	    }
	    if (Utils.isWindows()) {
	      os = "windows";
	    }
	  }
	  if (os === "macos") {
	    return "-apple-system, SF UI Text, Helvetica Neue";
	  }
	  if (os === "ios") {
	    return "-apple-system, SF UI Text, Helvetica Neue";
	  }
	  if (os === "android") {
	    return "Roboto, Helvetica Neue";
	  }
	  if (os === "windows") {
	    return "Segoe UI";
	  }
	  return "Helvetica";
	};
	
	Utils.round = function(value, decimals, increment, min, max) {
	  var d;
	  if (decimals == null) {
	    decimals = 0;
	  }
	  if (increment == null) {
	    increment = null;
	  }
	  if (min == null) {
	    min = null;
	  }
	  if (max == null) {
	    max = null;
	  }
	  d = Math.pow(10, decimals);
	  if (increment) {
	    value = Math.round(value / increment) * increment;
	  }
	  value = Math.round(value * d) / d;
	  if (min && value < min) {
	    return min;
	  }
	  if (max && value > max) {
	    return max;
	  }
	  return value;
	};
	
	Utils.roundWhole = function(value, decimals) {
	  if (decimals == null) {
	    decimals = 1;
	  }
	  if (parseInt(value) === value) {
	    return parseInt(value);
	  }
	  return Utils.round(value, decimals);
	};
	
	Utils.clamp = function(value, a, b) {
	  var max, min;
	  min = Math.min(a, b);
	  max = Math.max(a, b);
	  if (value < min) {
	    value = min;
	  }
	  if (value > max) {
	    value = max;
	  }
	  return value;
	};
	
	Utils.mapRange = function(value, fromLow, fromHigh, toLow, toHigh) {
	  return toLow + (((value - fromLow) / (fromHigh - fromLow)) * (toHigh - toLow));
	};
	
	Utils.modulate = function(value, rangeA, rangeB, limit) {
	  var fromHigh, fromLow, result, toHigh, toLow;
	  if (limit == null) {
	    limit = false;
	  }
	  fromLow = rangeA[0], fromHigh = rangeA[1];
	  toLow = rangeB[0], toHigh = rangeB[1];
	  result = toLow + (((value - fromLow) / (fromHigh - fromLow)) * (toHigh - toLow));
	  if (limit === true) {
	    if (toLow < toHigh) {
	      if (result < toLow) {
	        return toLow;
	      }
	      if (result > toHigh) {
	        return toHigh;
	      }
	    } else {
	      if (result > toLow) {
	        return toLow;
	      }
	      if (result < toHigh) {
	        return toHigh;
	      }
	    }
	  }
	  return result;
	};
	
	Utils.parseFunction = function(str) {
	  var result;
	  result = {
	    name: "",
	    args: []
	  };
	  if (_.endsWith(str, ")")) {
	    result.name = str.split("(")[0];
	    result.args = str.split("(")[1].split(",").map(function(a) {
	      return _.trim(_.trimEnd(a, ")"));
	    });
	  } else {
	    result.name = str;
	  }
	  return result;
	};
	
	__domCompleteState = "interactive";
	
	__domComplete = [];
	
	__domReady = false;
	
	if (typeof document !== "undefined" && document !== null) {
	  document.onreadystatechange = function(event) {
	    var f, results;
	    if (document.readyState === __domCompleteState) {
	      __domReady = true;
	      results = [];
	      while (__domComplete.length) {
	        results.push(f = __domComplete.shift()());
	      }
	      return results;
	    }
	  };
	}
	
	Utils.domComplete = function(f) {
	  if (__domReady) {
	    return f();
	  } else {
	    return __domComplete.push(f);
	  }
	};
	
	Utils.domCompleteCancel = function(f) {
	  return __domComplete = _.without(__domComplete, f);
	};
	
	Utils.domValidEvent = function(element, eventName) {
	  if (!eventName) {
	    return;
	  }
	  if (eventName === "touchstart" || eventName === "touchmove" || eventName === "touchend") {
	    return true;
	  }
	  return typeof element["on" + (eventName.toLowerCase())] !== "undefined";
	};
	
	Utils.domLoadScript = function(url, callback) {
	  var head, script;
	  script = document.createElement("script");
	  script.type = "text/javascript";
	  script.src = url;
	  script.onload = callback;
	  head = document.getElementsByTagName("head")[0];
	  head.appendChild(script);
	  return script;
	};
	
	Utils.domLoadData = function(path, callback) {
	  var request;
	  request = new XMLHttpRequest();
	  request.addEventListener("load", function() {
	    return callback(null, request.responseText);
	  }, false);
	  request.addEventListener("error", function() {
	    return callback(true, null);
	  }, false);
	  request.open("GET", path, true);
	  return request.send(null);
	};
	
	Utils.domLoadJSON = function(path, callback) {
	  return Utils.domLoadData(path, function(err, data) {
	    return callback(err, JSON.parse(data));
	  });
	};
	
	Utils.domLoadDataSync = function(path) {
	  var e, handleError, ref, request;
	  request = new XMLHttpRequest();
	  request.open("GET", path, false);
	  try {
	    request.send(null);
	  } catch (error) {
	    e = error;
	    console.debug("XMLHttpRequest.error", e);
	  }
	  handleError = function() {
	    throw Error("Utils.domLoadDataSync: " + path + " -> [" + request.status + " " + request.statusText + "]");
	  };
	  request.onerror = handleError;
	  if ((ref = request.status) !== 200 && ref !== 0) {
	    handleError();
	  }
	  if (!request.responseText) {
	    handleError();
	  }
	  return request.responseText;
	};
	
	Utils.domLoadJSONSync = function(path) {
	  return JSON.parse(Utils.domLoadDataSync(path));
	};
	
	Utils.domLoadScriptSync = function(path) {
	  var scriptData;
	  scriptData = Utils.domLoadDataSync(path);
	  eval(scriptData);
	  return scriptData;
	};
	
	Utils.insertCSS = function(css) {
	  var styleElement;
	  styleElement = document.createElement("style");
	  styleElement.type = "text/css";
	  styleElement.innerHTML = css;
	  return Utils.domComplete(function() {
	    return document.body.appendChild(styleElement);
	  });
	};
	
	Utils.loadImage = function(url, callback, context) {
	  var element;
	  element = new Image;
	  if (context == null) {
	    context = Framer.CurrentContext;
	  }
	  context.domEventManager.wrap(element).addEventListener("load", function(event) {
	    return callback();
	  });
	  context.domEventManager.wrap(element).addEventListener("error", function(event) {
	    return callback(true);
	  });
	  return element.src = url;
	};
	
	Utils.isInsideIframe = function() {
	  return window !== window.top;
	};
	
	Utils.point = function(input) {
	  var k, len, o, ref, result;
	  if (_.isNumber(input)) {
	    return Utils.pointZero(input);
	  }
	  if (!input) {
	    return Utils.pointZero();
	  }
	  result = Utils.pointZero();
	  ref = ["x", "y"];
	  for (o = 0, len = ref.length; o < len; o++) {
	    k = ref[o];
	    if (_.isNumber(input[k])) {
	      result[k] = input[k];
	    }
	  }
	  return result;
	};
	
	Utils.pointZero = function(n) {
	  if (n == null) {
	    n = 0;
	  }
	  return {
	    x: n,
	    y: n
	  };
	};
	
	Utils.pointDivide = function(point, fraction) {
	  return point = {
	    x: point.x / fraction,
	    y: point.y / fraction
	  };
	};
	
	Utils.pointAdd = function(pointA, pointB) {
	  var point;
	  return point = {
	    x: pointA.x + pointB.x,
	    y: pointA.y + pointB.y
	  };
	};
	
	Utils.pointSubtract = function(pointA, pointB) {
	  var point;
	  return point = {
	    x: pointA.x - pointB.x,
	    y: pointA.y - pointB.y
	  };
	};
	
	Utils.pointMin = function() {
	  var point, points;
	  points = Utils.arrayFromArguments(arguments);
	  return point = {
	    x: _.min(points.map(function(size) {
	      return size.x;
	    })),
	    y: _.min(points.map(function(size) {
	      return size.y;
	    }))
	  };
	};
	
	Utils.pointMax = function() {
	  var point, points;
	  points = Utils.arrayFromArguments(arguments);
	  return point = {
	    x: _.max(points.map(function(size) {
	      return size.x;
	    })),
	    y: _.max(points.map(function(size) {
	      return size.y;
	    }))
	  };
	};
	
	Utils.pointDelta = function(pointA, pointB) {
	  var delta;
	  return delta = {
	    x: pointB.x - pointA.x,
	    y: pointB.y - pointA.y
	  };
	};
	
	Utils.pointDistance = function(pointA, pointB) {
	  var a, b;
	  a = pointA.x - pointB.x;
	  b = pointA.y - pointB.y;
	  return Math.sqrt((a * a) + (b * b));
	};
	
	Utils.pointInvert = function(point) {
	  return point = {
	    x: 0 - point.x,
	    y: 0 - point.y
	  };
	};
	
	Utils.pointTotal = function(point) {
	  return point.x + point.y;
	};
	
	Utils.pointAbs = function(point) {
	  return point = {
	    x: Math.abs(point.x),
	    y: Math.abs(point.y)
	  };
	};
	
	Utils.pointInFrame = function(point, frame) {
	  if (point.x < Utils.frameGetMinX(frame) || point.x > Utils.frameGetMaxX(frame)) {
	    return false;
	  }
	  if (point.y < Utils.frameGetMinY(frame) || point.y > Utils.frameGetMaxY(frame)) {
	    return false;
	  }
	  return true;
	};
	
	Utils.pointCenter = function(pointA, pointB) {
	  var point;
	  return point = {
	    x: (pointA.x + pointB.x) / 2,
	    y: (pointA.y + pointB.y) / 2
	  };
	};
	
	Utils.pointAngle = function(pointA, pointB) {
	  return Math.atan2(pointB.y - pointA.y, pointB.x - pointA.x) * 180 / Math.PI;
	};
	
	Utils.size = function(input) {
	  var k, len, o, ref, result;
	  if (_.isNumber(input)) {
	    return Utils.sizeZero(input);
	  }
	  if (!input) {
	    return Utils.sizeZero();
	  }
	  result = Utils.sizeZero();
	  ref = ["width", "height"];
	  for (o = 0, len = ref.length; o < len; o++) {
	    k = ref[o];
	    if (_.isNumber(input[k])) {
	      result[k] = input[k];
	    }
	  }
	  return result;
	};
	
	Utils.sizeZero = function(n) {
	  if (n == null) {
	    n = 0;
	  }
	  return {
	    width: n,
	    height: n
	  };
	};
	
	Utils.sizeMin = function() {
	  var size, sizes;
	  sizes = Utils.arrayFromArguments(arguments);
	  return size = {
	    width: _.min(sizes.map(function(size) {
	      return size.width;
	    })),
	    height: _.min(sizes.map(function(size) {
	      return size.height;
	    }))
	  };
	};
	
	Utils.sizeMax = function() {
	  var size, sizes;
	  sizes = Utils.arrayFromArguments(arguments);
	  return size = {
	    width: _.max(sizes.map(function(size) {
	      return size.width;
	    })),
	    height: _.max(sizes.map(function(size) {
	      return size.height;
	    }))
	  };
	};
	
	Utils.rectZero = function(args) {
	  if (args == null) {
	    args = {};
	  }
	  return _.defaults(args, {
	    top: 0,
	    right: 0,
	    bottom: 0,
	    left: 0
	  });
	};
	
	Utils.parseRect = function(args) {
	  if (_.isArray(args) && _.isNumber(args[0])) {
	    if (args.length === 1) {
	      return Utils.parseRect({
	        top: args[0]
	      });
	    }
	    if (args.length === 2) {
	      return Utils.parseRect({
	        top: args[0],
	        right: args[1]
	      });
	    }
	    if (args.length === 3) {
	      return Utils.parseRect({
	        top: args[0],
	        right: args[1],
	        bottom: args[2]
	      });
	    }
	    if (args.length === 4) {
	      return Utils.parseRect({
	        top: args[0],
	        right: args[1],
	        bottom: args[2],
	        left: args[3]
	      });
	    }
	  }
	  if (_.isArray(args) && _.isObject(args[0])) {
	    return args[0];
	  }
	  if (_.isObject(args)) {
	    return args;
	  }
	  if (_.isNumber(args)) {
	    return {
	      top: args,
	      right: args,
	      bottom: args,
	      left: args
	    };
	  }
	  return {};
	};
	
	Utils.frameGetMinX = function(frame) {
	  return frame.x;
	};
	
	Utils.frameSetMinX = function(frame, value) {
	  return frame.x = value;
	};
	
	Utils.frameGetMidX = function(frame) {
	  if (frame.width === 0) {
	    return frame.x;
	  } else {
	    return frame.x + (frame.width / 2.0);
	  }
	};
	
	Utils.frameSetMidX = function(frame, value) {
	  return frame.x = frame.width === 0 ? value : value - (frame.width / 2.0);
	};
	
	Utils.frameGetMaxX = function(frame) {
	  if (frame.width === 0) {
	    return 0;
	  } else {
	    return frame.x + frame.width;
	  }
	};
	
	Utils.frameSetMaxX = function(frame, value) {
	  return frame.x = frame.width === 0 ? 0 : value - frame.width;
	};
	
	Utils.frameGetMinY = function(frame) {
	  return frame.y;
	};
	
	Utils.frameSetMinY = function(frame, value) {
	  return frame.y = value;
	};
	
	Utils.frameGetMidY = function(frame) {
	  if (frame.height === 0) {
	    return frame.y;
	  } else {
	    return frame.y + (frame.height / 2.0);
	  }
	};
	
	Utils.frameSetMidY = function(frame, value) {
	  return frame.y = frame.height === 0 ? value : value - (frame.height / 2.0);
	};
	
	Utils.frameGetMaxY = function(frame) {
	  if (frame.height === 0) {
	    return 0;
	  } else {
	    return frame.y + frame.height;
	  }
	};
	
	Utils.frameSetMaxY = function(frame, value) {
	  return frame.y = frame.height === 0 ? 0 : value - frame.height;
	};
	
	Utils.frame = function(input) {
	  var k, len, o, ref, result;
	  if (_.isNumber(input)) {
	    return Utils.frameZero(input);
	  }
	  if (!input) {
	    return Utils.frameZero();
	  }
	  result = Utils.frameZero();
	  ref = ["x", "y", "width", "height"];
	  for (o = 0, len = ref.length; o < len; o++) {
	    k = ref[o];
	    if (_.isNumber(input[k])) {
	      result[k] = input[k];
	    }
	  }
	  return result;
	};
	
	Utils.frameZero = function(n) {
	  if (n == null) {
	    n = 0;
	  }
	  return {
	    x: n,
	    y: n
	  };
	};
	
	Utils.frameSize = function(frame) {
	  var size;
	  return size = {
	    width: frame.width,
	    height: frame.height
	  };
	};
	
	Utils.framePoint = function(frame) {
	  var point;
	  return point = {
	    x: frame.x,
	    y: frame.y
	  };
	};
	
	Utils.pointsFromFrame = function(frame) {
	  var corner1, corner2, corner3, corner4, maxX, maxY, minX, minY;
	  minX = Utils.frameGetMinX(frame);
	  maxX = Utils.frameGetMaxX(frame);
	  minY = Utils.frameGetMinY(frame);
	  maxY = Utils.frameGetMaxY(frame);
	  corner1 = {
	    x: minX,
	    y: minY
	  };
	  corner2 = {
	    x: minX,
	    y: maxY
	  };
	  corner3 = {
	    x: maxX,
	    y: maxY
	  };
	  corner4 = {
	    x: maxX,
	    y: minY
	  };
	  return [corner1, corner2, corner3, corner4];
	};
	
	Utils.frameFromPoints = function(points) {
	  var frame, maxX, maxY, minX, minY, xValues, yValues;
	  xValues = _.map(points, "x");
	  yValues = _.map(points, "y");
	  minX = _.min(xValues);
	  maxX = _.max(xValues);
	  minY = _.min(yValues);
	  maxY = _.max(yValues);
	  return frame = {
	    x: minX,
	    y: minY,
	    width: maxX - minX,
	    height: maxY - minY
	  };
	};
	
	Utils.pixelAlignedFrame = function(frame) {
	  var result;
	  return result = {
	    width: Math.round(frame.width + (frame.x % 1)),
	    height: Math.round(frame.height + (frame.y % 1)),
	    x: Math.round(frame.x),
	    y: Math.round(frame.y)
	  };
	};
	
	Utils.frameMerge = function() {
	  var frame, frames;
	  frames = Utils.arrayFromArguments(arguments);
	  frame = {
	    x: _.min(frames.map(Utils.frameGetMinX)),
	    y: _.min(frames.map(Utils.frameGetMinY))
	  };
	  frame.width = _.max(frames.map(Utils.frameGetMaxX)) - frame.x;
	  frame.height = _.max(frames.map(Utils.frameGetMaxY)) - frame.y;
	  return frame;
	};
	
	Utils.frameInFrame = function(frameA, frameB) {
	  var len, o, point, ref;
	  ref = Utils.pointsFromFrame(frameA);
	  for (o = 0, len = ref.length; o < len; o++) {
	    point = ref[o];
	    if (!Utils.pointInFrame(point, frameB)) {
	      return false;
	    }
	  }
	  return true;
	};
	
	Utils.framePointForOrigin = function(frame, originX, originY) {
	  return frame = {
	    x: frame.x + (originX * frame.width),
	    y: frame.y + (originY * frame.height),
	    width: frame.width,
	    height: frame.height
	  };
	};
	
	Utils.frameInset = function(frame, inset) {
	  if (_.isNumber(inset)) {
	    inset = {
	      top: inset,
	      right: inset,
	      bottom: inset,
	      left: inset
	    };
	  }
	  frame = Utils.frame(frame);
	  return frame = {
	    x: frame.x + inset.left,
	    y: frame.y + inset.top,
	    width: frame.width - inset.left - inset.right,
	    height: frame.height - inset.top - inset.bottom
	  };
	};
	
	Utils.frameSortByAbsoluteDistance = function(point, frames, originX, originY) {
	  var distance;
	  if (originX == null) {
	    originX = 0;
	  }
	  if (originY == null) {
	    originY = 0;
	  }
	  distance = function(frame) {
	    var result;
	    result = Utils.pointDelta(point, Utils.framePointForOrigin(frame, originX, originY));
	    result = Utils.pointAbs(result);
	    result = Utils.pointTotal(result);
	    return result;
	  };
	  return frames.sort(function(a, b) {
	    return distance(a) - distance(b);
	  });
	};
	
	Utils.pointInPolygon = function(point, vs) {
	  var i, inside, intersect, j, x, xi, xj, y, yi, yj;
	  x = point[0];
	  y = point[1];
	  inside = false;
	  i = 0;
	  j = vs.length - 1;
	  while (i < vs.length) {
	    xi = vs[i][0];
	    yi = vs[i][1];
	    xj = vs[j][0];
	    yj = vs[j][1];
	    intersect = ((yi > y && y !== yj) && yj > y) && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
	    if (intersect) {
	      inside = !inside;
	    }
	    j = i++;
	  }
	  return inside;
	};
	
	Utils.frameIntersection = function(rectA, rect) {
	  var x1, x2, y1, y2;
	  x1 = rect.x;
	  y1 = rect.y;
	  x2 = x1 + rect.width;
	  y2 = y1 + rect.height;
	  if (rectA.x > x1) {
	    x1 = rectA.x;
	  }
	  if (rectA.y > y1) {
	    y1 = rectA.y;
	  }
	  if (rectA.x + rectA.width < x2) {
	    x2 = rectA.x + rectA.width;
	  }
	  if (rectA.y + rectA.height < y2) {
	    y2 = rectA.y + rectA.height;
	  }
	  if (x2 <= x1 || y2 <= y1) {
	    return null;
	  }
	  return rect = {
	    x: x1,
	    y: y1,
	    width: x2 - x1,
	    height: y2 - y1
	  };
	};
	
	Utils.frameCenterPoint = function(frame) {
	  var point;
	  return point = {
	    x: Utils.frameGetMidX(frame),
	    y: Utils.frameGetMidY(frame)
	  };
	};
	
	Utils.frameInFrame = function(frameA, frameB) {
	  var len, o, point, ref;
	  ref = Utils.pointsFromFrame(frameA);
	  for (o = 0, len = ref.length; o < len; o++) {
	    point = ref[o];
	    if (!Utils.pointInFrame(point, frameB)) {
	      return false;
	    }
	  }
	  return true;
	};
	
	Utils.rotationNormalizer = function() {
	  var lastValue;
	  lastValue = null;
	  return function(value) {
	    var diff, maxDiff, nTimes;
	    if (lastValue == null) {
	      lastValue = value;
	    }
	    diff = lastValue - value;
	    maxDiff = Math.abs(diff) + 180;
	    nTimes = Math.floor(maxDiff / 360);
	    if (diff < 180) {
	      value -= nTimes * 360;
	    }
	    if (diff > 180) {
	      value += nTimes * 360;
	    }
	    lastValue = value;
	    return value;
	  };
	};
	
	Utils.convertPointToContext = function(point, layer, rootContext, includeLayer) {
	  var ancestor, ancestors, len, o;
	  if (point == null) {
	    point = {};
	  }
	  if (rootContext == null) {
	    rootContext = false;
	  }
	  if (includeLayer == null) {
	    includeLayer = true;
	  }
	  point = _.defaults(point, {
	    x: 0,
	    y: 0,
	    z: 0
	  });
	  ancestors = layer.ancestors(rootContext);
	  if (includeLayer) {
	    ancestors.unshift(layer);
	  }
	  for (o = 0, len = ancestors.length; o < len; o++) {
	    ancestor = ancestors[o];
	    if (ancestor.flat || ancestor.clip) {
	      point.z = 0;
	    }
	    point = ancestor.matrix3d.point(point);
	    if (!ancestor.parent) {
	      point.z = 0;
	    }
	  }
	  return point;
	};
	
	Utils.convertFrameToContext = function(frame, layer, rootContext, includeLayer) {
	  var convertedCorners, corners;
	  if (frame == null) {
	    frame = {};
	  }
	  if (rootContext == null) {
	    rootContext = false;
	  }
	  if (includeLayer == null) {
	    includeLayer = true;
	  }
	  frame = _.defaults(frame, {
	    x: 0,
	    y: 0,
	    width: 100,
	    height: 100
	  });
	  corners = Utils.pointsFromFrame(frame);
	  convertedCorners = corners.map(function(point) {
	    return Utils.convertPointToContext(point, layer, rootContext, includeLayer);
	  });
	  return Utils.frameFromPoints(convertedCorners);
	};
	
	Utils.convertPointFromContext = function(point, layer, rootContext, includeLayer) {
	  var ancestor, ancestors, len, node, o, parent;
	  if (point == null) {
	    point = {};
	  }
	  if (rootContext == null) {
	    rootContext = false;
	  }
	  if (includeLayer == null) {
	    includeLayer = true;
	  }
	  point = _.defaults(point, {
	    x: 0,
	    y: 0,
	    z: 0
	  });
	  if (rootContext && (typeof webkitConvertPointFromPageToNode !== "undefined" && webkitConvertPointFromPageToNode !== null)) {
	    if (includeLayer) {
	      node = layer._element;
	    } else {
	      parent = layer.parent || layer.context;
	      node = parent._element;
	    }
	    return Utils.point(webkitConvertPointFromPageToNode(node, new WebKitPoint(point.x, point.y)));
	  }
	  ancestors = layer.ancestors(rootContext);
	  ancestors.reverse();
	  if (includeLayer) {
	    ancestors.push(layer);
	  }
	  for (o = 0, len = ancestors.length; o < len; o++) {
	    ancestor = ancestors[o];
	    if (!ancestor.matrix3d) {
	      continue;
	    }
	    point = ancestor.matrix3d.inverse().point(point);
	  }
	  return point;
	};
	
	Utils.convertFrameFromContext = function(frame, layer, rootContext, includeLayer) {
	  var convertedCorners, corners;
	  if (frame == null) {
	    frame = {};
	  }
	  if (rootContext == null) {
	    rootContext = false;
	  }
	  if (includeLayer == null) {
	    includeLayer = true;
	  }
	  frame = _.defaults(frame, {
	    x: 0,
	    y: 0,
	    width: 100,
	    height: 100
	  });
	  corners = Utils.pointsFromFrame(frame);
	  convertedCorners = corners.map(function(point) {
	    return Utils.convertPointFromContext(point, layer, rootContext, includeLayer);
	  });
	  return Utils.frameFromPoints(convertedCorners);
	};
	
	Utils.convertPoint = function(input, layerA, layerB, rootContext) {
	  var node, point;
	  if (rootContext == null) {
	    rootContext = false;
	  }
	  point = _.defaults(input, {
	    x: 0,
	    y: 0,
	    z: 0
	  });
	  if (layerA) {
	    point = Utils.convertPointToContext(point, layerA, rootContext);
	  }
	  if (layerB != null) {
	    return Utils.convertPointFromContext(point, layerB, rootContext);
	  } else if ((layerA != null) && rootContext && (typeof webkitConvertPointFromPageToNode !== "undefined" && webkitConvertPointFromPageToNode !== null)) {
	    node = layerA.context._element;
	    return Utils.point(webkitConvertPointFromPageToNode(node, new WebKitPoint(point.x, point.y)));
	  } else {
	    return point;
	  }
	};
	
	Utils.boundingFrame = function(layer, rootContext) {
	  var boundingFrame, contextCornerPoints, cornerPoints, frame;
	  if (rootContext == null) {
	    rootContext = true;
	  }
	  frame = {
	    x: 0,
	    y: 0,
	    width: layer.width,
	    height: layer.height
	  };
	  cornerPoints = Utils.pointsFromFrame(frame);
	  contextCornerPoints = cornerPoints.map(function(point) {
	    return Utils.convertPointToContext(point, layer, rootContext);
	  });
	  boundingFrame = Utils.frameFromPoints(contextCornerPoints);
	  return Utils.pixelAlignedFrame(boundingFrame);
	};
	
	Utils.perspectiveProjectionMatrix = function(element) {
	  var m, p;
	  p = element.perspective;
	  m = new Matrix();
	  if ((p != null) && p !== 0) {
	    m.m34 = -1 / p;
	  }
	  return m;
	};
	
	Utils.perspectiveMatrix = function(element) {
	  var ox, oy, ppm;
	  ox = element.perspectiveOriginX * element.width;
	  oy = element.perspectiveOriginY * element.height;
	  ppm = Utils.perspectiveProjectionMatrix(element);
	  return new Matrix().translate(ox, oy).multiply(ppm).translate(-ox, -oy);
	};
	
	Utils.globalLayers = function(importedLayers) {
	  var layer, layerName;
	  for (layerName in importedLayers) {
	    layer = importedLayers[layerName];
	    layerName = layerName.replace(/\s/g, "");
	    if (window.hasOwnProperty(layerName) && !window.Framer._globalWarningGiven) {
	      print("Warning: Cannot make layer '" + layerName + "' a global, a variable with that name already exists");
	    } else {
	      window[layerName] = layer;
	    }
	  }
	  return window.Framer._globalWarningGiven = true;
	};
	
	_textSizeNode = null;
	
	Utils.textSize = function(text, style, constraints) {
	  var frame, rect, shouldCreateNode;
	  if (style == null) {
	    style = {};
	  }
	  if (constraints == null) {
	    constraints = {};
	  }
	  shouldCreateNode = !_textSizeNode;
	  if (shouldCreateNode) {
	    _textSizeNode = document.createElement("div");
	    _textSizeNode.id = "_textSizeNode";
	  }
	  _textSizeNode.removeAttribute("style");
	  _textSizeNode.innerHTML = text;
	  style = _.extend(_.clone(style), {
	    position: "fixed",
	    display: "inline",
	    visibility: "hidden",
	    top: "-10000px",
	    left: "-10000px"
	  });
	  delete style.width;
	  delete style.height;
	  delete style.bottom;
	  delete style.right;
	  if (constraints.width) {
	    style.width = constraints.width + "px";
	  }
	  if (constraints.height) {
	    style.height = constraints.height + "px";
	  }
	  _.extend(_textSizeNode.style, style);
	  if (shouldCreateNode) {
	    if (!window.document.body) {
	      document.write(_textSizeNode.outerHTML);
	      _textSizeNode = document.getElementById("_textSizeNode");
	    } else {
	      window.document.body.appendChild(_textSizeNode);
	    }
	  }
	  rect = _textSizeNode.getBoundingClientRect();
	  return frame = {
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	};
	
	_.extend(exports, Utils);


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass, ScreenClass,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	ScreenClass = (function(superClass) {
	  extend(ScreenClass, superClass);
	
	  function ScreenClass() {
	    return ScreenClass.__super__.constructor.apply(this, arguments);
	  }
	
	  ScreenClass.define("width", {
	    get: function() {
	      if (this.device) {
	        return this.device.screenSize.width;
	      }
	      return Canvas.width;
	    }
	  });
	
	  ScreenClass.define("height", {
	    get: function() {
	      if (this.device) {
	        return this.device.screenSize.height;
	      }
	      return Canvas.height;
	    }
	  });
	
	  ScreenClass.define("canvasFrame", {
	    get: function() {
	      if (this.device) {
	        return this.device.context.canvasFrame;
	      }
	      return this.frame;
	    }
	  });
	
	  ScreenClass.define("midX", {
	    get: function() {
	      return Utils.frameGetMidX(this.frame);
	    }
	  });
	
	  ScreenClass.define("midY", {
	    get: function() {
	      return Utils.frameGetMidY(this.frame);
	    }
	  });
	
	  ScreenClass.define("size", {
	    get: function() {
	      return Utils.size(this);
	    }
	  });
	
	  ScreenClass.define("frame", {
	    get: function() {
	      return Utils.frame(this);
	    }
	  });
	
	  ScreenClass.define("device", {
	    get: function() {
	      return Framer.CurrentContext.device;
	    }
	  });
	
	  ScreenClass.define("backgroundColor", ScreenClass.proxyProperty("device.screen.backgroundColor"));
	
	  ScreenClass.define("perspective", ScreenClass.proxyProperty("device.context.perspective"));
	
	  ScreenClass.define("perspectiveOriginX", ScreenClass.proxyProperty("device.context.perspectiveOriginX"));
	
	  ScreenClass.define("perspectiveOriginY", ScreenClass.proxyProperty("device.context.perspectiveOriginY"));
	
	  ScreenClass.prototype.toInspect = function() {
	    return "<Screen " + (Utils.roundWhole(this.width)) + "x" + (Utils.roundWhole(this.height)) + ">";
	  };
	
	  ScreenClass.prototype.convertPointToLayer = function(point, layer) {
	    return Utils.convertPointFromContext(point, layer, false, true);
	  };
	
	  ScreenClass.prototype.convertPointToCanvas = function(point) {
	    var ctx;
	    ctx = Framer.Device.context;
	    return Utils.convertPointToContext(point, ctx, true, false);
	  };
	
	  ScreenClass.prototype.onEdgeSwipe = function(cb) {
	    return this.on(Events.EdgeSwipe, cb);
	  };
	
	  ScreenClass.prototype.onEdgeSwipeStart = function(cb) {
	    return this.on(Events.EdgeSwipeStart, cb);
	  };
	
	  ScreenClass.prototype.onEdgeSwipeEnd = function(cb) {
	    return this.on(Events.EdgeSwipeEnd, cb);
	  };
	
	  ScreenClass.prototype.onEdgeSwipeTop = function(cb) {
	    return this.on(Events.EdgeSwipeTop, cb);
	  };
	
	  ScreenClass.prototype.onEdgeSwipeTopStart = function(cb) {
	    return this.on(Events.EdgeSwipeTopStart, cb);
	  };
	
	  ScreenClass.prototype.onEdgeSwipeTopEnd = function(cb) {
	    return this.on(Events.EdgeSwipeTopEnd, cb);
	  };
	
	  ScreenClass.prototype.onEdgeSwipeRight = function(cb) {
	    return this.on(Events.EdgeSwipeRight, cb);
	  };
	
	  ScreenClass.prototype.onEdgeSwipeRightStart = function(cb) {
	    return this.on(Events.EdgeSwipeRightStart, cb);
	  };
	
	  ScreenClass.prototype.onEdgeSwipeRightEnd = function(cb) {
	    return this.on(Events.EdgeSwipeRightEnd, cb);
	  };
	
	  ScreenClass.prototype.onEdgeSwipeBottom = function(cb) {
	    return this.on(Events.EdgeSwipeBottom, cb);
	  };
	
	  ScreenClass.prototype.onEdgeSwipeBottomStart = function(cb) {
	    return this.on(Events.EdgeSwipeBottomStart, cb);
	  };
	
	  ScreenClass.prototype.onEdgeSwipeBottomEnd = function(cb) {
	    return this.on(Events.EdgeSwipeBottomEnd, cb);
	  };
	
	  ScreenClass.prototype.onEdgeSwipeLeft = function(cb) {
	    return this.on(Events.EdgeSwipeLeft, cb);
	  };
	
	  ScreenClass.prototype.onEdgeSwipeLeftStart = function(cb) {
	    return this.on(Events.EdgeSwipeLeftStart, cb);
	  };
	
	  ScreenClass.prototype.onEdgeSwipeLeftEnd = function(cb) {
	    return this.on(Events.EdgeSwipeLeftEnd, cb);
	  };
	
	  return ScreenClass;
	
	})(BaseClass);
	
	exports.Screen = new ScreenClass;


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var CounterKey, DefinedPropertiesKey, DefinedPropertiesOrderKey, DefinedPropertiesValuesKey, EventEmitter, Utils, _,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	_ = __webpack_require__(1)._;
	
	Utils = __webpack_require__(4);
	
	EventEmitter = __webpack_require__(7).EventEmitter;
	
	CounterKey = "_ObjectCounter";
	
	DefinedPropertiesKey = "_DefinedPropertiesKey";
	
	DefinedPropertiesValuesKey = "_DefinedPropertiesValuesKey";
	
	DefinedPropertiesOrderKey = "_DefinedPropertiesOrderKey";
	
	exports.BaseClass = (function(superClass) {
	  extend(BaseClass, superClass);
	
	  BaseClass.define = function(propertyName, descriptor) {
	    if (this !== BaseClass) {
	      this._addDescriptor(propertyName, descriptor);
	    }
	    return Object.defineProperty(this.prototype, propertyName, descriptor);
	  };
	
	  BaseClass._addDescriptor = function(propertyName, descriptor) {
	    var depend, i, len, ref;
	    descriptor.propertyName = propertyName;
	    if (descriptor.enumerable == null) {
	      descriptor.enumerable = true;
	    }
	    if (descriptor.exportable == null) {
	      descriptor.exportable = true;
	    }
	    if (descriptor.importable == null) {
	      descriptor.importable = true;
	    }
	    descriptor.importable = descriptor.importable && descriptor.set;
	    descriptor.exportable = descriptor.exportable && descriptor.set;
	    if (_.startsWith(propertyName, "_")) {
	      return;
	    }
	    if (descriptor.exportable || descriptor.importable) {
	      if (this[DefinedPropertiesKey] == null) {
	        this[DefinedPropertiesKey] = {};
	      }
	      this[DefinedPropertiesKey][propertyName] = descriptor;
	      if (this[DefinedPropertiesOrderKey] == null) {
	        this[DefinedPropertiesOrderKey] = [];
	      }
	      if (descriptor.depends) {
	        ref = descriptor.depends;
	        for (i = 0, len = ref.length; i < len; i++) {
	          depend = ref[i];
	          if (indexOf.call(this[DefinedPropertiesOrderKey], depend) < 0) {
	            this[DefinedPropertiesOrderKey].push(depend);
	          }
	        }
	      }
	      return this[DefinedPropertiesOrderKey].push(propertyName);
	    }
	  };
	
	  BaseClass.simpleProperty = function(name, fallback, options) {
	    if (options == null) {
	      options = {};
	    }
	    return _.extend(options, {
	      "default": fallback,
	      get: function() {
	        return this._getPropertyValue(name);
	      },
	      set: function(value) {
	        return this._setPropertyValue(name, value);
	      }
	    });
	  };
	
	  BaseClass.proxyProperty = function(keyPath, options) {
	    var descriptor, objectKey;
	    if (options == null) {
	      options = {};
	    }
	    objectKey = keyPath.split(".")[0];
	    return descriptor = _.extend(options, {
	      get: function() {
	        if (!_.isObject(this[objectKey])) {
	          return;
	        }
	        return Utils.getValueForKeyPath(this, keyPath);
	      },
	      set: function(value) {
	        if (!_.isObject(this[objectKey])) {
	          return;
	        }
	        return Utils.setValueForKeyPath(this, keyPath, value);
	      },
	      proxy: true
	    });
	  };
	
	  BaseClass.prototype._setPropertyValue = function(k, v) {
	    return this[DefinedPropertiesValuesKey][k] = v;
	  };
	
	  BaseClass.prototype._getPropertyValue = function(k) {
	    return Utils.valueOrDefault(this[DefinedPropertiesValuesKey][k], this._getPropertyDefaultValue(k));
	  };
	
	  BaseClass.prototype._getPropertyDefaultValue = function(k) {
	    return this._propertyList()[k]["default"];
	  };
	
	  BaseClass.prototype._propertyList = function() {
	    return this.constructor[DefinedPropertiesKey];
	  };
	
	  BaseClass.prototype.keys = function() {
	    return _.keys(this.props);
	  };
	
	  BaseClass.define("props", {
	    importable: false,
	    exportable: false,
	    get: function() {
	      var descriptor, key, keys, propertyList;
	      keys = [];
	      propertyList = this._propertyList();
	      for (key in propertyList) {
	        descriptor = propertyList[key];
	        if (descriptor.exportable) {
	          keys.push(key);
	        }
	      }
	      return _.pick(this, keys);
	    },
	    set: function(value) {
	      var k, propertyList, ref, results, v;
	      propertyList = this._propertyList();
	      results = [];
	      for (k in value) {
	        v = value[k];
	        if ((ref = propertyList[k]) != null ? ref.importable : void 0) {
	          results.push(this[k] = v);
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    }
	  });
	
	  BaseClass.define("id", {
	    get: function() {
	      return this._id;
	    }
	  });
	
	  BaseClass.prototype.toInspect = function() {
	    return "<" + this.constructor.name + " id:" + (this.id || null) + ">";
	  };
	
	  BaseClass.prototype.onChange = function(name, cb) {
	    return this.on("change:" + name, cb);
	  };
	
	  function BaseClass(options) {
	    this.toInspect = bind(this.toInspect, this);
	    this._getPropertyValue = bind(this._getPropertyValue, this);
	    this._setPropertyValue = bind(this._setPropertyValue, this);
	    var base;
	    BaseClass.__super__.constructor.apply(this, arguments);
	    this._context = typeof Framer !== "undefined" && Framer !== null ? Framer.CurrentContext : void 0;
	    this[DefinedPropertiesValuesKey] = {};
	    this._applyDefaults(options);
	    if ((base = this.constructor)[CounterKey] == null) {
	      base[CounterKey] = 0;
	    }
	    this.constructor[CounterKey] += 1;
	    this._id = this.constructor[CounterKey];
	  }
	
	  BaseClass.prototype._applyDefaults = function(options) {
	    var i, k, len, ref, results;
	    if (!this.constructor[DefinedPropertiesOrderKey]) {
	      return;
	    }
	    if (!options) {
	      return;
	    }
	    ref = this.constructor[DefinedPropertiesOrderKey];
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      k = ref[i];
	      results.push(this._applyDefault(k, options[k]));
	    }
	    return results;
	  };
	
	  BaseClass.prototype._applyProxyDefaults = function(options) {
	    var descriptor, i, k, len, ref, results;
	    if (!this.constructor[DefinedPropertiesOrderKey]) {
	      return;
	    }
	    if (!options) {
	      return;
	    }
	    ref = this.constructor[DefinedPropertiesOrderKey];
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      k = ref[i];
	      descriptor = this.constructor[DefinedPropertiesKey][k];
	      if (((descriptor != null ? descriptor.proxy : void 0) != null) !== true) {
	        continue;
	      }
	      results.push(this._applyDefault(k, options[k]));
	    }
	    return results;
	  };
	
	  BaseClass.prototype._applyDefault = function(key, optionValue) {
	    var descriptor, value;
	    descriptor = this.constructor[DefinedPropertiesKey][key];
	    if (!descriptor) {
	      throw Error("Missing dependant descriptor: " + key);
	    }
	    if (!descriptor.set) {
	      return;
	    }
	    if (descriptor.importable) {
	      value = optionValue;
	    }
	    value = Utils.valueOrDefault(optionValue, this._getPropertyDefaultValue(key));
	    if (value === null || value === (void 0)) {
	      return;
	    }
	    return this[key] = value;
	  };
	
	  return BaseClass;
	
	})(EventEmitter);


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var EventEmitter3, EventKey, _,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	_ = __webpack_require__(1)._;
	
	EventEmitter3 = __webpack_require__(8);
	
	EventKey = "_events";
	
	exports.EventEmitter = (function(superClass) {
	  extend(EventEmitter, superClass);
	
	  function EventEmitter() {
	    return EventEmitter.__super__.constructor.apply(this, arguments);
	  }
	
	  EventEmitter.prototype.listenerEvents = function() {
	    return _.keys(this[EventKey]);
	  };
	
	  EventEmitter.prototype.removeAllListeners = function(eventName) {
	    var eventNames, i, len, listener, results;
	    if (eventName) {
	      eventNames = [eventName];
	    } else {
	      eventNames = this.listenerEvents();
	    }
	    results = [];
	    for (i = 0, len = eventNames.length; i < len; i++) {
	      eventName = eventNames[i];
	      results.push((function() {
	        var j, len1, ref, results1;
	        ref = this.listeners(eventName);
	        results1 = [];
	        for (j = 0, len1 = ref.length; j < len1; j++) {
	          listener = ref[j];
	          results1.push(this.removeListener(eventName, listener));
	        }
	        return results1;
	      }).call(this));
	    }
	    return results;
	  };
	
	  return EventEmitter;
	
	})(EventEmitter3);


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	//
	// We store our EE objects in a plain object whose properties are event names.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// `~` to make sure that the built-in object properties are not overridden or
	// used as an attack vector.
	// We also assume that `Object.create(null)` is available when the event name
	// is an ES6 Symbol.
	//
	var prefix = typeof Object.create !== 'function' ? '~' : false;
	
	/**
	 * Representation of a single EventEmitter function.
	 *
	 * @param {Function} fn Event handler to be called.
	 * @param {Mixed} context Context for function execution.
	 * @param {Boolean} [once=false] Only emit once
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal EventEmitter interface that is molded against the Node.js
	 * EventEmitter interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() { /* Nothing to set */ }
	
	/**
	 * Hold the assigned EventEmitters by name.
	 *
	 * @type {Object}
	 * @private
	 */
	EventEmitter.prototype._events = undefined;
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var events = this._events
	    , names = []
	    , name;
	
	  if (!events) return names;
	
	  for (name in events) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return a list of assigned event listeners.
	 *
	 * @param {String} event The events that should be listed.
	 * @param {Boolean} exists We only need to know if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events && this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Emit an event to all registered event listeners.
	 *
	 * @param {String} event The name of the event.
	 * @returns {Boolean} Indication if we've emitted an event.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if ('function' === typeof listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Register a new EventListener for the given event.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Add an EventListener that's only called once.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Remove event listeners.
	 *
	 * @param {String} event The event we want to remove.
	 * @param {Function} fn The listener that we need to find.
	 * @param {Mixed} context Only remove listeners matching this context.
	 * @param {Boolean} once Only remove once listeners.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return this;
	
	  var listeners = this._events[evt]
	    , events = [];
	
	  if (fn) {
	    if (listeners.fn) {
	      if (
	           listeners.fn !== fn
	        || (once && !listeners.once)
	        || (context && listeners.context !== context)
	      ) {
	        events.push(listeners);
	      }
	    } else {
	      for (var i = 0, length = listeners.length; i < length; i++) {
	        if (
	             listeners[i].fn !== fn
	          || (once && !listeners[i].once)
	          || (context && listeners[i].context !== context)
	        ) {
	          events.push(listeners[i]);
	        }
	      }
	    }
	  }
	
	  //
	  // Reset the array, or remove it completely if we have no more listeners.
	  //
	  if (events.length) {
	    this._events[evt] = events.length === 1 ? events[0] : events;
	  } else {
	    delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners or only the listeners for the specified event.
	 *
	 * @param {String} event The event want to remove all listeners for.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  if (!this._events) return this;
	
	  if (event) delete this._events[prefix ? prefix + event : event];
	  else this._events = prefix ? {} : Object.create(null);
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ },
/* 9 */
/***/ function(module, exports) {

	WebKitCSSMatrix.prototype.skew = function(skew) {
	  var m, rad, value;
	  if (!skew) {
	    return this;
	  }
	  rad = skew * Math.PI / 180;
	  value = Math.tan(rad);
	  m = new WebKitCSSMatrix();
	  m.m12 = value;
	  m.m21 = value;
	  return this.multiply(m);
	};
	
	WebKitCSSMatrix.prototype.point = function(point) {
	  var ref, w, x, y, z;
	  if (point == null) {
	    point = {};
	  }
	  ref = _.defaults(point, {
	    x: 0,
	    y: 0,
	    z: 0
	  }), x = ref.x, y = ref.y, z = ref.z;
	  w = this.m14 * x + this.m24 * y + this.m34 * z + this.m44;
	  w = w || 1;
	  return point = {
	    x: (this.m11 * x + this.m21 * y + this.m31 * z + this.m41) / w,
	    y: (this.m12 * x + this.m22 * y + this.m32 * z + this.m42) / w,
	    z: (this.m13 * x + this.m23 * y + this.m33 * z + this.m43) / w
	  };
	};
	
	exports.Matrix = WebKitCSSMatrix;


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass, ColorModel, ColorType, _, bound01, convertToPercentage, correctAlpha, cssNames, hslToRgb, inputData, isNumeric, isOnePointZero, isPercentage, libhusl, matchers, numberFromString, pad2, percentToFraction, rgbToHex, rgbToHsl, rgbToRgb, rgbaFromHusl, stringToObject,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  slice = [].slice;
	
	_ = __webpack_require__(1)._;
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	libhusl = __webpack_require__(11);
	
	ColorType = {
	  RGB: "rgb",
	  HSL: "hsl",
	  HEX: "hex",
	  NAME: "name"
	};
	
	exports.Color = (function(superClass) {
	  extend(Color, superClass);
	
	  function Color(color1, r, g, b) {
	    var color, input;
	    this.color = color1;
	    this.toInspect = bind(this.toInspect, this);
	    if (this.color === "") {
	      this.color = null;
	    }
	    color = this.color;
	    if (Color.isColorObject(color)) {
	      return color;
	    }
	    input = inputData(color, r, g, b);
	    this._type = input.type;
	    this._r = input.r;
	    this._g = input.g;
	    this._b = input.b;
	    this._a = input.a;
	    this._h = input.h;
	    this._s = input.s;
	    this._l = input.l;
	    this._roundA = Math.round(100 * this._a) / 100;
	  }
	
	  Color.define("r", {
	    get: function() {
	      return this._r;
	    }
	  });
	
	  Color.define("g", {
	    get: function() {
	      return this._g;
	    }
	  });
	
	  Color.define("b", {
	    get: function() {
	      return this._b;
	    }
	  });
	
	  Color.define("a", {
	    get: function() {
	      return this._a;
	    }
	  });
	
	  Color.define("h", {
	    get: function() {
	      return this._h;
	    }
	  });
	
	  Color.define("s", {
	    get: function() {
	      return this._s;
	    }
	  });
	
	  Color.define("l", {
	    get: function() {
	      return this._l;
	    }
	  });
	
	  Color.prototype.toHex = function(allow3Char) {
	    return rgbToHex(this._r, this._g, this._b, allow3Char);
	  };
	
	  Color.prototype.toHexString = function(allow3Char) {
	    return "#" + this.toHex(allow3Char);
	  };
	
	  Color.prototype.toRgb = function() {
	    if (this._rgb === void 0) {
	      this._rgb = {
	        r: Math.round(this._r),
	        g: Math.round(this._g),
	        b: Math.round(this._b),
	        a: this._a
	      };
	    }
	    return _.clone(this._rgb);
	  };
	
	  Color.prototype.toRgbString = function() {
	    if (this._a === 1) {
	      return "rgb(" + (Utils.round(this._r, 0)) + ", " + (Utils.round(this._g, 0)) + ", " + (Utils.round(this._b, 0)) + ")";
	    } else {
	      return "rgba(" + (Utils.round(this._r, 0)) + ", " + (Utils.round(this._g, 0)) + ", " + (Utils.round(this._b, 0)) + ", " + this._roundA + ")";
	    }
	  };
	
	  Color.prototype.toHsl = function() {
	    if (this._hsl === void 0) {
	      this._hsl = {
	        h: this.h,
	        s: this.s,
	        l: this.l,
	        a: this.a
	      };
	    }
	    return _.clone(this._hsl);
	  };
	
	  Color.prototype.toHusl = function() {
	    var c, husl;
	    if (this._husl === void 0) {
	      c = libhusl._conv;
	      husl = c.lch.husl(c.luv.lch(c.xyz.luv(c.rgb.xyz([this.r / 255, this.g / 255, this.b / 255]))));
	      this._husl = {
	        h: husl[0],
	        s: husl[1],
	        l: husl[2]
	      };
	    }
	    return _.clone(this._husl);
	  };
	
	  Color.prototype.toHslString = function() {
	    var h, hsl, l, s;
	    if (this._hslString === void 0) {
	      hsl = this.toHsl();
	      h = Math.round(hsl.h);
	      s = Math.round(hsl.s * 100);
	      l = Math.round(hsl.l * 100);
	      if (this._a === 1) {
	        this._hslString = "hsl(" + h + ", " + s + "%, " + l + "%)";
	      } else {
	        this._hslString = "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
	      }
	    }
	    return this._hslString;
	  };
	
	  Color.prototype.toName = function() {
	    var hex, i, key, len, ref, value;
	    if (this._a === 0) {
	      return "transparent";
	    }
	    if (this._a < 1) {
	      return false;
	    }
	    hex = rgbToHex(this._r, this._g, this._b, true);
	    ref = _.keys(cssNames);
	    for (i = 0, len = ref.length; i < len; i++) {
	      key = ref[i];
	      value = cssNames[key];
	      if (value === hex) {
	        return key;
	      }
	    }
	    return false;
	  };
	
	  Color.prototype.lighten = function(amount) {
	    var hsl;
	    if (amount == null) {
	      amount = 10;
	    }
	    hsl = this.toHsl();
	    hsl.l += amount / 100;
	    hsl.l = Math.min(1, Math.max(0, hsl.l));
	    return new Color(hsl);
	  };
	
	  Color.prototype.brighten = function(amount) {
	    var rgb;
	    if (amount == null) {
	      amount = 10;
	    }
	    rgb = this.toRgb();
	    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
	    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
	    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
	    return new Color(rgb);
	  };
	
	  Color.prototype.darken = function(amount) {
	    var hsl;
	    if (amount == null) {
	      amount = 10;
	    }
	    hsl = this.toHsl();
	    hsl.l -= amount / 100;
	    hsl.l = Math.min(1, Math.max(0, hsl.l));
	    return new Color(hsl);
	  };
	
	  Color.prototype.desaturate = function(amount) {
	    var hsl;
	    if (amount == null) {
	      amount = 10;
	    }
	    hsl = this.toHsl();
	    hsl.s -= amount / 100;
	    hsl.s = Math.min(1, Math.max(0, hsl.s));
	    return new Color(hsl);
	  };
	
	  Color.prototype.saturate = function(amount) {
	    var hsl;
	    if (amount == null) {
	      amount = 10;
	    }
	    hsl = this.toHsl();
	    hsl.s += amount / 100;
	    hsl.s = Math.min(1, Math.max(0, hsl.s));
	    return new Color(hsl);
	  };
	
	  Color.prototype.grayscale = function() {
	    var hsl;
	    hsl = this.toHsl();
	    return new Color(hsl).desaturate(100);
	  };
	
	  Color.prototype.toString = function() {
	    return this.toRgbString();
	  };
	
	  Color.prototype.alpha = function(alpha) {
	    var result;
	    if (alpha == null) {
	      alpha = 1;
	    }
	    return result = new Color({
	      r: this.r,
	      g: this.g,
	      b: this.b,
	      a: alpha
	    });
	  };
	
	  Color.prototype.transparent = function() {
	    return this.alpha(0);
	  };
	
	  Color.prototype.mix = function(colorB, fraction, limit, model) {
	    if (limit == null) {
	      limit = false;
	    }
	    return Color.mix(this, colorB, fraction, limit, model);
	  };
	
	  Color.prototype.copy = function() {
	    return new Color(this);
	  };
	
	  Color.prototype.isEqual = function(colorB) {
	    return Color.equal(this, colorB);
	  };
	
	  Color.prototype.toInspect = function() {
	    if (this._type === ColorType.HSL) {
	      return "<" + this.constructor.name + " h:" + this.h + " s:" + this.s + " l:" + this.l + " a:" + this.a + ">";
	    } else if (this._type === ColorType.HEX || this._type === ColorType.NAME) {
	      return "<" + this.constructor.name + " \"" + this.color + "\">";
	    } else {
	      return "<" + this.constructor.name + " r:" + this.r + " g:" + this.g + " b:" + this.b + " a:" + this.a + ">";
	    }
	  };
	
	  Color.mix = function(colorA, colorB, fraction, limit, model) {
	    var deltaH, fromH, hslA, hslB, result, toH, tween;
	    if (fraction == null) {
	      fraction = .5;
	    }
	    if (limit == null) {
	      limit = false;
	    }
	    result = null;
	    if (typeof colorA === "string" && this.isColorString(colorA)) {
	      colorA = new Color(colorA);
	    }
	    if (typeof colorB === "string" && this.isColorString(colorB)) {
	      colorB = new Color(colorB);
	    }
	    if (!(colorA instanceof Color) && colorB instanceof Color) {
	      colorA = colorB.transparent();
	    } else if (colorA instanceof Color && colorA._a === 0 && colorB instanceof Color && colorB._a !== 0) {
	      colorA = colorB.transparent();
	    } else if (!(colorB instanceof Color) && colorA instanceof Color) {
	      colorB = colorA.transparent();
	    } else if (colorB instanceof Color && colorB._a === 0 && colorA instanceof Color && colorA._a !== 0) {
	      colorB = colorA.transparent();
	    }
	    if (colorB instanceof Color) {
	      if (ColorModel.isRGB(model)) {
	        result = new Color({
	          r: Utils.modulate(fraction, [0, 1], [colorA._r, colorB._r], limit),
	          g: Utils.modulate(fraction, [0, 1], [colorA._g, colorB._g], limit),
	          b: Utils.modulate(fraction, [0, 1], [colorA._b, colorB._b], limit),
	          a: Utils.modulate(fraction, [0, 1], [colorA._a, colorB._a], limit)
	        });
	      } else {
	        hslA;
	        hslB;
	        if (ColorModel.isHSL(model)) {
	          hslA = colorA.toHsl();
	          hslB = colorB.toHsl();
	        } else {
	          hslA = colorA.toHusl();
	          hslB = colorB.toHusl();
	        }
	        if (hslA.s === 0) {
	          hslA.h = hslB.h;
	        } else if (hslB.s === 0) {
	          hslB.h = hslA.h;
	        }
	        fromH = hslA.h;
	        toH = hslB.h;
	        deltaH = toH - fromH;
	        if (deltaH > 180) {
	          deltaH = (toH - 360) - fromH;
	        } else if (deltaH < -180) {
	          deltaH = (toH + 360) - fromH;
	        }
	        tween = {
	          h: Utils.modulate(fraction, [0, 1], [fromH, fromH + deltaH], limit),
	          s: Utils.modulate(fraction, [0, 1], [hslA.s, hslB.s], limit),
	          l: Utils.modulate(fraction, [0, 1], [hslA.l, hslB.l], limit),
	          a: Utils.modulate(fraction, [0, 1], [colorA.a, colorB.a], limit)
	        };
	        if (ColorModel.isHSL(model)) {
	          result = new Color(tween);
	        } else {
	          result = new Color(rgbaFromHusl(tween));
	        }
	      }
	    }
	    return result;
	  };
	
	  Color.random = function(alpha) {
	    var c;
	    if (alpha == null) {
	      alpha = 1.0;
	    }
	    c = function() {
	      return parseInt(Math.random() * 255);
	    };
	    return new Color("rgba(" + (c()) + ", " + (c()) + ", " + (c()) + ", " + alpha + ")");
	  };
	
	  Color.grey = function(g, alpha) {
	    if (g == null) {
	      g = 0.5;
	    }
	    if (alpha == null) {
	      alpha = 1;
	    }
	    g = parseInt(g * 255);
	    return new Color("rgba(" + g + ", " + g + ", " + g + ", " + alpha + ")");
	  };
	
	  Color.gray = function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    return this.grey.apply(this, args);
	  };
	
	  Color.toColor = function(color) {
	    return new Color(color);
	  };
	
	  Color.validColorValue = function(color) {
	    return color instanceof Color || color === null;
	  };
	
	  Color.isColor = function(color) {
	    if (_.isString(color)) {
	      return this.isColorString(color);
	    } else {
	      return this.isColorObject(color);
	    }
	  };
	
	  Color.isColorObject = function(color) {
	    return color instanceof Color;
	  };
	
	  Color.isColorString = function(colorString) {
	    if (_.isString(colorString)) {
	      return stringToObject(colorString) !== false;
	    }
	    return false;
	  };
	
	  Color.isValidColorProperty = function(name, value) {
	    if (_.endsWith(name.toLowerCase(), "color") && _.isString(value) && Color.isColorString(value)) {
	      return true;
	    }
	    return false;
	  };
	
	  Color.equal = function(colorA, colorB) {
	    if (!this.validColorValue(colorA)) {
	      if (!Color.isColorString(colorA)) {
	        return false;
	      }
	    }
	    if (!this.validColorValue(colorB)) {
	      if (!Color.isColorString(colorB)) {
	        return false;
	      }
	    }
	    colorA = new Color(colorA);
	    colorB = new Color(colorB);
	    if (colorA.r !== colorB.r) {
	      return false;
	    }
	    if (colorA.g !== colorB.g) {
	      return false;
	    }
	    if (colorA.b !== colorB.b) {
	      return false;
	    }
	    if (colorA.a !== colorB.a) {
	      return false;
	    }
	    return true;
	  };
	
	  Color.rgbToHsl = function(a, b, c) {
	    return rgbToHsl(a, b, c);
	  };
	
	  return Color;
	
	})(BaseClass);
	
	ColorModel = {
	  RGB: "rgb",
	  RGBA: "rgba",
	  HSL: "hsl",
	  HSLA: "hsla"
	};
	
	ColorModel.isRGB = function(colorModel) {
	  var ref;
	  if (_.isString(colorModel)) {
	    return (ref = colorModel.toLowerCase()) === ColorModel.RGB || ref === ColorModel.RGBA;
	  }
	  return false;
	};
	
	ColorModel.isHSL = function(colorModel) {
	  var ref;
	  if (_.isString(colorModel)) {
	    return (ref = colorModel.toLowerCase()) === ColorModel.HSL || ref === ColorModel.HSLA;
	  }
	  return false;
	};
	
	rgbaFromHusl = function(husl) {
	  var c, rgb, rgba;
	  c = libhusl._conv;
	  rgb = c.xyz.rgb(c.luv.xyz(c.lch.luv(c.husl.lch([husl.h, husl.s, husl.l]))));
	  rgba = {
	    r: rgb[0] * 255,
	    g: rgb[1] * 255,
	    b: rgb[2] * 255,
	    a: husl.a
	  };
	  return rgba;
	};
	
	inputData = function(color, g, b, alpha) {
	  var a, h, hsl, l, ok, rgb, s, type;
	  rgb = {
	    r: 0,
	    g: 0,
	    b: 0
	  };
	  hsl = {
	    h: 0,
	    s: 0,
	    l: 0
	  };
	  a = 1;
	  ok = false;
	  type = ColorType.RGB;
	  if (color === null) {
	    a = 0;
	  } else if (_.isNumber(color)) {
	    rgb.r = color;
	    if (_.isNumber(g)) {
	      rgb.g = g;
	    }
	    if (_.isNumber(b)) {
	      rgb.b = b;
	    }
	    if (_.isNumber(alpha)) {
	      a = alpha;
	    }
	  } else {
	    if (typeof color === "string") {
	      color = stringToObject(color);
	      if (!color) {
	        color = {
	          r: 0,
	          g: 0,
	          b: 0,
	          a: 0
	        };
	      }
	      if (color.hasOwnProperty("type")) {
	        type = color.type;
	      }
	    }
	    if (typeof color === "object") {
	      if (color.hasOwnProperty("r") || color.hasOwnProperty("g") || color.hasOwnProperty("b")) {
	        rgb = rgbToRgb(color.r, color.g, color.b);
	      } else if (color.hasOwnProperty("h") || color.hasOwnProperty("s") || color.hasOwnProperty("l")) {
	        h = isNumeric(color.h) ? parseFloat(color.h) : 0;
	        h = (h + 360) % 360;
	        s = isNumeric(color.s) ? color.s : 1;
	        if (_.isString(color.s)) {
	          s = numberFromString(color.s);
	        }
	        l = isNumeric(color.l) ? color.l : 0.5;
	        if (_.isString(color.l)) {
	          l = numberFromString(color.l);
	        }
	        rgb = hslToRgb(h, s, l);
	        type = ColorType.HSL;
	        hsl = {
	          h: h,
	          s: s,
	          l: l
	        };
	      }
	      if (color.hasOwnProperty("a")) {
	        a = color.a;
	      }
	    }
	  }
	  a = correctAlpha(a);
	  if (type !== ColorType.HSL) {
	    hsl = rgbToHsl(rgb.r, rgb.g, rgb.b);
	  }
	  return {
	    type: type,
	    r: Math.min(255, Math.max(rgb.r, 0)),
	    g: Math.min(255, Math.max(rgb.g, 0)),
	    b: Math.min(255, Math.max(rgb.b, 0)),
	    h: Utils.clamp(hsl.h, 0, 360),
	    s: Utils.clamp(hsl.s, 0, 1),
	    l: Utils.clamp(hsl.l, 0, 1),
	    a: a
	  };
	};
	
	numberFromString = function(string) {
	  return string.match(/\d+/)[0];
	};
	
	rgbToRgb = function(r, g, b) {
	  return {
	    r: isNumeric(r) ? bound01(r, 255) * 255 : 0,
	    g: isNumeric(g) ? bound01(g, 255) * 255 : 0,
	    b: isNumeric(b) ? bound01(b, 255) * 255 : 0
	  };
	};
	
	rgbToHex = function(r, g, b, allow3Char) {
	  var hex;
	  hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
	  if (allow3Char && hex[0].charAt(0) === hex[0].charAt(1) && hex[1].charAt(0) === hex[1].charAt(1) && hex[2].charAt(0) === hex[2].charAt(1)) {
	    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
	  }
	  return hex.join("");
	};
	
	rgbToHsl = function(r, g, b) {
	  var d, h, l, max, min, s;
	  r = bound01(r, 255);
	  g = bound01(g, 255);
	  b = bound01(b, 255);
	  max = Math.max(r, g, b);
	  min = Math.min(r, g, b);
	  h = s = l = (max + min) / 2;
	  if (max === min) {
	    h = s = 0;
	  } else {
	    d = max - min;
	    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	    switch (max) {
	      case r:
	        h = (g - b) / d + (g < b ? 6 : 0);
	        break;
	      case g:
	        h = (b - r) / d + 2;
	        break;
	      case b:
	        h = (r - g) / d + 4;
	    }
	    h /= 6;
	  }
	  return {
	    h: h * 360,
	    s: s,
	    l: l
	  };
	};
	
	hslToRgb = function(h, s, l) {
	  var b, g, hue2rgb, p, q, r;
	  r = void 0;
	  g = void 0;
	  b = void 0;
	  h = bound01(h, 360);
	  s = bound01(s * 100, 100);
	  l = bound01(l * 100, 100);
	  hue2rgb = function(p, q, t) {
	    if (t < 0) {
	      t += 1;
	    }
	    if (t > 1) {
	      t -= 1;
	    }
	    if (t < 1 / 6) {
	      return p + (q - p) * 6 * t;
	    }
	    if (t < 1 / 2) {
	      return q;
	    }
	    if (t < 2 / 3) {
	      return p + (q - p) * (2 / 3 - t) * 6;
	    }
	    return p;
	  };
	  if (s === 0) {
	    r = g = b = l;
	  } else {
	    q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	    p = 2 * l - q;
	    r = hue2rgb(p, q, h + 1 / 3);
	    g = hue2rgb(p, q, h);
	    b = hue2rgb(p, q, h - (1 / 3));
	  }
	  return {
	    r: r * 255,
	    g: g * 255,
	    b: b * 255
	  };
	};
	
	convertToPercentage = function(n) {
	  if (n <= 1) {
	    n = n * 100 + "%";
	  }
	  return n;
	};
	
	correctAlpha = function(a) {
	  a = parseFloat(a);
	  if (a < 0) {
	    a = 0;
	  }
	  if (isNaN(a) || a > 1) {
	    a = 1;
	  }
	  return a;
	};
	
	bound01 = function(n, max) {
	  var processPercent;
	  if (isOnePointZero(n)) {
	    n = "100%";
	  }
	  processPercent = isPercentage(n);
	  n = Math.min(max, Math.max(0, parseFloat(n)));
	  if (processPercent) {
	    n = parseInt(n * max, 10) / 100;
	  }
	  if (Math.abs(n - max) < 0.000001) {
	    return 1;
	  }
	  return n % max / parseFloat(max);
	};
	
	isOnePointZero = function(n) {
	  return typeof n === "string" && n.indexOf(".") !== -1 && parseFloat(n) === 1;
	};
	
	isPercentage = function(n) {
	  return typeof n === "string" && n.indexOf("%") !== -1;
	};
	
	pad2 = function(char) {
	  if (char.length === 1) {
	    return "0" + char;
	  } else {
	    return "" + char;
	  }
	};
	
	matchers = (function() {
	  var css_integer, css_number, css_unit, permissive_match3, permissive_match4;
	  css_integer = "[-\\+]?\\d+%?";
	  css_number = "[-\\+]?\\d*\\.\\d+%?";
	  css_unit = "(?:" + css_number + ")|(?:" + css_integer + ")";
	  permissive_match3 = "[\\s|\\(]+(" + css_unit + ")[,|\\s]+(" + css_unit + ")[,|\\s]+(" + css_unit + ")\\s*\\)?";
	  permissive_match4 = "[\\s|\\(]+(" + css_unit + ")[,|\\s]+(" + css_unit + ")[,|\\s]+(" + css_unit + ")[,|\\s]+(" + css_unit + ")\\s*\\)?";
	  return {
	    rgb: new RegExp("rgb" + permissive_match3),
	    rgba: new RegExp("rgba" + permissive_match4),
	    hsl: new RegExp("hsl" + permissive_match3),
	    hsla: new RegExp("hsla" + permissive_match4),
	    hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	    hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
	  };
	})();
	
	isNumeric = function(value) {
	  return !isNaN(value) && isFinite(value);
	};
	
	percentToFraction = function(percentage) {
	  return numberFromString(percentage) / 100;
	};
	
	stringToObject = function(color) {
	  var match, named, trimLeft, trimRight;
	  trimLeft = /^[\s,#]+/;
	  trimRight = /\s+$/;
	  color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
	  named = false;
	  if (cssNames[color]) {
	    color = cssNames[color];
	    named = true;
	    ({
	      type: ColorType.NAME
	    });
	  } else if (color === "transparent") {
	    return {
	      r: 0,
	      g: 0,
	      b: 0,
	      a: 0,
	      type: ColorType.NAME
	    };
	  }
	  match = void 0;
	  if (match = matchers.rgb.exec(color)) {
	    return {
	      r: match[1],
	      g: match[2],
	      b: match[3]
	    };
	  }
	  if (match = matchers.rgba.exec(color)) {
	    return {
	      r: match[1],
	      g: match[2],
	      b: match[3],
	      a: match[4]
	    };
	  }
	  if (match = matchers.hsl.exec(color)) {
	    return {
	      h: match[1],
	      s: percentToFraction(match[2]),
	      l: percentToFraction(match[3])
	    };
	  }
	  if (match = matchers.hsla.exec(color)) {
	    return {
	      h: match[1],
	      s: percentToFraction(match[2]),
	      l: percentToFraction(match[3]),
	      a: match[4]
	    };
	  }
	  if (match = matchers.hex6.exec(color) || (match = matchers.hex6.exec(cssNames[color]))) {
	    return {
	      r: parseInt(match[1], 16),
	      g: parseInt(match[2], 16),
	      b: parseInt(match[3], 16),
	      a: 1,
	      type: ColorType.HEX
	    };
	  }
	  if (match = matchers.hex3.exec(color) || (match = matchers.hex3.exec(cssNames[color]))) {
	    return {
	      r: parseInt(match[1] + "" + match[1], 16),
	      g: parseInt(match[2] + "" + match[2], 16),
	      b: parseInt(match[3] + "" + match[3], 16),
	      type: ColorType.HEX
	    };
	  } else {
	    return false;
	  }
	};
	
	cssNames = {
	  aliceblue: "f0f8ff",
	  antiquewhite: "faebd7",
	  aqua: "0ff",
	  aquamarine: "7fffd4",
	  azure: "f0ffff",
	  beige: "f5f5dc",
	  bisque: "ffe4c4",
	  black: "000",
	  blanchedalmond: "ffebcd",
	  blue: "00f",
	  blueviolet: "8a2be2",
	  brown: "a52a2a",
	  burlywood: "deb887",
	  burntsienna: "ea7e5d",
	  cadetblue: "5f9ea0",
	  chartreuse: "7fff00",
	  chocolate: "d2691e",
	  coral: "ff7f50",
	  cornflowerblue: "6495ed",
	  cornsilk: "fff8dc",
	  crimson: "dc143c",
	  cyan: "0ff",
	  darkblue: "00008b",
	  darkcyan: "008b8b",
	  darkgoldenrod: "b8860b",
	  darkgray: "a9a9a9",
	  darkgreen: "006400",
	  darkgrey: "a9a9a9",
	  darkkhaki: "bdb76b",
	  darkmagenta: "8b008b",
	  darkolivegreen: "556b2f",
	  darkorange: "ff8c00",
	  darkorchid: "9932cc",
	  darkred: "8b0000",
	  darksalmon: "e9967a",
	  darkseagreen: "8fbc8f",
	  darkslateblue: "483d8b",
	  darkslategray: "2f4f4f",
	  darkslategrey: "2f4f4f",
	  darkturquoise: "00ced1",
	  darkviolet: "9400d3",
	  deeppink: "ff1493",
	  deepskyblue: "00bfff",
	  dimgray: "696969",
	  dimgrey: "696969",
	  dodgerblue: "1e90ff",
	  firebrick: "b22222",
	  floralwhite: "fffaf0",
	  forestgreen: "228b22",
	  fuchsia: "f0f",
	  gainsboro: "dcdcdc",
	  ghostwhite: "f8f8ff",
	  gold: "ffd700",
	  goldenrod: "daa520",
	  gray: "808080",
	  green: "008000",
	  greenyellow: "adff2f",
	  grey: "808080",
	  honeydew: "f0fff0",
	  hotpink: "ff69b4",
	  indianred: "cd5c5c",
	  indigo: "4b0082",
	  ivory: "fffff0",
	  khaki: "f0e68c",
	  lavender: "e6e6fa",
	  lavenderblush: "fff0f5",
	  lawngreen: "7cfc00",
	  lemonchiffon: "fffacd",
	  lightblue: "add8e6",
	  lightcoral: "f08080",
	  lightcyan: "e0ffff",
	  lightgoldenrodyellow: "fafad2",
	  lightgray: "d3d3d3",
	  lightgreen: "90ee90",
	  lightgrey: "d3d3d3",
	  lightpink: "ffb6c1",
	  lightsalmon: "ffa07a",
	  lightseagreen: "20b2aa",
	  lightskyblue: "87cefa",
	  lightslategray: "789",
	  lightslategrey: "789",
	  lightsteelblue: "b0c4de",
	  lightyellow: "ffffe0",
	  lime: "0f0",
	  limegreen: "32cd32",
	  linen: "faf0e6",
	  magenta: "f0f",
	  maroon: "800000",
	  mediumaquamarine: "66cdaa",
	  mediumblue: "0000cd",
	  mediumorchid: "ba55d3",
	  mediumpurple: "9370db",
	  mediumseagreen: "3cb371",
	  mediumslateblue: "7b68ee",
	  mediumspringgreen: "00fa9a",
	  mediumturquoise: "48d1cc",
	  mediumvioletred: "c71585",
	  midnightblue: "191970",
	  mintcream: "f5fffa",
	  mistyrose: "ffe4e1",
	  moccasin: "ffe4b5",
	  navajowhite: "ffdead",
	  navy: "000080",
	  oldlace: "fdf5e6",
	  olive: "808000",
	  olivedrab: "6b8e23",
	  orange: "ffa500",
	  orangered: "ff4500",
	  orchid: "da70d6",
	  palegoldenrod: "eee8aa",
	  palegreen: "98fb98",
	  paleturquoise: "afeeee",
	  palevioletred: "db7093",
	  papayawhip: "ffefd5",
	  peachpuff: "ffdab9",
	  peru: "cd853f",
	  pink: "ffc0cb",
	  plum: "dda0dd",
	  powderblue: "b0e0e6",
	  purple: "800080",
	  rebeccapurple: "663399",
	  red: "f00",
	  rosybrown: "bc8f8f",
	  royalblue: "4169e1",
	  saddlebrown: "8b4513",
	  salmon: "fa8072",
	  sandybrown: "f4a460",
	  seagreen: "2e8b57",
	  seashell: "fff5ee",
	  sienna: "a0522d",
	  silver: "c0c0c0",
	  skyblue: "87ceeb",
	  slateblue: "6a5acd",
	  slategray: "708090",
	  slategrey: "708090",
	  snow: "fffafa",
	  springgreen: "00ff7f",
	  steelblue: "4682b4",
	  tan: "d2b48c",
	  teal: "008080",
	  thistle: "d8bfd8",
	  tomato: "ff6347",
	  turquoise: "40e0d0",
	  violet: "ee82ee",
	  wheat: "f5deb3",
	  white: "fff",
	  whitesmoke: "f5f5f5",
	  yellow: "ff0",
	  yellowgreen: "9acd32"
	};


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {// Generated by CoffeeScript 1.9.3
	(function() {
	  var L_to_Y, Y_to_L, conv, distanceFromPole, dotProduct, epsilon, fromLinear, getBounds, intersectLineLine, kappa, lengthOfRayUntilIntersect, m, m_inv, maxChromaForLH, maxSafeChromaForL, refU, refV, root, toLinear;
	
	  m = {
	    R: [3.2409699419045214, -1.5373831775700935, -0.49861076029300328],
	    G: [-0.96924363628087983, 1.8759675015077207, 0.041555057407175613],
	    B: [0.055630079696993609, -0.20397695888897657, 1.0569715142428786]
	  };
	
	  m_inv = {
	    X: [0.41239079926595948, 0.35758433938387796, 0.18048078840183429],
	    Y: [0.21263900587151036, 0.71516867876775593, 0.072192315360733715],
	    Z: [0.019330818715591851, 0.11919477979462599, 0.95053215224966058]
	  };
	
	  refU = 0.19783000664283681;
	
	  refV = 0.468319994938791;
	
	  kappa = 903.2962962962963;
	
	  epsilon = 0.0088564516790356308;
	
	  getBounds = function(L) {
	    var bottom, channel, j, k, len1, len2, m1, m2, m3, ref, ref1, ref2, ret, sub1, sub2, t, top1, top2;
	    sub1 = Math.pow(L + 16, 3) / 1560896;
	    sub2 = sub1 > epsilon ? sub1 : L / kappa;
	    ret = [];
	    ref = ['R', 'G', 'B'];
	    for (j = 0, len1 = ref.length; j < len1; j++) {
	      channel = ref[j];
	      ref1 = m[channel], m1 = ref1[0], m2 = ref1[1], m3 = ref1[2];
	      ref2 = [0, 1];
	      for (k = 0, len2 = ref2.length; k < len2; k++) {
	        t = ref2[k];
	        top1 = (284517 * m1 - 94839 * m3) * sub2;
	        top2 = (838422 * m3 + 769860 * m2 + 731718 * m1) * L * sub2 - 769860 * t * L;
	        bottom = (632260 * m3 - 126452 * m2) * sub2 + 126452 * t;
	        ret.push([top1 / bottom, top2 / bottom]);
	      }
	    }
	    return ret;
	  };
	
	  intersectLineLine = function(line1, line2) {
	    return (line1[1] - line2[1]) / (line2[0] - line1[0]);
	  };
	
	  distanceFromPole = function(point) {
	    return Math.sqrt(Math.pow(point[0], 2) + Math.pow(point[1], 2));
	  };
	
	  lengthOfRayUntilIntersect = function(theta, line) {
	    var b1, len, m1;
	    m1 = line[0], b1 = line[1];
	    len = b1 / (Math.sin(theta) - m1 * Math.cos(theta));
	    if (len < 0) {
	      return null;
	    }
	    return len;
	  };
	
	  maxSafeChromaForL = function(L) {
	    var b1, j, len1, lengths, m1, ref, ref1, x;
	    lengths = [];
	    ref = getBounds(L);
	    for (j = 0, len1 = ref.length; j < len1; j++) {
	      ref1 = ref[j], m1 = ref1[0], b1 = ref1[1];
	      x = intersectLineLine([m1, b1], [-1 / m1, 0]);
	      lengths.push(distanceFromPole([x, b1 + x * m1]));
	    }
	    return Math.min.apply(Math, lengths);
	  };
	
	  maxChromaForLH = function(L, H) {
	    var hrad, j, l, len1, lengths, line, ref;
	    hrad = H / 360 * Math.PI * 2;
	    lengths = [];
	    ref = getBounds(L);
	    for (j = 0, len1 = ref.length; j < len1; j++) {
	      line = ref[j];
	      l = lengthOfRayUntilIntersect(hrad, line);
	      if (l !== null) {
	        lengths.push(l);
	      }
	    }
	    return Math.min.apply(Math, lengths);
	  };
	
	  dotProduct = function(a, b) {
	    var i, j, ref, ret;
	    ret = 0;
	    for (i = j = 0, ref = a.length - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
	      ret += a[i] * b[i];
	    }
	    return ret;
	  };
	
	  fromLinear = function(c) {
	    if (c <= 0.0031308) {
	      return 12.92 * c;
	    } else {
	      return 1.055 * Math.pow(c, 1 / 2.4) - 0.055;
	    }
	  };
	
	  toLinear = function(c) {
	    var a;
	    a = 0.055;
	    if (c > 0.04045) {
	      return Math.pow((c + a) / (1 + a), 2.4);
	    } else {
	      return c / 12.92;
	    }
	  };
	
	  conv = {
	    'xyz': {},
	    'luv': {},
	    'lch': {},
	    'husl': {},
	    'huslp': {},
	    'rgb': {},
	    'hex': {}
	  };
	
	  conv.xyz.rgb = function(tuple) {
	    var B, G, R;
	    R = fromLinear(dotProduct(m.R, tuple));
	    G = fromLinear(dotProduct(m.G, tuple));
	    B = fromLinear(dotProduct(m.B, tuple));
	    return [R, G, B];
	  };
	
	  conv.rgb.xyz = function(tuple) {
	    var B, G, R, X, Y, Z, rgbl;
	    R = tuple[0], G = tuple[1], B = tuple[2];
	    rgbl = [toLinear(R), toLinear(G), toLinear(B)];
	    X = dotProduct(m_inv.X, rgbl);
	    Y = dotProduct(m_inv.Y, rgbl);
	    Z = dotProduct(m_inv.Z, rgbl);
	    return [X, Y, Z];
	  };
	
	  Y_to_L = function(Y) {
	    if (Y <= epsilon) {
	      return Y * kappa;
	    } else {
	      return 116 * Math.pow(Y, 1 / 3) - 16;
	    }
	  };
	
	  L_to_Y = function(L) {
	    if (L <= 8) {
	      return L / kappa;
	    } else {
	      return Math.pow((L + 16) / 116, 3);
	    }
	  };
	
	  conv.xyz.luv = function(tuple) {
	    var L, U, V, X, Y, Z, varU, varV;
	    X = tuple[0], Y = tuple[1], Z = tuple[2];
	    if (Y === 0) {
	      return [0, 0, 0];
	    }
	    L = Y_to_L(Y);
	    varU = (4 * X) / (X + (15 * Y) + (3 * Z));
	    varV = (9 * Y) / (X + (15 * Y) + (3 * Z));
	    U = 13 * L * (varU - refU);
	    V = 13 * L * (varV - refV);
	    return [L, U, V];
	  };
	
	  conv.luv.xyz = function(tuple) {
	    var L, U, V, X, Y, Z, varU, varV;
	    L = tuple[0], U = tuple[1], V = tuple[2];
	    if (L === 0) {
	      return [0, 0, 0];
	    }
	    varU = U / (13 * L) + refU;
	    varV = V / (13 * L) + refV;
	    Y = L_to_Y(L);
	    X = 0 - (9 * Y * varU) / ((varU - 4) * varV - varU * varV);
	    Z = (9 * Y - (15 * varV * Y) - (varV * X)) / (3 * varV);
	    return [X, Y, Z];
	  };
	
	  conv.luv.lch = function(tuple) {
	    var C, H, Hrad, L, U, V;
	    L = tuple[0], U = tuple[1], V = tuple[2];
	    C = Math.sqrt(Math.pow(U, 2) + Math.pow(V, 2));
	    if (C < 0.00000001) {
	      H = 0;
	    } else {
	      Hrad = Math.atan2(V, U);
	      H = Hrad * 360 / 2 / Math.PI;
	      if (H < 0) {
	        H = 360 + H;
	      }
	    }
	    return [L, C, H];
	  };
	
	  conv.lch.luv = function(tuple) {
	    var C, H, Hrad, L, U, V;
	    L = tuple[0], C = tuple[1], H = tuple[2];
	    Hrad = H / 360 * 2 * Math.PI;
	    U = Math.cos(Hrad) * C;
	    V = Math.sin(Hrad) * C;
	    return [L, U, V];
	  };
	
	  conv.husl.lch = function(tuple) {
	    var C, H, L, S, max;
	    H = tuple[0], S = tuple[1], L = tuple[2];
	    if (L > 99.9999999 || L < 0.00000001) {
	      C = 0;
	    } else {
	      max = maxChromaForLH(L, H);
	      C = max / 100 * S;
	    }
	    return [L, C, H];
	  };
	
	  conv.lch.husl = function(tuple) {
	    var C, H, L, S, max;
	    L = tuple[0], C = tuple[1], H = tuple[2];
	    if (L > 99.9999999 || L < 0.00000001) {
	      S = 0;
	    } else {
	      max = maxChromaForLH(L, H);
	      S = C / max * 100;
	    }
	    return [H, S, L];
	  };
	
	  conv.huslp.lch = function(tuple) {
	    var C, H, L, S, max;
	    H = tuple[0], S = tuple[1], L = tuple[2];
	    if (L > 99.9999999 || L < 0.00000001) {
	      C = 0;
	    } else {
	      max = maxSafeChromaForL(L);
	      C = max / 100 * S;
	    }
	    return [L, C, H];
	  };
	
	  conv.lch.huslp = function(tuple) {
	    var C, H, L, S, max;
	    L = tuple[0], C = tuple[1], H = tuple[2];
	    if (L > 99.9999999 || L < 0.00000001) {
	      S = 0;
	    } else {
	      max = maxSafeChromaForL(L);
	      S = C / max * 100;
	    }
	    return [H, S, L];
	  };
	
	  conv.rgb.hex = function(tuple) {
	    var ch, hex, j, len1;
	    hex = "#";
	    for (j = 0, len1 = tuple.length; j < len1; j++) {
	      ch = tuple[j];
	      ch = Math.round(ch * 1e6) / 1e6;
	      if (ch < 0 || ch > 1) {
	        throw new Error("Illegal rgb value: " + ch);
	      }
	      ch = Math.round(ch * 255).toString(16);
	      if (ch.length === 1) {
	        ch = "0" + ch;
	      }
	      hex += ch;
	    }
	    return hex;
	  };
	
	  conv.hex.rgb = function(hex) {
	    var b, g, j, len1, n, r, ref, results;
	    if (hex.charAt(0) === "#") {
	      hex = hex.substring(1, 7);
	    }
	    r = hex.substring(0, 2);
	    g = hex.substring(2, 4);
	    b = hex.substring(4, 6);
	    ref = [r, g, b];
	    results = [];
	    for (j = 0, len1 = ref.length; j < len1; j++) {
	      n = ref[j];
	      results.push(parseInt(n, 16) / 255);
	    }
	    return results;
	  };
	
	  conv.lch.rgb = function(tuple) {
	    return conv.xyz.rgb(conv.luv.xyz(conv.lch.luv(tuple)));
	  };
	
	  conv.rgb.lch = function(tuple) {
	    return conv.luv.lch(conv.xyz.luv(conv.rgb.xyz(tuple)));
	  };
	
	  conv.husl.rgb = function(tuple) {
	    return conv.lch.rgb(conv.husl.lch(tuple));
	  };
	
	  conv.rgb.husl = function(tuple) {
	    return conv.lch.husl(conv.rgb.lch(tuple));
	  };
	
	  conv.huslp.rgb = function(tuple) {
	    return conv.lch.rgb(conv.huslp.lch(tuple));
	  };
	
	  conv.rgb.huslp = function(tuple) {
	    return conv.lch.huslp(conv.rgb.lch(tuple));
	  };
	
	  root = {};
	
	  root.fromRGB = function(R, G, B) {
	    return conv.rgb.husl([R, G, B]);
	  };
	
	  root.fromHex = function(hex) {
	    return conv.rgb.husl(conv.hex.rgb(hex));
	  };
	
	  root.toRGB = function(H, S, L) {
	    return conv.husl.rgb([H, S, L]);
	  };
	
	  root.toHex = function(H, S, L) {
	    return conv.rgb.hex(conv.husl.rgb([H, S, L]));
	  };
	
	  root.p = {};
	
	  root.p.toRGB = function(H, S, L) {
	    return conv.xyz.rgb(conv.luv.xyz(conv.lch.luv(conv.huslp.lch([H, S, L]))));
	  };
	
	  root.p.toHex = function(H, S, L) {
	    return conv.rgb.hex(conv.xyz.rgb(conv.luv.xyz(conv.lch.luv(conv.huslp.lch([H, S, L])))));
	  };
	
	  root.p.fromRGB = function(R, G, B) {
	    return conv.lch.huslp(conv.luv.lch(conv.xyz.luv(conv.rgb.xyz([R, G, B]))));
	  };
	
	  root.p.fromHex = function(hex) {
	    return conv.lch.huslp(conv.luv.lch(conv.xyz.luv(conv.rgb.xyz(conv.hex.rgb(hex)))));
	  };
	
	  root._conv = conv;
	
	  root._getBounds = getBounds;
	
	  root._maxChromaForLH = maxChromaForLH;
	
	  root._maxSafeChromaForL = maxSafeChromaForL;
	
	  if (!((typeof module !== "undefined" && module !== null) || (typeof jQuery !== "undefined" && jQuery !== null) || (typeof requirejs !== "undefined" && requirejs !== null))) {
	    this.HUSL = root;
	  }
	
	  if (typeof module !== "undefined" && module !== null) {
	    module.exports = root;
	  }
	
	  if (typeof jQuery !== "undefined" && jQuery !== null) {
	    jQuery.husl = root;
	  }
	
	  if ((typeof requirejs !== "undefined" && requirejs !== null) && ("function" !== "undefined" && __webpack_require__(12) !== null)) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (root), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)(module)))

/***/ },
/* 12 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var Animation, BaseClass, Color, Config, Defaults, EventEmitter, Events, Gestures, LayerDraggable, LayerPinchable, LayerStates, LayerStyle, Matrix, NoCacheDateKey, Utils, _, layerProperty, layerPropertyIgnore, layerPropertyPointTransformer, layerValueTypeError,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
	  slice = [].slice;
	
	_ = __webpack_require__(1)._;
	
	Utils = __webpack_require__(4);
	
	Config = __webpack_require__(14).Config;
	
	Events = __webpack_require__(15).Events;
	
	Defaults = __webpack_require__(17).Defaults;
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	EventEmitter = __webpack_require__(7).EventEmitter;
	
	Color = __webpack_require__(10).Color;
	
	Matrix = __webpack_require__(9).Matrix;
	
	Animation = __webpack_require__(18).Animation;
	
	LayerStyle = __webpack_require__(26).LayerStyle;
	
	LayerStates = __webpack_require__(27).LayerStates;
	
	LayerDraggable = __webpack_require__(29).LayerDraggable;
	
	LayerPinchable = __webpack_require__(36).LayerPinchable;
	
	Gestures = __webpack_require__(16).Gestures;
	
	NoCacheDateKey = Date.now();
	
	layerValueTypeError = function(name, value) {
	  throw new Error("Layer." + name + ": value '" + value + "' of type '" + (typeof value) + "'' is not valid");
	};
	
	layerProperty = function(obj, name, cssProperty, fallback, validator, transformer, options, set) {
	  var result;
	  if (options == null) {
	    options = {};
	  }
	  result = {
	    "default": fallback,
	    get: function() {
	      if (this._properties.hasOwnProperty(name)) {
	        return this._properties[name];
	      }
	      return fallback;
	    },
	    set: function(value) {
	      if (transformer) {
	        value = transformer(value, this, name);
	      }
	      if (value === this._properties[name]) {
	        return;
	      }
	      if (value && validator && !validator(value)) {
	        layerValueTypeError(name, value);
	      }
	      this._properties[name] = value;
	      if (cssProperty !== null) {
	        this._element.style[cssProperty] = LayerStyle[cssProperty](this);
	      }
	      if (typeof set === "function") {
	        set(this, value);
	      }
	      if (this.__constructor) {
	        return;
	      }
	      this.emit("change:" + name, value);
	      if (name === "x" || name === "y") {
	        this.emit("change:point", value);
	      }
	      if (name === "width" || name === "height") {
	        this.emit("change:size", value);
	      }
	      if (name === "x" || name === "y" || name === "width" || name === "height") {
	        this.emit("change:frame", value);
	      }
	      if (name === "rotationZ") {
	        return this.emit("change:rotation", value);
	      }
	    }
	  };
	  return result = _.extend(result, options);
	};
	
	layerPropertyPointTransformer = function(value, layer, property) {
	  if (_.isFunction(value)) {
	    value = value(layer, property);
	  }
	  return value;
	};
	
	layerPropertyIgnore = function(options, propertyName, properties) {
	  var i, len, p;
	  if (!options.hasOwnProperty(propertyName)) {
	    return options;
	  }
	  for (i = 0, len = properties.length; i < len; i++) {
	    p = properties[i];
	    if (options.hasOwnProperty(p)) {
	      delete options[propertyName];
	      return options;
	    }
	  }
	  return options;
	};
	
	exports.Layer = (function(superClass) {
	  extend(Layer, superClass);
	
	  function Layer(options) {
	    var i, len, p, ref;
	    if (options == null) {
	      options = {};
	    }
	    this.addListener = bind(this.addListener, this);
	    this.once = bind(this.once, this);
	    this.convertPointToLayer = bind(this.convertPointToLayer, this);
	    this.convertPointToCanvas = bind(this.convertPointToCanvas, this);
	    this.convertPointToScreen = bind(this.convertPointToScreen, this);
	    if (this.__constructorCalled) {
	      throw Error("Layer.constructor " + (this.toInspect()) + " called twice");
	    }
	    this.__constructorCalled = true;
	    this.__constructor = true;
	    this._properties = {};
	    this._style = {};
	    this._children = [];
	    this._prefer2d = false;
	    this._alwaysUseImageCache = false;
	    this._cancelClickEventInDragSession = true;
	    this._cancelClickEventInDragSessionVelocity = 0.1;
	    this._cancelClickEventInDragSessionOffset = 8;
	    this._createElement();
	    layerPropertyIgnore(options, "point", ["x", "y"]);
	    layerPropertyIgnore(options, "size", ["width", "height"]);
	    layerPropertyIgnore(options, "frame", ["x", "y", "width", "height"]);
	    if (!options.hasOwnProperty("parent") && options.hasOwnProperty("superLayer")) {
	      options.parent = options.superLayer;
	      delete options.superLayer;
	    }
	    Layer.__super__.constructor.call(this, Defaults.getDefaults("Layer", options));
	    this._context.addLayer(this);
	    this._id = this._context.layerCounter;
	    if (!options.parent) {
	      if (!options.shadow) {
	        this._insertElement();
	      }
	    } else {
	      this.parent = options.parent;
	    }
	    if (options.hasOwnProperty("index")) {
	      this.index = options.index;
	    }
	    ref = ["x", "y", "width", "height"];
	    for (i = 0, len = ref.length; i < len; i++) {
	      p = ref[i];
	      if (options.hasOwnProperty(p)) {
	        this[p] = options[p];
	      }
	    }
	    this._context.emit("layer:create", this);
	    this.label = this.label;
	    delete this.__constructor;
	  }
	
	  Layer.define("context", {
	    get: function() {
	      return this._context;
	    }
	  });
	
	  Layer.define("label", {
	    get: function() {
	      return this._label;
	    },
	    set: function(value) {
	      if (value == null) {
	        value = "";
	      }
	      this._label = value;
	      return Utils.labelLayer(this, this._label);
	    }
	  });
	
	  Layer.define("custom", Layer.simpleProperty("custom", void 0));
	
	  Layer.define("animationOptions", Layer.simpleProperty("animationOptions", {}));
	
	  Layer.define("width", layerProperty(Layer, "width", "width", 100, _.isNumber));
	
	  Layer.define("height", layerProperty(Layer, "height", "height", 100, _.isNumber));
	
	  Layer.define("visible", layerProperty(Layer, "visible", "display", true, _.isBoolean));
	
	  Layer.define("opacity", layerProperty(Layer, "opacity", "opacity", 1, _.isNumber));
	
	  Layer.define("index", layerProperty(Layer, "index", "zIndex", 0, _.isNumber, null, {
	    importable: false,
	    exportable: false
	  }));
	
	  Layer.define("clip", layerProperty(Layer, "clip", "overflow", false, _.isBoolean));
	
	  Layer.define("scrollHorizontal", layerProperty(Layer, "scrollHorizontal", "overflowX", false, _.isBoolean, null, {}, function(layer, value) {
	    if (value === true) {
	      return layer.ignoreEvents = false;
	    }
	  }));
	
	  Layer.define("scrollVertical", layerProperty(Layer, "scrollVertical", "overflowY", false, _.isBoolean, null, {}, function(layer, value) {
	    if (value === true) {
	      return layer.ignoreEvents = false;
	    }
	  }));
	
	  Layer.define("scroll", {
	    get: function() {
	      return this.scrollHorizontal === true || this.scrollVertical === true;
	    },
	    set: function(value) {
	      return this.scrollHorizontal = this.scrollVertical = value;
	    }
	  });
	
	  Layer.define("ignoreEvents", layerProperty(Layer, "ignoreEvents", "pointerEvents", true, _.isBoolean));
	
	  Layer.define("x", layerProperty(Layer, "x", "webkitTransform", 0, _.isNumber, layerPropertyPointTransformer, {
	    depends: ["width", "height"]
	  }));
	
	  Layer.define("y", layerProperty(Layer, "y", "webkitTransform", 0, _.isNumber, layerPropertyPointTransformer, {
	    depends: ["width", "height"]
	  }));
	
	  Layer.define("z", layerProperty(Layer, "z", "webkitTransform", 0, _.isNumber));
	
	  Layer.define("scaleX", layerProperty(Layer, "scaleX", "webkitTransform", 1, _.isNumber));
	
	  Layer.define("scaleY", layerProperty(Layer, "scaleY", "webkitTransform", 1, _.isNumber));
	
	  Layer.define("scaleZ", layerProperty(Layer, "scaleZ", "webkitTransform", 1, _.isNumber));
	
	  Layer.define("scale", layerProperty(Layer, "scale", "webkitTransform", 1, _.isNumber));
	
	  Layer.define("skewX", layerProperty(Layer, "skewX", "webkitTransform", 0, _.isNumber));
	
	  Layer.define("skewY", layerProperty(Layer, "skewY", "webkitTransform", 0, _.isNumber));
	
	  Layer.define("skew", layerProperty(Layer, "skew", "webkitTransform", 0, _.isNumber));
	
	  Layer.define("originX", layerProperty(Layer, "originX", "webkitTransformOrigin", 0.5, _.isNumber));
	
	  Layer.define("originY", layerProperty(Layer, "originY", "webkitTransformOrigin", 0.5, _.isNumber));
	
	  Layer.define("originZ", layerProperty(Layer, "originZ", null, 0, _.isNumber));
	
	  Layer.define("perspective", layerProperty(Layer, "perspective", "webkitPerspective", 0, _.isNumber));
	
	  Layer.define("perspectiveOriginX", layerProperty(Layer, "perspectiveOriginX", "webkitPerspectiveOrigin", 0.5, _.isNumber));
	
	  Layer.define("perspectiveOriginY", layerProperty(Layer, "perspectiveOriginY", "webkitPerspectiveOrigin", 0.5, _.isNumber));
	
	  Layer.define("rotationX", layerProperty(Layer, "rotationX", "webkitTransform", 0, _.isNumber));
	
	  Layer.define("rotationY", layerProperty(Layer, "rotationY", "webkitTransform", 0, _.isNumber));
	
	  Layer.define("rotationZ", layerProperty(Layer, "rotationZ", "webkitTransform", 0, _.isNumber));
	
	  Layer.define("rotation", {
	    get: function() {
	      return this.rotationZ;
	    },
	    set: function(value) {
	      return this.rotationZ = value;
	    }
	  });
	
	  Layer.define("blur", layerProperty(Layer, "blur", "webkitFilter", 0, _.isNumber));
	
	  Layer.define("brightness", layerProperty(Layer, "brightness", "webkitFilter", 100, _.isNumber));
	
	  Layer.define("saturate", layerProperty(Layer, "saturate", "webkitFilter", 100, _.isNumber));
	
	  Layer.define("hueRotate", layerProperty(Layer, "hueRotate", "webkitFilter", 0, _.isNumber));
	
	  Layer.define("contrast", layerProperty(Layer, "contrast", "webkitFilter", 100, _.isNumber));
	
	  Layer.define("invert", layerProperty(Layer, "invert", "webkitFilter", 0, _.isNumber));
	
	  Layer.define("grayscale", layerProperty(Layer, "grayscale", "webkitFilter", 0, _.isNumber));
	
	  Layer.define("sepia", layerProperty(Layer, "sepia", "webkitFilter", 0, _.isNumber));
	
	  Layer.define("shadowX", layerProperty(Layer, "shadowX", "boxShadow", 0, _.isNumber));
	
	  Layer.define("shadowY", layerProperty(Layer, "shadowY", "boxShadow", 0, _.isNumber));
	
	  Layer.define("shadowBlur", layerProperty(Layer, "shadowBlur", "boxShadow", 0, _.isNumber));
	
	  Layer.define("shadowSpread", layerProperty(Layer, "shadowSpread", "boxShadow", 0, _.isNumber));
	
	  Layer.define("shadowColor", layerProperty(Layer, "shadowColor", "boxShadow", "", Color.validColorValue, Color.toColor));
	
	  Layer.define("backgroundColor", layerProperty(Layer, "backgroundColor", "backgroundColor", null, Color.validColorValue, Color.toColor));
	
	  Layer.define("color", layerProperty(Layer, "color", "color", null, Color.validColorValue, Color.toColor));
	
	  Layer.define("borderColor", layerProperty(Layer, "borderColor", "border", null, Color.validColorValue, Color.toColor));
	
	  Layer.define("borderWidth", layerProperty(Layer, "borderWidth", "border", 0, _.isNumber));
	
	  Layer.define("force2d", layerProperty(Layer, "force2d", "webkitTransform", false, _.isBoolean));
	
	  Layer.define("flat", layerProperty(Layer, "flat", "webkitTransformStyle", false, _.isBoolean));
	
	  Layer.define("backfaceVisible", layerProperty(Layer, "backfaceVisible", "webkitBackfaceVisibility", true, _.isBoolean));
	
	  Layer.define("name", {
	    "default": "",
	    get: function() {
	      var name;
	      name = this._getPropertyValue("name");
	      if (name != null) {
	        return "" + name;
	      } else {
	        return "";
	      }
	    },
	    set: function(value) {
	      this._setPropertyValue("name", value);
	      return this._element.setAttribute("name", value);
	    }
	  });
	
	  Layer.define("matrix", {
	    get: function() {
	      if (this.force2d) {
	        return this._matrix2d;
	      }
	      return new Matrix().translate(this.x, this.y, this.z).scale(this.scale).scale(this.scaleX, this.scaleY, this.scaleZ).skew(this.skew).skewX(this.skewX).skewY(this.skewY).translate(0, 0, this.originZ).rotate(this.rotationX, 0, 0).rotate(0, this.rotationY, 0).rotate(0, 0, this.rotationZ).translate(0, 0, -this.originZ);
	    }
	  });
	
	  Layer.define("_matrix2d", {
	    get: function() {
	      return new Matrix().translate(this.x, this.y).scale(this.scale).skewX(this.skew).skewY(this.skew).rotate(0, 0, this.rotationZ);
	    }
	  });
	
	  Layer.define("transformMatrix", {
	    get: function() {
	      return new Matrix().translate(this.originX * this.width, this.originY * this.height).multiply(this.matrix).translate(-this.originX * this.width, -this.originY * this.height);
	    }
	  });
	
	  Layer.define("matrix3d", {
	    get: function() {
	      var parent, ppm;
	      parent = this.parent || this.context;
	      ppm = Utils.perspectiveMatrix(parent);
	      return new Matrix().multiply(ppm).multiply(this.transformMatrix);
	    }
	  });
	
	  Layer.define("borderRadius", {
	    importable: true,
	    exportable: true,
	    "default": 0,
	    get: function() {
	      return this._properties["borderRadius"];
	    },
	    set: function(value) {
	      if (value && !_.isNumber(value)) {
	        console.warn("Layer.borderRadius should be a numeric property, not type " + (typeof value));
	      }
	      this._properties["borderRadius"] = value;
	      this._element.style["borderRadius"] = LayerStyle["borderRadius"](this);
	      return this.emit("change:borderRadius", value);
	    }
	  });
	
	  Layer.define("cornerRadius", {
	    importable: false,
	    exportable: false,
	    get: function() {
	      return this.borderRadius;
	    },
	    set: function(value) {
	      return this.borderRadius = value;
	    }
	  });
	
	  Layer.prototype._setGeometryValues = function(input, keys) {
	    var i, j, k, len, len1, results, results1;
	    if (_.isNumber(input)) {
	      results = [];
	      for (i = 0, len = keys.length; i < len; i++) {
	        k = keys[i];
	        results.push(this[k] = input);
	      }
	      return results;
	    } else {
	      if (!input) {
	        return;
	      }
	      results1 = [];
	      for (j = 0, len1 = keys.length; j < len1; j++) {
	        k = keys[j];
	        if (_.isNumber(input[k])) {
	          results1.push(this[k] = input[k]);
	        } else {
	          results1.push(void 0);
	        }
	      }
	      return results1;
	    }
	  };
	
	  Layer.define("point", {
	    importable: true,
	    exportable: false,
	    depends: ["width", "height", "size", "parent"],
	    get: function() {
	      return Utils.point(this);
	    },
	    set: function(input) {
	      input = layerPropertyPointTransformer(input, this, "point");
	      return this._setGeometryValues(input, ["x", "y"]);
	    }
	  });
	
	  Layer.define("size", {
	    importable: true,
	    exportable: false,
	    get: function() {
	      return Utils.size(this);
	    },
	    set: function(input) {
	      return this._setGeometryValues(input, ["width", "height"]);
	    }
	  });
	
	  Layer.define("frame", {
	    importable: true,
	    exportable: false,
	    get: function() {
	      return Utils.frame(this);
	    },
	    set: function(input) {
	      return this._setGeometryValues(input, ["x", "y", "width", "height"]);
	    }
	  });
	
	  Layer.define("minX", {
	    importable: true,
	    exportable: false,
	    get: function() {
	      return this.x;
	    },
	    set: function(value) {
	      return this.x = value;
	    }
	  });
	
	  Layer.define("midX", {
	    importable: true,
	    exportable: false,
	    get: function() {
	      return Utils.frameGetMidX(this);
	    },
	    set: function(value) {
	      return Utils.frameSetMidX(this, value);
	    }
	  });
	
	  Layer.define("maxX", {
	    importable: true,
	    exportable: false,
	    get: function() {
	      return Utils.frameGetMaxX(this);
	    },
	    set: function(value) {
	      return Utils.frameSetMaxX(this, value);
	    }
	  });
	
	  Layer.define("minY", {
	    importable: true,
	    exportable: false,
	    get: function() {
	      return this.y;
	    },
	    set: function(value) {
	      return this.y = value;
	    }
	  });
	
	  Layer.define("midY", {
	    importable: true,
	    exportable: false,
	    get: function() {
	      return Utils.frameGetMidY(this);
	    },
	    set: function(value) {
	      return Utils.frameSetMidY(this, value);
	    }
	  });
	
	  Layer.define("maxY", {
	    importable: true,
	    exportable: false,
	    get: function() {
	      return Utils.frameGetMaxY(this);
	    },
	    set: function(value) {
	      return Utils.frameSetMaxY(this, value);
	    }
	  });
	
	  Layer.prototype.convertPointToScreen = function(point) {
	    return Utils.convertPointToContext(point, this, false);
	  };
	
	  Layer.prototype.convertPointToCanvas = function(point) {
	    return Utils.convertPointToContext(point, this, true);
	  };
	
	  Layer.prototype.convertPointToLayer = function(point, layer) {
	    return Utils.convertPoint(point, this, layer, true);
	  };
	
	  Layer.define("canvasFrame", {
	    importable: true,
	    exportable: false,
	    get: function() {
	      return Utils.boundingFrame(this);
	    },
	    set: function(frame) {
	      return this.frame = Utils.convertFrameFromContext(frame, this, true, false);
	    }
	  });
	
	  Layer.define("screenFrame", {
	    importable: true,
	    exportable: false,
	    get: function() {
	      return Utils.boundingFrame(this, false);
	    },
	    set: function(frame) {
	      return this.frame = Utils.convertFrameFromContext(frame, this, false, false);
	    }
	  });
	
	  Layer.prototype.contentFrame = function() {
	    if (!this.children.length) {
	      return {
	        x: 0,
	        y: 0,
	        width: 0,
	        height: 0
	      };
	    }
	    return Utils.frameMerge(_.map(this.children, "frame"));
	  };
	
	  Layer.prototype.totalFrame = function() {
	    return Utils.frameMerge(this.frame, this.contentFrame());
	  };
	
	  Layer.prototype.centerFrame = function() {
	    var frame;
	    if (this.parent) {
	      frame = this.frame;
	      Utils.frameSetMidX(frame, parseInt((this.parent.width / 2.0) - this.parent.borderWidth));
	      Utils.frameSetMidY(frame, parseInt((this.parent.height / 2.0) - this.parent.borderWidth));
	      return frame;
	    } else {
	      frame = this.frame;
	      Utils.frameSetMidX(frame, parseInt(this._context.width / 2.0));
	      Utils.frameSetMidY(frame, parseInt(this._context.height / 2.0));
	      return frame;
	    }
	  };
	
	  Layer.prototype.center = function() {
	    this.frame = this.centerFrame();
	    return this;
	  };
	
	  Layer.prototype.centerX = function(offset) {
	    if (offset == null) {
	      offset = 0;
	    }
	    this.x = this.centerFrame().x + offset;
	    return this;
	  };
	
	  Layer.prototype.centerY = function(offset) {
	    if (offset == null) {
	      offset = 0;
	    }
	    this.y = this.centerFrame().y + offset;
	    return this;
	  };
	
	  Layer.prototype.pixelAlign = function() {
	    this.x = parseInt(this.x);
	    return this.y = parseInt(this.y);
	  };
	
	  Layer.prototype.canvasScaleX = function(self) {
	    var context, i, len, parent, ref, scale;
	    if (self == null) {
	      self = true;
	    }
	    scale = 1;
	    if (self) {
	      scale = this.scale * this.scaleX;
	    }
	    ref = this.ancestors(context = true);
	    for (i = 0, len = ref.length; i < len; i++) {
	      parent = ref[i];
	      scale = scale * parent.scale * parent.scaleX;
	    }
	    return scale;
	  };
	
	  Layer.prototype.canvasScaleY = function(self) {
	    var context, i, len, parent, ref, scale;
	    if (self == null) {
	      self = true;
	    }
	    scale = 1;
	    if (self) {
	      scale = this.scale * this.scaleY;
	    }
	    ref = this.ancestors(context = true);
	    for (i = 0, len = ref.length; i < len; i++) {
	      parent = ref[i];
	      scale = scale * parent.scale * parent.scaleY;
	    }
	    return scale;
	  };
	
	  Layer.prototype.screenScaleX = function(self) {
	    var context, i, len, parent, ref, scale;
	    if (self == null) {
	      self = true;
	    }
	    scale = 1;
	    if (self) {
	      scale = this.scale * this.scaleX;
	    }
	    ref = this.ancestors(context = false);
	    for (i = 0, len = ref.length; i < len; i++) {
	      parent = ref[i];
	      scale = scale * parent.scale * parent.scaleX;
	    }
	    return scale;
	  };
	
	  Layer.prototype.screenScaleY = function(self) {
	    var context, i, len, parent, ref, scale;
	    if (self == null) {
	      self = true;
	    }
	    scale = 1;
	    if (self) {
	      scale = this.scale * this.scaleY;
	    }
	    ref = this.ancestors(context = false);
	    for (i = 0, len = ref.length; i < len; i++) {
	      parent = ref[i];
	      scale = scale * parent.scale * parent.scaleY;
	    }
	    return scale;
	  };
	
	  Layer.prototype.screenScaledFrame = function() {
	    var context, factorX, factorY, frame, i, layerScaledFrame, layers, len, parent;
	    frame = {
	      x: 0,
	      y: 0,
	      width: this.width * this.screenScaleX(),
	      height: this.height * this.screenScaleY()
	    };
	    layers = this.ancestors(context = true);
	    layers.push(this);
	    layers.reverse();
	    for (i = 0, len = layers.length; i < len; i++) {
	      parent = layers[i];
	      factorX = parent._parentOrContext() ? parent._parentOrContext().screenScaleX() : 1;
	      factorY = parent._parentOrContext() ? parent._parentOrContext().screenScaleY() : 1;
	      layerScaledFrame = parent.scaledFrame();
	      frame.x += layerScaledFrame.x * factorX;
	      frame.y += layerScaledFrame.y * factorY;
	    }
	    return frame;
	  };
	
	  Layer.prototype.scaledFrame = function() {
	    var frame, scaleX, scaleY;
	    frame = this.frame;
	    scaleX = this.scale * this.scaleX;
	    scaleY = this.scale * this.scaleY;
	    frame.width *= scaleX;
	    frame.height *= scaleY;
	    frame.x += (1 - scaleX) * this.originX * this.width;
	    frame.y += (1 - scaleY) * this.originY * this.height;
	    return frame;
	  };
	
	  Layer.define("style", {
	    importable: true,
	    exportable: false,
	    get: function() {
	      return this._element.style;
	    },
	    set: function(value) {
	      _.extend(this._element.style, value);
	      return this.emit("change:style");
	    }
	  });
	
	  Layer.prototype.computedStyle = function() {
	    var getComputedStyle;
	    getComputedStyle = document.defaultView.getComputedStyle;
	    if (getComputedStyle == null) {
	      getComputedStyle = window.getComputedStyle;
	    }
	    return getComputedStyle(this._element);
	  };
	
	  Layer.define("classList", {
	    importable: true,
	    exportable: false,
	    get: function() {
	      return this._element.classList;
	    }
	  });
	
	  Layer.prototype._createElement = function() {
	    if (this._element != null) {
	      return;
	    }
	    this._element = document.createElement("div");
	    return this._element.classList.add("framerLayer");
	  };
	
	  Layer.prototype._insertElement = function() {
	    this.bringToFront();
	    return this._context.element.appendChild(this._element);
	  };
	
	  Layer.define("html", {
	    get: function() {
	      var ref;
	      return ((ref = this._elementHTML) != null ? ref.innerHTML : void 0) || "";
	    },
	    set: function(value) {
	      if (!this._elementHTML) {
	        this._elementHTML = document.createElement("div");
	        this._element.appendChild(this._elementHTML);
	      }
	      this._elementHTML.innerHTML = value;
	      return this.emit("change:html");
	    }
	  });
	
	  Layer.prototype.querySelector = function(query) {
	    return this._element.querySelector(query);
	  };
	
	  Layer.prototype.querySelectorAll = function(query) {
	    return this._element.querySelectorAll(query);
	  };
	
	  Layer.prototype.destroy = function() {
	    var ref;
	    if (this.parent) {
	      this.parent._children = _.without(this.parent._children, this);
	    }
	    if ((ref = this._element.parentNode) != null) {
	      ref.removeChild(this._element);
	    }
	    this.removeAllListeners();
	    this._context.removeLayer(this);
	    return this._context.emit("layer:destroy", this);
	  };
	
	  Layer.prototype.copy = function() {
	    var child, copiedChild, i, layer, len, ref;
	    layer = this.copySingle();
	    ref = this.children;
	    for (i = 0, len = ref.length; i < len; i++) {
	      child = ref[i];
	      copiedChild = child.copy();
	      copiedChild.parent = layer;
	    }
	    return layer;
	  };
	
	  Layer.prototype.copySingle = function() {
	    var copy;
	    copy = new this.constructor(this.props);
	    copy.style = this.style;
	    return copy;
	  };
	
	  Layer.prototype._cleanupImageLoader = function() {
	    var ref;
	    if ((ref = this._imageEventManager) != null) {
	      ref.removeAllListeners();
	    }
	    this._imageEventManager = null;
	    return this._imageLoader = null;
	  };
	
	  Layer.define("image", {
	    "default": "",
	    get: function() {
	      return this._getPropertyValue("image");
	    },
	    set: function(value) {
	      var currentValue, defaults, imageUrl, ref;
	      if (!(_.isString(value) || value === null)) {
	        layerValueTypeError("image", value);
	      }
	      currentValue = this._getPropertyValue("image");
	      if (currentValue === value) {
	        return this.emit("load");
	      }
	      defaults = Defaults.getDefaults("Layer", {});
	      if ((ref = this.backgroundColor) != null ? ref.isEqual(defaults.backgroundColor) : void 0) {
	        this.backgroundColor = null;
	      }
	      this._setPropertyValue("image", value);
	      if (value === null || value === "") {
	        if (this._imageLoader != null) {
	          this._imageEventManager.removeAllListeners();
	          this._imageLoader.src = null;
	        }
	        this.style["background-image"] = null;
	        if (this._imageLoader != null) {
	          this.emit(Events.ImageLoadCancelled, this._imageLoader);
	          this._cleanupImageLoader();
	        }
	        return;
	      }
	      if (_.endsWith(typeof value.toLowerCase === "function" ? value.toLowerCase() : void 0, ".pdf") && (!Utils.isWebKit() || Utils.isChrome())) {
	        this.style["background-image"] = "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAVlJREFUaAXtlwEOwiAMRdF4Cr3/0fQaSre9ZFSYLCrQpSSG/FLW9v92agghXJdP3KZlCp/J2up+WiUuzMt6zNukzPDYvALCsKme1/maV8BnQHqw9/IZ6KmAz0BP9ontMwATPXafgR6s65g+A5qRlrhmBu6FhG6LXf9/+JU/YclROkVWEs/8r9FLrChb2apSqVqWZgKmtRKz9/f+CdPxoVl8CAWylcWKUQZGwfhjB3OOHcw5djDn2MH6fBNLC42yaEnyoTXB2V36+lPlz+zN9x6HKfxrZwZ/HUbf5/lJviMpoBPWBWWxFJCtLNqplItIWuvPffx5Dphz7GB9vonNv4X2zICWuMTM3p7Gv/b5iVLmFaiZgb3M/Ns/Ud68AvIGkJ6ir8xh8wrQrzAve9Jjo2PzCsC8z4Aw0WP5DPRgXcf07wHNSEvsM9CS7VIsn4ESMy3sPgMtWN6K8QKfubDo2UqVogAAAABJRU5ErkJggg==')";
	        return;
	      }
	      imageUrl = value;
	      if (this._alwaysUseImageCache === false && Utils.isLocalAssetUrl(imageUrl)) {
	        imageUrl += "?nocache=" + NoCacheDateKey;
	      }
	      if (this.listeners(Events.ImageLoaded, true) || this.listeners(Events.ImageLoadError, true) || this.listeners(Events.ImageLoadCancelled, true)) {
	        this._imageLoader = new Image();
	        this._imageLoader.name = imageUrl;
	        this._imageLoader.src = imageUrl;
	        this._imageEventManager = this._context.domEventManager.wrap(this._imageLoader);
	        this._imageEventManager.addEventListener("load", (function(_this) {
	          return function() {
	            _this.style["background-image"] = "url('" + imageUrl + "')";
	            _this.emit(Events.ImageLoaded, _this._imageLoader);
	            return _this._cleanupImageLoader();
	          };
	        })(this));
	        return this._imageEventManager.addEventListener("error", (function(_this) {
	          return function() {
	            _this.emit(Events.ImageLoadError, _this._imageLoader);
	            return _this._cleanupImageLoader();
	          };
	        })(this));
	      } else {
	        return this.style["background-image"] = "url('" + imageUrl + "')";
	      }
	    }
	  });
	
	  Layer.define("parent", {
	    enumerable: false,
	    exportable: false,
	    importable: true,
	    get: function() {
	      return this._parent || null;
	    },
	    set: function(layer) {
	      if (layer === this._parent) {
	        return;
	      }
	      if (layer === this) {
	        throw Error("Layer.parent: a layer cannot be it's own parent.");
	      }
	      if (!layer instanceof Layer) {
	        throw Error("Layer.parent needs to be a Layer object");
	      }
	      Utils.domCompleteCancel(this.__insertElement);
	      if (this._parent) {
	        this._parent._children = _.without(this._parent._children, this);
	        this._parent._element.removeChild(this._element);
	        this._parent.emit("change:children", {
	          added: [],
	          removed: [this]
	        });
	        this._parent.emit("change:subLayers", {
	          added: [],
	          removed: [this]
	        });
	      }
	      if (layer) {
	        layer._element.appendChild(this._element);
	        layer._children.push(this);
	        layer.emit("change:children", {
	          added: [this],
	          removed: []
	        });
	        layer.emit("change:subLayers", {
	          added: [this],
	          removed: []
	        });
	      } else {
	        this._insertElement();
	      }
	      this._parent = layer;
	      this.bringToFront();
	      this.emit("change:parent");
	      return this.emit("change:superLayer");
	    }
	  });
	
	  Layer.define("children", {
	    enumerable: false,
	    exportable: false,
	    importable: false,
	    get: function() {
	      return _.clone(this._children);
	    }
	  });
	
	  Layer.define("siblings", {
	    enumerable: false,
	    exportable: false,
	    importable: false,
	    get: function() {
	      if (this.parent === null) {
	        return _.filter(this._context.layers, (function(_this) {
	          return function(layer) {
	            return layer !== _this && layer.parent === null;
	          };
	        })(this));
	      }
	      return _.without(this.parent.children, this);
	    }
	  });
	
	  Layer.define("descendants", {
	    enumerable: false,
	    exportable: false,
	    importable: false,
	    get: function() {
	      var f, result;
	      result = [];
	      f = function(layer) {
	        result.push(layer);
	        return layer.children.map(f);
	      };
	      this.children.map(f);
	      return result;
	    }
	  });
	
	  Layer.prototype.addChild = function(layer) {
	    return layer.parent = this;
	  };
	
	  Layer.prototype.removeChild = function(layer) {
	    if (indexOf.call(this.children, layer) < 0) {
	      return;
	    }
	    return layer.parent = null;
	  };
	
	  Layer.prototype.childrenWithName = function(name) {
	    return _.filter(this.children, function(layer) {
	      return layer.name === name;
	    });
	  };
	
	  Layer.prototype.siblingsWithName = function(name) {
	    return _.filter(this.siblingLayers, function(layer) {
	      return layer.name === name;
	    });
	  };
	
	  Layer.prototype.ancestors = function(context) {
	    var currentLayer, parents;
	    if (context == null) {
	      context = false;
	    }
	    parents = [];
	    currentLayer = this;
	    if (context === false) {
	      while (currentLayer.parent) {
	        parents.push(currentLayer.parent);
	        currentLayer = currentLayer.parent;
	      }
	    } else {
	      while (currentLayer._parentOrContext()) {
	        parents.push(currentLayer._parentOrContext());
	        currentLayer = currentLayer._parentOrContext();
	      }
	    }
	    return parents;
	  };
	
	  Layer.prototype.root = function(context) {
	    if (context == null) {
	      context = false;
	    }
	    if (this.parent === null) {
	      return this;
	    }
	    return _.last(this.ancestors(context = context));
	  };
	
	  Layer.prototype.childrenAbove = function(point, originX, originY) {
	    if (originX == null) {
	      originX = 0;
	    }
	    if (originY == null) {
	      originY = 0;
	    }
	    return _.filter(this.children, function(layer) {
	      return Utils.framePointForOrigin(layer.frame, originX, originY).y < point.y;
	    });
	  };
	
	  Layer.prototype.childrenBelow = function(point, originX, originY) {
	    if (originX == null) {
	      originX = 0;
	    }
	    if (originY == null) {
	      originY = 0;
	    }
	    return _.filter(this.children, function(layer) {
	      return Utils.framePointForOrigin(layer.frame, originX, originY).y > point.y;
	    });
	  };
	
	  Layer.prototype.childrenLeft = function(point, originX, originY) {
	    if (originX == null) {
	      originX = 0;
	    }
	    if (originY == null) {
	      originY = 0;
	    }
	    return _.filter(this.children, function(layer) {
	      return Utils.framePointForOrigin(layer.frame, originX, originY).x < point.x;
	    });
	  };
	
	  Layer.prototype.childrenRight = function(point, originX, originY) {
	    if (originX == null) {
	      originX = 0;
	    }
	    if (originY == null) {
	      originY = 0;
	    }
	    return _.filter(this.children, function(layer) {
	      return Utils.framePointForOrigin(layer.frame, originX, originY).x > point.x;
	    });
	  };
	
	  Layer.prototype._parentOrContext = function() {
	    if (this.parent) {
	      return this.parent;
	    }
	    if (this._context._parent) {
	      return this._context._parent;
	    }
	  };
	
	  Layer.define("superLayer", {
	    enumerable: false,
	    exportable: false,
	    importable: false,
	    get: function() {
	      return this.parent;
	    },
	    set: function(value) {
	      return this.parent = value;
	    }
	  });
	
	  Layer.define("subLayers", {
	    enumerable: false,
	    exportable: false,
	    importable: false,
	    get: function() {
	      return this.children;
	    }
	  });
	
	  Layer.define("siblingLayers", {
	    enumerable: false,
	    exportable: false,
	    importable: false,
	    get: function() {
	      return this.siblings;
	    }
	  });
	
	  Layer.prototype.superLayers = function(context) {
	    if (context == null) {
	      context = false;
	    }
	    return this.ancestors(context);
	  };
	
	  Layer.prototype.addSubLayer = function(layer) {
	    return this.addChild(layer);
	  };
	
	  Layer.prototype.removeSubLayer = function(layer) {
	    return this.removeChild(layer);
	  };
	
	  Layer.prototype.subLayersByName = function(name) {
	    return this.childrenWithName(name);
	  };
	
	  Layer.prototype.siblingLayersByName = function(name) {
	    return this.siblingsWithName(name);
	  };
	
	  Layer.prototype.subLayersAbove = function(point, originX, originY) {
	    if (originX == null) {
	      originX = 0;
	    }
	    if (originY == null) {
	      originY = 0;
	    }
	    return this.childrenAbove(point, originX, originY);
	  };
	
	  Layer.prototype.subLayersBelow = function(point, originX, originY) {
	    if (originX == null) {
	      originX = 0;
	    }
	    if (originY == null) {
	      originY = 0;
	    }
	    return this.childrenBelow(point, originX, originY);
	  };
	
	  Layer.prototype.subLayersLeft = function(point, originX, originY) {
	    if (originX == null) {
	      originX = 0;
	    }
	    if (originY == null) {
	      originY = 0;
	    }
	    return this.childrenLeft(point, originX, originY);
	  };
	
	  Layer.prototype.subLayersRight = function(point, originX, originY) {
	    if (originX == null) {
	      originX = 0;
	    }
	    if (originY == null) {
	      originY = 0;
	    }
	    return this.childrenRight(point, originX, originY);
	  };
	
	  Layer.prototype._superOrParentLayer = function() {
	    return this._parentOrContext();
	  };
	
	  Layer.prototype.animate = function(properties, options) {
	    var animation, stateName;
	    if (options == null) {
	      options = {};
	    }
	    if (_.isString(properties)) {
	      stateName = properties;
	      if (options.options != null) {
	        options = options.options;
	      }
	      return this.states.machine.switchTo(stateName, options);
	    }
	    properties = _.clone(properties);
	    if (properties.properties != null) {
	      options = properties;
	      properties = options.properties;
	      delete options.properties;
	    }
	    if (properties.options != null) {
	      options = _.defaults({}, options, properties.options);
	      delete properties.options;
	    }
	    options = _.defaults({}, options, this.animationOptions);
	    if (options.start == null) {
	      options.start = true;
	    }
	    animation = new Animation(this, properties, options);
	    if (options.start) {
	      animation.start();
	    }
	    return animation;
	  };
	
	  Layer.prototype.stateCycle = function() {
	    var args, options, states;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    states = _.flatten(args);
	    if (_.isObject(_.last(states))) {
	      options = states.pop();
	    }
	    return this.animate(this.states.machine.next(states), options);
	  };
	
	  Layer.prototype.stateSwitch = function(stateName, options) {
	    if (options == null) {
	      options = {};
	    }
	    if (stateName == null) {
	      throw new Error("Missing required argument 'stateName' in stateSwitch()");
	    }
	    if (options.animate === true) {
	      return this.animate(stateName, options);
	    }
	    return this.animate(stateName, _.defaults({}, options, {
	      instant: true
	    }));
	  };
	
	  Layer.prototype.animations = function(includePending) {
	    if (includePending == null) {
	      includePending = false;
	    }
	    return _.filter(this._context.animations, (function(_this) {
	      return function(animation) {
	        if (!(animation.layer === _this)) {
	          return false;
	        }
	        return includePending || !animation.isPending;
	      };
	    })(this));
	  };
	
	  Layer.prototype.animatingProperties = function() {
	    var animation, i, j, len, len1, properties, propertyName, ref, ref1;
	    properties = {};
	    ref = this.animations();
	    for (i = 0, len = ref.length; i < len; i++) {
	      animation = ref[i];
	      ref1 = animation.animatingProperties();
	      for (j = 0, len1 = ref1.length; j < len1; j++) {
	        propertyName = ref1[j];
	        properties[propertyName] = animation;
	      }
	    }
	    return properties;
	  };
	
	  Layer.define("isAnimating", {
	    enumerable: false,
	    exportable: false,
	    get: function() {
	      return this.animations().length !== 0;
	    }
	  });
	
	  Layer.prototype.animateStop = function() {
	    var ref;
	    _.invokeMap(this.animations(), "stop");
	    return (ref = this._draggable) != null ? ref.animateStop() : void 0;
	  };
	
	  Layer.prototype.bringToFront = function() {
	    return this.index = _.max(_.union([0], this.siblingLayers.map(function(layer) {
	      return layer.index;
	    }))) + 1;
	  };
	
	  Layer.prototype.sendToBack = function() {
	    return this.index = _.min(_.union([0], this.siblingLayers.map(function(layer) {
	      return layer.index;
	    }))) - 1;
	  };
	
	  Layer.prototype.placeBefore = function(layer) {
	    var i, l, len, ref;
	    if (indexOf.call(this.siblingLayers, layer) < 0) {
	      return;
	    }
	    ref = this.siblingLayers;
	    for (i = 0, len = ref.length; i < len; i++) {
	      l = ref[i];
	      if (l.index <= layer.index) {
	        l.index -= 1;
	      }
	    }
	    return this.index = layer.index + 1;
	  };
	
	  Layer.prototype.placeBehind = function(layer) {
	    var i, l, len, ref;
	    if (indexOf.call(this.siblingLayers, layer) < 0) {
	      return;
	    }
	    ref = this.siblingLayers;
	    for (i = 0, len = ref.length; i < len; i++) {
	      l = ref[i];
	      if (l.index >= layer.index) {
	        l.index += 1;
	      }
	    }
	    return this.index = layer.index - 1;
	  };
	
	  Layer.define("states", {
	    enumerable: false,
	    exportable: false,
	    importable: false,
	    get: function() {
	      if (this._states == null) {
	        this._states = new LayerStates(this);
	      }
	      return this._states;
	    },
	    set: function(states) {
	      this.states.machine.reset();
	      return _.extend(this.states, states);
	    }
	  });
	
	  Layer.define("stateNames", {
	    enumerable: false,
	    exportable: false,
	    importable: false,
	    get: function() {
	      return this.states.machine.stateNames;
	    }
	  });
	
	  Layer.define("draggable", {
	    importable: false,
	    exportable: false,
	    get: function() {
	      return this._draggable != null ? this._draggable : this._draggable = new LayerDraggable(this);
	    },
	    set: function(value) {
	      if (_.isBoolean(value)) {
	        return this.draggable.enabled = value;
	      }
	    }
	  });
	
	  Layer.define("pinchable", {
	    importable: false,
	    exportable: false,
	    get: function() {
	      return this._pinchable != null ? this._pinchable : this._pinchable = new LayerPinchable(this);
	    },
	    set: function(value) {
	      if (_.isBoolean(value)) {
	        return this.pinchable.enabled = value;
	      }
	    }
	  });
	
	  Layer.define("scrollFrame", {
	    importable: false,
	    get: function() {
	      var frame;
	      return frame = {
	        x: this.scrollX,
	        y: this.scrollY,
	        width: this.width,
	        height: this.height
	      };
	    },
	    set: function(frame) {
	      this.scrollX = frame.x;
	      return this.scrollY = frame.y;
	    }
	  });
	
	  Layer.define("scrollX", {
	    get: function() {
	      return this._element.scrollLeft;
	    },
	    set: function(value) {
	      if (!_.isNumber(value)) {
	        layerValueTypeError("scrollX", value);
	      }
	      return this._element.scrollLeft = value;
	    }
	  });
	
	  Layer.define("scrollY", {
	    get: function() {
	      return this._element.scrollTop;
	    },
	    set: function(value) {
	      if (!_.isNumber(value)) {
	        layerValueTypeError("scrollY", value);
	      }
	      return this._element.scrollTop = value;
	    }
	  });
	
	  Layer.define("_domEventManager", {
	    get: function() {
	      return this._context.domEventManager.wrap(this._element);
	    }
	  });
	
	  Layer.prototype.emit = function() {
	    var args, eventName, offset, parentDraggableLayer, velocity;
	    eventName = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	    if (this._cancelClickEventInDragSession && !this._draggable) {
	      if (eventName === Events.Click || eventName === Events.Tap || eventName === Events.TapStart || eventName === Events.TapEnd || eventName === Events.LongPress || eventName === Events.LongPressStart || eventName === Events.LongPressEnd) {
	        parentDraggableLayer = this._parentDraggableLayer();
	        if (parentDraggableLayer) {
	          offset = parentDraggableLayer.draggable.offset;
	          if (Math.abs(offset.x) > this._cancelClickEventInDragSessionOffset) {
	            return;
	          }
	          if (Math.abs(offset.y) > this._cancelClickEventInDragSessionOffset) {
	            return;
	          }
	          velocity = parentDraggableLayer.draggable.velocity;
	          if (Math.abs(velocity.x) > this._cancelClickEventInDragSessionVelocity) {
	            return;
	          }
	          if (Math.abs(velocity.y) > this._cancelClickEventInDragSessionVelocity) {
	            return;
	          }
	        }
	      }
	    }
	    return Layer.__super__.emit.apply(this, [eventName].concat(slice.call(args), [this]));
	  };
	
	  Layer.prototype.once = function(eventName, listener) {
	    Layer.__super__.once.call(this, eventName, listener);
	    return this._addListener(eventName, listener);
	  };
	
	  Layer.prototype.addListener = function(eventName, listener) {
	    if (!eventName) {
	      throw Error("Layer.on needs a valid event name");
	    }
	    if (!listener) {
	      throw Error("Layer.on needs an event listener");
	    }
	    Layer.__super__.addListener.call(this, eventName, listener);
	    return this._addListener(eventName, listener);
	  };
	
	  Layer.prototype.removeListener = function(eventName, listener) {
	    if (!eventName) {
	      throw Error("Layer.off needs a valid event name");
	    }
	    Layer.__super__.removeListener.call(this, eventName, listener);
	    return this._removeListener(eventName, listener);
	  };
	
	  Layer.prototype._addListener = function(eventName, listener) {
	    if (!_.startsWith(eventName, "change:")) {
	      this.ignoreEvents = false;
	    }
	    if (Utils.domValidEvent(this._element, eventName) || indexOf.call(_.values(Gestures), eventName) >= 0) {
	      if (!this._domEventManager.listeners(eventName).length) {
	        return this._domEventManager.addEventListener(eventName, (function(_this) {
	          return function(event) {
	            return _this.emit(eventName, event);
	          };
	        })(this));
	      }
	    }
	  };
	
	  Layer.prototype._removeListener = function(eventName, listener) {
	    if (!this.listeners(eventName).length) {
	      return this._domEventManager.removeAllListeners(eventName);
	    }
	  };
	
	  Layer.prototype._parentDraggableLayer = function() {
	    var i, layer, len, ref, ref1;
	    ref = this.ancestors();
	    for (i = 0, len = ref.length; i < len; i++) {
	      layer = ref[i];
	      if ((ref1 = layer._draggable) != null ? ref1.enabled : void 0) {
	        return layer;
	      }
	    }
	    return null;
	  };
	
	  Layer.prototype.on = Layer.prototype.addListener;
	
	  Layer.prototype.off = Layer.prototype.removeListener;
	
	  Layer.prototype.onClick = function(cb) {
	    return this.on(Events.Click, cb);
	  };
	
	  Layer.prototype.onDoubleClick = function(cb) {
	    return this.on(Events.DoubleClick, cb);
	  };
	
	  Layer.prototype.onScrollStart = function(cb) {
	    return this.on(Events.ScrollStart, cb);
	  };
	
	  Layer.prototype.onScroll = function(cb) {
	    return this.on(Events.Scroll, cb);
	  };
	
	  Layer.prototype.onScrollEnd = function(cb) {
	    return this.on(Events.ScrollEnd, cb);
	  };
	
	  Layer.prototype.onScrollAnimationDidStart = function(cb) {
	    return this.on(Events.ScrollAnimationDidStart, cb);
	  };
	
	  Layer.prototype.onScrollAnimationDidEnd = function(cb) {
	    return this.on(Events.ScrollAnimationDidEnd, cb);
	  };
	
	  Layer.prototype.onTouchStart = function(cb) {
	    return this.on(Events.TouchStart, cb);
	  };
	
	  Layer.prototype.onTouchEnd = function(cb) {
	    return this.on(Events.TouchEnd, cb);
	  };
	
	  Layer.prototype.onTouchMove = function(cb) {
	    return this.on(Events.TouchMove, cb);
	  };
	
	  Layer.prototype.onMouseUp = function(cb) {
	    return this.on(Events.MouseUp, cb);
	  };
	
	  Layer.prototype.onMouseDown = function(cb) {
	    return this.on(Events.MouseDown, cb);
	  };
	
	  Layer.prototype.onMouseOver = function(cb) {
	    return this.on(Events.MouseOver, cb);
	  };
	
	  Layer.prototype.onMouseOut = function(cb) {
	    return this.on(Events.MouseOut, cb);
	  };
	
	  Layer.prototype.onMouseMove = function(cb) {
	    return this.on(Events.MouseMove, cb);
	  };
	
	  Layer.prototype.onMouseWheel = function(cb) {
	    return this.on(Events.MouseWheel, cb);
	  };
	
	  Layer.prototype.onAnimationStart = function(cb) {
	    return this.on(Events.AnimationStart, cb);
	  };
	
	  Layer.prototype.onAnimationStop = function(cb) {
	    return this.on(Events.AnimationStop, cb);
	  };
	
	  Layer.prototype.onAnimationEnd = function(cb) {
	    return this.on(Events.AnimationEnd, cb);
	  };
	
	  Layer.prototype.onAnimationDidStart = function(cb) {
	    return this.on(Events.AnimationDidStart, cb);
	  };
	
	  Layer.prototype.onAnimationDidStop = function(cb) {
	    return this.on(Events.AnimationDidStop, cb);
	  };
	
	  Layer.prototype.onAnimationDidEnd = function(cb) {
	    return this.on(Events.AnimationDidEnd, cb);
	  };
	
	  Layer.prototype.onImageLoaded = function(cb) {
	    return this.on(Events.ImageLoaded, cb);
	  };
	
	  Layer.prototype.onImageLoadError = function(cb) {
	    return this.on(Events.ImageLoadError, cb);
	  };
	
	  Layer.prototype.onImageLoadCancelled = function(cb) {
	    return this.on(Events.ImageLoadCancelled, cb);
	  };
	
	  Layer.prototype.onMove = function(cb) {
	    return this.on(Events.Move, cb);
	  };
	
	  Layer.prototype.onDragStart = function(cb) {
	    return this.on(Events.DragStart, cb);
	  };
	
	  Layer.prototype.onDragWillMove = function(cb) {
	    return this.on(Events.DragWillMove, cb);
	  };
	
	  Layer.prototype.onDragMove = function(cb) {
	    return this.on(Events.DragMove, cb);
	  };
	
	  Layer.prototype.onDragDidMove = function(cb) {
	    return this.on(Events.DragDidMove, cb);
	  };
	
	  Layer.prototype.onDrag = function(cb) {
	    return this.on(Events.Drag, cb);
	  };
	
	  Layer.prototype.onDragEnd = function(cb) {
	    return this.on(Events.DragEnd, cb);
	  };
	
	  Layer.prototype.onDragAnimationStart = function(cb) {
	    return this.on(Events.DragAnimationStart, cb);
	  };
	
	  Layer.prototype.onDragAnimationEnd = function(cb) {
	    return this.on(Events.DragAnimationEnd, cb);
	  };
	
	  Layer.prototype.onDirectionLockStart = function(cb) {
	    return this.on(Events.DirectionLockStart, cb);
	  };
	
	  Layer.prototype.onStateSwitchStart = function(cb) {
	    return this.on(Events.StateSwitchStart, cb);
	  };
	
	  Layer.prototype.onStateSwitchStop = function(cb) {
	    return this.on(Events.StateSwitchStop, cb);
	  };
	
	  Layer.prototype.onStateSwitchEnd = function(cb) {
	    return this.on(Events.StateSwitchEnd, cb);
	  };
	
	  Layer.prototype.onStateWillSwitch = function(cb) {
	    return this.on(Events.StateSwitchStart, cb);
	  };
	
	  Layer.prototype.onStateDidSwitch = function(cb) {
	    return this.on(Events.StateSwitchEnd, cb);
	  };
	
	  Layer.prototype.onTap = function(cb) {
	    return this.on(Events.Tap, cb);
	  };
	
	  Layer.prototype.onTapStart = function(cb) {
	    return this.on(Events.TapStart, cb);
	  };
	
	  Layer.prototype.onTapEnd = function(cb) {
	    return this.on(Events.TapEnd, cb);
	  };
	
	  Layer.prototype.onDoubleTap = function(cb) {
	    return this.on(Events.DoubleTap, cb);
	  };
	
	  Layer.prototype.onForceTap = function(cb) {
	    return this.on(Events.ForceTap, cb);
	  };
	
	  Layer.prototype.onForceTapChange = function(cb) {
	    return this.on(Events.ForceTapChange, cb);
	  };
	
	  Layer.prototype.onForceTapStart = function(cb) {
	    return this.on(Events.ForceTapStart, cb);
	  };
	
	  Layer.prototype.onForceTapEnd = function(cb) {
	    return this.on(Events.ForceTapEnd, cb);
	  };
	
	  Layer.prototype.onLongPress = function(cb) {
	    return this.on(Events.LongPress, cb);
	  };
	
	  Layer.prototype.onLongPressStart = function(cb) {
	    return this.on(Events.LongPressStart, cb);
	  };
	
	  Layer.prototype.onLongPressEnd = function(cb) {
	    return this.on(Events.LongPressEnd, cb);
	  };
	
	  Layer.prototype.onSwipe = function(cb) {
	    return this.on(Events.Swipe, cb);
	  };
	
	  Layer.prototype.onSwipeStart = function(cb) {
	    return this.on(Events.SwipeStart, cb);
	  };
	
	  Layer.prototype.onSwipeEnd = function(cb) {
	    return this.on(Events.SwipeEnd, cb);
	  };
	
	  Layer.prototype.onSwipeUp = function(cb) {
	    return this.on(Events.SwipeUp, cb);
	  };
	
	  Layer.prototype.onSwipeUpStart = function(cb) {
	    return this.on(Events.SwipeUpStart, cb);
	  };
	
	  Layer.prototype.onSwipeUpEnd = function(cb) {
	    return this.on(Events.SwipeUpEnd, cb);
	  };
	
	  Layer.prototype.onSwipeDown = function(cb) {
	    return this.on(Events.SwipeDown, cb);
	  };
	
	  Layer.prototype.onSwipeDownStart = function(cb) {
	    return this.on(Events.SwipeDownStart, cb);
	  };
	
	  Layer.prototype.onSwipeDownEnd = function(cb) {
	    return this.on(Events.SwipeDownEnd, cb);
	  };
	
	  Layer.prototype.onSwipeLeft = function(cb) {
	    return this.on(Events.SwipeLeft, cb);
	  };
	
	  Layer.prototype.onSwipeLeftStart = function(cb) {
	    return this.on(Events.SwipeLeftStart, cb);
	  };
	
	  Layer.prototype.onSwipeLeftEnd = function(cb) {
	    return this.on(Events.SwipeLeftEnd, cb);
	  };
	
	  Layer.prototype.onSwipeRight = function(cb) {
	    return this.on(Events.SwipeRight, cb);
	  };
	
	  Layer.prototype.onSwipeRightStart = function(cb) {
	    return this.on(Events.SwipeRightStart, cb);
	  };
	
	  Layer.prototype.onSwipeRightEnd = function(cb) {
	    return this.on(Events.SwipeRightEnd, cb);
	  };
	
	  Layer.prototype.onPan = function(cb) {
	    return this.on(Events.Pan, cb);
	  };
	
	  Layer.prototype.onPanStart = function(cb) {
	    return this.on(Events.PanStart, cb);
	  };
	
	  Layer.prototype.onPanEnd = function(cb) {
	    return this.on(Events.PanEnd, cb);
	  };
	
	  Layer.prototype.onPanLeft = function(cb) {
	    return this.on(Events.PanLeft, cb);
	  };
	
	  Layer.prototype.onPanRight = function(cb) {
	    return this.on(Events.PanRight, cb);
	  };
	
	  Layer.prototype.onPanUp = function(cb) {
	    return this.on(Events.PanUp, cb);
	  };
	
	  Layer.prototype.onPanDown = function(cb) {
	    return this.on(Events.PanDown, cb);
	  };
	
	  Layer.prototype.onPinch = function(cb) {
	    return this.on(Events.Pinch, cb);
	  };
	
	  Layer.prototype.onPinchStart = function(cb) {
	    return this.on(Events.PinchStart, cb);
	  };
	
	  Layer.prototype.onPinchEnd = function(cb) {
	    return this.on(Events.PinchEnd, cb);
	  };
	
	  Layer.prototype.onScale = function(cb) {
	    return this.on(Events.Scale, cb);
	  };
	
	  Layer.prototype.onScaleStart = function(cb) {
	    return this.on(Events.ScaleStart, cb);
	  };
	
	  Layer.prototype.onScaleEnd = function(cb) {
	    return this.on(Events.ScaleEnd, cb);
	  };
	
	  Layer.prototype.onRotate = function(cb) {
	    return this.on(Events.Rotate, cb);
	  };
	
	  Layer.prototype.onRotateStart = function(cb) {
	    return this.on(Events.RotateStart, cb);
	  };
	
	  Layer.prototype.onRotateEnd = function(cb) {
	    return this.on(Events.RotateEnd, cb);
	  };
	
	  Layer.prototype._showHint = function(targetLayer) {
	    var context, frame, i, j, layer, len, len1, parent, ref, ref1;
	    if (!this.visible) {
	      return;
	    }
	    if (this.opacity === 0) {
	      return;
	    }
	    if (!this.shouldShowHint(targetLayer)) {
	      ref = this.children;
	      for (i = 0, len = ref.length; i < len; i++) {
	        layer = ref[i];
	        layer._showHint(targetLayer);
	      }
	      return null;
	    }
	    frame = this.canvasFrame;
	    ref1 = this.ancestors(context = true);
	    for (j = 0, len1 = ref1.length; j < len1; j++) {
	      parent = ref1[j];
	      if (parent.clip) {
	        frame = Utils.frameIntersection(frame, parent.canvasFrame);
	      }
	      if (!frame) {
	        return;
	      }
	    }
	    this.showHint(frame);
	    return _.invokeMap(this.children, "_showHint");
	  };
	
	  Layer.prototype.willSeemToDoSomething = function() {
	    if (this.ignoreEvents) {
	      return false;
	    }
	    if (this._draggable) {
	      if (this._draggable.isDragging === false && this._draggable.isMoving === false) {
	        return false;
	      }
	    }
	    return true;
	  };
	
	  Layer.prototype.shouldShowHint = function() {
	    var eventName, i, j, len, len1, parent, ref, ref1;
	    if (this.ignoreEvents === true) {
	      return false;
	    }
	    if (this.isAnimating) {
	      return false;
	    }
	    ref = this.ancestors();
	    for (i = 0, len = ref.length; i < len; i++) {
	      parent = ref[i];
	      if (parent.isAnimating) {
	        return false;
	      }
	    }
	    if (this._draggable && this._draggable.horizontal === false && this._draggable.vertical === false) {
	      return false;
	    }
	    if (this.opacity === 0) {
	      return false;
	    }
	    ref1 = this.listenerEvents();
	    for (j = 0, len1 = ref1.length; j < len1; j++) {
	      eventName = ref1[j];
	      if (Events.isInteractive(eventName)) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  Layer.prototype.showHint = function(highlightFrame) {
	    var animation, layer;
	    layer = new Layer({
	      frame: Utils.frameInset(highlightFrame, -1),
	      backgroundColor: null,
	      borderColor: Framer.Defaults.Hints.color,
	      borderRadius: this.borderRadius * Utils.average([this.canvasScaleX(), this.canvasScaleY()]),
	      borderWidth: 3
	    });
	    if (this._draggable) {
	      layer.backgroundColor = null;
	    }
	    if (Utils.frameInFrame(this.context.canvasFrame, highlightFrame)) {
	      layer.backgroundColor = null;
	    }
	    animation = layer.animate({
	      properties: {
	        opacity: 0
	      },
	      curve: "ease-out",
	      time: 0.5
	    });
	    return animation.onAnimationEnd(function() {
	      return layer.destroy();
	    });
	  };
	
	  Layer.prototype.toName = function() {
	    var ref;
	    if (this.name) {
	      return name;
	    }
	    return ((ref = this.__framerInstanceInfo) != null ? ref.name : void 0) || "";
	  };
	
	  Layer.prototype.toInspect = function(constructor) {
	    var name;
	    if (constructor == null) {
	      constructor = this.constructor.name;
	    }
	    name = this.name ? "name:" + this.name + " " : "";
	    return "<" + constructor + " " + (this.toName()) + " id:" + this.id + " " + name + " (" + (Utils.roundWhole(this.x)) + ", " + (Utils.roundWhole(this.y)) + ") " + (Utils.roundWhole(this.width)) + "x" + (Utils.roundWhole(this.height)) + ">";
	  };
	
	  return Layer;
	
	})(BaseClass);


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var FramerCSS, Utils;
	
	Utils = __webpack_require__(4);
	
	FramerCSS = "body {\n	margin: 0;\n}\n\n.framerContext {\n	position: absolute;\n	left: 0;\n	top: 0;\n	right: 0;\n	bottom: 0;\n	pointer-events: none;\n}\n\n.framerLayer {\n	display: block;\n	position: absolute;\n	left: 0;\n	top: 0;\n	background-repeat: no-repeat;\n	background-position: center;\n	background-size: cover;\n	-webkit-overflow-scrolling: touch;\n	-webkit-box-sizing: border-box;\n	-webkit-user-select: none;\n}\n\n.framerLayer input,\n.framerLayer textarea,\n.framerLayer select,\n.framerLayer option,\n.framerLayer div[contenteditable=true]\n{\n	pointer-events: auto;\n	-webkit-user-select: auto;\n}\n\n.framerDebug {\n	padding: 6px;\n	color: #fff;\n	font: 10px/1em Monaco;\n}\n";
	
	Utils.domComplete(function() {
	  return Utils.insertCSS(FramerCSS);
	});


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var Events, Gestures, Utils, _, interactiveEvents,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	Utils = __webpack_require__(4);
	
	_ = __webpack_require__(1)._;
	
	Gestures = __webpack_require__(16).Gestures;
	
	Events = {};
	
	Events.MouseUp = "mouseup";
	
	Events.MouseDown = "mousedown";
	
	Events.MouseOver = "mouseover";
	
	Events.MouseOut = "mouseout";
	
	Events.MouseMove = "mousemove";
	
	Events.MouseWheel = "mousewheel";
	
	Events.DoubleClick = "dblclick";
	
	Events.MouseDoubleClick = "dblclick";
	
	Events.enableEmulatedTouchEvents = function(enable) {
	  if (enable == null) {
	    enable = true;
	  }
	  if (enable) {
	    Events.TouchStart = Events.MouseDown;
	    Events.TouchEnd = Events.MouseUp;
	    return Events.TouchMove = Events.MouseMove;
	  } else {
	    Events.TouchStart = "touchstart";
	    Events.TouchEnd = "touchend";
	    return Events.TouchMove = "touchmove";
	  }
	};
	
	Events.enableEmulatedTouchEvents(false);
	
	if (!Utils.isTouch()) {
	  Events.enableEmulatedTouchEvents();
	}
	
	Events.Click = Events.TouchEnd;
	
	Events.AnimationStart = "start";
	
	Events.AnimationHalt = "halt";
	
	Events.AnimationStop = "stop";
	
	Events.AnimationEnd = "end";
	
	Events.AnimationDidStart = Events.AnimationStart;
	
	Events.AnimationDidStop = Events.AnimationStop;
	
	Events.AnimationDidEnd = Events.AnimationEnd;
	
	Events.StateSwitchStart = "stateswitchstart";
	
	Events.StateSwitchStop = "stateswitchstop";
	
	Events.StateSwitchEnd = "stateswitchend";
	
	Events.StateWillSwitch = Events.StateSwitchStart;
	
	Events.StateDidSwitch = Events.StateSwitchEnd;
	
	Events.Scroll = "scroll";
	
	Events.ImageLoaded = "imageload";
	
	Events.ImageLoadError = "imageerror";
	
	Events.ImageLoadCancelled = "imagecancelled";
	
	_.extend(Events, Gestures);
	
	Events.touchEvent = function(event) {
	  var ref, ref1, touchEvent;
	  touchEvent = (ref = event.touches) != null ? ref[0] : void 0;
	  if (touchEvent == null) {
	    touchEvent = (ref1 = event.changedTouches) != null ? ref1[0] : void 0;
	  }
	  if (touchEvent == null) {
	    touchEvent = event;
	  }
	  return touchEvent;
	};
	
	Events.wrap = function(element) {
	  return Framer.CurrentContext.domEventManager.wrap(element);
	};
	
	Events.isGesture = function(eventName) {
	  return indexOf.call(Gestures, eventName) >= 0;
	};
	
	interactiveEvents = _.values(Gestures).concat([Events.TouchStart, Events.TouchEnd, Events.MouseUp, Events.MouseDown, Events.MouseWheel, Events.DoubleClick]);
	
	Events.isInteractive = function(eventName) {
	  return indexOf.call(interactiveEvents, eventName) >= 0;
	};
	
	exports.Events = Events;


/***/ },
/* 16 */
/***/ function(module, exports) {

	var Gestures;
	
	Gestures = {};
	
	Gestures.Tap = "tap";
	
	Gestures.TapStart = "tapstart";
	
	Gestures.TapEnd = "tapend";
	
	Gestures.DoubleTap = "doubletap";
	
	Gestures.ForceTap = "forcetap";
	
	Gestures.ForceTapChange = "forcetapchange";
	
	Gestures.ForceTapStart = "forcetapstart";
	
	Gestures.ForceTapEnd = "forcetapend";
	
	Gestures.LongPress = "longpress";
	
	Gestures.LongPressStart = "longpressstart";
	
	Gestures.LongPressEnd = "longpressend";
	
	Gestures.Swipe = "swipe";
	
	Gestures.SwipeStart = "swipestart";
	
	Gestures.SwipeEnd = "swipeend";
	
	Gestures.SwipeUp = "swipeup";
	
	Gestures.SwipeUpStart = "swipeupstart";
	
	Gestures.SwipeUpEnd = "swipeupend";
	
	Gestures.SwipeDown = "swipedown";
	
	Gestures.SwipeDownStart = "swipedownstart";
	
	Gestures.SwipeDownEnd = "swipedownend";
	
	Gestures.SwipeLeft = "swipeleft";
	
	Gestures.SwipeLeftStart = "swipeleftstart";
	
	Gestures.SwipeLeftEnd = "swipeleftend";
	
	Gestures.SwipeRight = "swiperight";
	
	Gestures.SwipeRightStart = "swiperightstart";
	
	Gestures.SwipeRightEnd = "swiperightend";
	
	Gestures.EdgeSwipe = "edgeswipe";
	
	Gestures.EdgeSwipeStart = "edgeswipestart";
	
	Gestures.EdgeSwipeEnd = "edgeswipeend";
	
	Gestures.EdgeSwipeTop = "edgeswipetop";
	
	Gestures.EdgeSwipeTopStart = "edgeswipetopstart";
	
	Gestures.EdgeSwipeTopEnd = "edgeswipetopend";
	
	Gestures.EdgeSwipeRight = "edgeswiperight";
	
	Gestures.EdgeSwipeRightStart = "edgeswiperightstart";
	
	Gestures.EdgeSwipeRightEnd = "edgeswiperightend";
	
	Gestures.EdgeSwipeBottom = "edgeswipebottom";
	
	Gestures.EdgeSwipeBottomStart = "edgeswipebottomstart";
	
	Gestures.EdgeSwipeBottomEnd = "edgeswipebottomend";
	
	Gestures.EdgeSwipeLeft = "edgeswipeleft";
	
	Gestures.EdgeSwipeLeftStart = "edgeswipeleftstart";
	
	Gestures.EdgeSwipeLeftEnd = "edgeswipeleftend";
	
	Gestures.Pan = "pan";
	
	Gestures.PanStart = "panstart";
	
	Gestures.PanEnd = "panend";
	
	Gestures.PanLeft = "panleft";
	
	Gestures.PanRight = "panright";
	
	Gestures.PanUp = "panup";
	
	Gestures.PanDown = "pandown";
	
	Gestures.Pinch = "pinch";
	
	Gestures.PinchStart = "pinchstart";
	
	Gestures.PinchEnd = "pinchend";
	
	Gestures.Scale = "scale";
	
	Gestures.ScaleStart = "scalestart";
	
	Gestures.ScaleEnd = "scaleend";
	
	Gestures.Rotate = "rotate";
	
	Gestures.RotateStart = "rotatestart";
	
	Gestures.RotateEnd = "rotateend";
	
	exports.Gestures = Gestures;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var Originals, Utils, _;
	
	_ = __webpack_require__(1)._;
	
	Utils = __webpack_require__(4);
	
	Originals = {
	  Layer: {
	    backgroundColor: "rgba(123, 123, 123, 0.5)",
	    color: "white",
	    shadowColor: "rgba(123, 123, 123, 0.5)",
	    borderColor: "rgba(123, 123, 123, 0.5)",
	    width: 200,
	    height: 200
	  },
	  Animation: {
	    curve: "ease",
	    time: 1,
	    repeat: 0,
	    delay: 0,
	    debug: false,
	    colorModel: "husl",
	    animate: true,
	    looping: false
	  },
	  Context: {
	    perspective: 0,
	    perspectiveOriginX: 0.5,
	    perspectiveOriginY: 0.5,
	    parent: null,
	    name: null
	  },
	  DeviceComponent: {
	    fullScreen: false,
	    padding: 50,
	    deviceType: "apple-iphone-7-silver",
	    deviceZoom: "fit",
	    contentZoom: 1,
	    orientation: "portrait",
	    keyboard: false,
	    animationOptions: {
	      time: .3,
	      curve: "ease-in-out"
	    }
	  },
	  LayerDraggable: {
	    momentum: true,
	    momentumOptions: {
	      friction: 2.1,
	      tolerance: 1
	    },
	    bounce: true,
	    bounceOptions: {
	      friction: 40,
	      tension: 200,
	      tolerance: 1
	    },
	    directionLock: false,
	    directionLockThreshold: {
	      x: 10,
	      y: 10
	    },
	    overdrag: true,
	    overdragScale: 0.5,
	    pixelAlign: true,
	    velocityTimeout: 100,
	    velocityScale: 890
	  },
	  FrictionSimulator: {
	    friction: 2,
	    tolerance: 1 / 10
	  },
	  Spring: {
	    dampingRatio: 0.5,
	    mass: 1,
	    velocity: 0
	  },
	  SpringSimulator: {
	    tension: 500,
	    friction: 10,
	    tolerance: 1 / 10000
	  },
	  MomentumBounceSimulator: {
	    momentum: {
	      friction: 2,
	      tolerance: 10
	    },
	    bounce: {
	      tension: 500,
	      friction: 10,
	      tolerance: 1
	    }
	  },
	  GridComponent: {
	    rows: 3,
	    columns: 3,
	    spacing: 0,
	    backgroundColor: "transparent"
	  },
	  ScrollComponent: {
	    clip: true,
	    mouseWheelEnabled: false,
	    backgroundColor: null
	  },
	  Hints: {
	    color: "rgba(144, 19, 254, 0.8)"
	  }
	};
	
	exports.Defaults = {
	  getDefaults: function(className, options) {
	    var defaults, k, ref, v;
	    if (!Originals.hasOwnProperty(className)) {
	      return {};
	    }
	    if (!Framer.Defaults.hasOwnProperty(className)) {
	      return {};
	    }
	    options = _.clone(options);
	    defaults = _.cloneDeep(Originals[className]);
	    ref = Framer.Defaults[className];
	    for (k in ref) {
	      v = ref[k];
	      if (_.isFunction(v) && !(className === "Animation" && k === "curve")) {
	        defaults[k] = v();
	      } else {
	        defaults[k] = v;
	      }
	    }
	    for (k in defaults) {
	      v = defaults[k];
	      if (!options.hasOwnProperty(k)) {
	        options[k] = v;
	      }
	    }
	    return options;
	  },
	  setup: function() {
	    var className, classValues, k, ref, v;
	    if (window.FramerDefaults) {
	      ref = window.FramerDefaults;
	      for (className in ref) {
	        classValues = ref[className];
	        for (k in classValues) {
	          v = classValues[k];
	          Originals[className][k] = v;
	        }
	      }
	    }
	    return exports.Defaults.reset();
	  },
	  reset: function() {
	    return window.Framer.Defaults = _.cloneDeep(Originals);
	  }
	};


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var Animator, BaseClass, Config, Curves, Defaults, LinearAnimator, Utils, _, evaluateRelativeProperty, isRelativeProperty, numberRE, relativePropertyRE,
	  slice = [].slice,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	_ = __webpack_require__(1)._;
	
	Utils = __webpack_require__(4);
	
	Config = __webpack_require__(14).Config;
	
	Defaults = __webpack_require__(17).Defaults;
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	Animator = __webpack_require__(19).Animator;
	
	LinearAnimator = __webpack_require__(20).LinearAnimator;
	
	Curves = __webpack_require__(21);
	
	numberRE = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/;
	
	relativePropertyRE = new RegExp("^(?:([+-])=|)(" + numberRE.source + ")([a-z%]*)$", "i");
	
	isRelativeProperty = function(v) {
	  return _.isString(v) && relativePropertyRE.test(v);
	};
	
	evaluateRelativeProperty = function(target, k, v) {
	  var match, number, ref, rest, sign, unit;
	  ref = relativePropertyRE.exec(v), match = ref[0], sign = ref[1], number = ref[2], unit = ref[3], rest = 5 <= ref.length ? slice.call(ref, 4) : [];
	  if (sign) {
	    return target[k] + (sign + 1) * number;
	  }
	  return +number;
	};
	
	exports.Animation = (function(superClass) {
	  extend(Animation, superClass);
	
	  function Animation() {
	    var args, layer, options, properties;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    this._updateColorValue = bind(this._updateColorValue, this);
	    this._updateNumberValue = bind(this._updateNumberValue, this);
	    this._updateValues = bind(this._updateValues, this);
	    this._prepareUpdateValues = bind(this._prepareUpdateValues, this);
	    this._update = bind(this._update, this);
	    this.finish = bind(this.finish, this);
	    this._start = bind(this._start, this);
	    this._noop = bind(this._noop, this);
	    this._instant = bind(this._instant, this);
	    this.start = bind(this.start, this);
	    layer = null;
	    properties = {};
	    options = {};
	    if (arguments.length === 3) {
	      layer = args[0];
	      properties = args[1];
	      options = {};
	      if (properties.options != null) {
	        options = _.clone(properties.options);
	      }
	      if (args[2]) {
	        options = _.extend({}, options, args[2]);
	      }
	    }
	    if (arguments.length === 2) {
	      layer = args[0];
	      if (args[1].properties != null) {
	        properties = args[1].properties;
	      } else {
	        properties = args[1];
	      }
	      if (args[1].options != null) {
	        options = args[1].options;
	      }
	    }
	    if (arguments.length === 1) {
	      layer = args[0].layer;
	      properties = args[0].properties;
	      if (args[0].options != null) {
	        options = args[0].options;
	      } else {
	        options = args[0];
	      }
	    }
	    delete options.layer;
	    delete options.properties;
	    delete options.options;
	    this.options = _.cloneDeep(Defaults.getDefaults("Animation", options));
	    Animation.__super__.constructor.apply(this, arguments);
	    this._layer = layer;
	    if (!(layer instanceof _Layer)) {
	      throw Error("Animation: missing layer");
	    }
	    this.properties = Animation.filterAnimatableProperties(properties);
	    if (properties.origin) {
	      console.warn("Animation.origin: please use layer.originX and layer.originY");
	    }
	    if (_.isString(this.options.curve)) {
	      this.options.curve = Curves.fromString(this.options.curve);
	    }
	    if (this.options.curve === Curves.Spring || this.options.curve === Curves.Bezier) {
	      this.options.curve = this.options.curve.call();
	    }
	    this._originalState = this._currentState();
	    this._repeatCounter = this.options.repeat;
	  }
	
	  Animation.define("layer", {
	    get: function() {
	      return this._layer;
	    }
	  });
	
	  Animation.define("isPending", {
	    get: function() {
	      return this._delayTimer != null;
	    }
	  });
	
	  Animation.define("isAnimating", {
	    get: function() {
	      return indexOf.call(this.layer.animations(), this) >= 0;
	    }
	  });
	
	  Animation.define("looping", {
	    get: function() {
	      return this.options.looping;
	    },
	    set: function(value) {
	      var ref, ref1;
	      if ((ref = this.options) != null) {
	        ref.looping = value;
	      }
	      if (((ref1 = this.options) != null ? ref1.looping : void 0) && (this.layer != null) && !this.isAnimating) {
	        return this.restart();
	      }
	    }
	  });
	
	  Animation.define("isNoop", Animation.simpleProperty("isNoop", false));
	
	  Animation.prototype.start = function() {
	    var animation, k, property, ref, ref1, ref2, start, v;
	    this._animator = this.options.curve(this.options);
	    this._target = this.layer;
	    this._stateA = this._currentState();
	    this._stateB = {};
	    ref = this.properties;
	    for (k in ref) {
	      v = ref[k];
	      if (_.isFunction(v)) {
	        v = v(this.layer, k);
	      } else if (isRelativeProperty(v)) {
	        v = evaluateRelativeProperty(this._target, k, v);
	      }
	      if (this._stateA[k] !== v) {
	        this._stateB[k] = v;
	      }
	    }
	    if (_.keys(this._stateA).length === 0) {
	      console.warn("Animation: nothing to animate, no animatable properties");
	      return this._noop();
	    }
	    if (_.isEqual(this._stateA, this._stateB)) {
	      console.warn("Animation: nothing to animate, all properties are equal to what it is now");
	      return this._noop();
	    }
	    if (_.keys(this._stateB).length === 0) {
	      return this._noop();
	    }
	    ref1 = this._target.animatingProperties();
	    for (property in ref1) {
	      animation = ref1[property];
	      if (this._stateA.hasOwnProperty(property)) {
	        animation.stop();
	      }
	      if (property === "x" && (this._stateA.hasOwnProperty("minX") || this._stateA.hasOwnProperty("midX") || this._stateA.hasOwnProperty("maxX"))) {
	        animation.stop();
	      }
	      if (property === "y" && (this._stateA.hasOwnProperty("minY") || this._stateA.hasOwnProperty("midY") || this._stateA.hasOwnProperty("maxY"))) {
	        animation.stop();
	      }
	    }
	    if (this.options.debug) {
	      console.log("Animation.start");
	      ref2 = this._stateB;
	      for (k in ref2) {
	        v = ref2[k];
	        console.log("\t" + k + ": " + this._stateA[k] + " -> " + this._stateB[k]);
	      }
	    }
	    if (_.isFunction(this.options.onStart)) {
	      this.on(Events.AnimationStart, this.options.onStart);
	    }
	    if (_.isFunction(this.options.onHalt)) {
	      this.on(Events.AnimationHalt, this.options.onHalt);
	    }
	    if (_.isFunction(this.options.onStop)) {
	      this.on(Events.AnimationStop, this.options.onStop);
	    }
	    if (_.isFunction(this.options.onEnd)) {
	      this.on(Events.AnimationEnd, this.options.onEnd);
	    }
	    this.once("end", (function(_this) {
	      return function() {
	        if (_this._repeatCounter > 0 || _this.looping) {
	          _this.restart();
	          if (!_this.looping) {
	            return _this._repeatCounter--;
	          }
	        }
	      };
	    })(this));
	    this._prepareUpdateValues();
	    if (this.options.animate === false || this.options.instant === true) {
	      start = this._instant;
	    } else {
	      start = this._start;
	    }
	    this.layer.context.addAnimation(this);
	    if (this.options.delay) {
	      this._delayTimer = Utils.delay(this.options.delay, start);
	    } else {
	      start();
	    }
	    return true;
	  };
	
	  Animation.prototype.stop = function(emit) {
	    if (emit == null) {
	      emit = true;
	    }
	    if (this._delayTimer != null) {
	      Framer.CurrentContext.removeTimer(this._delayTimer);
	      this._delayTimer = null;
	    }
	    this.layer.context.removeAnimation(this);
	    if (emit) {
	      this.emit(Events.AnimationHalt);
	    }
	    if (emit) {
	      this.emit(Events.AnimationStop);
	    }
	    return Framer.Loop.off("update", this._update);
	  };
	
	  Animation.prototype.reverse = function() {
	    var options, properties;
	    properties = _.clone(this._originalState);
	    options = _.clone(this.options);
	    return new Animation(this.layer, properties, options);
	  };
	
	  Animation.prototype.reset = function() {
	    var k, ref, results, v;
	    ref = this._stateA;
	    results = [];
	    for (k in ref) {
	      v = ref[k];
	      results.push(this._target[k] = v);
	    }
	    return results;
	  };
	
	  Animation.prototype.restart = function() {
	    this.reset();
	    return this.start();
	  };
	
	  Animation.prototype.copy = function() {
	    var options, properties;
	    properties = _.clone(this.properties);
	    options = _.clone(this.options);
	    return new Animation(this.layer, properties, options);
	  };
	
	  Animation.prototype.revert = function() {
	    return this.reverse();
	  };
	
	  Animation.prototype.inverse = function() {
	    return this.reverse();
	  };
	
	  Animation.prototype.invert = function() {
	    return this.reverse();
	  };
	
	  Animation.prototype.emit = function(event) {
	    Animation.__super__.emit.apply(this, arguments);
	    return this.layer.emit(event, this);
	  };
	
	  Animation.prototype.animatingProperties = function() {
	    return _.keys(this._stateA);
	  };
	
	  Animation.prototype._instant = function() {
	    this.emit(Events.AnimationStart);
	    this._updateValues(1);
	    this.emit(Events.AnimationStop);
	    return this.emit(Events.AnimationEnd);
	  };
	
	  Animation.prototype._noop = function() {
	    this.isNoop = true;
	    return !this.isNoop;
	  };
	
	  Animation.prototype._start = function() {
	    this._delayTimer = null;
	    this.emit(Events.AnimationStart);
	    return Framer.Loop.on("update", this._update);
	  };
	
	  Animation.prototype.finish = function() {
	    this.stop();
	    return this._updateValues(1);
	  };
	
	  Animation.prototype._update = function(delta) {
	    var emit;
	    if (this._animator.finished()) {
	      this._updateValues(1);
	      this.stop(emit = false);
	      this.emit(Events.AnimationStop);
	      return this.emit(Events.AnimationEnd);
	    } else {
	      return this._updateValues(this._animator.next(delta));
	    }
	  };
	
	  Animation.prototype._prepareUpdateValues = function() {
	    var k, ref, results, v;
	    this._valueUpdaters = {};
	    ref = this._stateB;
	    results = [];
	    for (k in ref) {
	      v = ref[k];
	      if (Color.isColorObject(v) || Color.isColorObject(this._stateA[k])) {
	        results.push(this._valueUpdaters[k] = this._updateColorValue);
	      } else {
	        results.push(this._valueUpdaters[k] = this._updateNumberValue);
	      }
	    }
	    return results;
	  };
	
	  Animation.prototype._updateValues = function(value) {
	    var k, ref, v;
	    ref = this._stateB;
	    for (k in ref) {
	      v = ref[k];
	      this._valueUpdaters[k](k, value);
	    }
	    return null;
	  };
	
	  Animation.prototype._updateNumberValue = function(key, value) {
	    return this._target[key] = Utils.mapRange(value, 0, 1, this._stateA[key], this._stateB[key]);
	  };
	
	  Animation.prototype._updateColorValue = function(key, value) {
	    return this._target[key] = Color.mix(this._stateA[key], this._stateB[key], value, false, this.options.colorModel);
	  };
	
	  Animation.prototype._currentState = function() {
	    return _.pick(this.layer, _.keys(this.properties));
	  };
	
	  Animation.isAnimatable = function(v) {
	    return _.isNumber(v) || _.isFunction(v) || isRelativeProperty(v) || Color.isColorObject(v);
	  };
	
	  Animation.filterAnimatableProperties = function(properties) {
	    var animatableProperties, derivedKey, derivedKeys, i, k, len, v;
	    animatableProperties = {};
	    for (k in properties) {
	      v = properties[k];
	      if (k === "frame" || k === "size" || k === "point") {
	        switch (k) {
	          case "frame":
	            derivedKeys = ["x", "y", "width", "height"];
	            break;
	          case "size":
	            derivedKeys = ["width", "height"];
	            break;
	          case "point":
	            derivedKeys = ["x", "y"];
	            break;
	          default:
	            derivedKeys = [];
	        }
	        if (_.isObject(v)) {
	          _.defaults(animatableProperties, _.pick(v, derivedKeys));
	        } else if (_.isNumber(v)) {
	          for (i = 0, len = derivedKeys.length; i < len; i++) {
	            derivedKey = derivedKeys[i];
	            animatableProperties[derivedKey] = v;
	          }
	        }
	      } else if (this.isAnimatable(v)) {
	        animatableProperties[k] = v;
	      } else if (Color.isValidColorProperty(k, v)) {
	        animatableProperties[k] = new Color(v);
	      }
	    }
	    return animatableProperties;
	  };
	
	  Animation.prototype.toInspect = function() {
	    var ref;
	    return "<" + this.constructor.name + " id:" + this.id + " layer:" + ((ref = this.layer) != null ? ref.toName() : void 0) + " [" + (_.keys(this.properties).join(", ")) + "] isAnimating:" + this.isAnimating + ">";
	  };
	
	  Animation.prototype.onAnimationStart = function(cb) {
	    return this.on(Events.AnimationStart, cb);
	  };
	
	  Animation.prototype.onAnimationHalt = function(cb) {
	    return this.on(Events.AnimationHalt, cb);
	  };
	
	  Animation.prototype.onAnimationStop = function(cb) {
	    return this.on(Events.AnimationStop, cb);
	  };
	
	  Animation.prototype.onAnimationEnd = function(cb) {
	    return this.on(Events.AnimationEnd, cb);
	  };
	
	  Animation.prototype.onAnimationDidStart = function(cb) {
	    return this.on(Events.AnimationDidStart, cb);
	  };
	
	  Animation.prototype.onAnimationDidStop = function(cb) {
	    return this.on(Events.AnimationDidStop, cb);
	  };
	
	  Animation.prototype.onAnimationDidEnd = function(cb) {
	    return this.on(Events.AnimationDidEnd, cb);
	  };
	
	  return Animation;
	
	})(BaseClass);


/***/ },
/* 19 */
/***/ function(module, exports) {

	exports.Animator = (function() {
	  "The animator class is a very simple class that\n	- Takes a set of input values at setup({input values})\n	- Emits an output value for progress (0 -> 1) in value(progress)";
	  function Animator(options) {
	    if (options == null) {
	      options = {};
	    }
	    this.setup(options);
	  }
	
	  Animator.prototype.setup = function(options) {
	    throw Error("Not implemented");
	  };
	
	  Animator.prototype.next = function(delta) {
	    throw Error("Not implemented");
	  };
	
	  Animator.prototype.finished = function() {
	    throw Error("Not implemented");
	  };
	
	  Animator.prototype.values = function(delta, limit) {
	    var i, j, ref, values;
	    if (delta == null) {
	      delta = 1 / 60;
	    }
	    if (limit == null) {
	      limit = 100;
	    }
	    values = [];
	    for (i = j = 0, ref = limit; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
	      values.push(this.next(delta));
	      if (this.finished()) {
	        break;
	      }
	    }
	    return values;
	  };
	
	  return Animator;

	})();


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var Animator,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	Animator = __webpack_require__(19).Animator;
	
	exports.LinearAnimator = (function(superClass) {
	  extend(LinearAnimator, superClass);
	
	  function LinearAnimator() {
	    return LinearAnimator.__super__.constructor.apply(this, arguments);
	  }
	
	  LinearAnimator.prototype.setup = function(options) {
	    this.options = _.defaults(options, {
	      time: 1,
	      precision: 1 / 1000
	    });
	    return this._time = 0;
	  };
	
	  LinearAnimator.prototype.next = function(delta) {
	    this._time += delta;
	    if (this.finished()) {
	      return 1;
	    }
	    return this._time / this.options.time;
	  };
	
	  LinearAnimator.prototype.finished = function() {
	    return this._time >= this.options.time - this.options.precision;
	  };
	
	  return LinearAnimator;
	
	})(Animator);


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var Bezier, BezierCurveAnimator, BezierDefaults, Defaults, Spring, SpringRK4Animator, computeDampingRatio, computeDerivedCurveOptions, computeDuration, fromDefinition, parseFunction, ref,
	  slice = [].slice;
	
	BezierCurveAnimator = __webpack_require__(22).BezierCurveAnimator;
	
	ref = __webpack_require__(23), computeDerivedCurveOptions = ref.computeDerivedCurveOptions, computeDuration = ref.computeDuration, computeDampingRatio = ref.computeDampingRatio;
	
	SpringRK4Animator = __webpack_require__(24).SpringRK4Animator;
	
	Defaults = __webpack_require__(17).Defaults;
	
	Bezier = function() {
	  var values;
	  values = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	  return function(options) {
	    if (options == null) {
	      options = {};
	    }
	    if (values.length > 0) {
	      options.values = values;
	    }
	    return new BezierCurveAnimator(options);
	  };
	};
	
	BezierDefaults = {
	  linear: function(options) {
	    if (options == null) {
	      options = {};
	    }
	    return Bezier(0, 0, 1, 1)(options);
	  },
	  ease: function(options) {
	    if (options == null) {
	      options = {};
	    }
	    return Bezier(.25, .1, .25, 1)(options);
	  },
	  easeIn: function(options) {
	    if (options == null) {
	      options = {};
	    }
	    return Bezier(.42, 0, 1, 1)(options);
	  },
	  easeOut: function(options) {
	    if (options == null) {
	      options = {};
	    }
	    return Bezier(0, 0, .58, 1)(options);
	  },
	  easeInOut: function(options) {
	    if (options == null) {
	      options = {};
	    }
	    return Bezier(.42, 0, .58, 1)(options);
	  }
	};
	
	Spring = function(dampingRatio, mass, velocity) {
	  var curveOptions;
	  curveOptions = {};
	  if ((dampingRatio != null) && _.isFinite(dampingRatio)) {
	    curveOptions.dampingRatio = dampingRatio;
	  }
	  if (mass != null) {
	    curveOptions.mass = mass;
	  }
	  if (velocity != null) {
	    curveOptions.velocity = velocity;
	  }
	  if (!_.isFinite(dampingRatio) && typeof dampingRatio === 'object') {
	    curveOptions = dampingRatio;
	    if ((curveOptions.damping != null) && (curveOptions.dampingRatio == null)) {
	      curveOptions.dampingRatio = curveOptions.damping;
	    }
	  }
	  if ((curveOptions.tension == null) && (curveOptions.friction == null)) {
	    curveOptions = Defaults.getDefaults("Spring", curveOptions);
	  }
	  return function(options) {
	    var animator, derivedOptions, duration, ref1;
	    if (curveOptions.dampingRatio != null) {
	      duration = (ref1 = options != null ? options.time : void 0) != null ? ref1 : 1;
	      derivedOptions = computeDerivedCurveOptions(curveOptions.dampingRatio, duration, curveOptions.velocity, curveOptions.mass);
	      curveOptions = _.defaults(derivedOptions, curveOptions);
	    } else {
	      if (options != null) {
	        delete options.time;
	      }
	    }
	    options = _.defaults(curveOptions, options);
	    animator = new SpringRK4Animator(options);
	    if (duration != null) {
	      animator.time = duration;
	    }
	    return animator;
	  };
	};
	
	_.assign(Bezier, BezierDefaults);
	
	Spring.computeDerivedCurveOptions = computeDerivedCurveOptions;
	
	Spring.computeDuration = computeDuration;
	
	Spring.computeDampingRatio = computeDampingRatio;
	
	exports.Spring = Spring;
	
	exports.Bezier = Bezier;
	
	parseFunction = function(string) {
	  var args, argumentObject, argumentsRegex, match, matches, numbers, numbersRegex, prop, property, regex, result, type, value;
	  if (!_.isString(string)) {
	    return null;
	  }
	  regex = /.*(Spring|Bezier)(?:\(\s*{?([\w:\s,.]*)}?\s*\)|\.(\w+))?/;
	  matches = regex.exec(string);
	  if (matches == null) {
	    return null;
	  }
	  match = matches[0], type = matches[1], args = matches[2], prop = matches[3];
	  result = {
	    name: type,
	    property: null,
	    "arguments": null
	  };
	  if (prop != null) {
	    result.property = prop;
	    return result;
	  }
	  if (args == null) {
	    return result;
	  }
	  if (args.length === 0) {
	    result["arguments"] = [];
	  }
	  argumentsRegex = /\s*([\w]+)\s*:\s*([\d.]+)\s*,?/g;
	  argumentObject = {};
	  while (matches = argumentsRegex.exec(args)) {
	    match = matches[0], property = matches[1], value = matches[2];
	    value = parseFloat(value);
	    if (!isNaN(value)) {
	      argumentObject[property] = value;
	    }
	  }
	  if (_.size(argumentObject) > 0) {
	    result["arguments"] = argumentObject;
	    return result;
	  }
	  numbersRegex = /\s*([.\d]+)\s*/g;
	  numbers = [];
	  while (matches = numbersRegex.exec(args)) {
	    match = matches[0], value = matches[1];
	    value = parseFloat(value);
	    numbers.push(value);
	  }
	  result["arguments"] = numbers;
	  return result;
	};
	
	fromDefinition = function(definition) {
	  var curve;
	  if (definition == null) {
	    return null;
	  }
	  curve = Framer.Curves[definition.name];
	  if (curve == null) {
	    return null;
	  }
	  if (definition.property != null) {
	    return curve[definition.property];
	  }
	  if (definition["arguments"] == null) {
	    return curve;
	  }
	  if (_.isArray(definition["arguments"])) {
	    return curve.apply(null, definition["arguments"]);
	  }
	  return curve(definition["arguments"]);
	};
	
	exports.parseFunction = parseFunction;
	
	exports.fromDefinition = fromDefinition;
	
	exports.fromString = function(string) {
	  var args, func, object, pairs;
	  if (!_.isString(string)) {
	    return null;
	  }
	  func = fromDefinition(parseFunction(string));
	  if (func != null) {
	    return func;
	  }
	  func = Utils.parseFunction(string);
	  args = func.args.map(parseFloat);
	  switch (func.name) {
	    case "linear":
	      return Bezier.linear;
	    case "ease":
	      return Bezier.ease;
	    case "ease-in":
	      return Bezier.easeIn;
	    case "ease-out":
	      return Bezier.easeOut;
	    case "ease-in-out":
	      return Bezier.easeInOut;
	    case "bezier-curve":
	    case "cubic-bezier":
	      return Bezier.apply(null, args);
	    case "spring":
	    case "spring-rk4":
	    case "spring-dho":
	      pairs = _.zipWith(["tension", "friction", "velocity", "tolerance"], args, [250, 25, 0, 1 / 100], function(key, value, defaults) {
	        return [key, value != null ? value : defaults];
	      });
	      object = _.fromPairs(pairs);
	      return Spring(object);
	    default:
	      return Bezier.linear;
	  }
	};


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var Animator, BezierCurveDefaults, UnitBezier,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	Animator = __webpack_require__(19).Animator;
	
	BezierCurveDefaults = {
	  "linear": [0, 0, 1, 1],
	  "ease": [.25, .1, .25, 1],
	  "ease-in": [.42, 0, 1, 1],
	  "ease-out": [0, 0, .58, 1],
	  "ease-in-out": [.42, 0, .58, 1]
	};
	
	exports.BezierCurveAnimator = (function(superClass) {
	  extend(BezierCurveAnimator, superClass);
	
	  function BezierCurveAnimator() {
	    return BezierCurveAnimator.__super__.constructor.apply(this, arguments);
	  }
	
	  BezierCurveAnimator.prototype.setup = function(options) {
	    if (_.isString(options) && BezierCurveDefaults.hasOwnProperty(options.toLowerCase())) {
	      options = {
	        values: BezierCurveDefaults[options.toLowerCase()]
	      };
	    }
	    if (options.values && _.isString(options.values) && BezierCurveDefaults.hasOwnProperty(options.values.toLowerCase())) {
	      options = {
	        values: BezierCurveDefaults[options.values.toLowerCase()],
	        time: options.time
	      };
	    }
	    if (_.isArray(options) && options.length === 4) {
	      options = {
	        values: options
	      };
	    }
	    this.options = _.defaults(options, {
	      values: BezierCurveDefaults["ease"],
	      time: 1,
	      precision: 1 / 1000
	    });
	    return this._unitBezier = new UnitBezier(this.options.values[0], this.options.values[1], this.options.values[2], this.options.values[3], this._time = 0);
	  };
	
	  BezierCurveAnimator.prototype.next = function(delta) {
	    this._time += delta;
	    if (this.finished()) {
	      return 1;
	    }
	    return this._unitBezier.solve(this._time / this.options.time);
	  };
	
	  BezierCurveAnimator.prototype.finished = function() {
	    return this._time >= this.options.time - this.options.precision;
	  };
	
	  return BezierCurveAnimator;
	
	})(Animator);
	
	UnitBezier = (function() {
	  UnitBezier.prototype.epsilon = 1e-6;
	
	  function UnitBezier(p1x, p1y, p2x, p2y) {
	    this.cx = 3.0 * p1x;
	    this.bx = 3.0 * (p2x - p1x) - this.cx;
	    this.ax = 1.0 - this.cx - this.bx;
	    this.cy = 3.0 * p1y;
	    this.by = 3.0 * (p2y - p1y) - this.cy;
	    this.ay = 1.0 - this.cy - this.by;
	  }
	
	  UnitBezier.prototype.sampleCurveX = function(t) {
	    return ((this.ax * t + this.bx) * t + this.cx) * t;
	  };
	
	  UnitBezier.prototype.sampleCurveY = function(t) {
	    return ((this.ay * t + this.by) * t + this.cy) * t;
	  };
	
	  UnitBezier.prototype.sampleCurveDerivativeX = function(t) {
	    return (3.0 * this.ax * t + 2.0 * this.bx) * t + this.cx;
	  };
	
	  UnitBezier.prototype.solveCurveX = function(x) {
	    var d2, i, t0, t1, t2, x2;
	    t2 = x;
	    i = 0;
	    while (i < 8) {
	      x2 = this.sampleCurveX(t2) - x;
	      if (Math.abs(x2) < this.epsilon) {
	        return t2;
	      }
	      d2 = this.sampleCurveDerivativeX(t2);
	      if (Math.abs(d2) < this.epsilon) {
	        break;
	      }
	      t2 = t2 - x2 / d2;
	      i++;
	    }
	    t0 = 0.0;
	    t1 = 1.0;
	    t2 = x;
	    if (t2 < t0) {
	      return t0;
	    }
	    if (t2 > t1) {
	      return t1;
	    }
	    while (t0 < t1) {
	      x2 = this.sampleCurveX(t2);
	      if (Math.abs(x2 - x) < this.epsilon) {
	        return t2;
	      }
	      if (x > x2) {
	        t0 = t2;
	      } else {
	        t1 = t2;
	      }
	      t2 = (t1 - t0) * .5 + t0;
	    }
	    return t2;
	  };
	
	  UnitBezier.prototype.solve = function(x) {
	    return this.sampleCurveY(this.solveCurveX(x));
	  };
	
	  return UnitBezier;

	})();


/***/ },
/* 23 */
/***/ function(module, exports) {

	var angularFrequency, approximateRoot, computeDampingRatio, epsilon, maxDamping, maxDuration, minDamping, minDuration;
	
	epsilon = 0.001;
	
	minDuration = 0.01;
	
	maxDuration = 10.0;
	
	minDamping = Number.MIN_VALUE;
	
	maxDamping = 1;
	
	approximateRoot = function(func, derivative, initialGuess, times) {
	  var i, j, ref, result;
	  if (times == null) {
	    times = 12;
	  }
	  result = initialGuess;
	  for (i = j = 1, ref = times; 1 <= ref ? j < ref : j > ref; i = 1 <= ref ? ++j : --j) {
	    result = result - func(result) / derivative(result);
	  }
	  return result;
	};
	
	angularFrequency = function(undampedFrequency, dampingRatio) {
	  return undampedFrequency * Math.sqrt(1 - Math.pow(dampingRatio, 2));
	};
	
	exports.computeDampingRatio = computeDampingRatio = function(tension, friction, mass) {
	  if (mass == null) {
	    mass = 1;
	  }
	  return friction / (2 * Math.sqrt(mass * tension));
	};
	
	exports.computeDuration = function(tension, friction, velocity, mass) {
	  var a, b, c, d, dampingRatio, duration, undampedFrequency;
	  if (velocity == null) {
	    velocity = 0;
	  }
	  if (mass == null) {
	    mass = 1;
	  }
	  dampingRatio = computeDampingRatio(tension, friction);
	  undampedFrequency = Math.sqrt(tension / mass);
	  if (dampingRatio < 1) {
	    a = Math.sqrt(1 - Math.pow(dampingRatio, 2));
	    b = velocity / (a * undampedFrequency);
	    c = dampingRatio / a;
	    d = -((b - c) / epsilon);
	    if (d <= 0) {
	      return null;
	    }
	    duration = Math.log(d) / (dampingRatio * undampedFrequency);
	  } else {
	    return null;
	  }
	  return duration;
	};
	
	exports.computeDerivedCurveOptions = function(dampingRatio, duration, velocity, mass) {
	  var derivative, envelope, initialGuess, result, undampedFrequency;
	  if (velocity == null) {
	    velocity = 0;
	  }
	  if (mass == null) {
	    mass = 1;
	  }
	  dampingRatio = Math.max(Math.min(dampingRatio, maxDamping), minDamping);
	  duration = Math.max(Math.min(duration, maxDuration), minDuration);
	  if (dampingRatio < 1) {
	    envelope = function(undampedFrequency) {
	      var a, b, c, currentDisplacement, exponentialDecay;
	      exponentialDecay = undampedFrequency * dampingRatio;
	      currentDisplacement = exponentialDecay * duration;
	      a = exponentialDecay - velocity;
	      b = angularFrequency(undampedFrequency, dampingRatio);
	      c = Math.exp(-currentDisplacement);
	      return epsilon - (a / b) * c;
	    };
	    derivative = function(undampedFrequency) {
	      var currentDisplacement, d, e, exponentialDecay, f, factor, g;
	      exponentialDecay = undampedFrequency * dampingRatio;
	      currentDisplacement = exponentialDecay * duration;
	      d = currentDisplacement * velocity + velocity;
	      e = Math.pow(dampingRatio, 2) * Math.pow(undampedFrequency, 2) * duration;
	      f = Math.exp(-currentDisplacement);
	      g = angularFrequency(Math.pow(undampedFrequency, 2), dampingRatio);
	      factor = (-envelope(undampedFrequency) + epsilon) > 0 ? -1 : 1;
	      return factor * ((d - e) * f) / g;
	    };
	  } else {
	    envelope = function(undampedFrequency) {
	      var a, b;
	      a = Math.exp(-undampedFrequency * duration);
	      b = (undampedFrequency - velocity) * duration + 1;
	      return -epsilon + a * b;
	    };
	    derivative = function(undampedFrequency) {
	      var a, b;
	      a = Math.exp(-undampedFrequency * duration);
	      b = (velocity - undampedFrequency) * Math.pow(duration, 2);
	      return a * b;
	    };
	  }
	  result = {
	    tension: 100,
	    friction: 10,
	    velocity: velocity
	  };
	  initialGuess = 5 / duration;
	  undampedFrequency = approximateRoot(envelope, derivative, initialGuess);
	  if (!isNaN(undampedFrequency)) {
	    result.tension = Math.pow(undampedFrequency, 2) * mass;
	    result.friction = dampingRatio * 2 * Math.sqrt(mass * result.tension);
	  }
	  return result;
	};


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var Animator, Integrator,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	Animator = __webpack_require__(19).Animator;
	
	Integrator = __webpack_require__(25).Integrator;
	
	exports.SpringRK4Animator = (function(superClass) {
	  extend(SpringRK4Animator, superClass);
	
	  function SpringRK4Animator() {
	    this.finished = bind(this.finished, this);
	    return SpringRK4Animator.__super__.constructor.apply(this, arguments);
	  }
	
	  SpringRK4Animator.prototype.setup = function(options) {
	    this.options = _.defaults(options, {
	      tension: 250,
	      friction: 25,
	      velocity: 0,
	      tolerance: 1 / 1000
	    });
	    this._time = 0;
	    this._value = 0;
	    this._velocity = this.options.velocity;
	    this._stopSpring = false;
	    return this._integrator = new Integrator((function(_this) {
	      return function(state) {
	        return -_this.options.tension * state.x - _this.options.friction * state.v;
	      };
	    })(this));
	  };
	
	  SpringRK4Animator.prototype.next = function(delta) {
	    var finalVelocity, net1DVelocity, netFloat, netValueIsLow, netVelocityIsLow, stateAfter, stateBefore;
	    if (this.finished()) {
	      return 1;
	    }
	    this._time += delta;
	    stateBefore = {};
	    stateAfter = {};
	    stateBefore.x = this._value - 1;
	    stateBefore.v = this._velocity;
	    stateAfter = this._integrator.integrateState(stateBefore, delta);
	    this._value = 1 + stateAfter.x;
	    finalVelocity = stateAfter.v;
	    netFloat = stateAfter.x;
	    net1DVelocity = stateAfter.v;
	    netValueIsLow = Math.abs(netFloat) < this.options.tolerance;
	    netVelocityIsLow = Math.abs(net1DVelocity) < this.options.tolerance;
	    this._stopSpring = netValueIsLow && netVelocityIsLow;
	    this._velocity = finalVelocity;
	    return this._value;
	  };
	
	  SpringRK4Animator.prototype.finished = function() {
	    return this._stopSpring;
	  };
	
	  return SpringRK4Animator;
	
	})(Animator);


/***/ },
/* 25 */
/***/ function(module, exports) {

	exports.Integrator = (function() {
	  "Usage:\n	- Instantiate with a function that takes (state) -> acceleration\n	- Call integrateState with state={x, v} and delta";
	  function Integrator(_accelerationForState) {
	    this._accelerationForState = _accelerationForState;
	    if (!_.isFunction(this._accelerationForState)) {
	      console.warn("Integrator: an integrator must be constructed with an acceleration function");
	      this._accelerationForState = function() {
	        return 0;
	      };
	    }
	  }
	
	  Integrator.prototype.integrateState = function(state, dt) {
	    var a, b, c, d, dvdt, dxdt;
	    a = this._evaluateState(state);
	    b = this._evaluateStateWithDerivative(state, dt * 0.5, a);
	    c = this._evaluateStateWithDerivative(state, dt * 0.5, b);
	    d = this._evaluateStateWithDerivative(state, dt, c);
	    dxdt = 1.0 / 6.0 * (a.dx + 2.0 * (b.dx + c.dx) + d.dx);
	    dvdt = 1.0 / 6.0 * (a.dv + 2.0 * (b.dv + c.dv) + d.dv);
	    state.x = state.x + dxdt * dt;
	    state.v = state.v + dvdt * dt;
	    return state;
	  };
	
	  Integrator.prototype._evaluateState = function(initialState) {
	    var output;
	    output = {};
	    output.dx = initialState.v;
	    output.dv = this._accelerationForState(initialState);
	    return output;
	  };
	
	  Integrator.prototype._evaluateStateWithDerivative = function(initialState, dt, derivative) {
	    var output, state;
	    state = {};
	    state.x = initialState.x + derivative.dx * dt;
	    state.v = initialState.v + derivative.dv * dt;
	    output = {};
	    output.dx = state.v;
	    output.dv = this._accelerationForState(state);
	    return output;
	  };
	
	  return Integrator;

	})();


/***/ },
/* 26 */
/***/ function(module, exports) {

	var _Force2DProperties, _WebkitProperties, filterFormat, roundToZero;
	
	filterFormat = function(value, unit) {
	  return "" + (Utils.round(value, 2)) + unit;
	};
	
	roundToZero = function(num) {
	  if (-1e-6 < num && num < 1e-6) {
	    return 0;
	  }
	  return num;
	};
	
	_WebkitProperties = [["blur", "blur", 0, "px"], ["brightness", "brightness", 100, "%"], ["saturate", "saturate", 100, "%"], ["hue-rotate", "hueRotate", 0, "deg"], ["contrast", "contrast", 100, "%"], ["invert", "invert", 0, "%"], ["grayscale", "grayscale", 0, "%"], ["sepia", "sepia", 0, "%"]];
	
	_Force2DProperties = {
	  "z": 0,
	  "scaleX": 1,
	  "scaleY": 1,
	  "scaleZ": 1,
	  "skewX": 0,
	  "skewY": 0,
	  "rotationX": 0,
	  "rotationY": 0
	};
	
	exports.LayerStyle = {
	  width: function(layer) {
	    return layer._properties.width + "px";
	  },
	  height: function(layer) {
	    return layer._properties.height + "px";
	  },
	  display: function(layer) {
	    if (layer._properties.visible === true) {
	      return "block";
	    }
	    return "none";
	  },
	  opacity: function(layer) {
	    return layer._properties.opacity;
	  },
	  webkitTransformStyle: function(layer) {
	    if (layer._properties.flat) {
	      return "flat";
	    } else {
	      return "preserve-3d";
	    }
	  },
	  webkitBackfaceVisibility: function(layer) {
	    if (layer._properties.backfaceVisible) {
	      return "visible";
	    } else {
	      return "hidden";
	    }
	  },
	  overflow: function(layer) {
	    if (layer._properties.scrollHorizontal === true || layer._properties.scrollVertical === true) {
	      return "auto";
	    }
	    if (layer._properties.clip === true) {
	      return "hidden";
	    }
	    return "visible";
	  },
	  overflowX: function(layer) {
	    if (layer._properties.scrollHorizontal === true) {
	      return "scroll";
	    }
	    if (layer._properties.clip === true) {
	      return "hidden";
	    }
	    return "visible";
	  },
	  overflowY: function(layer) {
	    if (layer._properties.scrollVertical === true) {
	      return "scroll";
	    }
	    if (layer._properties.clip === true) {
	      return "hidden";
	    }
	    return "visible";
	  },
	  zIndex: function(layer) {
	    return layer._properties.index;
	  },
	  webkitFilter: function(layer) {
	    var css, cssName, fallback, i, layerName, len, ref, unit;
	    css = [];
	    for (i = 0, len = _WebkitProperties.length; i < len; i++) {
	      ref = _WebkitProperties[i], cssName = ref[0], layerName = ref[1], fallback = ref[2], unit = ref[3];
	      if (layer._properties.hasOwnProperty(layerName) && layer[layerName] !== fallback) {
	        css.push(cssName + "(" + (filterFormat(layer[layerName], unit)) + ")");
	      }
	    }
	    return css.join(" ");
	  },
	  webkitTransform: function(layer) {
	    if (layer._prefer2d || layer._properties.force2d) {
	      return exports.LayerStyle.webkitTransformForce2d(layer);
	    }
	    return "translate3d( " + (roundToZero(layer._properties.x)) + "px, " + (roundToZero(layer._properties.y)) + "px, " + (roundToZero(layer._properties.z)) + "px) scale3d( " + (roundToZero(layer._properties.scaleX * layer._properties.scale)) + ", " + (roundToZero(layer._properties.scaleY * layer._properties.scale)) + ", " + (roundToZero(layer._properties.scaleZ)) + ") skew(" + (roundToZero(layer._properties.skew)) + "deg," + (roundToZero(layer._properties.skew)) + "deg) skewX(" + (roundToZero(layer._properties.skewX)) + "deg) skewY(" + (roundToZero(layer._properties.skewY)) + "deg) translateZ(" + (roundToZero(layer._properties.originZ)) + "px) rotateX(" + (roundToZero(layer._properties.rotationX)) + "deg) rotateY(" + (roundToZero(layer._properties.rotationY)) + "deg) rotateZ(" + (roundToZero(layer._properties.rotationZ)) + "deg) translateZ(" + (roundToZero(-layer._properties.originZ)) + "px)";
	  },
	  webkitTransformForce2d: function(layer) {
	    var css, p, v;
	    css = [];
	    for (p in _Force2DProperties) {
	      v = _Force2DProperties[p];
	      if (layer._properties[p] !== v) {
	        console.warn("Layer property '" + p + "'' will be ignored with force2d enabled");
	      }
	    }
	    css.push("translate(" + (roundToZero(layer._properties.x)) + "px," + (roundToZero(layer._properties.y)) + "px)");
	    css.push("scale(" + (roundToZero(layer._properties.scale)) + ")");
	    css.push("skew(" + (roundToZero(layer._properties.skew)) + "deg," + (roundToZero(layer._properties.skew)) + "deg)");
	    css.push("rotate(" + (roundToZero(layer._properties.rotationZ)) + "deg)");
	    return css.join(" ");
	  },
	  webkitTransformOrigin: function(layer) {
	    return (layer._properties.originX * 100) + "% " + (layer._properties.originY * 100) + "%";
	  },
	  webkitPerspective: function(layer) {
	    return "" + layer._properties.perspective;
	  },
	  webkitPerspectiveOrigin: function(layer) {
	    return (layer._properties.perspectiveOriginX * 100) + "% " + (layer._properties.perspectiveOriginY * 100) + "%";
	  },
	  pointerEvents: function(layer) {
	    if (layer._properties.ignoreEvents) {
	      return "none";
	    } else {
	      return "auto";
	    }
	  },
	  boxShadow: function(layer) {
	    var props;
	    props = layer._properties;
	    if (!props.shadowColor) {
	      return "";
	    } else if (props.shadowX === 0 && props.shadowY === 0 && props.shadowBlur === 0 && props.shadowSpread === 0) {
	      return "";
	    }
	    return layer._properties.shadowX + "px " + layer._properties.shadowY + "px " + layer._properties.shadowBlur + "px " + layer._properties.shadowSpread + "px " + layer._properties.shadowColor;
	  },
	  backgroundColor: function(layer) {
	    return layer._properties.backgroundColor;
	  },
	  color: function(layer) {
	    return layer._properties.color;
	  },
	  borderRadius: function(layer) {
	    if (!_.isNumber(layer._properties.borderRadius)) {
	      return layer._properties.borderRadius;
	    }
	    return layer._properties.borderRadius + "px";
	  },
	  border: function(layer) {
	    return layer._properties.borderWidth + "px solid " + layer._properties.borderColor;
	  }
	};


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass, Defaults, Events, LayerStateMachine, LayerStates, LayerStatesIgnoredKeys, _, deprecatedWarning, namedState, reservedStateError,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
	  slice = [].slice;
	
	_ = __webpack_require__(1)._;
	
	Events = __webpack_require__(15).Events;
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	Defaults = __webpack_require__(17).Defaults;
	
	LayerStateMachine = __webpack_require__(28).LayerStateMachine;
	
	LayerStatesIgnoredKeys = ["ignoreEvents", "name", "id"];
	
	reservedStateError = function(name) {
	  throw Error("The state '" + name + "' is a reserved name.");
	};
	
	deprecatedWarning = function(name, suggestion) {
	  var message;
	  message = "layer.states." + name + " is deprecated";
	  if (suggestion != null) {
	    message += ", use '" + suggestion + "' instead.";
	  }
	  return console.warn(message);
	};
	
	namedState = function(state, name) {
	  return _.extend({}, {
	    name: name
	  }, state);
	};
	
	LayerStates = (function() {
	  var capture, methods;
	
	  LayerStates.defineReserved = function(propertyName, descriptor) {
	    descriptor.configurable = true;
	    if (descriptor.enumerable == null) {
	      descriptor.enumerable = false;
	    }
	    if (descriptor.set == null) {
	      descriptor.set = function() {
	        return reservedStateError(propertyName);
	      };
	    }
	    return Object.defineProperty(this.prototype, propertyName, descriptor);
	  };
	
	  LayerStates.defineReserved("previous", {
	    get: function() {
	      return namedState(this[this.machine.previousName], this.machine.previousName);
	    }
	  });
	
	  LayerStates.defineReserved("current", {
	    get: function() {
	      return namedState(this[this.machine.currentName], this.machine.currentName);
	    }
	  });
	
	  capture = function(name) {
	    return this[name] = LayerStates.filterStateProperties(this.machine.layer.props);
	  };
	
	  LayerStates.defineReserved("capture", {
	    get: function() {
	      return capture;
	    }
	  });
	
	  function LayerStates(layer) {
	    var _machine;
	    _machine = new LayerStateMachine(layer, this);
	    Object.defineProperty(this, "machine", {
	      enumerable: false,
	      configurable: false,
	      get: function() {
	        return _machine;
	      },
	      set: function() {
	        return reservedStateError("machine");
	      }
	    });
	    this.capture("default");
	  }
	
	  LayerStates.filterStateProperties = function(properties) {
	    var k, stateProperties, v;
	    stateProperties = {};
	    for (k in properties) {
	      v = properties[k];
	      if (indexOf.call(LayerStatesIgnoredKeys, k) >= 0) {
	        continue;
	      }
	      if (Color.isValidColorProperty(k, v)) {
	        stateProperties[k] = new Color(v);
	        continue;
	      }
	      if (this._isValidProperty(k, v)) {
	        stateProperties[k] = v;
	      }
	    }
	    return stateProperties;
	  };
	
	  LayerStates._isValidProperty = function(k, v) {
	    var ref;
	    if (_.isNumber(v)) {
	      return true;
	    }
	    if (_.isFunction(v)) {
	      return true;
	    }
	    if (_.isBoolean(v)) {
	      return true;
	    }
	    if (_.isString(v)) {
	      return true;
	    }
	    if (Color.isColorObject(v)) {
	      return true;
	    }
	    if (v === null) {
	      return true;
	    }
	    if ((v != null ? (ref = v.constructor) != null ? ref.name : void 0 : void 0) === "Layer") {
	      return true;
	    }
	    return false;
	  };
	
	  methods = {
	    add: function(states, object) {
	      if (object == null) {
	        object = {};
	      }
	      deprecatedWarning("add", "layer.states = ");
	      if (_.isString(states)) {
	        return this[states] = object;
	      } else {
	        return this.machine.layer.states = states;
	      }
	    },
	    remove: function(stateName) {
	      deprecatedWarning("remove", "delete layer.states.a");
	      return delete this[stateName];
	    },
	    "switch": function(stateName, options) {
	      deprecatedWarning("switch", "layer.animate(\"state\")");
	      return this.machine.switchTo(stateName, options);
	    },
	    switchInstant: function(stateName) {
	      deprecatedWarning("switchInstant", "layer.animate(\"state\", {instant: true})");
	      return this.machine.switchTo(stateName, {
	        instant: true
	      });
	    },
	    next: function() {
	      var options;
	      options = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	      deprecatedWarning("next", "layer.stateCycle()");
	      options = _.flatten(options);
	      return this.machine.layer.stateCycle(options);
	    }
	  };
	
	  LayerStates.defineReserved("add", {
	    get: function() {
	      return methods.add;
	    }
	  });
	
	  LayerStates.defineReserved("remove", {
	    get: function() {
	      return methods.remove;
	    }
	  });
	
	  LayerStates.defineReserved("switch", {
	    get: function() {
	      return methods["switch"];
	    }
	  });
	
	  LayerStates.defineReserved("switchInstant", {
	    get: function() {
	      return methods.switchInstant;
	    }
	  });
	
	  LayerStates.defineReserved("next", {
	    get: function() {
	      return methods.next;
	    }
	  });
	
	  LayerStates.defineReserved("animationOptions", {
	    get: function() {
	      return this.machine.layer.animationOptions;
	    },
	    set: function(options) {
	      return this.machine.layer.animationOptions = options;
	    }
	  });
	
	  return LayerStates;
	
	})();
	
	exports.LayerStates = LayerStates;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  slice = [].slice;
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	exports.LayerStateMachine = (function(superClass) {
	  extend(LayerStateMachine, superClass);
	
	  function LayerStateMachine(_layer, _states) {
	    this._layer = _layer;
	    this._states = _states;
	    LayerStateMachine.__super__.constructor.apply(this, arguments);
	    this.reset();
	  }
	
	  LayerStateMachine.define("layer", {
	    get: function() {
	      return this._layer;
	    }
	  });
	
	  LayerStateMachine.define("current", {
	    get: function() {
	      return this.currentName;
	    }
	  });
	
	  LayerStateMachine.define("previous", {
	    get: function() {
	      return this.previousName;
	    }
	  });
	
	  LayerStateMachine.define("currentName", {
	    get: function() {
	      return this._currentName;
	    }
	  });
	
	  LayerStateMachine.define("previousName", {
	    get: function() {
	      return _.last(this._previousNames) || "default";
	    }
	  });
	
	  LayerStateMachine.define("stateNames", {
	    get: function() {
	      return Object.keys(this.states);
	    }
	  });
	
	  LayerStateMachine.define("states", {
	    get: function() {
	      return this._states;
	    }
	  });
	
	  LayerStateMachine.prototype.switchInstant = function(stateName) {
	    return this.switchTo(stateName, {
	      instant: true
	    });
	  };
	
	  LayerStateMachine.prototype.switchTo = function(stateName, options) {
	    var animation, onEnd, onStart, onStop, properties, ref, startAnimation, started, stateNameA, stateNameB, stateSwitched, switchState;
	    if (options == null) {
	      options = {};
	    }
	    if (!this.states[stateName]) {
	      throw Error("No such state: '" + stateName + "'");
	    }
	    if (stateName === "previous") {
	      stateName = this.previousName;
	    }
	    properties = _.clone(this.states[stateName]);
	    options = _.clone(options);
	    if (properties.animationOptions) {
	      options = _.defaults({}, options, properties.animationOptions);
	    }
	    delete properties.animationOptions;
	    stateNameA = this.currentName;
	    stateNameB = stateName;
	    startAnimation = (ref = options.start) != null ? ref : true;
	    options.start = false;
	    animation = this.layer.animate(properties, options);
	    stateSwitched = false;
	    switchState = (function(_this) {
	      return function() {
	        if (stateSwitched) {
	          return;
	        }
	        stateSwitched = true;
	        _this._previousNames.push(stateNameA);
	        return _this._currentName = stateNameB;
	      };
	    })(this);
	    onStart = (function(_this) {
	      return function() {
	        _this.emit(Events.StateSwitchStart, stateNameA, stateNameB, _this);
	        return switchState();
	      };
	    })(this);
	    onStop = (function(_this) {
	      return function() {
	        return _this.emit(Events.StateSwitchStop, stateNameA, stateNameB, _this);
	      };
	    })(this);
	    onEnd = (function(_this) {
	      return function() {
	        var i, instantProperties, k, len;
	        instantProperties = _.difference(_.keys(properties), _.keys(animation.properties));
	        for (i = 0, len = instantProperties.length; i < len; i++) {
	          k = instantProperties[i];
	          _this.layer[k] = properties[k];
	        }
	        return _this.emit(Events.StateSwitchEnd, stateNameA, stateNameB, _this);
	      };
	    })(this);
	    animation.on(Events.AnimationStart, onStart);
	    animation.on(Events.AnimationStop, onStop);
	    animation.on(Events.AnimationEnd, onEnd);
	    if (startAnimation) {
	      started = animation.start();
	      if (!started) {
	        onStart();
	        onStop();
	        onEnd();
	      }
	    }
	    switchState();
	    return animation;
	  };
	
	  LayerStateMachine.prototype.next = function(states) {
	    if (!states.length) {
	      states = this.stateNames;
	    }
	    return Utils.arrayNext(states, this.currentName);
	  };
	
	  LayerStateMachine.prototype.emit = function() {
	    var args, ref;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    LayerStateMachine.__super__.emit.apply(this, arguments);
	    return (ref = this._layer).emit.apply(ref, args);
	  };
	
	  LayerStateMachine.prototype.reset = function() {
	    var i, k, len, ref;
	    ref = _.keys(this.states);
	    for (i = 0, len = ref.length; i < len; i++) {
	      k = ref[i];
	      if (k !== "default") {
	        delete this.states[k];
	      }
	    }
	    this._previousNames = [];
	    return this._currentName = "default";
	  };
	
	  LayerStateMachine.prototype.toInspect = function(constructor) {
	    return "<" + this.constructor.name + " id:" + this.id + " layer:" + this.layer.id + " current:'" + this.currentName + "'>";
	  };
	
	  return LayerStateMachine;
	
	})(BaseClass);


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass, Defaults, EventBuffer, Events, Gestures, Simulation, Utils, _,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	_ = __webpack_require__(1)._;
	
	Utils = __webpack_require__(4);
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	Events = __webpack_require__(15).Events;
	
	Simulation = __webpack_require__(30).Simulation;
	
	Defaults = __webpack_require__(17).Defaults;
	
	EventBuffer = __webpack_require__(35).EventBuffer;
	
	Gestures = __webpack_require__(16).Gestures;
	
	Events.Move = "move";
	
	Events.DragStart = "dragstart";
	
	Events.DragWillMove = "dragwillmove";
	
	Events.DragMove = "dragmove";
	
	Events.DragDidMove = "dragmove";
	
	Events.Drag = "dragmove";
	
	Events.DragEnd = "dragend";
	
	Events.DragAnimationStart = "draganimationstart";
	
	Events.DragAnimationEnd = "draganimationend";
	
	Events.DirectionLockStart = "directionlockstart";
	
	Events.DragSessionStart = "dragsessionstart";
	
	Events.DragSessionMove = "dragsessionmove";
	
	Events.DragSessionEnd = "dragsessionend";
	
	Events.DragAnimationDidStart = Events.DragAnimationStart;
	
	Events.DragAnimationDidEnd = Events.DragAnimationEnd;
	
	Events.DirectionLockDidStart = Events.DirectionLockStart;
	
	"\n┌──────┐                   │\n│      │\n│      │  ───────────────▶ │ ◀────▶\n│      │\n└──────┘                   │\n\n════════  ═════════════════ ═══════\n\n	Drag         Momentum      Bounce\n";
	
	exports.LayerDraggable = (function(superClass) {
	  extend(LayerDraggable, superClass);
	
	  LayerDraggable.define("speedX", LayerDraggable.simpleProperty("speedX", 1));
	
	  LayerDraggable.define("speedY", LayerDraggable.simpleProperty("speedY", 1));
	
	  LayerDraggable.define("horizontal", LayerDraggable.simpleProperty("horizontal", true));
	
	  LayerDraggable.define("vertical", LayerDraggable.simpleProperty("vertical", true));
	
	  LayerDraggable.define("momentumVelocityMultiplier", LayerDraggable.simpleProperty("momentumVelocityMultiplier", 800));
	
	  LayerDraggable.define("directionLock", LayerDraggable.simpleProperty("directionLock", true));
	
	  LayerDraggable.define("directionLockThreshold", LayerDraggable.simpleProperty("directionLockThreshold", {
	    x: 10,
	    y: 10
	  }));
	
	  LayerDraggable.define("propagateEvents", LayerDraggable.simpleProperty("propagateEvents", true));
	
	  LayerDraggable.define("constraints", {
	    get: function() {
	      return this._constraints;
	    },
	    set: function(value) {
	      if (value && _.isObject(value)) {
	        value = _.pick(value, ["x", "y", "width", "height"]);
	        value = _.defaults(value, {
	          x: 0,
	          y: 0,
	          width: 0,
	          height: 0
	        });
	        this._constraints = value;
	      } else {
	        this._constraints = {
	          x: 0,
	          y: 0,
	          width: 0,
	          height: 0
	        };
	      }
	      if (this._constraints) {
	        return this._updateSimulationConstraints(this._constraints);
	      }
	    }
	  });
	
	  LayerDraggable.define("isDragging", {
	    get: function() {
	      return this._isDragging || false;
	    }
	  });
	
	  LayerDraggable.define("isAnimating", {
	    get: function() {
	      return this._isAnimating || false;
	    }
	  });
	
	  LayerDraggable.define("isMoving", {
	    get: function() {
	      return this._isMoving || false;
	    }
	  });
	
	  LayerDraggable.define("layerStartPoint", {
	    get: function() {
	      return this._layerStartPoint || this.layer.point;
	    }
	  });
	
	  LayerDraggable.define("cursorStartPoint", {
	    get: function() {
	      return this._cursorStartPoint || {
	        x: 0,
	        y: 0
	      };
	    }
	  });
	
	  LayerDraggable.define("layerCursorOffset", {
	    get: function() {
	      return this._layerCursorOffset || {
	        x: 0,
	        y: 0
	      };
	    }
	  });
	
	  LayerDraggable.define("offset", {
	    get: function() {
	      var offset;
	      if (!this._correctedLayerStartPoint) {
	        return {
	          x: 0,
	          y: 0
	        };
	      }
	      return offset = {
	        x: this.layer.x - this._correctedLayerStartPoint.x,
	        y: this.layer.y - this._correctedLayerStartPoint.y
	      };
	    }
	  });
	
	  function LayerDraggable(layer) {
	    var options;
	    this.layer = layer;
	    this._stopSimulation = bind(this._stopSimulation, this);
	    this._onSimulationStop = bind(this._onSimulationStop, this);
	    this._onSimulationStep = bind(this._onSimulationStep, this);
	    this._touchEnd = bind(this._touchEnd, this);
	    this._touchMove = bind(this._touchMove, this);
	    this._touchStart = bind(this._touchStart, this);
	    this._updateLayerPosition = bind(this._updateLayerPosition, this);
	    this.touchStart = bind(this.touchStart, this);
	    options = Defaults.getDefaults("LayerDraggable", {});
	    LayerDraggable.__super__.constructor.call(this, options);
	    _.extend(this, options);
	    this.enabled = true;
	    this._eventBuffer = new EventBuffer;
	    this._constraints = null;
	    this._ignoreUpdateLayerPosition = true;
	    this.attach();
	  }
	
	  LayerDraggable.prototype.attach = function() {
	    this.layer.on(Gestures.TapStart, this.touchStart);
	    this.layer.on("change:x", this._updateLayerPosition);
	    return this.layer.on("change:y", this._updateLayerPosition);
	  };
	
	  LayerDraggable.prototype.remove = function() {
	    this.layer.off(Gestures.TapStart, this.touchStart);
	    this.layer.off(Gestures.Pan, this._touchMove);
	    return this.layer.off(Gestures.PanEnd, this._touchEnd);
	  };
	
	  LayerDraggable.prototype.updatePosition = function(point) {
	    return point;
	  };
	
	  LayerDraggable.prototype.touchStart = function(event) {
	    return this._touchStart(event);
	  };
	
	  LayerDraggable.prototype._updateLayerPosition = function() {
	    if (this._ignoreUpdateLayerPosition === true) {
	      return;
	    }
	    return this._point = this.layer.point;
	  };
	
	  LayerDraggable.prototype._touchStart = function(event) {
	    var animation, i, len, properties, ref, touchEvent;
	    Events.wrap(document).addEventListener(Gestures.Pan, this._touchMove);
	    Events.wrap(document).addEventListener(Gestures.TapEnd, this._touchEnd);
	    this._isMoving = this._isAnimating;
	    ref = this.layer.animations();
	    for (i = 0, len = ref.length; i < len; i++) {
	      animation = ref[i];
	      properties = animation.properties;
	      if (properties.hasOwnProperty("x") || properties.hasOwnProperty("y")) {
	        animation.stop();
	      }
	    }
	    this._stopSimulation();
	    this._resetdirectionLock();
	    event.preventDefault();
	    if (this.propagateEvents === false) {
	      event.stopPropagation();
	    }
	    touchEvent = Events.touchEvent(event);
	    this._eventBuffer.push({
	      x: touchEvent.clientX,
	      y: touchEvent.clientY,
	      t: Date.now()
	    });
	    this._layerStartPoint = this.layer.point;
	    this._correctedLayerStartPoint = this.layer.point;
	    if (this.constraints && this.bounce) {
	      this._correctedLayerStartPoint = this._constrainPosition(this._correctedLayerStartPoint, this.constraints, 1 / this.overdragScale);
	    }
	    this._cursorStartPoint = {
	      x: touchEvent.clientX,
	      y: touchEvent.clientY
	    };
	    this._layerCursorOffset = {
	      x: touchEvent.clientX - this._correctedLayerStartPoint.x,
	      y: touchEvent.clientY - this._correctedLayerStartPoint.y
	    };
	    this._point = this._correctedLayerStartPoint;
	    this._ignoreUpdateLayerPosition = false;
	    return this.emit(Events.DragSessionStart, event);
	  };
	
	  LayerDraggable.prototype._touchMove = function(event) {
	    var offset, point, touchEvent;
	    if (!this.enabled) {
	      return;
	    }
	    if (!this._point) {
	      this.touchStart(event);
	    }
	    event.preventDefault();
	    if (this.propagateEvents === false) {
	      event.stopPropagation();
	    }
	    touchEvent = Events.touchEvent(event);
	    this._lastEvent = touchEvent;
	    this._eventBuffer.push({
	      x: touchEvent.clientX,
	      y: touchEvent.clientY,
	      t: Date.now()
	    });
	    point = _.clone(this._point);
	    if (this.horizontal) {
	      point.x = this._point.x + (event.delta.x * this.speedX * (1 / this.layer.screenScaleX(false)));
	    }
	    if (this.vertical) {
	      point.y = this._point.y + (event.delta.y * this.speedY * (1 / this.layer.screenScaleY(false)));
	    }
	    this._point = _.clone(point);
	    if (this._constraints) {
	      point = this._constrainPosition(point, this._constraints, this.overdragScale);
	    }
	    if (this.directionLock) {
	      if (!this._directionLockEnabledX && !this._directionLockEnabledY) {
	        offset = event.offset;
	        offset.x = offset.x * this.speedX * (1 / this.layer.canvasScaleX()) * this.layer.scaleX * this.layer.scale;
	        offset.y = offset.y * this.speedY * (1 / this.layer.canvasScaleY()) * this.layer.scaleY * this.layer.scale;
	        this._updatedirectionLock(offset);
	        return;
	      } else {
	        if (this._directionLockEnabledX) {
	          point.x = this._layerStartPoint.x;
	        }
	        if (this._directionLockEnabledY) {
	          point.y = this._layerStartPoint.y;
	        }
	      }
	    }
	    if (point.x !== this._layerStartPoint.x || point.y !== this._layerStartPoint.y) {
	      if (!this._isDragging) {
	        this._isDragging = true;
	        this._isMoving = true;
	        this.emit(Events.DragStart, event);
	      }
	    }
	    if (this.isDragging) {
	      this.emit(Events.DragWillMove, event);
	    }
	    if (this.pixelAlign) {
	      if (this.horizontal) {
	        point.x = parseInt(point.x);
	      }
	      if (this.vertical) {
	        point.y = parseInt(point.y);
	      }
	    }
	    this._ignoreUpdateLayerPosition = true;
	    this.layer.point = this.updatePosition(point);
	    this._ignoreUpdateLayerPosition = false;
	    if (this.isDragging) {
	      this.emit(Events.Move, this.layer.point);
	      this.emit(Events.DragDidMove, event);
	    }
	    return this.emit(Events.DragSessionMove, event);
	  };
	
	  LayerDraggable.prototype._touchEnd = function(event) {
	    Events.wrap(document).removeEventListener(Gestures.Pan, this._touchMove);
	    Events.wrap(document).removeEventListener(Gestures.TapEnd, this._touchEnd);
	    if (this.propagateEvents === false) {
	      event.stopPropagation();
	    }
	    this._startSimulation();
	    this.emit(Events.DragSessionEnd, event);
	    if (this._isDragging) {
	      this.emit(Events.DragEnd, event);
	    }
	    this._isDragging = false;
	    this._isMoving = this._isAnimating;
	    this._ignoreUpdateLayerPosition = true;
	    this._lastEvent = null;
	    return this._eventBuffer.reset();
	  };
	
	  LayerDraggable.define("constraintsOffset", {
	    get: function() {
	      var constrainedPoint, maxX, maxY, minX, minY, offset, point, ref;
	      if (!this.constraints) {
	        return {
	          x: 0,
	          y: 0
	        };
	      }
	      ref = this._calculateConstraints(this.constraints), minX = ref.minX, maxX = ref.maxX, minY = ref.minY, maxY = ref.maxY;
	      point = this.layer.point;
	      constrainedPoint = {
	        x: Utils.clamp(point.x, minX, maxX),
	        y: Utils.clamp(point.y, minY, maxY)
	      };
	      offset = {
	        x: point.x - constrainedPoint.x,
	        y: point.y - constrainedPoint.y
	      };
	      return offset;
	    }
	  });
	
	  LayerDraggable.define("isBeyondConstraints", {
	    get: function() {
	      var constraintsOffset;
	      constraintsOffset = this.constraintsOffset;
	      if (constraintsOffset.x !== 0) {
	        return true;
	      }
	      if (constraintsOffset.y !== 0) {
	        return true;
	      }
	      return false;
	    }
	  });
	
	  LayerDraggable.prototype._clampAndScale = function(value, min, max, scale) {
	    if (value < min) {
	      value = min + (value - min) * scale;
	    }
	    if (value > max) {
	      value = max + (value - max) * scale;
	    }
	    return value;
	  };
	
	  LayerDraggable.prototype._calculateConstraints = function(bounds) {
	    var constraints;
	    if (!bounds) {
	      return constraints = {
	        minX: 2e308,
	        maxX: 2e308,
	        minY: 2e308,
	        maxY: 2e308
	      };
	    }
	    if (bounds.width < this.layer.width) {
	      bounds.width = this.layer.width;
	    }
	    if (bounds.height < this.layer.height) {
	      bounds.height = this.layer.height;
	    }
	    constraints = {
	      minX: Utils.frameGetMinX(bounds),
	      maxX: Utils.frameGetMaxX(bounds),
	      minY: Utils.frameGetMinY(bounds),
	      maxY: Utils.frameGetMaxY(bounds)
	    };
	    constraints.maxX -= this.layer.width;
	    constraints.maxY -= this.layer.height;
	    return constraints;
	  };
	
	  LayerDraggable.prototype._constrainPosition = function(proposedPoint, bounds, scale) {
	    var maxX, maxY, minX, minY, point, ref;
	    ref = this._calculateConstraints(this._constraints), minX = ref.minX, maxX = ref.maxX, minY = ref.minY, maxY = ref.maxY;
	    if (this.overdrag) {
	      point = {
	        x: this._clampAndScale(proposedPoint.x, minX, maxX, scale),
	        y: this._clampAndScale(proposedPoint.y, minY, maxY, scale)
	      };
	    } else {
	      point = {
	        x: Utils.clamp(proposedPoint.x, minX, maxX),
	        y: Utils.clamp(proposedPoint.y, minY, maxY)
	      };
	    }
	    if (this.speedX === 0 || this.horizontal === false) {
	      point.x = proposedPoint.x;
	    }
	    if (this.speedY === 0 || this.vertical === false) {
	      point.y = proposedPoint.y;
	    }
	    return point;
	  };
	
	  LayerDraggable.define("velocity", {
	    get: function() {
	      if (this.isAnimating) {
	        return this._calculateSimulationVelocity();
	      }
	      return this._eventBuffer.velocity;
	      return {
	        x: 0,
	        y: 0
	      };
	    }
	  });
	
	  LayerDraggable.define("angle", {
	    get: function() {
	      return this._eventBuffer.angle;
	    }
	  });
	
	  LayerDraggable.define("direction", {
	    get: function() {
	      var delta, ref, velocity;
	      velocity = this.velocity;
	      if (velocity.x === 0 && velocity.y === 0) {
	        delta = (ref = this._lastEvent) != null ? ref.delta : void 0;
	        if (!delta) {
	          return null;
	        }
	        if (Math.abs(delta.x) > Math.abs(delta.y)) {
	          if (delta.x > 0) {
	            return "right";
	          }
	          return "left";
	        } else {
	          if (delta.y > 0) {
	            return "down";
	          }
	          return "up";
	        }
	      }
	      if (Math.abs(velocity.x) > Math.abs(velocity.y)) {
	        if (velocity.x > 0) {
	          return "right";
	        }
	        return "left";
	      } else {
	        if (velocity.y > 0) {
	          return "down";
	        }
	        return "up";
	      }
	    }
	  });
	
	  LayerDraggable.prototype.calculateVelocity = function() {
	    return this.velocity;
	  };
	
	  LayerDraggable.prototype._calculateSimulationVelocity = function() {
	    var velocity, xFinished, yFinished;
	    xFinished = this._simulation.x.finished();
	    yFinished = this._simulation.y.finished();
	    velocity = {
	      x: 0,
	      y: 0
	    };
	    if (!xFinished) {
	      velocity.x = this._simulation.x.simulator.state.v / this.momentumVelocityMultiplier;
	    }
	    if (!yFinished) {
	      velocity.y = this._simulation.y.simulator.state.v / this.momentumVelocityMultiplier;
	    }
	    return velocity;
	  };
	
	  LayerDraggable.prototype.emit = function(eventName, event) {
	    this.layer.emit(eventName, event);
	    return LayerDraggable.__super__.emit.call(this, eventName, event);
	  };
	
	  LayerDraggable.prototype._updatedirectionLock = function(correctedDelta) {
	    this._directionLockEnabledX = Math.abs(correctedDelta.y) > this.directionLockThreshold.y;
	    this._directionLockEnabledY = Math.abs(correctedDelta.x) > this.directionLockThreshold.x;
	    if (this._directionLockEnabledX || this._directionLockEnabledY) {
	      return this.emit(Events.DirectionLockStart, {
	        x: this._directionLockEnabledX,
	        y: this._directionLockEnabledY
	      });
	    }
	  };
	
	  LayerDraggable.prototype._resetdirectionLock = function() {
	    this._directionLockEnabledX = false;
	    return this._directionLockEnabledY = false;
	  };
	
	  LayerDraggable.prototype._setupSimulation = function() {
	    if (this._simulation) {
	      return;
	    }
	    this._simulation = {
	      x: this._setupSimulationForAxis("x"),
	      y: this._setupSimulationForAxis("y")
	    };
	    return this._updateSimulationConstraints(this.constraints);
	  };
	
	  LayerDraggable.prototype._setupSimulationForAxis = function(axis) {
	    var properties, simulation;
	    properties = {};
	    properties[axis] = true;
	    simulation = new Simulation({
	      layer: this.layer,
	      properties: properties,
	      model: "inertial-scroll",
	      modelOptions: {
	        momentum: this.momentumOptions,
	        bounce: this.bounceOptions
	      }
	    });
	    simulation.on(Events.SimulationStep, (function(_this) {
	      return function(state) {
	        return _this._onSimulationStep(axis, state);
	      };
	    })(this));
	    simulation.on(Events.SimulationStop, (function(_this) {
	      return function(state) {
	        return _this._onSimulationStop(axis, state);
	      };
	    })(this));
	    return simulation;
	  };
	
	  LayerDraggable.prototype._updateSimulationConstraints = function(constraints) {
	    var maxX, maxY, minX, minY, ref;
	    if (!this._simulation) {
	      return;
	    }
	    if (constraints) {
	      ref = this._calculateConstraints(this._constraints), minX = ref.minX, maxX = ref.maxX, minY = ref.minY, maxY = ref.maxY;
	      this._simulation.x.simulator.options = {
	        min: minX,
	        max: maxX
	      };
	      return this._simulation.y.simulator.options = {
	        min: minY,
	        max: maxY
	      };
	    } else {
	      this._simulation.x.simulator.options = {
	        min: -2e308,
	        max: +2e308
	      };
	      return this._simulation.y.simulator.options = {
	        min: -2e308,
	        max: +2e308
	      };
	    }
	  };
	
	  LayerDraggable.prototype._onSimulationStep = function(axis, state) {
	    var delta, maxX, maxY, minX, minY, ref, updatePoint;
	    if (axis === "x" && this.horizontal === false) {
	      return;
	    }
	    if (axis === "y" && this.vertical === false) {
	      return;
	    }
	    if (this.constraints) {
	      if (this.bounce) {
	        delta = state.x - this.layer[axis];
	      } else {
	        ref = this._calculateConstraints(this._constraints), minX = ref.minX, maxX = ref.maxX, minY = ref.minY, maxY = ref.maxY;
	        if (axis === "x") {
	          delta = Utils.clamp(state.x, minX, maxX) - this.layer[axis];
	        }
	        if (axis === "y") {
	          delta = Utils.clamp(state.x, minY, maxY) - this.layer[axis];
	        }
	      }
	    } else {
	      delta = state.x - this.layer[axis];
	    }
	    updatePoint = this.layer.point;
	    if (axis === "x") {
	      updatePoint[axis] = updatePoint[axis] + delta;
	    }
	    if (axis === "y") {
	      updatePoint[axis] = updatePoint[axis] + delta;
	    }
	    this.updatePosition(updatePoint);
	    this.layer[axis] = this.updatePosition(updatePoint)[axis];
	    return this.emit(Events.Move, this.layer.point);
	  };
	
	  LayerDraggable.prototype._onSimulationStop = function(axis, state) {
	    if (axis === "x" && this.horizontal === false) {
	      return;
	    }
	    if (axis === "y" && this.vertical === false) {
	      return;
	    }
	    if (!this._simulation) {
	      return;
	    }
	    if (this.pixelAlign) {
	      this.layer[axis] = parseInt(this.layer[axis]);
	    }
	    if (this._simulation.x.finished() && this._simulation.y.finished()) {
	      return this._stopSimulation();
	    }
	  };
	
	  LayerDraggable.prototype._startSimulation = function() {
	    var maxX, maxY, minX, minY, ref, startSimulationX, startSimulationY, velocity, velocityX, velocityY;
	    if (!(this.momentum || this.bounce)) {
	      return;
	    }
	    if (this.isBeyondConstraints === false && this.momentum === false) {
	      return;
	    }
	    if (this.isBeyondConstraints === false && this.isDragging === false) {
	      return;
	    }
	    ref = this._calculateConstraints(this._constraints), minX = ref.minX, maxX = ref.maxX, minY = ref.minY, maxY = ref.maxY;
	    startSimulationX = this.overdrag === true || (this.layer.x > minX && this.layer.x < maxX);
	    startSimulationY = this.overdrag === true || (this.layer.y > minY && this.layer.y < maxY);
	    if ((startSimulationX === startSimulationY && startSimulationY === false)) {
	      return;
	    }
	    velocity = this.velocity;
	    velocityX = velocity.x * this.momentumVelocityMultiplier * this.speedX * (1 / this.layer.canvasScaleX()) * this.layer.scaleX * this.layer.scale;
	    velocityY = velocity.y * this.momentumVelocityMultiplier * this.speedY * (1 / this.layer.canvasScaleY()) * this.layer.scaleY * this.layer.scale;
	    this._setupSimulation();
	    this._isAnimating = true;
	    this._isMoving = true;
	    this._simulation.x.simulator.setState({
	      x: this.layer.x,
	      v: velocityX
	    });
	    if (startSimulationX) {
	      this._simulation.x.start();
	    }
	    this._simulation.y.simulator.setState({
	      x: this.layer.y,
	      v: velocityY
	    });
	    if (startSimulationY) {
	      this._simulation.y.start();
	    }
	    return this.emit(Events.DragAnimationStart);
	  };
	
	  LayerDraggable.prototype._stopSimulation = function() {
	    var ref, ref1;
	    if (this._isMoving) {
	      this.emit(Events.Move, this.layer.point);
	    }
	    this._isAnimating = false;
	    this._isMoving = false;
	    if (!this._simulation) {
	      return;
	    }
	    if ((ref = this._simulation) != null) {
	      ref.x.stop();
	    }
	    if ((ref1 = this._simulation) != null) {
	      ref1.y.stop();
	    }
	    this._simulation = null;
	    return this.emit(Events.DragAnimationEnd);
	  };
	
	  LayerDraggable.prototype.animateStop = function() {
	    return this._stopSimulation();
	  };
	
	  LayerDraggable.prototype.onMove = function(cb) {
	    return this.on(Events.Move, cb);
	  };
	
	  LayerDraggable.prototype.onDragStart = function(cb) {
	    return this.on(Events.DragStart, cb);
	  };
	
	  LayerDraggable.prototype.onDragWillMove = function(cb) {
	    return this.on(Events.DragWillMove, cb);
	  };
	
	  LayerDraggable.prototype.onDragMove = function(cb) {
	    return this.on(Events.DragMove, cb);
	  };
	
	  LayerDraggable.prototype.onDragDidMove = function(cb) {
	    return this.on(Events.DragDidMove, cb);
	  };
	
	  LayerDraggable.prototype.onDrag = function(cb) {
	    return this.on(Events.Drag, cb);
	  };
	
	  LayerDraggable.prototype.onDragEnd = function(cb) {
	    return this.on(Events.DragEnd, cb);
	  };
	
	  LayerDraggable.prototype.onDragAnimationStart = function(cb) {
	    return this.on(Events.DragAnimationStart, cb);
	  };
	
	  LayerDraggable.prototype.onDragAnimationEnd = function(cb) {
	    return this.on(Events.DragAnimationEnd, cb);
	  };
	
	  LayerDraggable.prototype.onDirectionLockStart = function(cb) {
	    return this.on(Events.DirectionLockStart, cb);
	  };
	
	  return LayerDraggable;
	
	})(BaseClass);


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass, Config, Defaults, Events, FrictionSimulator, MomentumBounceSimulator, SimulatorClasses, SpringSimulator, Utils, _,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	_ = __webpack_require__(1)._;
	
	Utils = __webpack_require__(4);
	
	Config = __webpack_require__(14).Config;
	
	Defaults = __webpack_require__(17).Defaults;
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	Events = __webpack_require__(15).Events;
	
	SpringSimulator = __webpack_require__(31).SpringSimulator;
	
	FrictionSimulator = __webpack_require__(33).FrictionSimulator;
	
	MomentumBounceSimulator = __webpack_require__(34).MomentumBounceSimulator;
	
	Events.SimulationStart = "simulationStart";
	
	Events.SimulationStep = "simulationStep";
	
	Events.SimulationStop = "simulationStop";
	
	SimulatorClasses = {
	  "spring": SpringSimulator,
	  "friction": FrictionSimulator,
	  "inertial-scroll": MomentumBounceSimulator
	};
	
	exports.Simulation = (function(superClass) {
	  extend(Simulation, superClass);
	
	  function Simulation(options) {
	    var SimulatorClass;
	    if (options == null) {
	      options = {};
	    }
	    this._update = bind(this._update, this);
	    this._start = bind(this._start, this);
	    this.start = bind(this.start, this);
	    Simulation.__super__.constructor.call(this, options);
	    this.options = _.defaults(options, {
	      layer: null,
	      properties: {},
	      model: "spring",
	      modelOptions: {},
	      delay: 0,
	      debug: false
	    });
	    this.layer = this.options.layer;
	    this.properties = this.options.properties;
	    this._running = false;
	    SimulatorClass = SimulatorClasses[this.options.model] || SpringSimulator;
	    this._simulator = new SimulatorClass(this.options.modelOptions);
	  }
	
	  Simulation.prototype.animatingProperties = function() {
	    return _.keys(this.properties);
	  };
	
	  Simulation.prototype.start = function() {
	    var animatingProperties, animation, property, ref;
	    if (this.layer === null) {
	      console.error("Simulation: missing layer");
	    }
	    if (this.options.debug) {
	      console.log("Simulation.start " + this._simulator.constructor.name, this.options.modelOptions);
	    }
	    animatingProperties = this.animatingProperties();
	    ref = this.layer.animatingProperties();
	    for (property in ref) {
	      animation = ref[property];
	      if (indexOf.call(animatingProperties, property) >= 0) {
	        animation.stop();
	      }
	    }
	    if (this.options.delay) {
	      Utils.delay(this.options.delay, this._start);
	    } else {
	      this._start();
	    }
	    return true;
	  };
	
	  Simulation.prototype.stop = function(emit) {
	    if (emit == null) {
	      emit = true;
	    }
	    if (!this._running) {
	      return;
	    }
	    this._running = false;
	    this.layer.context.removeAnimation(this);
	    if (emit) {
	      this.emit(Events.SimulationStop);
	    }
	    return Framer.Loop.off("update", this._update);
	  };
	
	  Simulation.prototype.emit = function(event) {
	    Simulation.__super__.emit.apply(this, arguments);
	    return this.layer.emit(event, this);
	  };
	
	  Simulation.prototype._start = function() {
	    if (this._running) {
	      return;
	    }
	    this._running = true;
	    this.layer.context.addAnimation(this);
	    this.emit(Events.SimulationStart);
	    return Framer.Loop.on("update", this._update);
	  };
	
	  Simulation.prototype._update = function(delta) {
	    var emit, result;
	    if (this._simulator.finished()) {
	      this.stop(emit = false);
	      this.emit("end");
	      return this.emit(Events.SimulationStop);
	    } else {
	      result = this._simulator.next(delta);
	      return this.emit(Events.SimulationStep, result, delta);
	    }
	  };
	
	  Simulation.define("simulator", {
	    get: function() {
	      return this._simulator;
	    }
	  });
	
	  Simulation.prototype.finished = function() {
	    return this._simulator.finished();
	  };
	
	  return Simulation;
	
	})(BaseClass);


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var Defaults, Integrator, Simulator, Utils,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	Utils = __webpack_require__(4);
	
	Defaults = __webpack_require__(17).Defaults;
	
	Simulator = __webpack_require__(32).Simulator;
	
	Integrator = __webpack_require__(25).Integrator;
	
	exports.SpringSimulator = (function(superClass) {
	  extend(SpringSimulator, superClass);
	
	  function SpringSimulator() {
	    this.finished = bind(this.finished, this);
	    return SpringSimulator.__super__.constructor.apply(this, arguments);
	  }
	
	  SpringSimulator.prototype.setup = function(options) {
	    this.options = Defaults.getDefaults("SpringSimulator", options);
	    this.options = _.defaults(options, {
	      velocity: 0,
	      position: 0,
	      offset: 0
	    });
	    this._state = {
	      x: this.options.position,
	      v: this.options.velocity
	    };
	    return this._integrator = new Integrator((function(_this) {
	      return function(state) {
	        return -_this.options.tension * state.x - _this.options.friction * state.v;
	      };
	    })(this));
	  };
	
	  SpringSimulator.prototype.next = function(delta) {
	    this._state = this._integrator.integrateState(this._state, delta);
	    return this.getState();
	  };
	
	  SpringSimulator.prototype.finished = function() {
	    var positionNearZero, velocityNearZero;
	    positionNearZero = Math.abs(this._state.x) < this.options.tolerance;
	    velocityNearZero = Math.abs(this._state.v) < this.options.tolerance;
	    return positionNearZero && velocityNearZero;
	  };
	
	  SpringSimulator.prototype.setState = function(state) {
	    return this._state = {
	      x: state.x - this.options.offset,
	      v: state.v
	    };
	  };
	
	  SpringSimulator.prototype.getState = function() {
	    var state;
	    return state = {
	      x: this._state.x + this.options.offset,
	      v: this._state.v
	    };
	  };
	
	  return SpringSimulator;
	
	})(Simulator);


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass, Config, Utils, _,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	Utils = __webpack_require__(4);
	
	_ = __webpack_require__(1)._;
	
	Config = __webpack_require__(14).Config;
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	exports.Simulator = (function(superClass) {
	  "The simulator class runs a physics simulation based on a set of input values\nat setup({input values}), and emits an output state {x, v}";
	  extend(Simulator, superClass);
	
	  Simulator.define("state", {
	    get: function() {
	      return _.clone(this._state);
	    },
	    set: function(state) {
	      return this._state = _.clone(state);
	    }
	  });
	
	  function Simulator(options) {
	    if (options == null) {
	      options = {};
	    }
	    this._state = {
	      x: 0,
	      v: 0
	    };
	    this.options = null;
	    this.setup(options);
	  }
	
	  Simulator.prototype.setup = function(options) {
	    throw Error("Not implemented");
	  };
	
	  Simulator.prototype.next = function(delta) {
	    throw Error("Not implemented");
	  };
	
	  Simulator.prototype.finished = function() {
	    throw Error("Not implemented");
	  };
	
	  Simulator.prototype.setState = function(state) {
	    return this._state = state;
	  };
	
	  return Simulator;
	
	})(BaseClass);


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var Defaults, Integrator, Simulator, Utils,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	Utils = __webpack_require__(4);
	
	Defaults = __webpack_require__(17).Defaults;
	
	Simulator = __webpack_require__(32).Simulator;
	
	Integrator = __webpack_require__(25).Integrator;
	
	exports.FrictionSimulator = (function(superClass) {
	  extend(FrictionSimulator, superClass);
	
	  function FrictionSimulator() {
	    this.finished = bind(this.finished, this);
	    return FrictionSimulator.__super__.constructor.apply(this, arguments);
	  }
	
	  FrictionSimulator.prototype.setup = function(options) {
	    this.options = Defaults.getDefaults("FrictionSimulator", options);
	    this.options = _.defaults(options, {
	      velocity: 0,
	      position: 0
	    });
	    this._state = {
	      x: this.options.position,
	      v: this.options.velocity
	    };
	    return this._integrator = new Integrator((function(_this) {
	      return function(state) {
	        return -(_this.options.friction * state.v);
	      };
	    })(this));
	  };
	
	  FrictionSimulator.prototype.next = function(delta) {
	    this._state = this._integrator.integrateState(this._state, delta);
	    return this._state;
	  };
	
	  FrictionSimulator.prototype.finished = function() {
	    return Math.abs(this._state.v) < this.options.tolerance;
	  };
	
	  return FrictionSimulator;
	
	})(Simulator);


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var Defaults, FrictionSimulator, Simulator, SpringSimulator, Utils,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	Utils = __webpack_require__(4);
	
	Defaults = __webpack_require__(17).Defaults;
	
	Simulator = __webpack_require__(32).Simulator;
	
	SpringSimulator = __webpack_require__(31).SpringSimulator;
	
	FrictionSimulator = __webpack_require__(33).FrictionSimulator;
	
	exports.MomentumBounceSimulator = (function(superClass) {
	  extend(MomentumBounceSimulator, superClass);
	
	  function MomentumBounceSimulator() {
	    this.finished = bind(this.finished, this);
	    return MomentumBounceSimulator.__super__.constructor.apply(this, arguments);
	  }
	
	  MomentumBounceSimulator.prototype.setup = function(options) {
	    this.options = Defaults.getDefaults("MomentumBounceSimulator", options);
	    this.options = _.defaults(options, {
	      velocity: 0,
	      position: 0,
	      min: 0,
	      max: 0
	    });
	    this._frictionSimulator = new FrictionSimulator({
	      friction: this.options.momentum.friction,
	      tolerance: this.options.momentum.tolerance,
	      velocity: this.options.velocity,
	      position: this.options.position
	    });
	    this._springSimulator = new SpringSimulator({
	      tension: this.options.bounce.tension,
	      friction: this.options.bounce.friction,
	      tolerance: this.options.bounce.tolerance,
	      velocity: this.options.velocity,
	      position: this.options.position
	    });
	    this._state = {
	      x: this.options.position,
	      v: this.options.velocity
	    };
	    return this._useSpring = false;
	  };
	
	  MomentumBounceSimulator.prototype.next = function(delta) {
	    if (this._useSpring) {
	      this._state = this._springSimulator.next(delta);
	    } else {
	      this._state = this._frictionSimulator.next(delta);
	      this._tryTransitionToSpring(this._state);
	    }
	    return this._state;
	  };
	
	  MomentumBounceSimulator.prototype.finished = function() {
	    if (this._useSpring) {
	      return this._springSimulator.finished();
	    }
	    return this._frictionSimulator.finished();
	  };
	
	  MomentumBounceSimulator.prototype.setState = function(state) {
	    var bound;
	    this._state = {
	      x: state.x,
	      v: state.v
	    };
	    this._frictionSimulator.setState(this._state);
	    if (this._isValidState()) {
	      return this._tryTransitionToSpring();
	    } else {
	      if (this._state.x <= this.options.min) {
	        bound = this.options.min;
	      }
	      if (this._state.x >= this.options.max) {
	        bound = this.options.max;
	      }
	      return this._transitionToSpring(bound);
	    }
	  };
	
	  MomentumBounceSimulator.prototype._tryTransitionToSpring = function(force) {
	    var aboveMaxWithVelocity, belowMinWithVelocity, bound;
	    belowMinWithVelocity = this._state.x < this.options.min && this._state.v <= 0;
	    aboveMaxWithVelocity = this._state.x > this.options.max && this._state.v >= 0;
	    if (belowMinWithVelocity || aboveMaxWithVelocity) {
	      if (belowMinWithVelocity) {
	        bound = this.options.min;
	      }
	      if (aboveMaxWithVelocity) {
	        bound = this.options.max;
	      }
	      return this._transitionToSpring(bound);
	    } else {
	      return this._useSpring = false;
	    }
	  };
	
	  MomentumBounceSimulator.prototype._transitionToSpring = function(bound) {
	    this._useSpring = true;
	    this._springSimulator.options.offset = bound;
	    return this._springSimulator.setState(this._state);
	  };
	
	  MomentumBounceSimulator.prototype._isValidState = function() {
	    var aboveMaxTravelingBack, belowMinTravelingBack, bound, check, friction, solution;
	    belowMinTravelingBack = this._state.x < this.options.min && this._state.v > 0;
	    aboveMaxTravelingBack = this._state.x > this.options.max && this._state.v < 0;
	    check = false;
	    if (belowMinTravelingBack) {
	      bound = this.options.min;
	      check = true;
	    } else if (aboveMaxTravelingBack) {
	      bound = this.options.max;
	      check = true;
	    }
	    if (check) {
	      friction = this._frictionSimulator.options.friction;
	      solution = 1 - (friction * (bound - this._state.x)) / this._state.v;
	      return solution > 0;
	    }
	    return true;
	  };
	
	  return MomentumBounceSimulator;
	
	})(Simulator);


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass, Events, Utils, _,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	_ = __webpack_require__(1)._;
	
	Utils = __webpack_require__(4);
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	Events = __webpack_require__(15).Events;
	
	Events.EventBufferReset = "eventbufferreset";
	
	Events.EventBufferUpdated = "eventbufferupdated";
	
	exports.EventBuffer = (function(superClass) {
	  extend(EventBuffer, superClass);
	
	  function EventBuffer(options) {
	    if (options == null) {
	      options = {};
	    }
	    this.options = _.defaults(options, {
	      velocityTimeout: 100
	    });
	    this._events = [];
	  }
	
	  EventBuffer.prototype.push = function(event) {
	    this._events.push(event);
	    return this.emit(Events.EventBufferUpdated, event);
	  };
	
	  EventBuffer.prototype.reset = function() {
	    this._events.length = 0;
	    return this.emit(Events.EventBufferReset);
	  };
	
	  EventBuffer.define("length", {
	    get: function() {
	      return this._events.length;
	    }
	  });
	
	  EventBuffer.define("first", {
	    get: function() {
	      return this._events[0];
	    }
	  });
	
	  EventBuffer.define("offset", {
	    get: function() {
	      var current, first, offset;
	      if (events.length < 2) {
	        return {
	          x: 0,
	          y: 0
	        };
	      }
	      current = events[events.length - 1];
	      first = events[0];
	      return offset = {
	        x: current.x - first.x,
	        y: current.y - first.y
	      };
	    }
	  });
	
	  EventBuffer.define("events", {
	    get: function() {
	      var timeout;
	      timeout = Date.now() - this.options.velocityTimeout;
	      return _.filter(this._events, function(event) {
	        return event.t > timeout;
	      });
	    }
	  });
	
	  EventBuffer.define("angle", {
	    get: function() {
	      var events, p1, p2;
	      events = this.events;
	      if (events.length < 2) {
	        return 0;
	      }
	      p1 = events[0];
	      p2 = events[1];
	      return Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180 / Math.PI;
	    }
	  });
	
	  EventBuffer.define("velocity", {
	    get: function() {
	      var current, events, first, time, velocity;
	      events = this.events;
	      if (events.length < 2) {
	        return {
	          x: 0,
	          y: 0
	        };
	      }
	      current = events[events.length - 1];
	      first = events[0];
	      time = current.t - first.t;
	      velocity = {
	        x: (current.x - first.x) / time,
	        y: (current.y - first.y) / time
	      };
	      if (velocity.x === 2e308) {
	        velocity.x = 0;
	      }
	      if (velocity.y === 2e308) {
	        velocity.y = 0;
	      }
	      return velocity;
	    }
	  });
	
	  return EventBuffer;
	
	})(BaseClass);


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass, Events, Gestures, Utils,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	Utils = __webpack_require__(4);
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	Events = __webpack_require__(15).Events;
	
	Gestures = __webpack_require__(16).Gestures;
	
	Events.PinchStart = "pinchstart";
	
	Events.Pinch = "pinch";
	
	Events.PinchEnd = "pinchend";
	
	Events.RotateStart = "rotatestart";
	
	Events.Rotate = "rotate";
	
	Events.RotateEnd = "rotateend";
	
	Events.ScaleStart = "scalestart";
	
	Events.Scale = "scale";
	
	Events.ScaleEnd = "scaleend";
	
	exports.LayerPinchable = (function(superClass) {
	  extend(LayerPinchable, superClass);
	
	  LayerPinchable.define("enabled", LayerPinchable.simpleProperty("enabled", true));
	
	  LayerPinchable.define("threshold", LayerPinchable.simpleProperty("threshold", 0));
	
	  LayerPinchable.define("centerOrigin", LayerPinchable.simpleProperty("centerOrigin", true));
	
	  LayerPinchable.define("scale", LayerPinchable.simpleProperty("scale", true));
	
	  LayerPinchable.define("scaleIncrements", LayerPinchable.simpleProperty("scaleIncrements", 0));
	
	  LayerPinchable.define("minScale", LayerPinchable.simpleProperty("minScale", 0));
	
	  LayerPinchable.define("maxScale", LayerPinchable.simpleProperty("maxScale", Number.MAX_VALUE));
	
	  LayerPinchable.define("scaleFactor", LayerPinchable.simpleProperty("scaleFactor", 1));
	
	  LayerPinchable.define("rotate", LayerPinchable.simpleProperty("rotate", true));
	
	  LayerPinchable.define("rotateIncrements", LayerPinchable.simpleProperty("rotateIncrements", 0));
	
	  LayerPinchable.define("rotateMin", LayerPinchable.simpleProperty("rotateMin", 0));
	
	  LayerPinchable.define("rotateMax", LayerPinchable.simpleProperty("rotateMax", 0));
	
	  LayerPinchable.define("rotateFactor", LayerPinchable.simpleProperty("rotateFactor", 1));
	
	  function LayerPinchable(layer) {
	    this.layer = layer;
	    this._pinchEnd = bind(this._pinchEnd, this);
	    this._pinch = bind(this._pinch, this);
	    this._pinchStart = bind(this._pinchStart, this);
	    this._centerOrigin = bind(this._centerOrigin, this);
	    LayerPinchable.__super__.constructor.apply(this, arguments);
	    this._attach();
	  }
	
	  LayerPinchable.prototype._attach = function() {
	    this.layer.on(Gestures.PinchStart, this._pinchStart);
	    this.layer.on(Gestures.Pinch, this._pinch);
	    this.layer.on(Gestures.PinchEnd, this._pinchEnd);
	    return this.layer.on(Gestures.TapStart, this._tapStart);
	  };
	
	  LayerPinchable.prototype._reset = function() {
	    this._scaleStart = null;
	    this._rotationStart = null;
	    return this._rotationOffset = null;
	  };
	
	  LayerPinchable.prototype._tapStart = function(event) {};
	
	  LayerPinchable.prototype._centerOrigin = function(event) {
	    var originDelta, pinchLocation, topInSuperAfter, topInSuperBefore;
	    topInSuperBefore = Utils.convertPoint({}, this.layer, this.layer.superLayer);
	    pinchLocation = Utils.convertPointFromContext(event.touchCenter, this.layer, true, true);
	    this.layer.originX = pinchLocation.x / this.layer.width;
	    this.layer.originY = pinchLocation.y / this.layer.height;
	    topInSuperAfter = Utils.convertPoint({}, this.layer, this.layer.superLayer);
	    originDelta = {
	      x: topInSuperAfter.x - topInSuperBefore.x,
	      y: topInSuperAfter.y - topInSuperBefore.y
	    };
	    this.layer.x -= originDelta.x;
	    return this.layer.y -= originDelta.y;
	  };
	
	  LayerPinchable.prototype._pinchStart = function(event) {
	    this._reset();
	    if (this.centerOrigin) {
	      this._centerOrigin(event);
	    }
	    return this.normalizeRotation = Utils.rotationNormalizer();
	  };
	
	  LayerPinchable.prototype._pinch = function(event) {
	    var pointA, pointB, rotation, scale;
	    if (event.fingers !== 2) {
	      return;
	    }
	    if (!this.enabled) {
	      return;
	    }
	    pointA = {
	      x: event.touches[0].pageX,
	      y: event.touches[0].pageY
	    };
	    pointB = {
	      x: event.touches[1].pageX,
	      y: event.touches[1].pageY
	    };
	    if (!(Utils.pointTotal(Utils.pointAbs(Utils.pointSubtract(pointA, pointB))) > this.threshold)) {
	      return;
	    }
	    if (this.scale) {
	      if (this._scaleStart == null) {
	        this._scaleStart = this.layer.scale;
	      }
	      scale = (((event.scale - 1) * this.scaleFactor) + 1) * this._scaleStart;
	      if (this.minScale && this.maxScale) {
	        scale = Utils.clamp(scale, this.minScale, this.maxScale);
	      } else if (this.minScale) {
	        scale = Utils.clamp(scale, this.minScale, 1000000);
	      } else if (this.maxScale) {
	        scale = Utils.clamp(scale, 0.00001, this.maxScale);
	      }
	      if (this.scaleIncrements) {
	        scale = Utils.nearestIncrement(scale, this.scaleIncrements);
	      }
	      this.layer.scale = scale;
	      this.emit(Events.Scale, event);
	    }
	    if (this.rotate) {
	      if (this._rotationStart == null) {
	        this._rotationStart = this.layer.rotation;
	      }
	      if (this._rotationOffset == null) {
	        this._rotationOffset = event.rotation;
	      }
	      rotation = event.rotation - this._rotationOffset + this._rotationStart;
	      rotation = rotation * this.rotateFactor;
	      rotation = this.normalizeRotation(rotation);
	      if (this.rotateMin && this.rotateMax) {
	        rotation = Utils.clamp(rotation, this.rotateMin, this.rotateMax);
	      }
	      if (this.rotateIncrements) {
	        rotation = Utils.nearestIncrement(rotation, this.rotateIncrements);
	      }
	      return this.layer.rotation = rotation;
	    }
	  };
	
	  LayerPinchable.prototype._pinchEnd = function(event) {
	    return this._reset();
	  };
	
	  return LayerPinchable;
	
	})(BaseClass);


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var Layer,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	Layer = __webpack_require__(13).Layer;
	
	"Todo: make it work in a parent layer";
	
	exports.BackgroundLayer = (function(superClass) {
	  extend(BackgroundLayer, superClass);
	
	  function BackgroundLayer(options) {
	    var ref;
	    if (options == null) {
	      options = {};
	    }
	    this.layout = bind(this.layout, this);
	    if (options.backgroundColor == null) {
	      options.backgroundColor = "#fff";
	    }
	    console.warn("BackgroundLayer is deprecated, please use\n\nScreen.backgroundColor = \"" + options.backgroundColor + "\"\n\ninstead.");
	    BackgroundLayer.__super__.constructor.call(this, options);
	    this.sendToBack();
	    this.layout();
	    this._context.domEventManager.wrap(window).addEventListener("resize", this.layout);
	    if ((ref = Framer.Device) != null) {
	      ref.on("change:orientation", this.layout);
	    }
	  }
	
	  BackgroundLayer.prototype.layout = function() {
	    if (this.parent) {
	      return this.frame = this.parent.frame;
	    } else {
	      return this.frame = this._context.frame;
	    }
	  };
	
	  return BackgroundLayer;
	
	})(Layer);


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var Layer,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	Layer = __webpack_require__(13).Layer;
	
	exports.VideoLayer = (function(superClass) {
	  extend(VideoLayer, superClass);
	
	  function VideoLayer(options) {
	    if (options == null) {
	      options = {};
	    }
	    this.player = document.createElement("video");
	    this.player.setAttribute("webkit-playsinline", "true");
	    this.player.setAttribute("playsinline", "");
	    this.player.style.width = "100%";
	    this.player.style.height = "100%";
	    VideoLayer.__super__.constructor.call(this, options);
	    this.player.on = this._context.domEventManager.wrap(this.player).addEventListener;
	    this.player.off = this._context.domEventManager.wrap(this.player).removeEventListener;
	    this.video = options.video;
	    this._element.appendChild(this.player);
	  }
	
	  VideoLayer.define("video", {
	    get: function() {
	      return this.player.src;
	    },
	    set: function(video) {
	      return this.player.src = video;
	    }
	  });
	
	  return VideoLayer;
	
	})(Layer);


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var Layer, _,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	_ = __webpack_require__(1)._;
	
	Layer = __webpack_require__(13).Layer;
	
	exports.SVGLayer = (function(superClass) {
	  extend(SVGLayer, superClass);
	
	  function SVGLayer(options) {
	    if (options == null) {
	      options = {};
	    }
	    SVGLayer.__super__.constructor.call(this, _.defaults(options, {
	      backgroundColor: null
	    }));
	    this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
	    this.svg.setAttribute("width", "100%");
	    this.svg.setAttribute("height", "100%");
	    this.svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
	  }
	
	  SVGLayer.prototype.addShape = function(type) {
	    var shape;
	    shape = document.createElementNS("http://www.w3.org/2000/svg", "circle");
	    this.svg.appendChild(shape);
	    return shape;
	  };
	
	  return SVGLayer;
	
	})(Layer);


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var AnimationGroup, AnimationStateGroup, BaseClass, _,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  slice = [].slice,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	_ = __webpack_require__(1)._;
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	AnimationGroup = (function(superClass) {
	  extend(AnimationGroup, superClass);
	
	  function AnimationGroup() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    AnimationGroup.__super__.constructor.apply(this, arguments);
	    this._animations = _.flatten(args);
	    this.stopAnimations = true;
	    this.stop();
	  }
	
	  AnimationGroup.prototype.start = function() {
	    return this._start(this._animations);
	  };
	
	  AnimationGroup.prototype.stop = function() {
	    this._stop();
	    this._started = [];
	    this._halted = [];
	    this._stopped = [];
	    return this._ended = [];
	  };
	
	  AnimationGroup.prototype._start = function(animations) {
	    this.stop();
	    this._onStart();
	    return animations.map((function(_this) {
	      return function(animation) {
	        _this._started.push(animation);
	        animation.onAnimationHalt(function() {
	          _this._halted.push(animation);
	          if (_this._halted.length > 1) {
	            return;
	          }
	          _this._stop();
	          return _this._onHalt();
	        });
	        animation.onAnimationStop(function() {
	          _this._stopped.push(animation);
	          if (_this._stopped.length === _this._started.length) {
	            return _this._onStop();
	          }
	        });
	        animation.onAnimationEnd(function() {
	          _this._ended.push(animation);
	          if (_this._ended.length === _this._started.length) {
	            return _this._onEnd();
	          }
	        });
	        return animation.start();
	      };
	    })(this));
	  };
	
	  AnimationGroup.prototype._stop = function() {
	    if (!this._started) {
	      return;
	    }
	    if (this.stopAnimations !== true) {
	      return;
	    }
	    return this._started.map(function(a) {
	      if (a.isAnimating) {
	        return a.stop();
	      }
	    });
	  };
	
	  AnimationGroup.prototype._onStart = function() {
	    return this.emit(Events.AnimationStart);
	  };
	
	  AnimationGroup.prototype._onHalt = function() {
	    return this.emit(Events.AnimationHalt);
	  };
	
	  AnimationGroup.prototype._onStop = function() {
	    return this.emit(Events.AnimationStop);
	  };
	
	  AnimationGroup.prototype._onEnd = function() {
	    return this.emit(Events.AnimationEnd);
	  };
	
	  AnimationGroup.prototype.onAnimationStart = function(cb) {
	    return this.on(Events.AnimationStart, cb);
	  };
	
	  AnimationGroup.prototype.onAnimationHalt = function(cb) {
	    return this.on(Events.AnimationHalt, cb);
	  };
	
	  AnimationGroup.prototype.onAnimationStop = function(cb) {
	    return this.on(Events.AnimationStop, cb);
	  };
	
	  AnimationGroup.prototype.onAnimationEnd = function(cb) {
	    return this.on(Events.AnimationEnd, cb);
	  };
	
	  AnimationGroup.prototype.onStart = function(cb) {
	    return this.onAnimationStart(cb);
	  };
	
	  AnimationGroup.prototype.onHalt = function(cb) {
	    return this.onAnimationHalt(cb);
	  };
	
	  AnimationGroup.prototype.onStop = function(cb) {
	    return this.onAnimationStop(cb);
	  };
	
	  AnimationGroup.prototype.onEnd = function(cb) {
	    return this.onAnimationEnd(cb);
	  };
	
	  return AnimationGroup;
	
	})(BaseClass);
	
	AnimationStateGroup = (function(superClass) {
	  extend(AnimationStateGroup, superClass);
	
	  function AnimationStateGroup() {
	    var layers;
	    layers = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    AnimationStateGroup.__super__.constructor.apply(this, arguments);
	    this._layers = _.flatten(layers);
	    this._state = "default";
	  }
	
	  AnimationStateGroup.prototype.animate = function(state) {
	    var animations, i, layer, len, ref;
	    animations = [];
	    ref = this._layers;
	    for (i = 0, len = ref.length; i < len; i++) {
	      layer = ref[i];
	      if (layer.states[state]) {
	        animations.push(layer.animate(state, {
	          start: false
	        }));
	      }
	    }
	    if (!animations) {
	      return;
	    }
	    this._start(animations);
	    return this._state = state;
	  };
	
	  AnimationStateGroup.define("state", {
	    get: function() {
	      return this._state;
	    }
	  });
	
	  AnimationStateGroup.define("states", {
	    get: function() {
	      var i, j, layer, len, len1, ref, ref1, state, states;
	      states = [];
	      ref = this._layers;
	      for (i = 0, len = ref.length; i < len; i++) {
	        layer = ref[i];
	        ref1 = _.keys(layer.states);
	        for (j = 0, len1 = ref1.length; j < len1; j++) {
	          state = ref1[j];
	          if (indexOf.call(states, state) < 0) {
	            states.push(state);
	          }
	        }
	      }
	      return states;
	    }
	  });
	
	  AnimationStateGroup.prototype.stateCycle = function() {
	    var args, states;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    states = _.flatten(args);
	    if (!states.length) {
	      states = this.states;
	    }
	    return this.animate(Utils.arrayNext(states, this.state));
	  };
	
	  return AnimationStateGroup;
	
	})(AnimationGroup);
	
	exports.AnimationGroup = AnimationGroup;
	
	exports.AnimationStateGroup = AnimationStateGroup;


/***/ },
/* 41 */
/***/ function(module, exports) {

	var bottom, center, left, pixelRound, right, top, wrapper;
	
	pixelRound = parseInt;
	
	center = function(layer, property, offset) {
	  var borderWidth, parent, x, y;
	  if (offset == null) {
	    offset = 0;
	  }
	  parent = Screen;
	  if (layer.parent) {
	    parent = layer.parent;
	  }
	  borderWidth = parent.borderWidth;
	  if (borderWidth == null) {
	    borderWidth = 0;
	  }
	  x = pixelRound((parent.width / 2) - (layer.width / 2) - borderWidth + offset);
	  y = pixelRound((parent.height / 2) - (layer.height / 2) - borderWidth + offset);
	  if (property === "x") {
	    return x;
	  }
	  if (property === "y") {
	    return y;
	  }
	  if (property === "point") {
	    return {
	      x: x,
	      y: y
	    };
	  }
	  return 0;
	};
	
	left = function(layer, property, offset) {
	  var parent;
	  if (offset == null) {
	    offset = 0;
	  }
	  if (property !== "x") {
	    throw Error("Align.left only works for x");
	  }
	  parent = Screen;
	  if (layer.parent) {
	    parent = layer.parent;
	  }
	  return pixelRound(0 + offset);
	};
	
	right = function(layer, property, offset) {
	  var borderWidth, parent;
	  if (offset == null) {
	    offset = 0;
	  }
	  if (property !== "x") {
	    throw Error("Align.right only works for x");
	  }
	  parent = Screen;
	  if (layer.parent) {
	    parent = layer.parent;
	  }
	  borderWidth = parent.borderWidth;
	  if (borderWidth == null) {
	    borderWidth = 0;
	  }
	  return pixelRound(parent.width - (2 * borderWidth) - layer.width + offset);
	};
	
	top = function(layer, property, offset) {
	  var parent;
	  if (offset == null) {
	    offset = 0;
	  }
	  if (property !== "y") {
	    throw Error("Align.top only works for y");
	  }
	  parent = Screen;
	  if (layer.parent) {
	    parent = layer.parent;
	  }
	  return pixelRound(0 + offset);
	};
	
	bottom = function(layer, property, offset) {
	  var borderWidth, parent;
	  if (offset == null) {
	    offset = 0;
	  }
	  if (property !== "y") {
	    throw Error("Align.bottom only works for y");
	  }
	  parent = Screen;
	  if (layer.parent) {
	    parent = layer.parent;
	  }
	  borderWidth = parent.borderWidth;
	  if (borderWidth == null) {
	    borderWidth = 0;
	  }
	  return pixelRound(parent.height - (2 * borderWidth) - layer.height + offset);
	};
	
	wrapper = function(f, name) {
	  var align;
	  align = function(a, b) {
	    if ((a == null) || _.isNumber(a)) {
	      return (function(l, p) {
	        return f(l, p, a);
	      });
	    }
	    return f(a, b, 0);
	  };
	  align.toInspect = function() {
	    return "Align." + name;
	  };
	  return align;
	};
	
	exports.Align = {
	  center: wrapper(center, "center"),
	  left: wrapper(left, "left"),
	  right: wrapper(right, "right"),
	  top: wrapper(top, "top"),
	  bottom: wrapper(bottom, "bottom")
	};


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var Context, Printer, Utils, _printer,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  slice = [].slice;
	
	Utils = __webpack_require__(4);
	
	Context = __webpack_require__(43).Context;
	
	Printer = (function() {
	  function Printer() {
	    this.scrollToBottom = bind(this.scrollToBottom, this);
	    this.print = bind(this.print, this);
	    this.resize = bind(this.resize, this);
	    this.createLayer = bind(this.createLayer, this);
	    this._context = new Context({
	      name: "PrintConsole"
	    });
	    this._context.run((function(_this) {
	      return function() {
	        return Events.wrap(window).addEventListener("resize", _this.resize);
	      };
	    })(this));
	  }
	
	  Printer.prototype.createLayer = function() {
	    if (this._printLayer) {
	      return this._printLayer;
	    }
	    this._context.run((function(_this) {
	      return function() {
	        _this._container = new Layer({
	          backgroundColor: null
	        });
	        _this._container.style.zIndex = 999;
	        _this._printLayer = new Layer({
	          parent: _this._container
	        });
	        _this._printLayer.scrollVertical = true;
	        _this._printLayer.ignoreEvents = false;
	        _this._printLayer.html = "";
	        _this._printLayer.style = {
	          "font": "12px/1.35em Menlo",
	          "color": "rgba(0, 0, 0, .7)",
	          "padding": "8px",
	          "padding-bottom": "30px",
	          "border-top": "1px solid #d9d9d9"
	        };
	        _this._printLayer.opacity = 0.9;
	        _this._printLayer.visible = true;
	        _this._printLayer.backgroundColor = "white";
	        _this._closeButton = new Layer({
	          parent: _this._container,
	          html: '<svg><g stroke="#B8B8B8"><path d="M1,1 L8,8"></path><path d="M1,8 L8,1"></path></g></svg>',
	          y: 9,
	          width: 9,
	          height: 9,
	          backgroundColor: null
	        });
	        _this._closeButton.style["cursor"] = "auto";
	        return _this._closeButton.onClick(function() {
	          return _this.hide();
	        });
	      };
	    })(this));
	    this.resize();
	    return this._printLayer;
	  };
	
	  Printer.prototype.resize = function() {
	    if (!this._printLayer) {
	      return;
	    }
	    this._container.width = window.innerWidth;
	    this._container.height = 160;
	    this._container.maxY = window.innerHeight;
	    this._printLayer.size = this._container.size;
	    return this._closeButton.maxX = this._container.maxX - this._closeButton.y + 1;
	  };
	
	  Printer.prototype.hide = function() {
	    return this._context.visible = false;
	  };
	
	  Printer.prototype.print = function() {
	    var args, printNode, printPrefix;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    this.createLayer();
	    this._context.visible = true;
	    printPrefix = "» ";
	    printNode = document.createElement("div");
	    printNode.style["-webkit-user-select"] = "text";
	    printNode.style["cursor"] = "auto";
	    printNode.innerHTML = _.escape(printPrefix + args.map(function(obj) {
	      return Utils.inspect(obj);
	    }).join(", ")) + "<br>";
	    this._printLayer._element.appendChild(printNode);
	    this.scrollToBottom();
	    return Utils.delay(0, this.scrollToBottom);
	  };
	
	  Printer.prototype.scrollToBottom = function() {
	    if (!this._printLayer) {
	      return;
	    }
	    return this._printLayer._element.scrollTop = this._printLayer._element.scrollHeight;
	  };
	
	  return Printer;
	
	})();
	
	_printer = null;
	
	exports.print = function() {
	  var args;
	  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	  if (_printer == null) {
	    _printer = new Printer;
	  }
	  return _printer.print.apply(_printer, args);
	};


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass, Config, Contexts, DOMEventManager, Defaults, Utils, _,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
	  slice = [].slice;
	
	_ = __webpack_require__(1)._;
	
	Utils = __webpack_require__(4);
	
	Config = __webpack_require__(14).Config;
	
	Defaults = __webpack_require__(17).Defaults;
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	DOMEventManager = __webpack_require__(44).DOMEventManager;
	
	
	/*
	
	An easy way to think of the context is a bucket of things related to a set of layers. There
	is always at least one context on the screen, but often many more. For example, the device has
	a special context and replaces the default one (so it renders in the screen), and the print
	function uses on to draw the console.
	
	The default context lives under Framer.DefaultContext and the current one in
	Framer.CurrentContext. You can create layers in any context by using the run function.
	
	A context keeps track of everyting around those layers, so it can clean it up again. We use
	this a lot in Framer Studio's autocomplete function. Async things like running animations and
	timers get stopped too.
	
	Contexts can live inside another context (with a layer as a parent) so you can only reload
	a part of a prototype. This is mainly how device works.
	
	Another feature is to temporarily freeze/resume a context. If you freeze it, all user event
	will temporarily get blocked so in theory nothing will change in the context. You can restore
	these at any time.
	 */
	
	Contexts = [];
	
	exports.Context = (function(superClass) {
	  extend(Context, superClass);
	
	  Context.all = function() {
	    return _.clone(Contexts);
	  };
	
	  Context.define("parent", {
	    get: function() {
	      return this._parent;
	    }
	  });
	
	  Context.define("element", {
	    get: function() {
	      return this._element;
	    }
	  });
	
	  function Context(options) {
	    if (options == null) {
	      options = {};
	    }
	    options = Defaults.getDefaults("Context", options);
	    Context.__super__.constructor.apply(this, arguments);
	    if (!options.name) {
	      throw Error("Contexts need a name");
	    }
	    this._parent = options.parent;
	    this._name = options.name;
	    this.perspective = options.perspective;
	    this.perspectiveOriginX = options.perspectiveOriginX;
	    this.perspectiveOriginY = options.perspectiveOriginY;
	    this.reset();
	    if (options.hasOwnProperty("index")) {
	      this.index = options.index;
	    } else {
	      this.index = this.id;
	    }
	    Contexts.push(this);
	  }
	
	  Context.prototype.reset = function() {
	    this._createDOMEventManager();
	    this._createRootElement();
	    this.resetFrozenEvents();
	    this.resetLayers();
	    this.resetAnimations();
	    this.resetTimers();
	    this.resetIntervals();
	    return this.emit("reset", this);
	  };
	
	  Context.prototype.destroy = function() {
	    this.reset();
	    this._destroyRootElement();
	    return _.remove(Contexts, this);
	  };
	
	  Context.define("layers", {
	    get: function() {
	      return _.clone(this._layers);
	    }
	  });
	
	  Context.define("layerCounter", {
	    get: function() {
	      return this._layerCounter;
	    }
	  });
	
	  Context.define("rootLayers", {
	    get: function() {
	      return _.filter(this._layers, function(layer) {
	        return layer.parent === null;
	      });
	    }
	  });
	
	  Context.define("visible", {
	    get: function() {
	      return this._visible || true;
	    },
	    set: function(value) {
	      var ref;
	      if (value === this._visible) {
	        return;
	      }
	      if ((ref = this._element) != null) {
	        ref.style.visibility = value ? "visible" : "hidden";
	      }
	      return this._visible = value;
	    }
	  });
	
	  Context.prototype.addLayer = function(layer) {
	    if (indexOf.call(this._layers, layer) >= 0) {
	      return;
	    }
	    this._layerCounter++;
	    return this._layers.push(layer);
	  };
	
	  Context.prototype.removeLayer = function(layer) {
	    return this._layers = _.without(this._layers, layer);
	  };
	
	  Context.prototype.resetLayers = function() {
	    this.resetGestures();
	    this._layers = [];
	    return this._layerCounter = 0;
	  };
	
	  Context.prototype.layerForId = function(layerId) {
	    var i, layer, len, ref;
	    ref = this._layers;
	    for (i = 0, len = ref.length; i < len; i++) {
	      layer = ref[i];
	      if (layer.id === layerId) {
	        return layer;
	      }
	    }
	    return null;
	  };
	
	  Context.prototype._layerForElement = function(element) {
	    var i, layer, len, ref;
	    ref = this._layers;
	    for (i = 0, len = ref.length; i < len; i++) {
	      layer = ref[i];
	      if (layer._element === element) {
	        return layer;
	      }
	    }
	    return null;
	  };
	
	  Context.prototype.layerForElement = function(element) {
	    var layer;
	    if (!element) {
	      return null;
	    }
	    layer = this._layerForElement(element);
	    if (layer) {
	      return layer;
	    }
	    return this.layerForElement(element.parentNode);
	  };
	
	  Context.define("animations", {
	    get: function() {
	      return _.clone(this._animations);
	    }
	  });
	
	  Context.prototype.addAnimation = function(animation) {
	    if (indexOf.call(this._animations, animation) >= 0) {
	      return;
	    }
	    return this._animations.push(animation);
	  };
	
	  Context.prototype.removeAnimation = function(animation) {
	    return this._animations = _.without(this._animations, animation);
	  };
	
	  Context.prototype.resetAnimations = function() {
	    this.stopAnimations();
	    return this._animations = [];
	  };
	
	  Context.prototype.stopAnimations = function() {
	    if (!this._animations) {
	      return;
	    }
	    return this._animations.map(function(animation) {
	      return animation.stop(true);
	    });
	  };
	
	  Context.prototype.resetFrozenEvents = function() {
	    return delete this._frozenEvents;
	  };
	
	  Context.define("timers", {
	    get: function() {
	      return _.clone(this._timers);
	    }
	  });
	
	  Context.prototype.addTimer = function(timer) {
	    if (indexOf.call(this._timers, timer) >= 0) {
	      return;
	    }
	    return this._timers.push(timer);
	  };
	
	  Context.prototype.removeTimer = function(timer) {
	    window.clearTimeout(timer);
	    return this._timers = _.without(this._timers, timer);
	  };
	
	  Context.prototype.resetTimers = function() {
	    if (this._timers) {
	      this._timers.map(window.clearTimeout);
	    }
	    return this._timers = [];
	  };
	
	  Context.define("intervals", {
	    get: function() {
	      return _.clone(this._intervals);
	    }
	  });
	
	  Context.prototype.addInterval = function(interval) {
	    if (indexOf.call(this._intervals, interval) >= 0) {
	      return;
	    }
	    return this._intervals.push(interval);
	  };
	
	  Context.prototype.removeInterval = function(interval) {
	    return this._intervals = _.without(this._intervals, interval);
	  };
	
	  Context.prototype.resetIntervals = function() {
	    if (this._intervals) {
	      this._intervals.map(window.clearInterval);
	    }
	    return this._intervals = [];
	  };
	
	  Context.prototype.resetGestures = function() {
	    var i, layer, len, ref;
	    if (!this._layers) {
	      return;
	    }
	    ref = this._layers;
	    for (i = 0, len = ref.length; i < len; i++) {
	      layer = ref[i];
	      if (layer._gestures) {
	        layer._gestures.destroy();
	      }
	    }
	  };
	
	  Context.prototype.run = function(fn) {
	    var previousContext;
	    previousContext = Framer.CurrentContext;
	    Framer.CurrentContext = this;
	    fn();
	    return Framer.CurrentContext = previousContext;
	  };
	
	  Context.prototype.freeze = function() {
	    var eventName, i, j, layer, layerId, layerListeners, len, len1, ref, ref1;
	    if (this._frozenEvents != null) {
	      throw new Error("Context is already frozen");
	    }
	    this._frozenEvents = {};
	    ref = this._layers;
	    for (i = 0, len = ref.length; i < len; i++) {
	      layer = ref[i];
	      layerListeners = {};
	      ref1 = layer.listenerEvents();
	      for (j = 0, len1 = ref1.length; j < len1; j++) {
	        eventName = ref1[j];
	        layerListeners[eventName] = layer.listeners(eventName);
	      }
	      layer.removeAllListeners();
	      layerId = this._layers.indexOf(layer);
	      this._frozenEvents[layerId] = layerListeners;
	    }
	    this.stopAnimations();
	    this.resetTimers();
	    return this.resetIntervals();
	  };
	
	  Context.prototype.resume = function() {
	    var eventName, events, i, layer, layerId, len, listener, listeners, ref;
	    if (this._frozenEvents == null) {
	      throw new Error("Context is not frozen, cannot resume");
	    }
	    ref = this._frozenEvents;
	    for (layerId in ref) {
	      events = ref[layerId];
	      layer = this._layers[layerId];
	      for (eventName in events) {
	        listeners = events[eventName];
	        for (i = 0, len = listeners.length; i < len; i++) {
	          listener = listeners[i];
	          layer.on(eventName, listener);
	        }
	      }
	    }
	    return this.resetFrozenEvents();
	  };
	
	  Context.prototype._createDOMEventManager = function() {
	    var ref;
	    if ((ref = this.domEventManager) != null) {
	      ref.reset();
	    }
	    return this.domEventManager = new DOMEventManager;
	  };
	
	  Context.prototype._createRootElement = function() {
	    this._destroyRootElement();
	    this._element = document.createElement("div");
	    this._element.id = "FramerContextRoot-" + this._name;
	    this._element.classList.add("framerContext");
	    this._element.style["webkitPerspective"] = this.perspective;
	    this._element.style["backgroundColor"] = this.backgroundColor;
	    this.__pendingElementAppend = (function(_this) {
	      return function() {
	        var parentElement, ref;
	        parentElement = (ref = _this._parent) != null ? ref._element : void 0;
	        if (parentElement == null) {
	          parentElement = document.body;
	        }
	        return parentElement.appendChild(_this._element);
	      };
	    })(this);
	    return Utils.domComplete(this.__pendingElementAppend);
	  };
	
	  Context.prototype._destroyRootElement = function() {
	    var ref;
	    if ((ref = this._element) != null ? ref.parentNode : void 0) {
	      this._element.parentNode.removeChild(this._element);
	    }
	    if (this.__pendingElementAppend) {
	      Utils.domCompleteCancel(this.__pendingElementAppend);
	      this.__pendingElementAppend = null;
	    }
	    return this._element = null;
	  };
	
	  Context.define("width", {
	    get: function() {
	      if (this.parent != null) {
	        return this.parent.width;
	      }
	      return window.innerWidth;
	    }
	  });
	
	  Context.define("height", {
	    get: function() {
	      if (this.parent != null) {
	        return this.parent.height;
	      }
	      return window.innerHeight;
	    }
	  });
	
	  Context.define("frame", {
	    get: function() {
	      return {
	        x: 0,
	        y: 0,
	        width: this.width,
	        height: this.height
	      };
	    }
	  });
	
	  Context.define("size", {
	    get: function() {
	      return _.pick(this.frame, ["width", "height"]);
	    }
	  });
	
	  Context.define("point", {
	    get: function() {
	      return _.pick(this.frame, ["x", "y"]);
	    }
	  });
	
	  Context.define("canvasFrame", {
	    get: function() {
	      if (this.parent == null) {
	        return this.frame;
	      }
	      return this.parent.canvasFrame;
	    }
	  });
	
	  Context.define("backgroundColor", {
	    get: function() {
	      if (Color.isColor(this._backgroundColor)) {
	        return this._backgroundColor;
	      }
	      return "transparent";
	    },
	    set: function(value) {
	      var ref;
	      if (Color.isColor(value)) {
	        this._backgroundColor = value;
	        return (ref = this._element) != null ? ref.style["backgroundColor"] = new Color(value.toString()) : void 0;
	      }
	    }
	  });
	
	  Context.define("perspective", {
	    get: function() {
	      return this._perspective;
	    },
	    set: function(value) {
	      var ref;
	      if (_.isNumber(value)) {
	        this._perspective = value;
	        return (ref = this._element) != null ? ref.style["webkitPerspective"] = this._perspective : void 0;
	      }
	    }
	  });
	
	  Context.prototype._updatePerspective = function() {
	    var ref;
	    return (ref = this._element) != null ? ref.style["webkitPerspectiveOrigin"] = (this.perspectiveOriginX * 100) + "% " + (this.perspectiveOriginY * 100) + "%" : void 0;
	  };
	
	  Context.define("perspectiveOriginX", {
	    get: function() {
	      if (_.isNumber(this._perspectiveOriginX)) {
	        return this._perspectiveOriginX;
	      }
	      return 0.5;
	    },
	    set: function(value) {
	      if (_.isNumber(value)) {
	        this._perspectiveOriginX = value;
	        return this._updatePerspective();
	      }
	    }
	  });
	
	  Context.define("perspectiveOriginY", {
	    get: function() {
	      if (_.isNumber(this._perspectiveOriginY)) {
	        return this._perspectiveOriginY;
	      }
	      return .5;
	    },
	    set: function(value) {
	      if (_.isNumber(value)) {
	        this._perspectiveOriginY = value;
	        return this._updatePerspective();
	      }
	    }
	  });
	
	  Context.define("index", {
	    get: function() {
	      var ref;
	      return ((ref = this._element) != null ? ref.style["z-index"] : void 0) || 0 || 0;
	    },
	    set: function(value) {
	      if (!this._element) {
	        return;
	      }
	      return this._element.style["z-index"] = value;
	    }
	  });
	
	  Context.prototype.ancestors = function() {
	    var args, ref;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    return ((ref = this._parent) != null ? ref.ancestors.apply(ref, args) : void 0) || [];
	  };
	
	  Context.prototype.toInspect = function() {
	    var round;
	    round = function(value) {
	      if (parseInt(value) === value) {
	        return parseInt(value);
	      }
	      return Utils.round(value, 1);
	    };
	    return "<" + this.constructor.name + " id:" + this.id + " name:" + this._name + " " + (round(this.width)) + "x" + (round(this.height)) + ">";
	  };
	
	  return Context;
	
	})(BaseClass);


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var DOMEventManagerElement, EventEmitter, EventManagerIdCounter, Utils, _,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	_ = __webpack_require__(1)._;
	
	EventEmitter = __webpack_require__(7).EventEmitter;
	
	Utils = __webpack_require__(4);
	
	EventManagerIdCounter = 0;
	
	DOMEventManagerElement = (function(superClass) {
	  extend(DOMEventManagerElement, superClass);
	
	  function DOMEventManagerElement(element1) {
	    this.element = element1;
	  }
	
	  DOMEventManagerElement.prototype.addListener = function(eventName, listener, capture) {
	    if (capture == null) {
	      capture = false;
	    }
	    listener.capture = capture;
	    DOMEventManagerElement.__super__.addListener.call(this, eventName, listener);
	    return this.element.addEventListener(eventName, listener, capture);
	  };
	
	  DOMEventManagerElement.prototype.removeListener = function(eventName, listener, capture) {
	    if (capture == null) {
	      capture = false;
	    }
	    DOMEventManagerElement.__super__.removeListener.call(this, eventName, listener);
	    return this.element.removeEventListener(eventName, listener, listener.capture);
	  };
	
	  DOMEventManagerElement.prototype.addEventListener = DOMEventManagerElement.prototype.addListener;
	
	  DOMEventManagerElement.prototype.removeEventListener = DOMEventManagerElement.prototype.removeListener;
	
	  DOMEventManagerElement.prototype.on = DOMEventManagerElement.prototype.addListener;
	
	  DOMEventManagerElement.prototype.off = DOMEventManagerElement.prototype.removeListener;
	
	  return DOMEventManagerElement;
	
	})(EventEmitter);
	
	exports.DOMEventManager = (function() {
	  function DOMEventManager(element) {
	    this.wrap = bind(this.wrap, this);
	    this._elements = {};
	  }
	
	  DOMEventManager.prototype.wrap = function(element) {
	    if (!element._eventManagerId) {
	      element._eventManagerId = EventManagerIdCounter++;
	    }
	    if (!this._elements[element._eventManagerId]) {
	      this._elements[element._eventManagerId] = new DOMEventManagerElement(element);
	    }
	    return this._elements[element._eventManagerId];
	  };
	
	  DOMEventManager.prototype.reset = function() {
	    var element, elementEventManager, ref, results;
	    ref = this._elements;
	    results = [];
	    for (element in ref) {
	      elementEventManager = ref[element];
	      results.push(elementEventManager.removeAllListeners());
	    }
	    return results;
	  };
	
	  return DOMEventManager;

	})();


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var Defaults, EventMappers, Events, Layer, Utils, _, wrapComponent,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  slice = [].slice,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	_ = __webpack_require__(1)._;
	
	Utils = __webpack_require__(4);
	
	Layer = __webpack_require__(13).Layer;
	
	Events = __webpack_require__(15).Events;
	
	Defaults = __webpack_require__(17).Defaults;
	
	"ScrollComponent\n\ncontent <Layer>\ncontentSize <{width:n, height:n}>\ncontentInset <{top:n, right:n, bottom:n, left:n}> TODO\ncontentOffset <{x:n, y:n}> TODO\nscrollFrame <{x:n, y:n, width:n, height:n}>\nscrollPoint <{x:n, y:n}>\nscrollHorizontal <bool>\nscrollVertical <bool>\nspeedX <number>\nspeedY <number>\ndelaysContentTouches <bool> TODO\nloadPreset(<\"ios\"|\"android\">) TODO\nscrollToPoint(<{x:n, y:n}>, animate=true, animationOptions={})\nscrollToLayer(contentLayer, originX=0, originY=0)\nscrollFrameForContentLayer(<x:n, y:n>) <{x:n, y:n, width:n, height:n}> TODO\nclosestContentLayer(<x:n, y:n>) <Layer> TODO\n\nScrollComponent Events\n\n(all of the draggable events)\nScrollStart -> DragStart\nScrollWillMove -> DragWillMove\nScrollDidMove -> DragDidMove\nscroll -> DragMove (html compat)\nScrollEnd -> DragEnd";
	
	Events.ScrollStart = "scrollstart";
	
	Events.Scroll = "scroll";
	
	Events.ScrollMove = Events.Scroll;
	
	Events.ScrollEnd = "scrollend";
	
	Events.ScrollAnimationDidStart = "scrollanimationdidstart";
	
	Events.ScrollAnimationDidEnd = "scrollanimationdidend";
	
	EventMappers = {};
	
	EventMappers[Events.Move] = Events.Move;
	
	EventMappers[Events.ScrollStart] = Events.DragStart;
	
	EventMappers[Events.ScrollMove] = Events.DragMove;
	
	EventMappers[Events.ScrollEnd] = Events.DragEnd;
	
	EventMappers[Events.ScrollAnimationDidStart] = Events.DragAnimationStart;
	
	EventMappers[Events.ScrollAnimationDidEnd] = Events.DragAnimationEnd;
	
	EventMappers[Events.DirectionLockStart] = Events.DirectionLockStart;
	
	exports.ScrollComponent = (function(superClass) {
	  extend(ScrollComponent, superClass);
	
	  ScrollComponent.define("velocity", ScrollComponent.proxyProperty("content.draggable.velocity", {
	    importable: false,
	    exportable: false
	  }));
	
	  ScrollComponent.define("scrollHorizontal", ScrollComponent.proxyProperty("content.draggable.horizontal"));
	
	  ScrollComponent.define("scrollVertical", ScrollComponent.proxyProperty("content.draggable.vertical"));
	
	  ScrollComponent.define("speedX", ScrollComponent.proxyProperty("content.draggable.speedX"));
	
	  ScrollComponent.define("speedY", ScrollComponent.proxyProperty("content.draggable.speedY"));
	
	  ScrollComponent.define("isDragging", ScrollComponent.proxyProperty("content.draggable.isDragging", {
	    importable: false,
	    exportable: false
	  }));
	
	  ScrollComponent.define("isMoving", ScrollComponent.proxyProperty("content.draggable.isMoving", {
	    importable: false,
	    exportable: false
	  }));
	
	  ScrollComponent.define("isAnimating", ScrollComponent.proxyProperty("content.draggable.isAnimating", {
	    importable: false,
	    exportable: false
	  }));
	
	  ScrollComponent.define("propagateEvents", ScrollComponent.proxyProperty("content.draggable.propagateEvents"));
	
	  ScrollComponent.define("directionLock", ScrollComponent.proxyProperty("content.draggable.directionLock"));
	
	  ScrollComponent.define("directionLockThreshold", ScrollComponent.proxyProperty("content.draggable.directionLockThreshold"));
	
	  ScrollComponent.define("content", {
	    importable: false,
	    exportable: false,
	    get: function() {
	      return this._content;
	    }
	  });
	
	  ScrollComponent.define("mouseWheelSpeedMultiplier", ScrollComponent.simpleProperty("mouseWheelSpeedMultiplier", 1));
	
	  function ScrollComponent(options) {
	    if (options == null) {
	      options = {};
	    }
	    this._onMouseWheel = bind(this._onMouseWheel, this);
	    this._onAnimationStop = bind(this._onAnimationStop, this);
	    this._onAnimationStep = bind(this._onAnimationStep, this);
	    this._onAnimationStart = bind(this._onAnimationStart, this);
	    this.updateContent = bind(this.updateContent, this);
	    ScrollComponent.__super__.constructor.call(this, Defaults.getDefaults("ScrollComponent", options));
	    this._contentInset = options.contentInset || Utils.rectZero();
	    this.setContentLayer(new Layer);
	    this._applyProxyDefaults(options);
	    this._enableMouseWheelHandling(options.mouseWheelEnabled);
	    if (options.hasOwnProperty("wrap")) {
	      wrapComponent(this, options.wrap);
	    }
	  }
	
	  ScrollComponent.prototype.calculateContentFrame = function() {
	    var contentFrame, size;
	    if (!this.content) {
	      return Utils.rectZero();
	    }
	    contentFrame = this.content.contentFrame();
	    return size = {
	      x: 0,
	      y: 0,
	      width: Math.max(this.width, contentFrame.x + contentFrame.width),
	      height: Math.max(this.height, contentFrame.y + contentFrame.height)
	    };
	  };
	
	  ScrollComponent.prototype.setContentLayer = function(layer) {
	    if (this.content) {
	      this._onAnimationStop();
	      this.content.off(Events.AnimationStart, this._onAnimationStart);
	      this.content.off(Events.AnimationStop, this._onAnimationStop);
	      this._content.destroy();
	    }
	    this._content = layer;
	    this._content.parent = this;
	    this._content.name = "content";
	    this._content.clip = true;
	    this._content.draggable.enabled = true;
	    this._content.draggable.momentum = true;
	    this._content.on("change:children", this.updateContent);
	    this.on("change:width", this.updateContent);
	    this.on("change:height", this.updateContent);
	    this.updateContent();
	    this.scrollPoint = {
	      x: 0,
	      y: 0
	    };
	    this.content.on(Events.AnimationStart, this._onAnimationStart);
	    this.content.on(Events.AnimationStop, this._onAnimationStop);
	    return this._content;
	  };
	
	  ScrollComponent.prototype.updateContent = function() {
	    var constraintsFrame, contentFrame, ref;
	    if (!this.content) {
	      return;
	    }
	    contentFrame = this.calculateContentFrame();
	    this.content.width = contentFrame.width;
	    this.content.height = contentFrame.height;
	    constraintsFrame = this.calculateContentFrame();
	    constraintsFrame = {
	      x: -constraintsFrame.width + this.width - this._contentInset.right,
	      y: -constraintsFrame.height + this.height - this._contentInset.bottom,
	      width: constraintsFrame.width + constraintsFrame.width - this.width + this._contentInset.left + this._contentInset.right,
	      height: constraintsFrame.height + constraintsFrame.height - this.height + this._contentInset.top + this._contentInset.bottom
	    };
	    this.content.draggable.constraints = constraintsFrame;
	    this.scrollPoint = this.scrollPoint;
	    if (this.content.children.length) {
	      if ((ref = this.content.backgroundColor) != null ? ref.isEqual(Framer.Defaults.Layer.backgroundColor) : void 0) {
	        return this.content.backgroundColor = null;
	      }
	    }
	  };
	
	  ScrollComponent.define("scroll", {
	    exportable: false,
	    get: function() {
	      return this.scrollHorizontal === true || this.scrollVertical === true;
	    },
	    set: function(value) {
	      if (!this.content) {
	        return;
	      }
	      if (value === false) {
	        this.content.animateStop();
	      }
	      return this.scrollHorizontal = this.scrollVertical = value;
	    }
	  });
	
	  ScrollComponent.prototype._calculateContentPoint = function(scrollPoint) {
	    var point;
	    scrollPoint = _.defaults(scrollPoint, {
	      x: 0,
	      y: 0
	    });
	    scrollPoint.x -= this.contentInset.left;
	    scrollPoint.y -= this.contentInset.top;
	    point = this._pointInConstraints(scrollPoint);
	    return Utils.pointInvert(point);
	  };
	
	  ScrollComponent.define("scrollX", {
	    get: function() {
	      if (!this.content) {
	        return 0;
	      }
	      return 0 - this.content.x + this.contentInset.left;
	    },
	    set: function(value) {
	      if (!this.content) {
	        return;
	      }
	      this.content.draggable.animateStop();
	      return this.content.x = this._calculateContentPoint({
	        x: value,
	        y: 0
	      }).x;
	    }
	  });
	
	  ScrollComponent.define("scrollY", {
	    get: function() {
	      if (!this.content) {
	        return 0;
	      }
	      return 0 - this.content.y + this.contentInset.top;
	    },
	    set: function(value) {
	      if (!this.content) {
	        return;
	      }
	      this.content.draggable.animateStop();
	      return this.content.y = this._calculateContentPoint({
	        x: 0,
	        y: value
	      }).y;
	    }
	  });
	
	  ScrollComponent.define("scrollPoint", {
	    importable: true,
	    exportable: false,
	    get: function() {
	      var point;
	      return point = {
	        x: this.scrollX,
	        y: this.scrollY
	      };
	    },
	    set: function(point) {
	      if (!this.content) {
	        return;
	      }
	      this.scrollX = point.x;
	      return this.scrollY = point.y;
	    }
	  });
	
	  ScrollComponent.define("scrollFrame", {
	    importable: true,
	    exportable: false,
	    get: function() {
	      var rect;
	      rect = this.scrollPoint;
	      rect.width = this.width;
	      rect.height = this.height;
	      return rect;
	    },
	    set: function(value) {
	      return this.scrollPoint = value;
	    }
	  });
	
	  ScrollComponent.define("contentInset", {
	    get: function() {
	      return _.clone(this._contentInset);
	    },
	    set: function(contentInset) {
	      var contentFrame;
	      this._contentInset = Utils.rectZero(Utils.parseRect(contentInset));
	      if (!this.content) {
	        return;
	      }
	      contentFrame = this.calculateContentFrame();
	      contentFrame.x = contentFrame.x + this._contentInset.left;
	      contentFrame.y = contentFrame.y + this._contentInset.top;
	      this.content.frame = contentFrame;
	      return this.updateContent();
	    }
	  });
	
	  ScrollComponent.define("direction", {
	    importable: false,
	    exportable: false,
	    get: function() {
	      var direction;
	      direction = this.content.draggable.direction;
	      if (direction === "down") {
	        return "up";
	      }
	      if (direction === "up") {
	        return "down";
	      }
	      if (direction === "right") {
	        return "left";
	      }
	      if (direction === "left") {
	        return "right";
	      }
	      return direction;
	    }
	  });
	
	  ScrollComponent.define("angle", {
	    importable: false,
	    exportable: false,
	    get: function() {
	      if (!this.content) {
	        return 0;
	      }
	      return -this.content.draggable.angle;
	    }
	  });
	
	  ScrollComponent.prototype.scrollToPoint = function(point, animate, animationOptions) {
	    var contentPoint;
	    if (animate == null) {
	      animate = true;
	    }
	    if (animationOptions == null) {
	      animationOptions = {
	        curve: "spring(500, 50, 0)"
	      };
	    }
	    contentPoint = this._calculateContentPoint(point);
	    this.content.draggable.animateStop();
	    if (animate) {
	      point = {};
	      if (contentPoint.hasOwnProperty("x")) {
	        point.x = contentPoint.x;
	      }
	      if (contentPoint.hasOwnProperty("y")) {
	        point.y = contentPoint.y;
	      }
	      this.content.animateStop();
	      return this.content.animate(point, animationOptions);
	    } else {
	      return this.content.point = contentPoint;
	    }
	  };
	
	  ScrollComponent.prototype.scrollToTop = function(animate, animationOptions) {
	    if (animate == null) {
	      animate = true;
	    }
	    if (animationOptions == null) {
	      animationOptions = {
	        curve: "spring(500, 50, 0)"
	      };
	    }
	    return this.scrollToPoint({
	      x: 0,
	      y: 0
	    }, animate, animationOptions);
	  };
	
	  ScrollComponent.prototype.scrollToLayer = function(contentLayer, originX, originY, animate, animationOptions) {
	    var scrollPoint;
	    if (originX == null) {
	      originX = 0;
	    }
	    if (originY == null) {
	      originY = 0;
	    }
	    if (animate == null) {
	      animate = true;
	    }
	    if (animationOptions == null) {
	      animationOptions = {
	        curve: "spring(500, 50, 0)"
	      };
	    }
	    if (contentLayer && contentLayer.parent !== this.content) {
	      throw Error("Can't scroll to this layer because it's not in the ScrollComponent. Add it to the content like layer.parent = scroll.content.");
	    }
	    if (!contentLayer || this.content.children.length === 0) {
	      scrollPoint = {
	        x: 0,
	        y: 0
	      };
	    } else {
	      scrollPoint = this._scrollPointForLayer(contentLayer, originX, originY);
	      scrollPoint.x -= this.width * originX;
	      scrollPoint.y -= this.height * originY;
	    }
	    this.scrollToPoint(scrollPoint, animate, animationOptions);
	    return contentLayer;
	  };
	
	  ScrollComponent.prototype.scrollToClosestLayer = function(originX, originY, animate, animationOptions) {
	    var closestLayer;
	    if (originX == null) {
	      originX = 0;
	    }
	    if (originY == null) {
	      originY = 0;
	    }
	    if (animate == null) {
	      animate = true;
	    }
	    if (animationOptions == null) {
	      animationOptions = {
	        curve: "spring(500, 50, 0)"
	      };
	    }
	    closestLayer = this.closestContentLayer(originX, originY, animate, animationOptions);
	    if (closestLayer) {
	      this.scrollToLayer(closestLayer, originX, originY);
	      return closestLayer;
	    } else {
	      if (!closestLayer) {
	        this.scrollToPoint({
	          x: 0,
	          y: 0
	        });
	      }
	      return null;
	    }
	  };
	
	  ScrollComponent.prototype.closestContentLayer = function(originX, originY) {
	    var scrollPoint;
	    if (originX == null) {
	      originX = 0;
	    }
	    if (originY == null) {
	      originY = 0;
	    }
	    scrollPoint = Utils.framePointForOrigin(this.scrollFrame, originX, originY);
	    return this.closestContentLayerForScrollPoint(scrollPoint, originX, originY);
	  };
	
	  ScrollComponent.prototype.closestContentLayerForScrollPoint = function(scrollPoint, originX, originY) {
	    if (originX == null) {
	      originX = 0;
	    }
	    if (originY == null) {
	      originY = 0;
	    }
	    return _.head(this._contentLayersSortedByDistanceForScrollPoint(scrollPoint, originX, originY));
	  };
	
	  ScrollComponent.prototype._onAnimationStart = function(event) {
	    return this.content.on("change:frame", this._onAnimationStep);
	  };
	
	  ScrollComponent.prototype._onAnimationStep = function(event) {
	    this.content.emit(Events.Move, this.content.point);
	    return this.emit(Events.Scroll, event);
	  };
	
	  ScrollComponent.prototype._onAnimationStop = function() {
	    return this.content.off("change:frame", this._onAnimationStep);
	  };
	
	  ScrollComponent.prototype._scrollPointForLayer = function(layer, originX, originY, clamp) {
	    if (originX == null) {
	      originX = 0;
	    }
	    if (originY == null) {
	      originY = 0;
	    }
	    if (clamp == null) {
	      clamp = true;
	    }
	    return Utils.framePointForOrigin(layer, originX, originY);
	  };
	
	  ScrollComponent.prototype._contentLayersSortedByDistanceForScrollPoint = function(scrollPoint, originX, originY) {
	    if (originX == null) {
	      originX = 0;
	    }
	    if (originY == null) {
	      originY = 0;
	    }
	    return Utils.frameSortByAbsoluteDistance(scrollPoint, this.content.children, originX, originY);
	  };
	
	  ScrollComponent.prototype._pointInConstraints = function(point) {
	    var maxX, maxY, minX, minY, ref;
	    ref = this.content.draggable._calculateConstraints(this.content.draggable.constraints), minX = ref.minX, maxX = ref.maxX, minY = ref.minY, maxY = ref.maxY;
	    point = {
	      x: -Utils.clamp(-point.x, minX, maxX),
	      y: -Utils.clamp(-point.y, minY, maxY)
	    };
	    return point;
	  };
	
	  ScrollComponent.prototype.addListener = function() {
	    var eventName, eventNames, i, j, len, listener, results;
	    eventNames = 2 <= arguments.length ? slice.call(arguments, 0, i = arguments.length - 1) : (i = 0, []), listener = arguments[i++];
	    ScrollComponent.__super__.addListener.apply(this, arguments);
	    results = [];
	    for (j = 0, len = eventNames.length; j < len; j++) {
	      eventName = eventNames[j];
	      if (indexOf.call(_.keys(EventMappers), eventName) >= 0) {
	        results.push(this.content.on(EventMappers[eventName], listener));
	      } else {
	        results.push(void 0);
	      }
	    }
	    return results;
	  };
	
	  ScrollComponent.prototype.removeListener = function() {
	    var eventName, eventNames, i, j, len, listener, results;
	    eventNames = 2 <= arguments.length ? slice.call(arguments, 0, i = arguments.length - 1) : (i = 0, []), listener = arguments[i++];
	    ScrollComponent.__super__.removeListener.apply(this, arguments);
	    results = [];
	    for (j = 0, len = eventNames.length; j < len; j++) {
	      eventName = eventNames[j];
	      if (indexOf.call(_.keys(EventMappers), eventName) >= 0) {
	        results.push(this.content.off(EventMappers[eventName], listener));
	      } else {
	        results.push(void 0);
	      }
	    }
	    return results;
	  };
	
	  ScrollComponent.prototype.on = ScrollComponent.prototype.addListener;
	
	  ScrollComponent.prototype.off = ScrollComponent.prototype.removeListener;
	
	  ScrollComponent.define("mouseWheelEnabled", {
	    get: function() {
	      return this._mouseWheelEnabled;
	    },
	    set: function(value) {
	      this._mouseWheelEnabled = value;
	      return this._enableMouseWheelHandling(value);
	    }
	  });
	
	  ScrollComponent.prototype._enableMouseWheelHandling = function(enable) {
	    if (enable) {
	      return this.on(Events.MouseWheel, this._onMouseWheel);
	    } else {
	      return this.off(Events.MouseWheel, this._onMouseWheel);
	    }
	  };
	
	  ScrollComponent.prototype._onMouseWheel = function(event) {
	    var deltaX, deltaY, maxX, maxY, minX, minY, point, ref;
	    deltaX = 0;
	    deltaY = 0;
	    if (this.scrollHorizontal) {
	      deltaX = event.wheelDeltaX;
	    }
	    if (this.scrollVertical) {
	      deltaY = event.wheelDeltaY;
	    }
	    if (deltaX === 0 && deltaY === 0) {
	      return;
	    }
	    if (!this._mouseWheelScrolling) {
	      this._mouseWheelScrolling = true;
	      this.emit(Events.ScrollStart, event);
	    }
	    this.content.animateStop();
	    ref = this.content.draggable._calculateConstraints(this.content.draggable.constraints), minX = ref.minX, maxX = ref.maxX, minY = ref.minY, maxY = ref.maxY;
	    point = {
	      x: Utils.clamp(this.content.x + (deltaX * this.mouseWheelSpeedMultiplier), minX, maxX),
	      y: Utils.clamp(this.content.y + (deltaY * this.mouseWheelSpeedMultiplier), minY, maxY)
	    };
	    this.content.point = point;
	    this.content.emit(Events.Move, point);
	    this.emit(Events.Scroll, event);
	    return this._onMouseWheelEnd(event);
	  };
	
	  ScrollComponent.prototype._onMouseWheelEnd = Utils.debounce(0.3, function(event) {
	    this.emit(Events.ScrollEnd, event);
	    return this._mouseWheelScrolling = false;
	  });
	
	  ScrollComponent.prototype.copy = function() {
	    var contentLayer, copy;
	    copy = ScrollComponent.__super__.copy.apply(this, arguments);
	    contentLayer = _.head(_.without(copy.children, copy.content));
	    copy.setContentLayer(contentLayer);
	    copy.props = this.props;
	    return copy;
	  };
	
	  ScrollComponent.wrap = function(layer, options) {
	    return wrapComponent(new this(options), layer, options);
	  };
	
	  return ScrollComponent;
	
	})(Layer);
	
	wrapComponent = function(instance, layer, options) {
	  var isPageComponent, ref, screenFrame, scroll, wrapper;
	  if (options == null) {
	    options = {
	      correct: true
	    };
	  }
	  if (!(layer instanceof Layer)) {
	    throw new Error("ScrollComponent.wrap expects a layer, not " + layer + ". Are you sure the layer exists?");
	  }
	  scroll = instance;
	  isPageComponent = instance.constructor.name === "PageComponent";
	  if (options.correct === true) {
	    if (layer.children.length === 0 && !isPageComponent) {
	      wrapper = new Layer;
	      wrapper.frame = layer.frame;
	      layer.parent = wrapper;
	      layer.x = layer.y = 0;
	      layer = wrapper;
	    }
	  }
	  scroll.frame = layer.frame;
	  scroll.parent = layer.parent;
	  scroll.index = layer.index;
	  if ((layer.name != null) && !isPageComponent) {
	    scroll.name = layer.name;
	  }
	  if (scroll.__framerInstanceInfo == null) {
	    scroll.__framerInstanceInfo = {};
	  }
	  if ((ref = scroll.__framerInstanceInfo) != null) {
	    ref.name = instance.constructor.name;
	  }
	  if (layer.image && !isPageComponent) {
	    scroll.image = layer.image;
	    layer.image = null;
	  }
	  if (isPageComponent) {
	    scroll.addPage(layer);
	  } else {
	    scroll.setContentLayer(layer);
	  }
	  if (options.correct === true) {
	    screenFrame = scroll.screenFrame;
	    if (screenFrame.x < Screen.width) {
	      if (screenFrame.x + screenFrame.width > Screen.width) {
	        scroll.width = Screen.width - screenFrame.x;
	      }
	    }
	    if (screenFrame.y < Screen.height) {
	      if (screenFrame.y + screenFrame.height > Screen.height) {
	        scroll.height = Screen.height - screenFrame.y;
	      }
	    }
	  }
	  return scroll;
	};


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var Events, ScrollComponent,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	Events = __webpack_require__(15).Events;
	
	ScrollComponent = __webpack_require__(45).ScrollComponent;
	
	"PageComponent\n\noriginX <number>\noriginY <number>\n\nvelocityThreshold <number>\nanimationOptions <animationOptions={}>\ncurrentPage <Layer>\nclosestPage(<originX:n, originY:n>) <Layer>\n\nnextPage(direction=\"\", currentPage)\nsnapToNextPage(direction=\"\", animate, animationOptions={})\n";
	
	exports.PageComponent = (function(superClass) {
	  extend(PageComponent, superClass);
	
	  PageComponent.define("originX", PageComponent.simpleProperty("originX", .5));
	
	  PageComponent.define("originY", PageComponent.simpleProperty("originY", .5));
	
	  PageComponent.define("velocityThreshold", PageComponent.simpleProperty("velocityThreshold", 0.1));
	
	  function PageComponent(options) {
	    this._resetHistory = bind(this._resetHistory, this);
	    this._scrollEnd = bind(this._scrollEnd, this);
	    this._scrollMove = bind(this._scrollMove, this);
	    this._scrollStart = bind(this._scrollStart, this);
	    PageComponent.__super__.constructor.call(this, _.defaults(options, {
	      animationOptions: {
	        curve: "spring(500, 50, 0)"
	      }
	    }));
	    this.content.draggable.momentum = false;
	    this.content.draggable.bounce = false;
	    this.content.on(Events.DragSessionStart, this._scrollStart);
	    this.content.on(Events.DragSessionEnd, this._scrollEnd);
	    this.content.on("change:frame", _.debounce(this._scrollMove, 16));
	    this.content.on("change:children", this._resetHistory);
	    this._resetHistory();
	  }
	
	  PageComponent.define("closestPage", {
	    get: function() {
	      return this.closestContentLayerForScrollPoint(this._originScrollPoint(), this.originX, this.originY);
	    }
	  });
	
	  PageComponent.define("currentPage", {
	    get: function() {
	      return _.last(this._previousPages);
	    }
	  });
	
	  PageComponent.define("previousPage", {
	    get: function() {
	      return this._previousPages[this._previousPages.length - 2];
	    }
	  });
	
	  PageComponent.prototype.nextPage = function(direction, currentPage, withoutCurrentPage) {
	    var layers, point;
	    if (direction == null) {
	      direction = "right";
	    }
	    if (currentPage == null) {
	      currentPage = null;
	    }
	    if (withoutCurrentPage == null) {
	      withoutCurrentPage = true;
	    }
	    if (currentPage == null) {
	      currentPage = this.currentPage;
	    }
	    point = {
	      x: 0,
	      y: 0
	    };
	    if (currentPage) {
	      point = Utils.framePointForOrigin(currentPage, this.originX, this.originY);
	    }
	    if (!withoutCurrentPage) {
	      point = {
	        x: this.scrollX + (this.originX * this.width),
	        y: this.scrollY + (this.originY * this.height)
	      };
	    }
	    if (direction === "up" || direction === "top" || direction === "north") {
	      layers = this.content.childrenAbove(point, this.originX, this.originY);
	    }
	    if (direction === "down" || direction === "bottom" || direction === "south") {
	      layers = this.content.childrenBelow(point, this.originX, this.originY);
	    }
	    if (direction === "left" || direction === "west") {
	      layers = this.content.childrenLeft(point, this.originX, this.originY);
	    }
	    if (direction === "right" || direction === "east") {
	      layers = this.content.childrenRight(point, this.originX, this.originY);
	    }
	    if (withoutCurrentPage) {
	      layers = _.without(layers, currentPage);
	    }
	    layers = Utils.frameSortByAbsoluteDistance(point, layers, this.originX, this.originY);
	    return _.head(layers);
	  };
	
	  PageComponent.prototype.snapToPage = function(page, animate, animationOptions) {
	    if (animate == null) {
	      animate = true;
	    }
	    if (animationOptions == null) {
	      animationOptions = null;
	    }
	    this.scrollToLayer(page, this.originX, this.originY, animate, animationOptions);
	    if (this.currentPage !== page) {
	      this._previousPages.push(page);
	      this.emit("change:previousPage", this.previousPage);
	      return this.emit("change:currentPage", this.currentPage);
	    }
	  };
	
	  PageComponent.prototype.snapToNextPage = function(direction, animate, animationOptions) {
	    var nextPage;
	    if (direction == null) {
	      direction = "right";
	    }
	    if (animate == null) {
	      animate = true;
	    }
	    if (animationOptions == null) {
	      animationOptions = null;
	    }
	    if (animationOptions == null) {
	      animationOptions = this.animationOptions;
	    }
	    nextPage = this.nextPage(direction);
	    if (nextPage == null) {
	      nextPage = this.closestPage;
	    }
	    return this.snapToPage(nextPage, animate, animationOptions);
	  };
	
	  PageComponent.prototype.snapToPreviousPage = function() {
	    if (!this.previousPage) {
	      return;
	    }
	    this.snapToPage(this.previousPage);
	    return this._previousPages = this._previousPages.slice(0, +(this._previousPages.length - 3) + 1 || 9e9);
	  };
	
	  PageComponent.prototype.addPage = function(page, direction) {
	    var directions, point, ref;
	    if (direction == null) {
	      direction = "right";
	    }
	    directions = ["down", "bottom", "south"] + ["right", "east"];
	    if (ref = !direction, indexOf.call(directions, ref) >= 0) {
	      direction = "right";
	      throw new Error(direction + " should be in " + directions);
	    }
	    point = page.point;
	    if (this.content.children.length) {
	      if (direction === "right" || direction === "east") {
	        point.x = Utils.frameGetMaxX(this.content.contentFrame());
	      }
	      if (direction === "down" || direction === "bottom" || direction === "south") {
	        point.y = Utils.frameGetMaxY(this.content.contentFrame());
	      }
	    }
	    page.point = point;
	    if (page.parent !== this.content) {
	      return page.parent = this.content;
	    } else {
	      return this.updateContent();
	    }
	  };
	
	  PageComponent.prototype.horizontalPageIndex = function(page) {
	    return (_.sortBy(this.content.children, function(l) {
	      return l.x;
	    })).indexOf(page);
	  };
	
	  PageComponent.prototype.verticalPageIndex = function(page) {
	    return (_.sortBy(this.content.children, function(l) {
	      return l.y;
	    })).indexOf(page);
	  };
	
	  PageComponent.prototype._scrollStart = function() {
	    return this._currentPage = this.currentPage;
	  };
	
	  PageComponent.prototype._scrollMove = function() {
	    var currentPage;
	    currentPage = this.currentPage;
	    if (currentPage !== _.last(this._previousPages) && currentPage !== (void 0)) {
	      this._previousPages.push(currentPage);
	      return this.emit("change:currentPage", {
	        old: this.previousPage,
	        "new": currentPage
	      });
	    }
	  };
	
	  PageComponent.prototype._scrollEnd = function() {
	    var maximumVelocity, nextPage, velocity, xDisabled, xLock, yDisabled, yLock;
	    if (this.content.isAnimating) {
	      return;
	    }
	    velocity = this.content.draggable.velocity;
	    xDisabled = !this.scrollHorizontal && (this.direction === "right" || this.direction === "left");
	    yDisabled = !this.scrollVertical && (this.direction === "down" || this.direction === "up");
	    xLock = this.content.draggable._directionLockEnabledX && (this.direction === "right" || this.direction === "left");
	    yLock = this.content.draggable._directionLockEnabledY && (this.direction === "down" || this.direction === "up");
	    maximumVelocity = Math.max(Math.abs(velocity.x), Math.abs(velocity.y));
	    if (maximumVelocity < this.velocityThreshold || xLock || yLock || xDisabled || yDisabled) {
	      return this.snapToPage(this.closestPage, true, this.animationOptions);
	    }
	    nextPage = this.nextPage(this.direction, this._currentPage, false);
	    if (nextPage == null) {
	      nextPage = this.closestPage;
	    }
	    return this.snapToPage(nextPage, true, this.animationOptions);
	  };
	
	  PageComponent.prototype._originScrollPoint = function() {
	    var scrollPoint;
	    scrollPoint = this.scrollPoint;
	    scrollPoint.x += this.width * this.originX;
	    scrollPoint.y += this.height * this.originY;
	    return scrollPoint;
	  };
	
	  PageComponent.prototype._resetHistory = function() {
	    this._currentPage = this.closestPage;
	    return this._previousPages = [this._currentPage];
	  };
	
	  return PageComponent;
	
	})(ScrollComponent);


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var Events, Knob, Layer, Utils,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	Utils = __webpack_require__(4);
	
	Layer = __webpack_require__(13).Layer;
	
	Events = __webpack_require__(15).Events;
	
	"SliderComponent\n\nknob <layer>\nknobSize <width, height>\nfill <layer>\nmin <number>\nmax <number>\n\npointForValue(<n>)\nvalueForPoint(<n>)\n\nanimateToValue(value, animationOptions={})";
	
	Events.SliderValueChange = "sliderValueChange";
	
	Knob = (function(superClass) {
	  extend(Knob, superClass);
	
	  function Knob(options) {
	    Knob.__super__.constructor.call(this, options);
	  }
	
	  Knob.define("constrained", Knob.simpleProperty("constrained", false));
	
	  return Knob;
	
	})(Layer);
	
	exports.SliderComponent = (function(superClass) {
	  extend(SliderComponent, superClass);
	
	  function SliderComponent(options) {
	    if (options == null) {
	      options = {};
	    }
	    this._updateValue = bind(this._updateValue, this);
	    this._knobDidMove = bind(this._knobDidMove, this);
	    this._setRadius = bind(this._setRadius, this);
	    this._updateFrame = bind(this._updateFrame, this);
	    this._updateKnob = bind(this._updateKnob, this);
	    this._updateFill = bind(this._updateFill, this);
	    this._touchEnd = bind(this._touchEnd, this);
	    this._touchStart = bind(this._touchStart, this);
	    _.defaults(options, {
	      backgroundColor: "#ccc",
	      borderRadius: 50,
	      clip: false,
	      width: 300,
	      height: 10,
	      value: 0,
	      knobSize: 30
	    });
	    if (options.hitArea == null) {
	      options.hitArea = options.knobSize;
	    }
	    this.knob = new Knob({
	      backgroundColor: "#fff",
	      shadowY: 1,
	      shadowBlur: 3,
	      shadowColor: "rgba(0, 0, 0, 0.35)",
	      name: "knob"
	    });
	    this.fill = new Layer({
	      backgroundColor: "#333",
	      width: 0,
	      force2d: true,
	      name: "fill"
	    });
	    this.sliderOverlay = new Layer({
	      backgroundColor: null,
	      name: "sliderOverlay"
	    });
	    SliderComponent.__super__.constructor.call(this, options);
	    this.knobSize = options.knobSize;
	    this.knob.parent = this.fill.parent = this.sliderOverlay.parent = this;
	    if (this.width > this.height) {
	      this.fill.height = this.height;
	    } else {
	      this.fill.width = this.width;
	    }
	    this.fill.borderRadius = this.sliderOverlay.borderRadius = this.borderRadius;
	    this.knob.draggable.enabled = true;
	    this.knob.draggable.overdrag = false;
	    this.knob.draggable.momentum = true;
	    this.knob.draggable.momentumOptions = {
	      friction: 5,
	      tolerance: 0.25
	    };
	    this.knob.draggable.bounce = false;
	    this.knob.borderRadius = this.knobSize / 2;
	    this._updateFrame();
	    this._updateKnob();
	    this._updateFill();
	    this.on("change:frame", this._updateFrame);
	    this.on("change:borderRadius", this._setRadius);
	    this.knob.on("change:size", this._updateKnob);
	    this.knob.on("change:frame", this._updateFill);
	    this.knob.on("change:frame", this._knobDidMove);
	    this.sliderOverlay.on(Events.TapStart, this._touchStart);
	    this.sliderOverlay.on(Events.TapEnd, this._touchEnd);
	  }
	
	  SliderComponent.prototype._touchStart = function(event) {
	    var offsetX, offsetY;
	    event.preventDefault();
	    offsetX = (this.min / this.canvasScaleX()) - this.min;
	    offsetY = (this.min / this.canvasScaleY()) - this.min;
	    if (this.width > this.height) {
	      this.value = this.valueForPoint(Events.touchEvent(event).clientX - this.screenScaledFrame().x) / this.canvasScaleX() - offsetX;
	    } else {
	      this.value = this.valueForPoint(Events.touchEvent(event).clientY - this.screenScaledFrame().y) / this.canvasScaleY() - offsetY;
	    }
	    this.knob.draggable._touchStart(event);
	    return this._updateValue();
	  };
	
	  SliderComponent.prototype._touchEnd = function(event) {
	    return this._updateValue();
	  };
	
	  SliderComponent.prototype._updateFill = function() {
	    if (this.width > this.height) {
	      return this.fill.width = this.knob.midX;
	    } else {
	      return this.fill.height = this.knob.midY;
	    }
	  };
	
	  SliderComponent.prototype._updateKnob = function() {
	    if (this.width > this.height) {
	      this.knob.midX = this.fill.width;
	      return this.knob.centerY();
	    } else {
	      this.knob.midY = this.fill.height;
	      return this.knob.centerX();
	    }
	  };
	
	  SliderComponent.prototype._updateFrame = function() {
	    this.knob.draggable.constraints = {
	      x: -this.knob.width / 2,
	      y: -this.knob.height / 2,
	      width: this.width + this.knob.width,
	      height: this.height + this.knob.height
	    };
	    if (this.knob.constrained) {
	      this.knob.draggable.constraints = {
	        x: 0,
	        y: 0,
	        width: this.width,
	        height: this.height
	      };
	    }
	    this.hitArea = this.hitArea;
	    if (this.width > this.height) {
	      this.fill.height = this.height;
	      this.knob.midX = this.pointForValue(this.value);
	      this.knob.centerY();
	    } else {
	      this.fill.width = this.width;
	      this.knob.midY = this.pointForValue(this.value);
	      this.knob.centerX();
	    }
	    if (this.width > this.height) {
	      this.knob.draggable.speedY = 0;
	      this.knob.draggable.speedX = 1;
	    } else {
	      this.knob.draggable.speedX = 0;
	      this.knob.draggable.speedY = 1;
	    }
	    return this.sliderOverlay.center();
	  };
	
	  SliderComponent.prototype._setRadius = function() {
	    var radius;
	    radius = this.borderRadius;
	    return this.fill.style.borderRadius = radius + "px 0 0 " + radius + "px";
	  };
	
	  SliderComponent.define("knobSize", {
	    get: function() {
	      return this._knobSize;
	    },
	    set: function(value) {
	      var isRound;
	      isRound = this.knob.borderRadius * 2 === this._knobSize;
	      this._knobSize = value;
	      this.knob.width = this._knobSize;
	      this.knob.height = this._knobSize;
	      if (isRound) {
	        this.knob.borderRadius = this._knobSize / 2;
	      }
	      return this._updateFrame();
	    }
	  });
	
	  SliderComponent.define("hitArea", {
	    get: function() {
	      return this._hitArea;
	    },
	    set: function(value) {
	      this._hitArea = value;
	      if (this.width > this.height) {
	        this.sliderOverlay.width = this.width + this.hitArea;
	        return this.sliderOverlay.height = this.hitArea;
	      } else {
	        this.sliderOverlay.width = this.hitArea;
	        return this.sliderOverlay.height = this.height + this.hitArea;
	      }
	    }
	  });
	
	  SliderComponent.define("min", {
	    get: function() {
	      return this._min || 0;
	    },
	    set: function(value) {
	      if (_.isFinite(value)) {
	        return this._min = value;
	      }
	    }
	  });
	
	  SliderComponent.define("max", {
	    get: function() {
	      return this._max || 1;
	    },
	    set: function(value) {
	      if (_.isFinite(value)) {
	        return this._max = value;
	      }
	    }
	  });
	
	  SliderComponent.define("value", {
	    get: function() {
	      return this._value;
	    },
	    set: function(value) {
	      if (!_.isFinite(value)) {
	        return;
	      }
	      this._value = Utils.clamp(value, this.min, this.max);
	      if (this.width > this.height) {
	        this.knob.midX = this.pointForValue(value);
	      } else {
	        this.knob.midY = this.pointForValue(value);
	      }
	      this._updateFill();
	      return this._updateValue();
	    }
	  });
	
	  SliderComponent.prototype._knobDidMove = function() {
	    if (this.width > this.height) {
	      return this.value = this.valueForPoint(this.knob.midX);
	    } else {
	      return this.value = this.valueForPoint(this.knob.midY);
	    }
	  };
	
	  SliderComponent.prototype._updateValue = function() {
	    if (this._lastUpdatedValue === this.value) {
	      return;
	    }
	    this._lastUpdatedValue = this.value;
	    this.emit("change:value", this.value);
	    return this.emit(Events.SliderValueChange, this.value);
	  };
	
	  SliderComponent.prototype.pointForValue = function(value) {
	    if (this.width > this.height) {
	      if (this.knob.constrained) {
	        return Utils.modulate(value, [this.min, this.max], [0 + (this.knob.width / 2), this.width - (this.knob.width / 2)], true);
	      } else {
	        return Utils.modulate(value, [this.min, this.max], [0, this.width], true);
	      }
	    } else {
	      if (this.knob.constrained) {
	        return Utils.modulate(value, [this.min, this.max], [0 + (this.knob.height / 2), this.height - (this.knob.height / 2)], true);
	      } else {
	        return Utils.modulate(value, [this.min, this.max], [0, this.height], true);
	      }
	    }
	  };
	
	  SliderComponent.prototype.valueForPoint = function(value) {
	    if (this.width > this.height) {
	      if (this.knob.constrained) {
	        return Utils.modulate(value, [0 + (this.knob.width / 2), this.width - (this.knob.width / 2)], [this.min, this.max], true);
	      } else {
	        return Utils.modulate(value, [0, this.width], [this.min, this.max], true);
	      }
	    } else {
	      if (this.knob.constrained) {
	        return Utils.modulate(value, [0 + (this.knob.height / 2), this.height - (this.knob.height / 2)], [this.min, this.max], true);
	      } else {
	        return Utils.modulate(value, [0, this.height], [this.min, this.max], true);
	      }
	    }
	  };
	
	  SliderComponent.prototype.animateToValue = function(value, animationOptions) {
	    if (animationOptions == null) {
	      animationOptions = {
	        curve: "spring(300, 25, 0)"
	      };
	    }
	    if (!_.isFinite(value)) {
	      return;
	    }
	    if (this.width > this.height) {
	      animationOptions.properties = {
	        x: this.pointForValue(value) - (this.knob.width / 2)
	      };
	    } else {
	      animationOptions.properties = {
	        y: this.pointForValue(value) - (this.knob.height / 2)
	      };
	    }
	    return this.knob.animate(animationOptions);
	  };
	
	  SliderComponent.prototype.onValueChange = function(cb) {
	    return this.on(Events.SliderValueChange, cb);
	  };
	
	  return SliderComponent;
	
	})(Layer);


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var AppleIMac, AppleMacBook, AppleMacBookAir, AppleMacBookPro, AppleWatch38BlackLeatherDevice, AppleWatch38Device, AppleWatch42Device, AppleWatchSeries238Device, AppleWatchSeries242Device, BaseClass, BuiltInDevices, Defaults, DellXPS, Devices, Events, HTCa9BaseDevice, HTCm8BaseDevice, Layer, MSFTLumia950BaseDevice, Nexus4BaseDevice, Nexus5BaseDevice, Nexus6BaseDevice, Nexus9BaseDevice, PixelBaseDevice, SamsungGalaxyNote5BaseDevice, SonyW85OC, Utils, _, desktopReleaseVersion, googlePixelReleaseVersion, iPadAir2BaseDevice, iPadMini4BaseDevice, iPadProBaseDevice, iPhone5BaseDevice, iPhone5CBaseDevice, iPhone6BaseDevice, iPhone6PlusBaseDevice, iPhone7BaseDevice, iPhone7PlusBaseDevice, newDeviceMinVersion, oldDeviceMaxVersion, old_AppleWatch38Device, old_AppleWatch42Device, old_Nexus5BaseDevice, old_Nexus5BaseDeviceHand, old_Nexus9BaseDevice, old_iPadAirBaseDevice, old_iPadAirBaseDeviceHand, old_iPadMiniBaseDevice, old_iPadMiniBaseDeviceHand, old_iPhone5BaseDevice, old_iPhone5BaseDeviceHand, old_iPhone5CBaseDevice, old_iPhone5CBaseDeviceHand, old_iPhone6BaseDevice, old_iPhone6BaseDeviceHand, old_iPhone6PlusBaseDevice, old_iPhone6PlusBaseDeviceHand,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	Utils = __webpack_require__(4);
	
	_ = __webpack_require__(1)._;
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	Layer = __webpack_require__(13).Layer;
	
	Defaults = __webpack_require__(17).Defaults;
	
	Events = __webpack_require__(15).Events;
	
	
	/*
	
	Device._setup()
	Device._update()
	Device._setupContext()
	
	Device.fullScreen bool
	Device.deviceType str
	Device.padding int
	
	Device.orientation(orientation:float)
	Device.orientationName landscape|portrait|unknown
	Device.rotateLeft()
	Device.rotateRight()
	
	Device.setDeviceScale(zoom:float, animate:bool)
	Device.setContentScale(zoom:float, animate:bool)
	
	Device.nextHand()
	
	 * Events
	Events.DeviceTypeDidChange
	Events.DeviceFullScreenDidChange
	 */
	
	exports.DeviceComponent = (function(superClass) {
	  extend(DeviceComponent, superClass);
	
	  DeviceComponent.define("context", {
	    get: function() {
	      return this._context;
	    }
	  });
	
	  function DeviceComponent(options) {
	    var defaults;
	    if (options == null) {
	      options = {};
	    }
	    this._orientationChange = bind(this._orientationChange, this);
	    this._viewportOrientationOffset = bind(this._viewportOrientationOffset, this);
	    this._updateDeviceImage = bind(this._updateDeviceImage, this);
	    this.customize = bind(this.customize, this);
	    this._update = bind(this._update, this);
	    defaults = Defaults.getDefaults("DeviceComponent", options);
	    if (Framer.Defaults.hasOwnProperty("DeviceView")) {
	      defaults = _.extend(defaults, Framer.Defaults.DeviceView);
	    }
	    this._setup();
	    this.animationOptions = defaults.animationOptions;
	    this.deviceType = defaults.deviceType;
	    _.extend(this, _.defaults(options, defaults));
	    this.Type = {
	      Tablet: "tablet",
	      Phone: "phone",
	      Computer: "computer"
	    };
	  }
	
	  DeviceComponent.prototype._setup = function() {
	    var i, layer, len, ref;
	    if (this._setupDone) {
	      return;
	    }
	    this._setupDone = true;
	    this.background = new Layer;
	    this.background.clip = true;
	    this.background.backgroundColor = "transparent";
	    this.background.classList.add("DeviceBackground");
	    this.hands = new Layer;
	    this.handsImageLayer = new Layer({
	      parent: this.hands
	    });
	    this.phone = new Layer({
	      parent: this.hands
	    });
	    this.screen = new Layer({
	      parent: this.phone
	    });
	    this.viewport = new Layer({
	      parent: this.screen
	    });
	    this.content = new Layer({
	      parent: this.viewport
	    });
	    this.hands.backgroundColor = "transparent";
	    this.hands._alwaysUseImageCache = true;
	    this.handsImageLayer.backgroundColor = "transparent";
	    this.phone.backgroundColor = "transparent";
	    this.phone.classList.add("DevicePhone");
	    this.screen.classList.add("DeviceScreen");
	    this.screen.clip = true;
	    this.viewport.backgroundColor = "transparent";
	    this.viewport.classList.add("DeviceComponentPort");
	    this.content.backgroundColor = "transparent";
	    this.content.classList.add("DeviceContent");
	    this.content.originX = 0;
	    this.content.originY = 0;
	    if (!Utils.isMobile()) {
	      Framer.CurrentContext.domEventManager.wrap(window).addEventListener("resize", this._update);
	    }
	    if (Utils.isMobile()) {
	      Framer.CurrentContext.domEventManager.wrap(window).addEventListener("resize", this._orientationChange);
	    }
	    ref = [this.background, this.phone, this.viewport, this.content, this.screen];
	    for (i = 0, len = ref.length; i < len; i++) {
	      layer = ref[i];
	      layer.on("touchmove", function(event) {
	        return event.preventDefault();
	      });
	    }
	    this._context = new Framer.Context({
	      parent: this.content,
	      name: "DeviceScreen"
	    });
	    this._context.perspective = 1200;
	    return this._context.device = this;
	  };
	
	  DeviceComponent.prototype._update = function() {
	    var backgroundOverlap, contentScaleFactor, height, i, layer, len, ref, ref1, width;
	    contentScaleFactor = this.contentScale;
	    if (contentScaleFactor > 1) {
	      contentScaleFactor = 1;
	    }
	    if (this._shouldRenderFullScreen()) {
	      width = window.innerWidth / contentScaleFactor;
	      height = window.innerHeight / contentScaleFactor;
	      ref = [this.background, this.hands, this.phone, this.viewport, this.content, this.screen];
	      for (i = 0, len = ref.length; i < len; i++) {
	        layer = ref[i];
	        layer.x = layer.y = 0;
	        layer.width = width;
	        layer.height = height;
	        layer.scale = 1;
	      }
	      return this.content.scale = contentScaleFactor;
	    } else {
	      backgroundOverlap = 100;
	      this.background.x = 0 - backgroundOverlap;
	      this.background.y = 0 - backgroundOverlap;
	      this.background.width = window.innerWidth + (2 * backgroundOverlap);
	      this.background.height = window.innerHeight + (2 * backgroundOverlap);
	      this._updateDeviceImage();
	      this.hands.scale = this._calculatePhoneScale();
	      this.hands.center();
	      this.phone.center();
	      ref1 = this._getOrientationDimensions(this._device.screenWidth / contentScaleFactor, this._device.screenHeight / contentScaleFactor), width = ref1[0], height = ref1[1];
	      this.screen.width = this.viewport.width = this._device.screenWidth;
	      this.screen.height = this.viewport.height = this._device.screenHeight;
	      this.content.width = width;
	      this.content.height = height;
	      this.screen.center();
	      if (this.selectedHand && this._orientation === 0) {
	        return this.setHand(this.selectedHand);
	      }
	    }
	  };
	
	  DeviceComponent.prototype._shouldRenderFullScreen = function() {
	    if (!this._device) {
	      return true;
	    }
	    if (this.fullScreen === true) {
	      return true;
	    }
	    if (this.deviceType === "fullscreen") {
	      return true;
	    }
	    if (Utils.isInsideIframe()) {
	      return false;
	    }
	    if (Utils.deviceType() === "phone" && Utils.deviceType() === this._device.deviceType) {
	      return true;
	    }
	    if (Utils.deviceType() === "tablet" && Utils.deviceType() === this._device.deviceType) {
	      return true;
	    }
	    if (Utils.deviceType() === "phone" && this._device.deviceType === "tablet") {
	      return true;
	    }
	    if (this._device.screenWidth === Canvas.width && this._device.screenHeight === Canvas.height) {
	      return true;
	    }
	    return false;
	  };
	
	  DeviceComponent.prototype.setupContext = function() {
	    return Framer.CurrentContext = this._context;
	  };
	
	  DeviceComponent.define("fullScreen", {
	    get: function() {
	      return this._fullScreen;
	    },
	    set: function(fullScreen) {
	      return this._setFullScreen(fullScreen);
	    }
	  });
	
	  DeviceComponent.prototype._setFullScreen = function(fullScreen) {
	    if (this._deviceType === "fullscreen") {
	      return;
	    }
	    if (!_.isBoolean(fullScreen)) {
	      return;
	    }
	    if (fullScreen === this._fullScreen) {
	      return;
	    }
	    this._fullScreen = fullScreen;
	    if (fullScreen === true) {
	      this.phone.image = "";
	      this.hands.image = "";
	    } else {
	      this._updateDeviceImage();
	    }
	    this._update();
	    return this.emit("change:fullScreen");
	  };
	
	  DeviceComponent.define("screenSize", {
	    get: function() {
	      var size;
	      if (this._shouldRenderFullScreen()) {
	        return Canvas.size;
	      }
	      if (this.isLandscape) {
	        return size = {
	          width: this._device.screenHeight,
	          height: this._device.screenWidth
	        };
	      } else {
	        return size = {
	          width: this._device.screenWidth,
	          height: this._device.screenHeight
	        };
	      }
	    }
	  });
	
	  DeviceComponent.prototype.customize = function(deviceProps) {
	    Devices.custom = _.defaults(deviceProps, Devices.custom);
	    return this.deviceType = "custom";
	  };
	
	  DeviceComponent.define("deviceType", {
	    get: function() {
	      return this._deviceType;
	    },
	    set: function(deviceType) {
	      var device, i, key, lDevicetype, lKey, len, ref, shouldZoomToFit;
	      if (deviceType === this._deviceType && deviceType !== "custom") {
	        return;
	      }
	      device = null;
	      if (_.isString(deviceType)) {
	        lDevicetype = deviceType.toLowerCase();
	        ref = _.keys(Devices);
	        for (i = 0, len = ref.length; i < len; i++) {
	          key = ref[i];
	          lKey = key.toLowerCase();
	          if (lDevicetype === lKey) {
	            device = Devices[key];
	          }
	        }
	      }
	      if (!device) {
	        throw Error("No device named " + deviceType + ". Options are: " + (_.keys(Devices)));
	      }
	      if (this._device === device) {
	        return;
	      }
	      shouldZoomToFit = this._deviceType === "fullscreen";
	      this.screen.backgroundColor = "black";
	      if (device.backgroundColor != null) {
	        this.screen.backgroundColor = device.backgroundColor;
	      }
	      if (device.deviceType === "computer") {
	        Utils.domComplete(function() {
	          return document.body.style.cursor = "auto";
	        });
	      }
	      this._device = _.clone(device);
	      this._deviceType = deviceType;
	      this.fullscreen = false;
	      this._updateDeviceImage();
	      this._update();
	      this.emit("change:deviceType");
	      this.viewport.point = this._viewportOrientationOffset();
	      if (shouldZoomToFit) {
	        return this.deviceScale = "fit";
	      }
	    }
	  });
	
	  DeviceComponent.prototype._updateDeviceImage = function() {
	    if (/PhantomJS/.test(navigator.userAgent)) {
	      return;
	    }
	    if (this._shouldRenderFullScreen()) {
	      this.phone.image = "";
	      return this.hands.image = "";
	    } else if (!this._deviceImageUrl(this._deviceImageName())) {
	      return this.phone.image = "";
	    } else {
	      this.phone._alwaysUseImageCache = true;
	      this.phone.image = this._deviceImageUrl(this._deviceImageName());
	      this.phone.width = this._device.deviceImageWidth;
	      this.phone.height = this._device.deviceImageHeight;
	      this.hands.width = this.phone.width;
	      return this.hands.height = this.phone.height;
	    }
	  };
	
	  DeviceComponent.prototype._deviceImageName = function() {
	    if (this._device.hasOwnProperty("deviceImage")) {
	      return this._device.deviceImage;
	    }
	    return this._deviceType + ".png";
	  };
	
	  DeviceComponent.prototype._deviceImageUrl = function(name) {
	    var ref, resourceUrl;
	    if (!name) {
	      return null;
	    }
	    if (_.startsWith(name, "http://") || _.startsWith(name, "https://")) {
	      return name;
	    }
	    if ((ref = this._deviceType, indexOf.call(BuiltInDevices, ref) < 0) || this._deviceType === "custom") {
	      return name;
	    }
	    resourceUrl = "//resources.framerjs.com/static/DeviceResources";
	    if (Utils.isFileUrl(window.location.href)) {
	      resourceUrl = "http:" + resourceUrl;
	    }
	    if (Utils.isFramerStudio() && window.FramerStudioInfo) {
	      if (this._device.minStudioVersion && Utils.framerStudioVersion() >= this._device.minStudioVersion || !this._device.minStudioVersion) {
	        if (this._device.maxStudioVersion && Utils.framerStudioVersion() <= this._device.maxStudioVersion || !this._device.maxStudioVersion) {
	          resourceUrl = window.FramerStudioInfo.deviceImagesUrl;
	          return resourceUrl + "/" + (name.replace(".png", ".jp2"));
	        }
	      }
	    }
	    if (this._device.deviceImageCompression === true) {
	      if (Utils.isWebPSupported()) {
	        return resourceUrl + "/" + (name.replace(".png", ".webp"));
	      }
	      if (Utils.isJP2Supported()) {
	        return resourceUrl + "/" + (name.replace(".png", ".jp2"));
	      }
	    }
	    return resourceUrl + "/" + name;
	  };
	
	  DeviceComponent.define("deviceScale", {
	    get: function() {
	      if (this._shouldRenderFullScreen()) {
	        return 1;
	      }
	      return this._deviceScale || 1;
	    },
	    set: function(deviceScale) {
	      return this.setDeviceScale(deviceScale, false);
	    }
	  });
	
	  DeviceComponent.prototype.setDeviceScale = function(deviceScale, animate) {
	    var phoneScale;
	    if (animate == null) {
	      animate = false;
	    }
	    if (deviceScale === "fit" || deviceScale < 0) {
	      deviceScale = "fit";
	    } else {
	      deviceScale = parseFloat(deviceScale);
	    }
	    if (deviceScale === this._deviceScale) {
	      return;
	    }
	    this._deviceScale = deviceScale;
	    if (this._shouldRenderFullScreen()) {
	      return;
	    }
	    if (deviceScale === "fit") {
	      phoneScale = this._calculatePhoneScale();
	    } else {
	      phoneScale = deviceScale;
	    }
	    this.hands.animateStop();
	    if (animate) {
	      this.hands.animate(_.extend(this.animationOptions, {
	        properties: {
	          scale: phoneScale
	        }
	      }));
	    } else {
	      this.hands.scale = phoneScale;
	      this.hands.center();
	    }
	    return this.emit("change:deviceScale");
	  };
	
	  DeviceComponent.prototype._calculatePhoneScale = function() {
	    var height, paddingOffset, phoneScale, ref, ref1, width;
	    ref = this._getOrientationDimensions(this.phone.width, this.phone.height), width = ref[0], height = ref[1];
	    paddingOffset = ((ref1 = this._device) != null ? ref1.paddingOffset : void 0) || 0;
	    phoneScale = _.min([(window.innerWidth - ((this.padding + paddingOffset) * 2)) / width, (window.innerHeight - ((this.padding + paddingOffset) * 2)) / height]);
	    if (phoneScale > 1) {
	      phoneScale = 1;
	    }
	    this.emit("change:phoneScale", phoneScale);
	    if (this._deviceScale && this._deviceScale !== "fit") {
	      return this._deviceScale;
	    }
	    return phoneScale;
	  };
	
	  DeviceComponent.define("contentScale", {
	    get: function() {
	      return this._contentScale || 1;
	    },
	    set: function(contentScale) {
	      return this.setContentScale(contentScale, false);
	    }
	  });
	
	  DeviceComponent.prototype.setContentScale = function(contentScale, animate) {
	    if (animate == null) {
	      animate = false;
	    }
	    contentScale = parseFloat(contentScale);
	    if (contentScale <= 0) {
	      return;
	    }
	    if (contentScale === this._contentScale) {
	      return;
	    }
	    this._contentScale = contentScale;
	    if (animate) {
	      this.content.animate(_.extend(this.animationOptions, {
	        properties: {
	          scale: this._contentScale
	        }
	      }));
	    } else {
	      this.content.scale = this._contentScale;
	    }
	    this._update();
	    return this.emit("change:contentScale");
	  };
	
	  DeviceComponent.define("orientation", {
	    get: function() {
	      if (Utils.isMobile()) {
	        return window.orientation;
	      }
	      return this._orientation || 0;
	    },
	    set: function(orientation) {
	      return this.setOrientation(orientation, false);
	    }
	  });
	
	  DeviceComponent.prototype.setOrientation = function(orientation, animate) {
	    var animation, contentProperties, phoneProperties;
	    if (animate == null) {
	      animate = false;
	    }
	    if (Utils.framerStudioVersion() === oldDeviceMaxVersion) {
	      orientation *= -1;
	    }
	    if (orientation === "portrait") {
	      orientation = 0;
	    }
	    if (orientation === "landscape") {
	      orientation = 90;
	    }
	    if (this._shouldRenderFullScreen()) {
	      return;
	    }
	    orientation = parseInt(orientation);
	    if (orientation !== 0 && orientation !== 90 && orientation !== (-90)) {
	      return;
	    }
	    if (orientation === this._orientation) {
	      return;
	    }
	    this._orientation = orientation;
	    phoneProperties = {
	      rotationZ: -this._orientation,
	      scale: this._calculatePhoneScale()
	    };
	    contentProperties = this._viewportOrientationOffset();
	    this.hands.animateStop();
	    this.viewport.animateStop();
	    if (animate) {
	      animation = this.hands.animate(_.extend(this.animationOptions, {
	        properties: phoneProperties
	      }));
	      this.viewport.animate(_.extend(this.animationOptions, {
	        properties: contentProperties
	      }));
	      animation.on(Events.AnimationEnd, (function(_this) {
	        return function() {
	          return _this._update();
	        };
	      })(this));
	    } else {
	      this.hands.props = phoneProperties;
	      this.viewport.props = contentProperties;
	      this._update();
	    }
	    if (this._orientation !== 0) {
	      this.handsImageLayer.image = "";
	    }
	    return this.emit("change:orientation", this._orientation);
	  };
	
	  DeviceComponent.prototype._viewportOrientationOffset = function() {
	    var contentProperties, height, offset, ref, ref1, width, x, y;
	    ref = this._getOrientationDimensions(this._device.screenWidth, this._device.screenHeight), width = ref[0], height = ref[1];
	    this.content.width = width;
	    this.content.height = height;
	    offset = (this.screen.width - width) / 2;
	    if (this._orientation === -90) {
	      offset *= -1;
	    }
	    ref1 = [0, 0], x = ref1[0], y = ref1[1];
	    if (this.isLandscape) {
	      x = offset;
	      y = offset;
	    }
	    return contentProperties = {
	      rotationZ: this._orientation,
	      x: x,
	      y: y
	    };
	  };
	
	  DeviceComponent.prototype._orientationChange = function() {
	    this._orientation = window.orientation;
	    this._update();
	    return this.emit("change:orientation", window.orientation);
	  };
	
	  DeviceComponent.define("isPortrait", {
	    get: function() {
	      return Math.abs(this.orientation) % 180 === 0;
	    }
	  });
	
	  DeviceComponent.define("isLandscape", {
	    get: function() {
	      return !this.isPortrait;
	    }
	  });
	
	  DeviceComponent.define("orientationName", {
	    get: function() {
	      if (this.isPortrait) {
	        return "portrait";
	      }
	      if (this.isLandscape) {
	        return "landscape";
	      }
	    },
	    set: function(orientationName) {
	      return this.setOrientation(orientationName, false);
	    }
	  });
	
	  DeviceComponent.prototype.rotateLeft = function(animate) {
	    if (animate == null) {
	      animate = true;
	    }
	    if (this.orientation === 90) {
	      return;
	    }
	    return this.setOrientation(this.orientation + 90, animate);
	  };
	
	  DeviceComponent.prototype.rotateRight = function(animate) {
	    if (animate == null) {
	      animate = true;
	    }
	    if (this.orientation === -90) {
	      return;
	    }
	    return this.setOrientation(this.orientation - 90, animate);
	  };
	
	  DeviceComponent.prototype._getOrientationDimensions = function(width, height) {
	    if (this.isLandscape) {
	      return [height, width];
	    } else {
	      return [width, height];
	    }
	  };
	
	  DeviceComponent.prototype.handSwitchingSupported = function() {
	    return this._device.hands !== void 0;
	  };
	
	  DeviceComponent.prototype.nextHand = function() {
	    var hand, hands, nextHand, nextHandIndex;
	    if (this.hands.rotationZ !== 0) {
	      return;
	    }
	    if (this.handSwitchingSupported()) {
	      hands = _.keys(this._device.hands);
	      if (hands.length > 0) {
	        nextHandIndex = hands.indexOf(this.selectedHand) + 1;
	        nextHand = "";
	        if (nextHandIndex < hands.length) {
	          nextHand = hands[nextHandIndex];
	        }
	        hand = this.setHand(nextHand);
	        this._update();
	        return hand;
	      }
	    }
	    return false;
	  };
	
	  DeviceComponent.prototype.setHand = function(hand) {
	    var handData;
	    this.selectedHand = hand;
	    if (!hand || !this.handSwitchingSupported()) {
	      return this.handsImageLayer.image = "";
	    }
	    handData = this._device.hands[hand];
	    if (handData) {
	      this.hands.width = handData.width;
	      this.hands.height = handData.height;
	      this.hands.center();
	      this.phone.center();
	      this.handsImageLayer.size = this.hands.size;
	      this.handsImageLayer.y = 0;
	      if (handData.offset) {
	        this.handsImageLayer.y = handData.offset;
	      }
	      this.handsImageLayer.image = this.handImageUrl(hand);
	      return hand;
	    }
	  };
	
	  DeviceComponent.prototype.handImageUrl = function(hand) {
	    var resourceUrl;
	    resourceUrl = "//resources.framerjs.com/static/DeviceResources";
	    if (Utils.isFileUrl(window.location.href)) {
	      resourceUrl = "http://" + resourceUrl;
	    }
	    if (Utils.isFramerStudio() && window.FramerStudioInfo && Utils.framerStudioVersion() >= newDeviceMinVersion) {
	      resourceUrl = window.FramerStudioInfo.deviceImagesUrl;
	      return resourceUrl + "/" + hand + ".png";
	    }
	    if (Utils.isWebPSupported()) {
	      return resourceUrl + "/" + hand + ".webp";
	    }
	    if (Utils.isJP2Supported()) {
	      return resourceUrl + "/" + hand + ".jp2";
	    }
	    return resourceUrl + "/" + hand + ".png";
	  };
	
	  DeviceComponent.prototype.toInspect = function() {
	    return "<Device '" + this.deviceType + "' " + this.screenSize.width + "x" + this.screenSize.height + ">";
	  };
	
	  return DeviceComponent;
	
	})(BaseClass);
	
	googlePixelReleaseVersion = 75;
	
	desktopReleaseVersion = 70;
	
	newDeviceMinVersion = 53;
	
	oldDeviceMaxVersion = 52;
	
	iPadAir2BaseDevice = {
	  deviceImageWidth: 1856,
	  deviceImageHeight: 2608,
	  deviceImageCompression: true,
	  screenWidth: 1536,
	  screenHeight: 2048,
	  deviceType: "tablet",
	  minStudioVersion: newDeviceMinVersion
	};
	
	iPadMini4BaseDevice = {
	  deviceImageWidth: 1936,
	  deviceImageHeight: 2688,
	  deviceImageCompression: true,
	  screenWidth: 1536,
	  screenHeight: 2048,
	  deviceType: "tablet",
	  minStudioVersion: newDeviceMinVersion
	};
	
	iPadProBaseDevice = {
	  deviceImageWidth: 2448,
	  deviceImageHeight: 3432,
	  deviceImageCompression: true,
	  screenWidth: 2048,
	  screenHeight: 2732,
	  deviceType: "tablet",
	  minStudioVersion: newDeviceMinVersion
	};
	
	iPhone7BaseDevice = {
	  deviceImageWidth: 874,
	  deviceImageHeight: 1792,
	  deviceImageCompression: true,
	  screenWidth: 750,
	  screenHeight: 1334,
	  deviceType: "phone",
	  minStudioVersion: 71,
	  hands: {
	    "iphone-hands-2": {
	      width: 2400,
	      height: 3740
	    },
	    "iphone-hands-1": {
	      width: 2400,
	      height: 3740
	    }
	  }
	};
	
	iPhone7PlusBaseDevice = {
	  deviceImageWidth: 1452,
	  deviceImageHeight: 2968,
	  deviceImageCompression: true,
	  screenWidth: 1242,
	  screenHeight: 2208,
	  deviceType: "phone",
	  minStudioVersion: 71,
	  hands: {
	    "iphone-hands-2": {
	      width: 3987,
	      height: 6212
	    },
	    "iphone-hands-1": {
	      width: 3987,
	      height: 6212
	    }
	  }
	};
	
	iPhone6BaseDevice = {
	  deviceImageWidth: 874,
	  deviceImageHeight: 1792,
	  deviceImageCompression: true,
	  screenWidth: 750,
	  screenHeight: 1334,
	  deviceType: "phone",
	  minStudioVersion: newDeviceMinVersion,
	  hands: {
	    "iphone-hands-2": {
	      width: 2400,
	      height: 3740
	    },
	    "iphone-hands-1": {
	      width: 2400,
	      height: 3740
	    }
	  }
	};
	
	iPhone6PlusBaseDevice = {
	  deviceImageWidth: 1452,
	  deviceImageHeight: 2968,
	  deviceImageCompression: true,
	  screenWidth: 1242,
	  screenHeight: 2208,
	  deviceType: "phone",
	  minStudioVersion: newDeviceMinVersion,
	  hands: {
	    "iphone-hands-2": {
	      width: 3987,
	      height: 6212
	    },
	    "iphone-hands-1": {
	      width: 3987,
	      height: 6212
	    }
	  }
	};
	
	iPhone5BaseDevice = {
	  deviceImageWidth: 768,
	  deviceImageHeight: 1612,
	  deviceImageCompression: true,
	  screenWidth: 640,
	  screenHeight: 1136,
	  deviceType: "phone",
	  minStudioVersion: newDeviceMinVersion,
	  hands: {
	    "iphone-hands-2": {
	      width: 2098,
	      height: 3269,
	      offset: 19
	    },
	    "iphone-hands-1": {
	      width: 2098,
	      height: 3269,
	      offset: 19
	    }
	  }
	};
	
	iPhone5CBaseDevice = {
	  deviceImageWidth: 776,
	  deviceImageHeight: 1620,
	  deviceImageCompression: true,
	  screenWidth: 640,
	  screenHeight: 1136,
	  deviceType: "phone",
	  minStudioVersion: newDeviceMinVersion,
	  hands: {
	    "iphone-hands-2": {
	      width: 2098,
	      height: 3269,
	      offset: 28
	    },
	    "iphone-hands-1": {
	      width: 2098,
	      height: 3269,
	      offset: 28
	    }
	  }
	};
	
	Nexus4BaseDevice = {
	  deviceImageWidth: 860,
	  deviceImageHeight: 1668,
	  deviceImageCompression: true,
	  screenWidth: 768,
	  screenHeight: 1280,
	  deviceType: "phone",
	  minStudioVersion: newDeviceMinVersion,
	  hands: {
	    "iphone-hands-2": {
	      width: 2362,
	      height: 3681,
	      offset: -52
	    },
	    "iphone-hands-1": {
	      width: 2362,
	      height: 3681,
	      offset: -52
	    }
	  }
	};
	
	Nexus5BaseDevice = {
	  deviceImageWidth: 1204,
	  deviceImageHeight: 2432,
	  deviceImageCompression: true,
	  screenWidth: 1080,
	  screenHeight: 1920,
	  deviceType: "phone",
	  minStudioVersion: newDeviceMinVersion,
	  hands: {
	    "iphone-hands-2": {
	      width: 3292,
	      height: 5130,
	      offset: 8
	    },
	    "iphone-hands-1": {
	      width: 3292,
	      height: 5130,
	      offset: 8
	    }
	  }
	};
	
	Nexus6BaseDevice = {
	  deviceImageWidth: 1576,
	  deviceImageHeight: 3220,
	  deviceImageCompression: true,
	  screenWidth: 1440,
	  screenHeight: 2560,
	  deviceType: "phone",
	  minStudioVersion: newDeviceMinVersion,
	  hands: {
	    "iphone-hands-2": {
	      width: 4304,
	      height: 6707,
	      offset: 8
	    },
	    "iphone-hands-1": {
	      width: 4304,
	      height: 6707,
	      offset: 8
	    }
	  }
	};
	
	PixelBaseDevice = {
	  deviceImageWidth: 1224,
	  deviceImageHeight: 2492,
	  deviceImageCompression: true,
	  screenWidth: 1080,
	  screenHeight: 1920,
	  deviceType: "phone",
	  minStudioVersion: googlePixelReleaseVersion,
	  hands: {
	    "iphone-hands-2": {
	      width: 3344,
	      height: 5211,
	      offset: 23
	    },
	    "iphone-hands-1": {
	      width: 3344,
	      height: 5211,
	      offset: 23
	    }
	  }
	};
	
	Nexus9BaseDevice = {
	  deviceImageWidth: 1896,
	  deviceImageHeight: 2648,
	  deviceImageCompression: true,
	  screenWidth: 1536,
	  screenHeight: 2048,
	  deviceType: "tablet",
	  minStudioVersion: newDeviceMinVersion
	};
	
	HTCa9BaseDevice = {
	  deviceImageWidth: 1252,
	  deviceImageHeight: 2592,
	  deviceImageCompression: true,
	  screenWidth: 1080,
	  screenHeight: 1920,
	  deviceType: "phone",
	  minStudioVersion: newDeviceMinVersion,
	  hands: {
	    "iphone-hands-2": {
	      width: 3436,
	      height: 5354,
	      offset: 36
	    },
	    "iphone-hands-1": {
	      width: 3436,
	      height: 5354,
	      offset: 36
	    }
	  }
	};
	
	HTCm8BaseDevice = {
	  deviceImageWidth: 1232,
	  deviceImageHeight: 2572,
	  deviceImageCompression: true,
	  screenWidth: 1080,
	  screenHeight: 1920,
	  deviceType: "phone",
	  minStudioVersion: newDeviceMinVersion,
	  hands: {
	    "iphone-hands-2": {
	      width: 3436,
	      height: 5354,
	      offset: 12
	    },
	    "iphone-hands-1": {
	      width: 3436,
	      height: 5354,
	      offset: 12
	    }
	  }
	};
	
	MSFTLumia950BaseDevice = {
	  deviceImageWidth: 1660,
	  deviceImageHeight: 3292,
	  deviceImageCompression: true,
	  screenWidth: 1440,
	  screenHeight: 2560,
	  deviceType: "phone",
	  minStudioVersion: newDeviceMinVersion,
	  hands: {
	    "iphone-hands-2": {
	      width: 4494,
	      height: 7003,
	      offset: -84
	    },
	    "iphone-hands-1": {
	      width: 4494,
	      height: 7003,
	      offset: -84
	    }
	  }
	};
	
	SamsungGalaxyNote5BaseDevice = {
	  deviceImageWidth: 1572,
	  deviceImageHeight: 3140,
	  deviceImageCompression: true,
	  screenWidth: 1440,
	  screenHeight: 2560,
	  deviceType: "phone",
	  minStudioVersion: newDeviceMinVersion,
	  hands: {
	    "iphone-hands-2": {
	      width: 4279,
	      height: 6668,
	      offset: -24
	    },
	    "iphone-hands-1": {
	      width: 4279,
	      height: 6668,
	      offset: -84
	    }
	  }
	};
	
	AppleWatchSeries242Device = {
	  deviceImageWidth: 512,
	  deviceImageHeight: 990,
	  deviceImageCompression: true,
	  screenWidth: 312,
	  screenHeight: 390,
	  minStudioVersion: 71
	};
	
	AppleWatchSeries238Device = {
	  deviceImageWidth: 472,
	  deviceImageHeight: 772,
	  deviceImageCompression: true,
	  screenWidth: 272,
	  screenHeight: 340,
	  minStudioVersion: 71
	};
	
	AppleWatch42Device = {
	  deviceImageWidth: 512,
	  deviceImageHeight: 990,
	  deviceImageCompression: true,
	  screenWidth: 312,
	  screenHeight: 390,
	  minStudioVersion: newDeviceMinVersion
	};
	
	AppleWatch38Device = {
	  deviceImageWidth: 472,
	  deviceImageHeight: 772,
	  deviceImageCompression: true,
	  screenWidth: 272,
	  screenHeight: 340,
	  minStudioVersion: newDeviceMinVersion
	};
	
	AppleWatch38BlackLeatherDevice = {
	  deviceImageWidth: 472,
	  deviceImageHeight: 796,
	  deviceImageCompression: true,
	  screenWidth: 272,
	  screenHeight: 340,
	  minStudioVersion: newDeviceMinVersion
	};
	
	AppleMacBook = {
	  deviceImageWidth: 3084,
	  deviceImageHeight: 1860,
	  deviceImageCompression: true,
	  screenWidth: 2304,
	  screenHeight: 1440,
	  deviceType: "computer",
	  minStudioVersion: desktopReleaseVersion
	};
	
	AppleMacBookAir = {
	  deviceImageWidth: 2000,
	  deviceImageHeight: 1220,
	  deviceImageCompression: true,
	  screenWidth: 1440,
	  screenHeight: 900,
	  deviceType: "computer",
	  minStudioVersion: desktopReleaseVersion
	};
	
	AppleMacBookPro = {
	  deviceImageWidth: 3820,
	  deviceImageHeight: 2320,
	  deviceImageCompression: true,
	  screenWidth: 2880,
	  screenHeight: 1800,
	  deviceType: "computer",
	  minStudioVersion: desktopReleaseVersion
	};
	
	AppleIMac = {
	  deviceImageWidth: 2800,
	  deviceImageHeight: 2940,
	  deviceImageCompression: true,
	  screenWidth: 2560,
	  screenHeight: 1440,
	  deviceType: "computer",
	  minStudioVersion: desktopReleaseVersion
	};
	
	DellXPS = {
	  deviceImageWidth: 5200,
	  deviceImageHeight: 3040,
	  deviceImageCompression: true,
	  screenWidth: 3840,
	  screenHeight: 2160,
	  deviceType: "computer",
	  minStudioVersion: desktopReleaseVersion
	};
	
	SonyW85OC = {
	  deviceImageWidth: 1320,
	  deviceImageHeight: 860,
	  deviceImageCompression: true,
	  screenWidth: 1280,
	  screenHeight: 720,
	  minStudioVersion: desktopReleaseVersion
	};
	
	old_iPhone6BaseDevice = {
	  deviceImageWidth: 870,
	  deviceImageHeight: 1738,
	  deviceImageCompression: true,
	  screenWidth: 750,
	  screenHeight: 1334,
	  deviceType: "phone",
	  maxStudioVersion: oldDeviceMaxVersion
	};
	
	old_iPhone6BaseDeviceHand = _.extend({}, old_iPhone6BaseDevice, {
	  deviceImageWidth: 1988,
	  deviceImageHeight: 2368,
	  deviceImageCompression: true,
	  paddingOffset: -150,
	  maxStudioVersion: oldDeviceMaxVersion
	});
	
	old_iPhone6PlusBaseDevice = {
	  deviceImageWidth: 1460,
	  deviceImageHeight: 2900,
	  deviceImageCompression: true,
	  screenWidth: 1242,
	  screenHeight: 2208,
	  deviceType: "phone",
	  maxStudioVersion: oldDeviceMaxVersion
	};
	
	old_iPhone6PlusBaseDeviceHand = _.extend({}, old_iPhone6PlusBaseDevice, {
	  deviceImageWidth: 3128,
	  deviceImageHeight: 3487,
	  deviceImageCompression: true,
	  paddingOffset: -150,
	  maxStudioVersion: oldDeviceMaxVersion
	});
	
	old_iPhone5BaseDevice = {
	  deviceImageWidth: 780,
	  deviceImageHeight: 1608,
	  deviceImageCompression: true,
	  screenWidth: 640,
	  screenHeight: 1136,
	  deviceType: "phone",
	  maxStudioVersion: oldDeviceMaxVersion
	};
	
	old_iPhone5BaseDeviceHand = _.extend({}, old_iPhone5BaseDevice, {
	  deviceImageWidth: 1884,
	  deviceImageHeight: 2234,
	  deviceImageCompression: true,
	  paddingOffset: -200,
	  maxStudioVersion: oldDeviceMaxVersion
	});
	
	old_iPhone5CBaseDevice = {
	  deviceImageWidth: 776,
	  deviceImageHeight: 1612,
	  deviceImageCompression: true,
	  screenWidth: 640,
	  screenHeight: 1136,
	  deviceType: "phone",
	  maxStudioVersion: oldDeviceMaxVersion
	};
	
	old_iPhone5CBaseDeviceHand = _.extend({}, old_iPhone5CBaseDevice, {
	  deviceImageWidth: 1894,
	  deviceImageHeight: 2244,
	  deviceImageCompression: true,
	  paddingOffset: -200,
	  maxStudioVersion: oldDeviceMaxVersion
	});
	
	old_iPadMiniBaseDevice = {
	  deviceImageWidth: 872,
	  deviceImageHeight: 1292,
	  deviceImageCompression: true,
	  screenWidth: 768,
	  screenHeight: 1024,
	  deviceType: "tablet",
	  maxStudioVersion: oldDeviceMaxVersion
	};
	
	old_iPadMiniBaseDeviceHand = _.extend({}, old_iPadMiniBaseDevice, {
	  deviceImageWidth: 1380,
	  deviceImageHeight: 2072,
	  deviceImageCompression: true,
	  paddingOffset: -120,
	  maxStudioVersion: oldDeviceMaxVersion
	});
	
	old_iPadAirBaseDevice = {
	  deviceImageWidth: 1769,
	  deviceImageHeight: 2509,
	  deviceImageCompression: true,
	  screenWidth: 1536,
	  screenHeight: 2048,
	  deviceType: "tablet",
	  maxStudioVersion: oldDeviceMaxVersion
	};
	
	old_iPadAirBaseDeviceHand = _.extend({}, old_iPadAirBaseDevice, {
	  deviceImageWidth: 4744,
	  deviceImageHeight: 4101,
	  deviceImageCompression: true,
	  paddingOffset: -120,
	  maxStudioVersion: oldDeviceMaxVersion
	});
	
	old_Nexus5BaseDevice = {
	  deviceImageWidth: 1208,
	  deviceImageHeight: 2440,
	  deviceImageCompression: true,
	  screenWidth: 1080,
	  screenHeight: 1920,
	  deviceType: "phone",
	  maxStudioVersion: oldDeviceMaxVersion
	};
	
	old_Nexus5BaseDeviceHand = _.extend({}, old_Nexus5BaseDevice, {
	  deviceImageWidth: 2692,
	  deviceImageHeight: 2996,
	  deviceImageCompression: true,
	  paddingOffset: -120,
	  maxStudioVersion: oldDeviceMaxVersion
	});
	
	old_Nexus9BaseDevice = {
	  deviceImageWidth: 1733,
	  deviceImageHeight: 2575,
	  deviceImageCompression: true,
	  screenWidth: 1536,
	  screenHeight: 2048,
	  deviceType: "tablet",
	  maxStudioVersion: oldDeviceMaxVersion
	};
	
	old_AppleWatch42Device = {
	  deviceImageWidth: 552,
	  deviceImageHeight: 938,
	  deviceImageCompression: true,
	  screenWidth: 312,
	  screenHeight: 390,
	  maxStudioVersion: oldDeviceMaxVersion
	};
	
	old_AppleWatch38Device = {
	  deviceImageWidth: 508,
	  deviceImageHeight: 900,
	  deviceImageCompression: true,
	  screenWidth: 272,
	  screenHeight: 340,
	  maxStudioVersion: oldDeviceMaxVersion
	};
	
	Devices = {
	  "fullscreen": {
	    name: "Fullscreen",
	    deviceType: "desktop",
	    backgroundColor: "transparent"
	  },
	  "custom": {
	    name: "Custom",
	    deviceImageWidth: 874,
	    deviceImageHeight: 1792,
	    screenWidth: 750,
	    screenHeight: 1334,
	    deviceType: "phone"
	  },
	  "apple-ipad-air-2-silver": _.clone(iPadAir2BaseDevice),
	  "apple-ipad-air-2-gold": _.clone(iPadAir2BaseDevice),
	  "apple-ipad-air-2-space-gray": _.clone(iPadAir2BaseDevice),
	  "apple-ipad-mini-4-silver": _.clone(iPadMini4BaseDevice),
	  "apple-ipad-mini-4-gold": _.clone(iPadMini4BaseDevice),
	  "apple-ipad-mini-4-space-gray": _.clone(iPadMini4BaseDevice),
	  "apple-ipad-pro-silver": _.clone(iPadProBaseDevice),
	  "apple-ipad-pro-gold": _.clone(iPadProBaseDevice),
	  "apple-ipad-pro-space-gray": _.clone(iPadProBaseDevice),
	  "apple-iphone-7-gold": _.clone(iPhone7BaseDevice),
	  "apple-iphone-7-rose-gold": _.clone(iPhone7BaseDevice),
	  "apple-iphone-7-silver": _.clone(iPhone7BaseDevice),
	  "apple-iphone-7-black": _.clone(iPhone7BaseDevice),
	  "apple-iphone-7-jet-black": _.clone(iPhone7BaseDevice),
	  "apple-iphone-7-plus-gold": _.clone(iPhone7PlusBaseDevice),
	  "apple-iphone-7-plus-rose-gold": _.clone(iPhone7PlusBaseDevice),
	  "apple-iphone-7-plus-silver": _.clone(iPhone7PlusBaseDevice),
	  "apple-iphone-7-plus-black": _.clone(iPhone7PlusBaseDevice),
	  "apple-iphone-7-plus-jet-black": _.clone(iPhone7PlusBaseDevice),
	  "apple-iphone-6s-gold": _.clone(iPhone6BaseDevice),
	  "apple-iphone-6s-rose-gold": _.clone(iPhone6BaseDevice),
	  "apple-iphone-6s-silver": _.clone(iPhone6BaseDevice),
	  "apple-iphone-6s-space-gray": _.clone(iPhone6BaseDevice),
	  "apple-iphone-6s-plus-gold": _.clone(iPhone6PlusBaseDevice),
	  "apple-iphone-6s-plus-rose-gold": _.clone(iPhone6PlusBaseDevice),
	  "apple-iphone-6s-plus-silver": _.clone(iPhone6PlusBaseDevice),
	  "apple-iphone-6s-plus-space-gray": _.clone(iPhone6PlusBaseDevice),
	  "apple-iphone-5s-gold": _.clone(iPhone5BaseDevice),
	  "apple-iphone-5s-silver": _.clone(iPhone5BaseDevice),
	  "apple-iphone-5s-space-gray": _.clone(iPhone5BaseDevice),
	  "apple-iphone-5c-blue": _.clone(iPhone5CBaseDevice),
	  "apple-iphone-5c-green": _.clone(iPhone5CBaseDevice),
	  "apple-iphone-5c-red": _.clone(iPhone5CBaseDevice),
	  "apple-iphone-5c-white": _.clone(iPhone5CBaseDevice),
	  "apple-iphone-5c-yellow": _.clone(iPhone5CBaseDevice),
	  "apple-watch-series-2-38mm-black-steel-black": _.clone(AppleWatchSeries238Device),
	  "apple-watch-series-2-38mm-edition": _.clone(AppleWatchSeries238Device),
	  "apple-watch-series-2-38mm-rose-gold-aluminum-midnight-blue": _.clone(AppleWatchSeries238Device),
	  "apple-watch-series-2-38mm-silver-aluminum-cocoa": _.clone(AppleWatchSeries238Device),
	  "apple-watch-series-2-38mm-silver-aluminum-concrete": _.clone(AppleWatchSeries238Device),
	  "apple-watch-series-2-38mm-silver-aluminum-ocean-blue": _.clone(AppleWatchSeries238Device),
	  "apple-watch-series-2-38mm-silver-aluminum-red": _.clone(AppleWatchSeries238Device),
	  "apple-watch-series-2-38mm-silver-aluminum-turquoise": _.clone(AppleWatchSeries238Device),
	  "apple-watch-series-2-38mm-silver-aluminum-white": _.clone(AppleWatchSeries238Device),
	  "apple-watch-series-2-38mm-silver-aluminum-yellow": _.clone(AppleWatchSeries238Device),
	  "apple-watch-series-2-38mm-space-gray-aluminum-black": _.clone(AppleWatchSeries238Device),
	  "apple-watch-series-2-38mm-sport-aluminum-walnut": _.clone(AppleWatchSeries238Device),
	  "apple-watch-series-2-38mm-steel-white": _.clone(AppleWatchSeries238Device),
	  "apple-watch-series-2-42mm-edition": _.clone(AppleWatchSeries242Device),
	  "apple-watch-series-2-42mm-gold-aluminum-cocoa": _.clone(AppleWatchSeries242Device),
	  "apple-watch-series-2-42mm-rose-gold-aluminum-midnight-blue": _.clone(AppleWatchSeries242Device),
	  "apple-watch-series-2-42mm-silver-aluminum-concrete": _.clone(AppleWatchSeries242Device),
	  "apple-watch-series-2-42mm-silver-aluminum-green": _.clone(AppleWatchSeries242Device),
	  "apple-watch-series-2-42mm-silver-aluminum-light-pink": _.clone(AppleWatchSeries242Device),
	  "apple-watch-series-2-42mm-silver-aluminum-ocean-blue": _.clone(AppleWatchSeries242Device),
	  "apple-watch-series-2-42mm-silver-aluminum-pink-sand": _.clone(AppleWatchSeries242Device),
	  "apple-watch-series-2-42mm-silver-aluminum-red": _.clone(AppleWatchSeries242Device),
	  "apple-watch-series-2-42mm-silver-aluminum-turquoise": _.clone(AppleWatchSeries242Device),
	  "apple-watch-series-2-42mm-silver-aluminum-white": _.clone(AppleWatchSeries242Device),
	  "apple-watch-series-2-42mm-silver-aluminum-yellow": _.clone(AppleWatchSeries242Device),
	  "apple-watch-series-2-42mm-space-black-steel-black": _.clone(AppleWatchSeries242Device),
	  "apple-watch-series-2-42mm-space-gray-aluminum-black": _.clone(AppleWatchSeries242Device),
	  "apple-watch-series-2-42mm-steel-white": _.clone(AppleWatchSeries242Device),
	  "apple-watch-nike-plus-38mm-silver-aluminum-flat-silver-volt": _.clone(AppleWatchSeries238Device),
	  "apple-watch-nike-plus-38mm-silver-aluminum-flat-silver-white": _.clone(AppleWatchSeries238Device),
	  "apple-watch-nike-plus-38mm-space-gray-aluminum-black-cool-gray": _.clone(AppleWatchSeries238Device),
	  "apple-watch-nike-plus-38mm-space-gray-aluminum-black-volt": _.clone(AppleWatchSeries238Device),
	  "apple-watch-nike-plus-42mm-silver-aluminum-flat-silver-volt": _.clone(AppleWatchSeries242Device),
	  "apple-watch-nike-plus-42mm-silver-aluminum-flat-silver-white": _.clone(AppleWatchSeries242Device),
	  "apple-watch-nike-plus-42mm-space-gray-aluminum-black-cool-gray": _.clone(AppleWatchSeries242Device),
	  "apple-watch-nike-plus-42mm-space-gray-aluminum-black-volt": _.clone(AppleWatchSeries242Device),
	  "apple-watch-38mm-gold-black-leather-closed": _.clone(AppleWatch38BlackLeatherDevice),
	  "apple-watch-38mm-rose-gold-black-leather-closed": _.clone(AppleWatch38BlackLeatherDevice),
	  "apple-watch-38mm-stainless-steel-black-leather-closed": _.clone(AppleWatch38BlackLeatherDevice),
	  "apple-watch-38mm-black-steel-black-closed": _.clone(AppleWatch38Device),
	  "apple-watch-38mm-gold-midnight-blue-closed": _.clone(AppleWatch38Device),
	  "apple-watch-38mm-rose-gold-lavender-closed": _.clone(AppleWatch38Device),
	  "apple-watch-38mm-sport-aluminum-blue-closed": _.clone(AppleWatch38Device),
	  "apple-watch-38mm-sport-aluminum-fog-closed": _.clone(AppleWatch38Device),
	  "apple-watch-38mm-sport-aluminum-green-closed": _.clone(AppleWatch38Device),
	  "apple-watch-38mm-sport-aluminum-red-closed": _.clone(AppleWatch38Device),
	  "apple-watch-38mm-sport-aluminum-walnut-closed": _.clone(AppleWatch38Device),
	  "apple-watch-38mm-sport-aluminum-white-closed": _.clone(AppleWatch38Device),
	  "apple-watch-38mm-sport-aluminum-gold-antique-white-closed": _.clone(AppleWatch38Device),
	  "apple-watch-38mm-sport-aluminum-rose-gold-stone-closed": _.clone(AppleWatch38Device),
	  "apple-watch-38mm-sport-space-gray-black-closed": _.clone(AppleWatch38Device),
	  "apple-watch-42mm-black-steel-black-closed": _.clone(AppleWatch42Device),
	  "apple-watch-42mm-gold-black-leather-closed": _.clone(AppleWatch42Device),
	  "apple-watch-42mm-gold-midnight-blue-closed": _.clone(AppleWatch42Device),
	  "apple-watch-42mm-rose-gold-black-leather-closed": _.clone(AppleWatch42Device),
	  "apple-watch-42mm-rose-gold-lavender-closed": _.clone(AppleWatch42Device),
	  "apple-watch-42mm-sport-aluminum-blue-closed": _.clone(AppleWatch42Device),
	  "apple-watch-42mm-sport-aluminum-fog-closed": _.clone(AppleWatch42Device),
	  "apple-watch-42mm-sport-aluminum-green-closed": _.clone(AppleWatch42Device),
	  "apple-watch-42mm-sport-aluminum-red-closed": _.clone(AppleWatch42Device),
	  "apple-watch-42mm-sport-aluminum-walnut-closed": _.clone(AppleWatch42Device),
	  "apple-watch-42mm-sport-aluminum-white-closed": _.clone(AppleWatch42Device),
	  "apple-watch-42mm-sport-aluminum-gold-antique-white-closed": _.clone(AppleWatch42Device),
	  "apple-watch-42mm-sport-aluminum-rose-gold-stone-closed": _.clone(AppleWatch42Device),
	  "apple-watch-42mm-sport-space-gray-black-closed": _.clone(AppleWatch42Device),
	  "apple-watch-42mm-stainless-steel-black-leather-closed": _.clone(AppleWatch42Device),
	  "google-nexus-4": _.clone(Nexus4BaseDevice),
	  "google-nexus-5x": _.clone(Nexus5BaseDevice),
	  "google-nexus-6p": _.clone(Nexus6BaseDevice),
	  "google-nexus-9": _.clone(Nexus9BaseDevice),
	  "google-pixel-quite-black": _.clone(PixelBaseDevice),
	  "google-pixel-really-blue": _.clone(PixelBaseDevice),
	  "google-pixel-very-silver": _.clone(PixelBaseDevice),
	  "htc-one-a9-black": _.clone(HTCa9BaseDevice),
	  "htc-one-a9-white": _.clone(HTCa9BaseDevice),
	  "htc-one-m8-black": _.clone(HTCm8BaseDevice),
	  "htc-one-m8-gold": _.clone(HTCm8BaseDevice),
	  "htc-one-m8-silver": _.clone(HTCm8BaseDevice),
	  "microsoft-lumia-950-black": _.clone(MSFTLumia950BaseDevice),
	  "microsoft-lumia-950-white": _.clone(MSFTLumia950BaseDevice),
	  "samsung-galaxy-note-5-black": _.clone(SamsungGalaxyNote5BaseDevice),
	  "samsung-galaxy-note-5-gold": _.clone(SamsungGalaxyNote5BaseDevice),
	  "samsung-galaxy-note-5-pink": _.clone(SamsungGalaxyNote5BaseDevice),
	  "samsung-galaxy-note-5-silver-titanium": _.clone(SamsungGalaxyNote5BaseDevice),
	  "samsung-galaxy-note-5-white": _.clone(SamsungGalaxyNote5BaseDevice),
	  "apple-macbook": _.clone(AppleMacBook),
	  "apple-macbook-air": _.clone(AppleMacBookAir),
	  "apple-macbook-pro": _.clone(AppleMacBookPro),
	  "dell-xps": _.clone(DellXPS),
	  "apple-imac": _.clone(AppleIMac),
	  "sony-w85Oc": _.clone(SonyW85OC),
	  "desktop-safari-1024-600": {
	    deviceType: "browser",
	    name: "Desktop Safari 1024 x 600",
	    screenWidth: 1024,
	    screenHeight: 600,
	    deviceImageWidth: 1136,
	    deviceImageHeight: 760,
	    deviceImageCompression: true,
	    backgroundColor: "white"
	  },
	  "desktop-safari-1280-800": {
	    deviceType: "browser",
	    name: "Desktop Safari 1280 x 800",
	    screenWidth: 1280,
	    screenHeight: 800,
	    deviceImageWidth: 1392,
	    deviceImageHeight: 960,
	    deviceImageCompression: true,
	    backgroundColor: "white"
	  },
	  "desktop-safari-1440-900": {
	    deviceType: "browser",
	    name: "Desktop Safari 1440 x 900",
	    screenWidth: 1440,
	    screenHeight: 900,
	    deviceImageWidth: 1552,
	    deviceImageHeight: 1060,
	    deviceImageCompression: true,
	    backgroundColor: "white"
	  },
	  "iphone-6-spacegray": _.clone(old_iPhone6BaseDevice),
	  "iphone-6-spacegray-hand": _.clone(old_iPhone6BaseDeviceHand),
	  "iphone-6-silver": _.clone(old_iPhone6BaseDevice),
	  "iphone-6-silver-hand": _.clone(old_iPhone6BaseDeviceHand),
	  "iphone-6-gold": _.clone(old_iPhone6BaseDevice),
	  "iphone-6-gold-hand": _.clone(old_iPhone6BaseDeviceHand),
	  "iphone-6plus-spacegray": _.clone(old_iPhone6PlusBaseDevice),
	  "iphone-6plus-spacegray-hand": _.clone(old_iPhone6PlusBaseDeviceHand),
	  "iphone-6plus-silver": _.clone(old_iPhone6PlusBaseDevice),
	  "iphone-6plus-silver-hand": _.clone(old_iPhone6PlusBaseDeviceHand),
	  "iphone-6plus-gold": _.clone(old_iPhone6PlusBaseDevice),
	  "iphone-6plus-gold-hand": _.clone(old_iPhone6PlusBaseDeviceHand),
	  "iphone-5s-spacegray": _.clone(old_iPhone5BaseDevice),
	  "iphone-5s-spacegray-hand": _.clone(old_iPhone5BaseDeviceHand),
	  "iphone-5s-silver": _.clone(old_iPhone5BaseDevice),
	  "iphone-5s-silver-hand": _.clone(old_iPhone5BaseDeviceHand),
	  "iphone-5s-gold": _.clone(old_iPhone5BaseDevice),
	  "iphone-5s-gold-hand": _.clone(old_iPhone5BaseDeviceHand),
	  "iphone-5c-green": _.clone(old_iPhone5CBaseDevice),
	  "iphone-5c-green-hand": _.clone(old_iPhone5CBaseDeviceHand),
	  "iphone-5c-blue": _.clone(old_iPhone5CBaseDevice),
	  "iphone-5c-blue-hand": _.clone(old_iPhone5CBaseDeviceHand),
	  "iphone-5c-pink": _.clone(old_iPhone5CBaseDevice),
	  "iphone-5c-pink-hand": _.clone(old_iPhone5CBaseDeviceHand),
	  "iphone-5c-white": _.clone(old_iPhone5CBaseDevice),
	  "iphone-5c-white-hand": _.clone(old_iPhone5CBaseDeviceHand),
	  "iphone-5c-yellow": _.clone(old_iPhone5CBaseDevice),
	  "iphone-5c-yellow-hand": _.clone(old_iPhone5CBaseDeviceHand),
	  "ipad-mini-spacegray": _.clone(old_iPadMiniBaseDevice),
	  "ipad-mini-spacegray-hand": _.clone(old_iPadMiniBaseDeviceHand),
	  "ipad-mini-silver": _.clone(old_iPadMiniBaseDevice),
	  "ipad-mini-silver-hand": _.clone(old_iPadMiniBaseDeviceHand),
	  "ipad-air-spacegray": _.clone(old_iPadAirBaseDevice),
	  "ipad-air-spacegray-hand": _.clone(old_iPadAirBaseDeviceHand),
	  "ipad-air-silver": _.clone(old_iPadAirBaseDevice),
	  "ipad-air-silver-hand": _.clone(old_iPadAirBaseDeviceHand),
	  "nexus-5-black": _.clone(old_Nexus5BaseDevice),
	  "nexus-5-black-hand": _.clone(old_Nexus5BaseDeviceHand),
	  "nexus-9": _.clone(old_Nexus9BaseDevice),
	  "applewatchsport-38-aluminum-sportband-black": _.clone(old_AppleWatch38Device),
	  "applewatchsport-38-aluminum-sportband-blue": _.clone(old_AppleWatch38Device),
	  "applewatchsport-38-aluminum-sportband-green": _.clone(old_AppleWatch38Device),
	  "applewatchsport-38-aluminum-sportband-pink": _.clone(old_AppleWatch38Device),
	  "applewatchsport-38-aluminum-sportband-white": _.clone(old_AppleWatch38Device),
	  "applewatch-38-black-bracelet": _.clone(old_AppleWatch38Device),
	  "applewatch-38-steel-bracelet": _.clone(old_AppleWatch38Device),
	  "applewatchedition-38-gold-buckle-blue": _.clone(old_AppleWatch38Device),
	  "applewatchedition-38-gold-buckle-gray": _.clone(old_AppleWatch38Device),
	  "applewatchedition-38-gold-buckle-red": _.clone(old_AppleWatch38Device),
	  "applewatchedition-38-gold-sportband-black": _.clone(old_AppleWatch38Device),
	  "applewatchedition-38-gold-sportband-white": _.clone(old_AppleWatch38Device),
	  "applewatchsport-42-aluminum-sportband-black": _.clone(old_AppleWatch42Device),
	  "applewatchsport-42-aluminum-sportband-blue": _.clone(old_AppleWatch42Device),
	  "applewatchsport-42-aluminum-sportband-green": _.clone(old_AppleWatch42Device),
	  "applewatchsport-42-aluminum-sportband-pink": _.clone(old_AppleWatch42Device),
	  "applewatchsport-42-aluminum-sportband-white": _.clone(old_AppleWatch42Device),
	  "applewatch-42-black-bracelet": _.clone(old_AppleWatch42Device),
	  "applewatch-42-steel-bracelet": _.clone(old_AppleWatch42Device),
	  "applewatchedition-42-gold-buckle-blue": _.clone(old_AppleWatch42Device),
	  "applewatchedition-42-gold-buckle-gray": _.clone(old_AppleWatch42Device),
	  "applewatchedition-42-gold-buckle-red": _.clone(old_AppleWatch42Device),
	  "applewatchedition-42-gold-sportband-black": _.clone(old_AppleWatch42Device),
	  "applewatchedition-42-gold-sportband-white": _.clone(old_AppleWatch42Device)
	};
	
	exports.DeviceComponent.Devices = Devices;
	
	BuiltInDevices = _.keys(Devices);


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var Defaults, Layer, Utils,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	Utils = __webpack_require__(4);
	
	Defaults = __webpack_require__(17).Defaults;
	
	Layer = __webpack_require__(13).Layer;
	
	exports.GridComponent = (function(superClass) {
	  extend(GridComponent, superClass);
	
	  function GridComponent(options) {
	    if (options == null) {
	      options = {};
	    }
	    GridComponent.__super__.constructor.call(this, Defaults.getDefaults("GridComponent", options));
	  }
	
	  GridComponent.define("rows", {
	    get: function() {
	      return this._rows;
	    },
	    set: function(value) {
	      this._rows = value;
	      return this._render();
	    }
	  });
	
	  GridComponent.define("columns", {
	    get: function() {
	      return this._columns;
	    },
	    set: function(value) {
	      this._columns = value;
	      return this._render();
	    }
	  });
	
	  GridComponent.define("spacing", {
	    get: function() {
	      return this._spacing || {
	        horizontal: 0,
	        vertical: 0
	      };
	    },
	    set: function(value) {
	      if (_.isNumber(value)) {
	        value = {
	          horizontal: value,
	          vertical: value
	        };
	      }
	      this._spacing = value;
	      return this._render();
	    }
	  });
	
	  GridComponent.define("renderCell", {
	    get: function() {
	      return this._renderCell || this._defaultRenderCell;
	    },
	    set: function(f) {
	      if (f === this._renderCell) {
	        return;
	      }
	      if (!_.isFunction(f)) {
	        throw Error("GridComponent.renderCell should be a function, not " + (typeof f));
	      }
	      this._renderCell = f;
	      return this.render();
	    }
	  });
	
	  GridComponent.define("cellWidth", {
	    get: function() {
	      return (this.width - (this.spacing.horizontal * (this.columns - 1))) / this.columns;
	    }
	  });
	
	  GridComponent.define("cellHeight", {
	    get: function() {
	      return (this.height - (this.spacing.vertical * (this.rows - 1))) / this.rows;
	    }
	  });
	
	  GridComponent.define("cells", {
	    get: function() {
	      return _.values(this._cells);
	    }
	  });
	
	  GridComponent.prototype.cellX = function(row) {
	    return row * (this.cellWidth + this.spacing.horizontal);
	  };
	
	  GridComponent.prototype.cellY = function(column) {
	    return column * (this.cellHeight + this.spacing.vertical);
	  };
	
	  GridComponent.prototype.cellFrame = function(column, row) {
	    var frame;
	    return frame = {
	      x: this.cellX(column),
	      y: this.cellY(row),
	      width: this.cellWidth,
	      height: this.cellHeight
	    };
	  };
	
	  GridComponent.prototype.cell = function(column, row) {
	    return this._cells[column + ":" + row];
	  };
	
	  GridComponent.prototype.render = function() {
	    return this._render();
	  };
	
	  GridComponent.prototype._render = function() {
	    var cell, column, frame, i, ref, results, row;
	    this._reset();
	    results = [];
	    for (row = i = ref = this.rows - 1; ref <= 0 ? i <= 0 : i >= 0; row = ref <= 0 ? ++i : --i) {
	      results.push((function() {
	        var j, ref1, results1;
	        results1 = [];
	        for (column = j = ref1 = this.columns - 1; ref1 <= 0 ? j <= 0 : j >= 0; column = ref1 <= 0 ? ++j : --j) {
	          frame = this.cellFrame(column, row);
	          cell = new Layer({
	            parent: this,
	            frame: frame,
	            name: "Cell " + column + ":" + row
	          });
	          this.renderCell(cell, row, column);
	          results1.push(this._cells[column + ":" + row] = cell);
	        }
	        return results1;
	      }).call(this));
	    }
	    return results;
	  };
	
	  GridComponent.prototype._defaultRenderCell = function(cell, column, row) {
	    var fraction;
	    fraction = (column / this.columns) + (row / this.rows) / 2;
	    cell.backgroundColor = "#28affa";
	    cell.hueRotate = column * 20 + (row % this.columns) * (20 / (this.columns + 1));
	    Utils.labelLayer(cell, row + ":" + column);
	    return cell.style.fontSize = "30px";
	  };
	
	  GridComponent.prototype._reset = function() {
	    _.invokeMap(this.cells, "destroy");
	    return this._cells = {};
	  };
	
	  return GridComponent;
	
	})(Layer);


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var AnimationGroup, Events, FlowComponentLayerScrollKey, Layer, LayerStateMachine, LayerStates, Transitions, Utils,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  slice = [].slice;
	
	Utils = __webpack_require__(4);
	
	Layer = __webpack_require__(13).Layer;
	
	Events = __webpack_require__(15).Events;
	
	LayerStates = __webpack_require__(27).LayerStates;
	
	LayerStateMachine = __webpack_require__(28).LayerStateMachine;
	
	AnimationGroup = __webpack_require__(40).AnimationGroup;
	
	FlowComponentLayerScrollKey = "_flowComponentWrapped";
	
	Events.TransitionStart = "transitionstart";
	
	Events.TransitionHalt = "transitionhalt";
	
	Events.TransitionStop = "transitionstop";
	
	Events.TransitionEnd = "transitionend";
	
	exports.FlowComponent = (function(superClass) {
	  extend(FlowComponent, superClass);
	
	  function FlowComponent(layerOrOptions, options) {
	    var layer;
	    if (layerOrOptions == null) {
	      layerOrOptions = {};
	    }
	    if (options == null) {
	      options = {};
	    }
	    this._runTransition = bind(this._runTransition, this);
	    this._handleOverlayTap = bind(this._handleOverlayTap, this);
	    this.showPrevious = bind(this.showPrevious, this);
	    layer = null;
	    if (layerOrOptions instanceof Layer) {
	      layer = layerOrOptions;
	      options = options;
	    } else {
	      options = layerOrOptions;
	    }
	    options = _.defaults({}, options, {
	      backgroundColor: "black"
	    });
	    if (!options.size) {
	      if (options.width == null) {
	        options.width = Screen.width;
	      }
	      if (options.height == null) {
	        options.height = Screen.height;
	      }
	    }
	    if (options.clip == null) {
	      options.clip = true;
	    }
	    FlowComponent.__super__.constructor.call(this, options);
	    this.reset();
	    this.overlay = new Layer({
	      name: "overlay",
	      parent: this,
	      size: 0,
	      backgroundColor: "black",
	      visible: false
	    });
	    this.overlay.onTap(this._handleOverlayTap);
	    if (layer) {
	      this.showNext(layer);
	    } else {
	      this._tempScroll = new ScrollComponent({
	        name: "scrollComponent",
	        parent: this,
	        width: this.width,
	        height: this.height
	      });
	    }
	  }
	
	  FlowComponent.prototype.reset = function() {
	    var i, item, len, ref;
	    if (this._stack) {
	      ref = this._stack;
	      for (i = 0, len = ref.length; i < len; i++) {
	        item = ref[i];
	        if (item.layer !== this._initial) {
	          item.layer.visible = false;
	        }
	      }
	    }
	    this._stack = [];
	    this._seen = [];
	    this._current = null;
	    this._isModal = false;
	    if (this._initial) {
	      return this.showNext(this._initial, {
	        animate: false
	      });
	    }
	  };
	
	  FlowComponent.define("isModal", {
	    get: function() {
	      return this._isModal;
	    }
	  });
	
	  FlowComponent.define("stack", {
	    get: function() {
	      return this._stack.map(function(item) {
	        return item.layer;
	      });
	    }
	  });
	
	  FlowComponent.define("current", {
	    get: function() {
	      var ref;
	      return (ref = this._stack[this._stack.length - 1]) != null ? ref.layer : void 0;
	    }
	  });
	
	  FlowComponent.define("previous", {
	    get: function() {
	      var ref;
	      return (ref = this._stack[this._stack.length - 2]) != null ? ref.layer : void 0;
	    }
	  });
	
	  FlowComponent.define("header", {
	    get: function() {
	      return this._header;
	    },
	    set: function(layer) {
	      if (!(layer instanceof Layer)) {
	        return;
	      }
	      this._header = layer;
	      this._header.name = "header";
	      this._header.parent = this;
	      this._header.x = Align.center;
	      this._header.y = Align.top;
	      if (this.current) {
	        return this._wrapLayer(this.current);
	      }
	    }
	  });
	
	  FlowComponent.define("footer", {
	    get: function() {
	      return this._footer;
	    },
	    set: function(layer) {
	      if (!(layer instanceof Layer)) {
	        return;
	      }
	      this._footer = layer;
	      this._footer.name = "footer";
	      this._footer.parent = this;
	      this._footer.x = Align.center;
	      this._footer.y = Align.bottom;
	      if (this.current) {
	        return this._wrapLayer(this.current);
	      }
	    }
	  });
	
	  FlowComponent.prototype.transition = function(layer, transitionFunction, options) {
	    var layerA, layerB, overlay, ref, template, transition, wrappedLayer;
	    if (options == null) {
	      options = {};
	    }
	    if (!layer) {
	      throw new Error("FlowComponent.transition expects a layer");
	    }
	    if (!transitionFunction) {
	      throw new Error("FlowComponent.transition expects transitionFunction");
	    }
	    if (layer === this.current) {
	      return;
	    }
	    if ((ref = this._tempScroll) != null) {
	      ref.destroy();
	    }
	    options = _.defaults({}, options, {
	      animate: this._firstTransition === true ? true : false,
	      scroll: true,
	      modal: false
	    });
	    this._isModal = options.modal;
	    layer.visible = true;
	    layer.opacity = 1;
	    layer.ignoreEvents = false;
	    wrappedLayer = layer;
	    if (options.scroll) {
	      wrappedLayer = this._wrapLayer(layer);
	    }
	    wrappedLayer.parent = this;
	    wrappedLayer.visible = !options.animate;
	    layerA = this._wrappedLayer(this.current);
	    layerB = wrappedLayer;
	    overlay = this.overlay;
	    template = transitionFunction(this, layerA, layerB, overlay);
	    transition = this._buildTransition(template, layerA, layerB, overlay);
	    this._runTransition(transition, "forward", options.animate, this.current, layer);
	    return this._stack.push({
	      layer: layer,
	      transition: transition
	    });
	  };
	
	  FlowComponent.prototype.showNext = function(layer, options) {
	    if (options == null) {
	      options = {};
	    }
	    if (this._initial == null) {
	      this._initial = layer;
	    }
	    return this.transition(layer, Transitions.show, options);
	  };
	
	  FlowComponent.prototype.showPrevious = function(options) {
	    var count, i, n, previous, ref;
	    if (options == null) {
	      options = {};
	    }
	    if (!this.previous) {
	      return;
	    }
	    if (this.isTransitioning) {
	      return;
	    }
	    if (options instanceof Framer._Layer) {
	      options = {};
	    }
	    options = _.defaults({}, options, {
	      count: 1,
	      animate: true
	    });
	    if (options.count > 1) {
	      count = options.count;
	      for (n = i = 2, ref = count; 2 <= ref ? i <= ref : i >= ref; n = 2 <= ref ? ++i : --i) {
	        this.showPrevious({
	          animate: false,
	          count: 1
	        });
	      }
	    }
	    previous = this._stack.pop();
	    return this._runTransition(previous != null ? previous.transition : void 0, "back", options.animate, this.current, previous.layer);
	  };
	
	  FlowComponent.prototype.showOverlayCenter = function(layer, options) {
	    if (options == null) {
	      options = {};
	    }
	    return this._showOverlay(layer, Transitions.overlayCenter, options);
	  };
	
	  FlowComponent.prototype.showOverlayTop = function(layer, options) {
	    if (options == null) {
	      options = {};
	    }
	    return this._showOverlay(layer, Transitions.overlayTop, options);
	  };
	
	  FlowComponent.prototype.showOverlayRight = function(layer, options) {
	    if (options == null) {
	      options = {};
	    }
	    return this._showOverlay(layer, Transitions.overlayRight, options);
	  };
	
	  FlowComponent.prototype.showOverlayBottom = function(layer, options) {
	    if (options == null) {
	      options = {};
	    }
	    return this._showOverlay(layer, Transitions.overlayBottom, options);
	  };
	
	  FlowComponent.prototype.showOverlayLeft = function(layer, options) {
	    if (options == null) {
	      options = {};
	    }
	    return this._showOverlay(layer, Transitions.overlayLeft, options);
	  };
	
	  FlowComponent.prototype._showOverlay = function(layer, transition, options) {
	    if (options == null) {
	      options = {};
	    }
	    return this.transition(layer, transition, _.defaults({}, options, {
	      animate: true,
	      scroll: false,
	      modal: false
	    }));
	  };
	
	  FlowComponent.prototype._handleOverlayTap = function() {
	    if (!this.isModal) {
	      return this.showPrevious();
	    }
	  };
	
	  FlowComponent.prototype._wrapLayer = function(layer) {
	    var _addListener, contentInset, height, ref, ref1, ref2, ref3, scroll, width;
	    scroll = null;
	    width = this.width;
	    height = this.height;
	    if (this.header) {
	      height = -this.header.height;
	    }
	    if (this.footer) {
	      height = -this.footer.height;
	    }
	    if (layer[FlowComponentLayerScrollKey]) {
	      scroll = layer[FlowComponentLayerScrollKey];
	    } else if (layer.width === this.width && layer.height === height) {
	      return layer;
	    } else if (layer.width < this.width && layer.height < height) {
	      return layer;
	    }
	    if (layer instanceof ScrollComponent) {
	      scroll = layer;
	      if (scroll._originalContentInset == null) {
	        scroll._originalContentInset = scroll.contentInset;
	      }
	    }
	    layer.point = Utils.pointZero();
	    if (!scroll) {
	      scroll = new ScrollComponent;
	      scroll.name = "scrollComponent";
	      scroll.backgroundColor = this.backgroundColor;
	      layer[FlowComponentLayerScrollKey] = scroll;
	      layer.parent = scroll.content;
	      _addListener = layer.addListener;
	      layer.on = function() {
	        var args, event;
	        event = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	        _addListener.apply(layer, [event].concat(slice.call(args)));
	        if (event === Events.ScrollStart || event === Events.Scroll || event === Events.ScrollMove || event === Events.ScrollEnd || event === Events.ScrollAnimationDidStart || event === Events.ScrollAnimationDidEnd) {
	          return scroll.addListener.apply(scroll, [event].concat(slice.call(args)));
	        }
	      };
	    }
	    scroll.parent = this;
	    scroll.size = this.size;
	    scroll.scrollHorizontal = layer.width > width;
	    scroll.scrollVertical = layer.height > height;
	    contentInset = {
	      top: (ref = (ref1 = scroll._originalContentInset) != null ? ref1.top : void 0) != null ? ref : 0,
	      bottom: (ref2 = (ref3 = scroll._originalContentInset) != null ? ref3.bottom : void 0) != null ? ref2 : 0
	    };
	    if (this.header) {
	      contentInset.top += this.header.height;
	    }
	    if (this.footer) {
	      contentInset.bottom += this.footer.height;
	    }
	    scroll.contentInset = contentInset;
	    return scroll;
	  };
	
	  FlowComponent.prototype._wrappedLayer = function(layer) {
	    if (!layer) {
	      return null;
	    }
	    return layer[FlowComponentLayerScrollKey] || layer;
	  };
	
	  FlowComponent.prototype._runTransition = function(transition, direction, animate, from, to) {
	    var a, b;
	    if (direction === "forward") {
	      a = from;
	      b = to;
	    } else {
	      a = to;
	      b = from;
	    }
	    this.emit(Events.TransitionStart, a, b, direction);
	    return Utils.delay(0, (function(_this) {
	      return function() {
	        _this._firstTransition = true;
	        return transition[direction](animate);
	      };
	    })(this));
	  };
	
	  FlowComponent.prototype._buildTransition = function(template, layerA, layerB, overlay) {
	    var transition;
	    transition = {};
	    transition.forward = (function(_this) {
	      return function(animate, callback) {
	        var animations, forwardEvents, group, options;
	        if (animate == null) {
	          animate = true;
	        }
	        forwardEvents = function(group, direction) {
	          group.once(Events.AnimationHalt, function() {
	            return _this.emit(Events.TransitionHalt, layerA, layerB, direction);
	          });
	          group.once(Events.AnimationStop, function() {
	            return _this.emit(Events.TransitionStop, layerA, layerB, direction);
	          });
	          return group.once(Events.AnimationEnd, function() {
	            return _this.emit(Events.TransitionEnd, layerA, layerB, direction);
	          });
	        };
	        animations = [];
	        options = {
	          instant: !animate
	        };
	        if (layerA && template.layerA) {
	          layerA.visible = true;
	          animations.push(new Animation(layerA, template.layerA.hide, options));
	        }
	        if (layerB && template.layerB) {
	          layerB.props = template.layerB.hide;
	          layerB.bringToFront();
	          layerB.visible = true;
	          animations.push(new Animation(layerB, template.layerB.show, options));
	        }
	        if (overlay && template.overlay) {
	          overlay.visible = true;
	          overlay.ignoreEvents = false;
	          overlay.placeBehind(layerB);
	          overlay.props = template.overlay.hide;
	          animations.push(new Animation(overlay, template.overlay.show, options));
	        }
	        if (overlay && template.overlay) {
	          if (_this.header) {
	            _this.header.placeBehind(overlay);
	          }
	          if (_this.footer) {
	            _this.footer.placeBehind(overlay);
	          }
	        } else {
	          if (_this.header) {
	            _this.header.bringToFront();
	          }
	          if (_this.footer) {
	            _this.footer.bringToFront();
	          }
	        }
	        group = new AnimationGroup(animations);
	        forwardEvents(group, "forward");
	        group.once(Events.AnimationEnd, function() {
	          if (layerA && template.layerA && !(overlay && template.overlay)) {
	            return layerA.visible = false;
	          }
	        });
	        return group.start();
	      };
	    })(this);
	    transition.back = (function(_this) {
	      return function(animate, callback) {
	        var animations, forwardEvents, group, options;
	        if (animate == null) {
	          animate = true;
	        }
	        forwardEvents = function(group, direction) {
	          group.once(Events.AnimationHalt, function() {
	            return _this.emit(Events.TransitionHalt, layerB, layerA, direction);
	          });
	          group.once(Events.AnimationStop, function() {
	            return _this.emit(Events.TransitionStop, layerB, layerA, direction);
	          });
	          return group.once(Events.AnimationEnd, function() {
	            return _this.emit(Events.TransitionEnd, layerB, layerA, direction);
	          });
	        };
	        animations = [];
	        options = {
	          instant: !animate
	        };
	        if (overlay && template.overlay) {
	          overlay.visible = true;
	          overlay.ignoreEvents = true;
	          animations.push(new Animation(overlay, template.overlay.hide, options));
	        }
	        if (layerA && template.layerA) {
	          layerA.visible = true;
	          animations.push(new Animation(layerA, template.layerA.show, options));
	        }
	        if (layerB && template.layerB) {
	          layerB.visible = true;
	          animations.push(new Animation(layerB, template.layerB.hide, options));
	        }
	        group = new AnimationGroup(animations);
	        group.stopAnimations = false;
	        forwardEvents(group, "back");
	        group.once(Events.AnimationEnd, function() {
	          if (layerB && template.layerB) {
	            return layerB.visible = false;
	          }
	        });
	        return group.start();
	      };
	    })(this);
	    return transition;
	  };
	
	  FlowComponent.prototype.onTransitionStart = function(cb) {
	    return this.on(Events.TransitionStart, cb);
	  };
	
	  FlowComponent.prototype.onTransitionHalt = function(cb) {
	    return this.on(Events.TransitionHalt, cb);
	  };
	
	  FlowComponent.prototype.onTransitionStop = function(cb) {
	    return this.on(Events.TransitionStop, cb);
	  };
	
	  FlowComponent.prototype.onTransitionEnd = function(cb) {
	    return this.on(Events.TransitionEnd, cb);
	  };
	
	  FlowComponent.prototype.onStart = function(cb) {
	    return this.onTransitionStart(cb);
	  };
	
	  FlowComponent.prototype.onHalt = function(cb) {
	    return this.onTransitionHalt(cb);
	  };
	
	  FlowComponent.prototype.onStop = function(cb) {
	    return this.onTransitionStop(cb);
	  };
	
	  FlowComponent.prototype.onEnd = function(cb) {
	    return this.onTransitionEnd(cb);
	  };
	
	  return FlowComponent;
	
	})(Layer);
	
	Transitions = {};
	
	Transitions.show = function(nav, layerA, layerB, overlay) {
	  var options, transition;
	  options = {
	    curve: "spring(300, 35, 0)"
	  };
	  return transition = {
	    layerA: {
	      show: {
	        options: options,
	        x: 0,
	        y: 0
	      },
	      hide: {
	        options: options,
	        x: 0 - (layerA != null ? layerA.width : void 0) / 2,
	        y: 0
	      }
	    },
	    layerB: {
	      show: {
	        options: options,
	        x: 0,
	        y: 0
	      },
	      hide: {
	        options: options,
	        x: layerB.width,
	        y: 0
	      }
	    }
	  };
	};
	
	Transitions.overlayCenter = function(nav, layerA, layerB, overlay) {
	  var transition;
	  return transition = {
	    layerB: {
	      show: {
	        options: {
	          curve: "spring(500, 35, 0)"
	        },
	        x: Align.center,
	        y: Align.center,
	        scale: 1.0,
	        opacity: 1
	      },
	      hide: {
	        options: {
	          curve: "spring(500, 35, 0)"
	        },
	        x: Align.center,
	        y: Align.center,
	        scale: 0.5,
	        opacity: 0
	      }
	    },
	    overlay: {
	      show: {
	        options: {
	          time: 0.1
	        },
	        opacity: .5,
	        x: 0,
	        y: 0,
	        size: nav.size
	      },
	      hide: {
	        options: {
	          time: 0.1
	        },
	        opacity: 0,
	        x: 0,
	        y: 0,
	        size: nav.size
	      }
	    }
	  };
	};
	
	Transitions.overlayLeft = function(nav, layerA, layerB, overlay) {
	  var transition;
	  return transition = {
	    layerB: {
	      show: {
	        options: {
	          curve: "spring(300, 35, 0)"
	        },
	        y: 0,
	        x: 0
	      },
	      hide: {
	        options: {
	          curve: "spring(300, 35, 0)"
	        },
	        y: 0,
	        x: 0 - (layerB != null ? layerB.width : void 0)
	      }
	    },
	    overlay: {
	      show: {
	        options: {
	          time: 0.1
	        },
	        opacity: .5,
	        x: 0,
	        y: 0,
	        size: nav.size
	      },
	      hide: {
	        options: {
	          time: 0.1
	        },
	        opacity: 0,
	        x: 0,
	        y: 0,
	        size: nav.size
	      }
	    }
	  };
	};
	
	Transitions.overlayRight = function(nav, layerA, layerB, overlay) {
	  var transition;
	  return transition = {
	    layerB: {
	      show: {
	        options: {
	          curve: "spring(300, 35, 0)"
	        },
	        y: 0,
	        x: (nav != null ? nav.width : void 0) - (layerB != null ? layerB.width : void 0)
	      },
	      hide: {
	        options: {
	          curve: "spring(300, 35, 0)"
	        },
	        y: 0,
	        x: nav != null ? nav.width : void 0
	      }
	    },
	    overlay: {
	      show: {
	        options: {
	          time: 0.1
	        },
	        opacity: .5,
	        x: 0,
	        y: 0,
	        size: nav.size
	      },
	      hide: {
	        options: {
	          time: 0.1
	        },
	        opacity: 0,
	        x: 0,
	        y: 0,
	        size: nav.size
	      }
	    }
	  };
	};
	
	Transitions.overlayTop = function(nav, layerA, layerB, overlay) {
	  var transition;
	  return transition = {
	    layerB: {
	      show: {
	        options: {
	          curve: "spring(300, 35, 0)"
	        },
	        x: Align.center,
	        y: 0
	      },
	      hide: {
	        options: {
	          curve: "spring(300, 35, 0)"
	        },
	        x: Align.center,
	        maxY: 0
	      }
	    },
	    overlay: {
	      show: {
	        options: {
	          time: 0.1
	        },
	        opacity: .5,
	        x: 0,
	        y: 0,
	        size: nav.size
	      },
	      hide: {
	        options: {
	          time: 0.1
	        },
	        opacity: 0,
	        x: 0,
	        y: 0,
	        size: nav.size
	      }
	    }
	  };
	};
	
	Transitions.overlayBottom = function(nav, layerA, layerB, overlay) {
	  var transition;
	  return transition = {
	    layerB: {
	      show: {
	        options: {
	          curve: "spring(300, 35, 0)"
	        },
	        x: Align.center,
	        y: (nav != null ? nav.height : void 0) - (layerB != null ? layerB.height : void 0)
	      },
	      hide: {
	        options: {
	          curve: "spring(300, 35, 0)"
	        },
	        x: Align.center,
	        y: nav != null ? nav.height : void 0
	      }
	    },
	    overlay: {
	      show: {
	        options: {
	          time: 0.1
	        },
	        opacity: .5,
	        x: 0,
	        y: 0,
	        size: nav.size
	      },
	      hide: {
	        options: {
	          time: 0.1
	        },
	        opacity: 0,
	        x: 0,
	        y: 0,
	        size: nav.size
	      }
	    }
	  };
	};


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var SVGLayer,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	SVGLayer = __webpack_require__(39).SVGLayer;
	
	exports.CircularProgressComponent = (function(superClass) {
	  extend(CircularProgressComponent, superClass);
	
	  function CircularProgressComponent(options) {
	    if (options == null) {
	      options = {};
	    }
	    CircularProgressComponent.__super__.constructor.apply(this, arguments);
	    this.backgroundColor = null;
	    this.rotation = -90;
	    this.rails = this.addShape("circle");
	    this.rails.setAttribute("fill", "transparent");
	    this.circle = this.addShape("circle");
	    this.circle.setAttribute("fill", "transparent");
	    this.strokeWidth = 1;
	    this.progress = 0;
	    this.railsColor = Color.grey(.2);
	    this.progressColor = Color.grey(1);
	    this.svg.appendChild(this.rails);
	    this.svg.appendChild(this.circle);
	    this._element.appendChild(this.svg);
	  }
	
	  CircularProgressComponent.define("radius", {
	    get: function() {
	      return this.width / 2 - this.strokeWidth / 2;
	    }
	  });
	
	  CircularProgressComponent.define("strokeWidth", {
	    get: function() {
	      return this._strokeWidth || 1;
	    },
	    set: function(value) {
	      this._strokeWidth = value;
	      this.rails.cx.baseVal.value = this.width / 2;
	      this.rails.cy.baseVal.value = this.width / 2;
	      this.rails.r.baseVal.value = this.radius;
	      this.rails.setAttribute("stroke-width", value);
	      this.circle.cx.baseVal.value = this.width / 2;
	      this.circle.cy.baseVal.value = this.width / 2;
	      this.circle.r.baseVal.value = this.radius;
	      return this.circle.setAttribute("stroke-width", value);
	    }
	  });
	
	  CircularProgressComponent.define("progressColor", {
	    get: function() {
	      return this._progressColor || Color.grey(1);
	    },
	    set: function(value) {
	      return this.circle.setAttribute("stroke", value);
	    }
	  });
	
	  CircularProgressComponent.define("railsColor", {
	    get: function() {
	      return this._progressColor || Color.grey(.1);
	    },
	    set: function(value) {
	      return this.rails.setAttribute("stroke", value);
	    }
	  });
	
	  CircularProgressComponent.define("progress", {
	    get: function() {
	      return this._progress || 0;
	    },
	    set: function(value) {
	      var strokeDashArray, strokeDashOffset;
	      this._progress = Utils.clamp(value, 0, 1);
	      strokeDashArray = this.radius * Math.PI * 2;
	      strokeDashOffset = (1 - this.progress) * strokeDashArray;
	      this.circle.setAttribute("stroke-dasharray", strokeDashArray);
	      return this.circle.setAttribute("stroke-dashoffset", strokeDashOffset);
	    }
	  });
	
	  CircularProgressComponent.prototype.setProgress = function(value, animated, animationOptions) {
	    var animationProperties, dynamicTime;
	    if (animated == null) {
	      animated = true;
	    }
	    if (animationOptions == null) {
	      animationOptions = {};
	    }
	    if (!animated) {
	      return this.progress = value;
	    }
	    dynamicTime = Math.abs(this.progress - value) * 0.3;
	    animationOptions = _.defaults(animationOptions, {
	      curve: "linear",
	      time: dynamicTime
	    });
	    animationProperties = {
	      progress: Utils.clamp(value, 0, 1)
	    };
	    return this.animate(animationProperties, animationOptions);
	  };
	
	  return CircularProgressComponent;
	
	})(SVGLayer);


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass, Events, MIDIComponent, MIDIInput, _,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	_ = __webpack_require__(1)._;
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	Events = __webpack_require__(15).Events;
	
	MIDIInput = __webpack_require__(53).MIDIInput;
	
	Events.MIDIComponentValueChange = "MIDIComponentValueChange";
	
	MIDIComponent = (function(superClass) {
	  extend(MIDIComponent, superClass);
	
	  MIDIComponent.define("min", MIDIComponent.simpleProperty("min", 0));
	
	  MIDIComponent.define("max", MIDIComponent.simpleProperty("max", 127));
	
	  MIDIComponent.define("control", MIDIComponent.simpleProperty("control", null));
	
	  MIDIComponent.define("channel", MIDIComponent.simpleProperty("channel", null));
	
	  MIDIComponent.define("source", MIDIComponent.simpleProperty("source", null));
	
	  function MIDIComponent(options) {
	    if (options == null) {
	      options = {};
	    }
	    MIDIComponent.__super__.constructor.call(this, options);
	    MIDIInput.enabled = true;
	    MIDIInput.onCommand((function(_this) {
	      return function(source, timeStamp, data) {
	        var b1, b2, b3, channel, command, data1, data2, info;
	        b1 = data[0], b2 = data[1], b3 = data[2];
	        command = b1 & 0xf0;
	        channel = (b1 & 0x0f) + 1;
	        data1 = b2 & 0x7f;
	        data2 = b3 & 0x7f;
	        if (command !== 0xb0 && command !== 0x90 && command !== 0x80) {
	          return;
	        }
	        if ((_this.source != null) && _this.source !== source) {
	          return;
	        }
	        if ((_this.channel != null) && _this.channel !== channel) {
	          return;
	        }
	        if ((_this.control != null) && _this.control !== data1) {
	          return;
	        }
	        info = {
	          source: source,
	          channel: channel,
	          control: data1
	        };
	        if (command === 0x90 || command === 0x80) {
	          info = _.defaults(info, {
	            type: "note"
	          });
	        }
	        return _this.emit(Events.MIDIComponentValueChange, _this._modulate(data2), info);
	      };
	    })(this));
	  }
	
	  MIDIComponent.prototype._modulate = function(value) {
	    return Utils.modulate(value, [0, 127], [this.min, this.max]);
	  };
	
	  MIDIComponent.prototype.onValueChange = function(cb) {
	    return this.on(Events.MIDIComponentValueChange, cb);
	  };
	
	  return MIDIComponent;
	
	})(BaseClass);
	
	exports.MIDIComponent = MIDIComponent;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass, Events, MIDIInput,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	Events = __webpack_require__(15).Events;
	
	Events.MIDICommand = "midiCommand";
	
	MIDIInput = (function(superClass) {
	  extend(MIDIInput, superClass);
	
	  function MIDIInput() {
	    this._onmidimessage = bind(this._onmidimessage, this);
	    this._requestResolved = bind(this._requestResolved, this);
	    return MIDIInput.__super__.constructor.apply(this, arguments);
	  }
	
	  MIDIInput.define("enabled", {
	    get: function() {
	      var ref;
	      return ((ref = this._inputs) != null ? ref.length : void 0) || this._request;
	    },
	    set: function(value) {
	      var ref;
	      if (value === this.enabled) {
	        return;
	      }
	      if (!navigator.requestMIDIAccess) {
	        return this._requestRejected();
	      }
	      if (value) {
	        return this._request = navigator.requestMIDIAccess().then(this._requestResolved, this._requestRejected);
	      } else {
	        if ((ref = this._inputs) != null) {
	          ref.map(close);
	        }
	        this._request = null;
	        return this._inputs = [];
	      }
	    }
	  });
	
	  MIDIInput.prototype._requestResolved = function(access) {
	    if (this._inputs == null) {
	      this._inputs = [];
	    }
	    return access.inputs.forEach((function(_this) {
	      return function(input) {
	        _this._inputs.push(input);
	        return input.onmidimessage = _this._onmidimessage(input.id);
	      };
	    })(this));
	  };
	
	  MIDIInput.prototype._requestRejected = function(error) {
	    throw Error("Requesting MIDI access failed: " + (error != null ? error : "not supported by browser"));
	  };
	
	  MIDIInput.prototype._onmidimessage = function(sourceID) {
	    return (function(_this) {
	      return function(message) {
	        return _this.emit(Events.MIDICommand, sourceID, message.timeStamp, message.data);
	      };
	    })(this);
	  };
	
	  MIDIInput.prototype.onCommand = function(cb) {
	    return this.on(Events.MIDICommand, cb);
	  };
	
	  return MIDIInput;
	
	})(BaseClass);
	
	exports.MIDIInput = new MIDIInput;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var Config, EventEmitter, Utils, _, getTime,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	_ = __webpack_require__(1)._;
	
	Utils = __webpack_require__(4);
	
	Config = __webpack_require__(14).Config;
	
	EventEmitter = __webpack_require__(7).EventEmitter;
	
	getTime = function() {
	  return Utils.getTime() * 1000;
	};
	
	exports.AnimationLoop = (function(superClass) {
	  extend(AnimationLoop, superClass);
	
	  function AnimationLoop() {
	    this.start = bind(this.start, this);
	    this.delta = 1 / 60;
	    this.raf = true;
	    if (Utils.webkitVersion() > 600 && Utils.webkitVersion() < 601) {
	      if (Utils.isFramerStudio() || Utils.isDesktop()) {
	        this.raf = false;
	      }
	    }
	    this.maximumListeners = 2e308;
	  }
	
	  AnimationLoop.prototype.start = function() {
	    var _timestamp, animationLoop, tick, update;
	    animationLoop = this;
	    _timestamp = getTime();
	    update = function() {
	      var delta, timestamp;
	      if (animationLoop.delta) {
	        delta = animationLoop.delta;
	      } else {
	        timestamp = getTime();
	        delta = (timestamp - _timestamp) / 1000;
	        _timestamp = timestamp;
	      }
	      animationLoop.emit("update", delta);
	      return animationLoop.emit("render", delta);
	    };
	    tick = function(timestamp) {
	      if (animationLoop.raf) {
	        window.requestAnimationFrame(tick);
	        return update();
	      } else {
	        return window.setTimeout(function() {
	          window.requestAnimationFrame(tick);
	          return update();
	        }, 0);
	      }
	    };
	    return tick();
	  };
	
	  return AnimationLoop;
	
	})(EventEmitter);


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var Animator,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	Animator = __webpack_require__(19).Animator;
	
	exports.SpringDHOAnimator = (function(superClass) {
	  extend(SpringDHOAnimator, superClass);
	
	  function SpringDHOAnimator() {
	    this.finished = bind(this.finished, this);
	    return SpringDHOAnimator.__super__.constructor.apply(this, arguments);
	  }
	
	  SpringDHOAnimator.prototype.setup = function(options) {
	    this.options = _.defaults(options, {
	      velocity: 0,
	      tolerance: 1 / 10000,
	      stiffness: 50,
	      damping: 2,
	      mass: 0.2,
	      time: null
	    });
	    this._time = 0;
	    this._value = 0;
	    return this._velocity = this.options.velocity;
	  };
	
	  SpringDHOAnimator.prototype.next = function(delta) {
	    var F_damper, F_spring, b, k;
	    if (this.finished()) {
	      return 1;
	    }
	    this._time += delta;
	    k = 0 - this.options.stiffness;
	    b = 0 - this.options.damping;
	    F_spring = k * (this._value - 1);
	    F_damper = b * this._velocity;
	    this._velocity += ((F_spring + F_damper) / this.options.mass) * delta;
	    this._value += this._velocity * delta;
	    return this._value;
	  };
	
	  SpringDHOAnimator.prototype.finished = function() {
	    return this._time > 0 && Math.abs(this._velocity) < this.options.tolerance;
	  };
	
	  return SpringDHOAnimator;
	
	})(Animator);


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var ChromeAlert, Utils, _, getScaleFromName, resizeFrame, sanitizeLayerName, startsWithNumber;
	
	_ = __webpack_require__(1)._;
	
	Utils = __webpack_require__(4);
	
	ChromeAlert = "Importing layers is currently only supported on Safari. If you really want it to work with Chrome quit it, open a terminal and run:\nopen -a Google\ Chrome -–allow-file-access-from-files";
	
	resizeFrame = function(scale, frame) {
	  var i, key, len, ref, result;
	  if (scale === 1) {
	    return frame;
	  }
	  result = {};
	  ref = ["x", "y", "width", "height"];
	  for (i = 0, len = ref.length; i < len; i++) {
	    key = ref[i];
	    if (frame.hasOwnProperty(key)) {
	      result[key] = frame[key] * scale;
	    }
	  }
	  return result;
	};
	
	getScaleFromName = function(str) {
	  var m, re;
	  re = /@([\d]+|[\d]+.[\d]+)x/;
	  m = void 0;
	  if ((m = re.exec(str)) !== null) {
	    if (m[1]) {
	      return parseFloat(m[1]);
	    }
	  }
	  return null;
	};
	
	startsWithNumber = function(str) {
	  return (new RegExp("^[0-9]")).test(str);
	};
	
	sanitizeLayerName = function(name) {
	  var i, len, ref, suffix;
	  ref = ["*", "-", ".png", ".jpg", ".pdf"];
	  for (i = 0, len = ref.length; i < len; i++) {
	    suffix = ref[i];
	    if (_.endsWith(name.toLowerCase(), suffix)) {
	      name = name.slice(0, +(name.length - suffix.length - 1) + 1 || 9e9);
	    }
	  }
	  return name;
	};
	
	exports.Importer = (function() {
	  function Importer(path1, scale1, extraLayerProperties) {
	    this.path = path1;
	    this.scale = scale1 != null ? scale1 : 1;
	    this.extraLayerProperties = extraLayerProperties != null ? extraLayerProperties : {};
	    this.paths = {
	      layerInfo: Utils.pathJoin(this.path, "layers.json"),
	      images: Utils.pathJoin(this.path, "images"),
	      documentName: this.path.split("/").pop()
	    };
	    this._createdLayers = [];
	    this._createdLayersByName = {};
	  }
	
	  Importer.prototype.load = function() {
	    var i, j, layer, layerInfo, layersByName, len, len1, ref, ref1;
	    layersByName = {};
	    layerInfo = this._loadlayerInfo();
	    if (layerInfo.length === 0) {
	      throw new Error("Importer: no layers. Do you have at least one layer group?");
	    }
	    layerInfo.map((function(_this) {
	      return function(layerItemInfo) {
	        return _this._createLayer(layerItemInfo);
	      };
	    })(this));
	    ref = this._createdLayers;
	    for (i = 0, len = ref.length; i < len; i++) {
	      layer = ref[i];
	      this._correctLayer(layer);
	    }
	    this._correctArtboards(this._createdLayers);
	    ref1 = this._createdLayers;
	    for (j = 0, len1 = ref1.length; j < len1; j++) {
	      layer = ref1[j];
	      if (!layer.parent) {
	        layer.parent = null;
	      }
	    }
	    return this._createdLayersByName;
	  };
	
	  Importer.prototype._loadlayerInfo = function() {
	    var importedKey, ref;
	    importedKey = this.paths.documentName + "/layers.json.js";
	    if ((ref = window.__imported__) != null ? ref.hasOwnProperty(importedKey) : void 0) {
	      return _.cloneDeep(window.__imported__[importedKey]);
	    }
	    return Framer.Utils.domLoadJSONSync(this.paths.layerInfo);
	  };
	
	  Importer.prototype._createLayer = function(info, parent) {
	    var LayerClass, layer, layerInfo, ref, ref1;
	    if (info.layerFrame) {
	      info.layerFrame = resizeFrame(this.scale, info.layerFrame);
	    }
	    if (info.maskFrame) {
	      info.maskFrame = resizeFrame(this.scale, info.maskFrame);
	    }
	    if (((ref = info.image) != null ? ref.frame : void 0) != null) {
	      info.image.frame = resizeFrame(this.scale, info.image.frame);
	    }
	    if (!info.children) {
	      info.children = [];
	    }
	    LayerClass = Layer;
	    layerInfo = {
	      shadow: true,
	      name: sanitizeLayerName(info.name),
	      frame: info.layerFrame,
	      clip: false,
	      backgroundColor: null,
	      visible: (ref1 = info.visible) != null ? ref1 : true
	    };
	    _.extend(layerInfo, this.extraLayerProperties);
	    if (info.image) {
	      layerInfo.frame = info.image.frame;
	      layerInfo.image = Utils.pathJoin(this.path, info.image.path);
	    }
	    if (info.maskFrame) {
	      layerInfo.clip = true;
	    }
	    if (info.kind === "artboard") {
	      layerInfo.backgroundColor = info.backgroundColor;
	    }
	    if (parent != null ? parent.contentLayer : void 0) {
	      layerInfo.parent = parent.contentLayer;
	    } else if (parent) {
	      layerInfo.parent = parent;
	    }
	    if (startsWithNumber(layerInfo.name)) {
	      throw new Error("Layer or Artboard names can not start with a number: '" + layerInfo.name + "'");
	    }
	    layer = new LayerClass(layerInfo);
	    layer.name = layerInfo.name;
	    layer.__framerImportedFromPath = this.path;
	    if (layerInfo.name.toLowerCase().indexOf("scroll") !== -1) {
	      layer.scroll = true;
	    }
	    if (layerInfo.name.toLowerCase().indexOf("draggable") !== -1) {
	      layer.draggable.enabled = true;
	    }
	    if (!layer.image && !info.children.length && !info.maskFrame) {
	      layer.frame = Utils.frameZero();
	    }
	    _.clone(info.children).reverse().map((function(_this) {
	      return function(info) {
	        return _this._createLayer(info, layer);
	      };
	    })(this));
	    if (info.kind === "artboard") {
	      layer.point = {
	        x: 0,
	        y: 0
	      };
	    } else if (!layer.image && !info.maskFrame) {
	      layer.frame = layer.contentFrame();
	    }
	    layer._info = info;
	    this._createdLayers.push(layer);
	    return this._createdLayersByName[layer.name] = layer;
	  };
	
	  Importer.prototype._correctArtboards = function(layers) {
	    var i, j, layer, leftMostLayer, len, len1, pointOffset, results;
	    leftMostLayer = null;
	    for (i = 0, len = layers.length; i < len; i++) {
	      layer = layers[i];
	      if (layer._info.kind === "artboard") {
	        layer.point = layer._info.layerFrame;
	        layer.visible = true;
	        if (leftMostLayer === null || layer.x < leftMostLayer.x) {
	          leftMostLayer = layer;
	        }
	      }
	    }
	    if (!leftMostLayer) {
	      return;
	    }
	    pointOffset = leftMostLayer.point;
	    results = [];
	    for (j = 0, len1 = layers.length; j < len1; j++) {
	      layer = layers[j];
	      if (layer._info.kind === "artboard") {
	        layer.x -= pointOffset.x;
	        results.push(layer.y -= pointOffset.y);
	      } else {
	        results.push(void 0);
	      }
	    }
	    return results;
	  };
	
	  Importer.prototype._correctLayer = function(layer) {
	    var traverse;
	    traverse = function(layer) {
	      var child, i, len, ref, results;
	      if (layer.parent) {
	        layer.frame = Utils.convertPoint(layer.frame, null, layer.parent);
	      }
	      ref = layer.children;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        child = ref[i];
	        results.push(traverse(child));
	      }
	      return results;
	    };
	    if (!layer.parent) {
	      return traverse(layer);
	    }
	  };
	
	  return Importer;
	
	})();
	
	exports.Importer.load = function(path, scale) {
	  var importer;
	  if (scale == null) {
	    scale = getScaleFromName(path);
	  }
	  if (scale == null) {
	    scale = 1;
	  }
	  importer = new exports.Importer(path, scale);
	  return importer.load();
	};


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	exports.TouchEmulator = __webpack_require__(58);
	
	exports.MobileScrollFix = __webpack_require__(59);
	
	exports.ErrorDisplay = __webpack_require__(60);
	
	exports.OmitNew = __webpack_require__(61);
	
	exports.Hints = __webpack_require__(62);
	
	exports.Preloader = __webpack_require__(63);
	
	exports.ShareInfo = __webpack_require__(64);


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass, TouchEmulator, Utils, cancelEvent, createTouch, dispatchTouchEvent, touchEmulator,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	Utils = __webpack_require__(4);
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	createTouch = function(event, identifier, offset) {
	  var touch;
	  if (offset == null) {
	    offset = {
	      x: 0,
	      y: 0
	    };
	  }
	  return touch = {
	    identifier: identifier,
	    target: event.target,
	    pageX: event.pageX - offset.x,
	    pageY: event.pageY - offset.y,
	    clientX: event.clientX - offset.x,
	    clientY: event.clientY - offset.y,
	    screenX: event.screenX - offset.x,
	    screenY: event.screenY - offset.y
	  };
	};
	
	dispatchTouchEvent = function(type, target, event, offset) {
	  var touchEvent, touches;
	  if (target == null) {
	    target = event.target;
	  }
	  touchEvent = document.createEvent("MouseEvent");
	  touchEvent.initMouseEvent(type, true, true, window, event.detail, event.screenX, event.screenY, event.clientX, event.clientY, event.ctrlKey, event.shiftKey, event.altKey, event.metaKey, event.button, event.relatedTarget);
	  touches = [];
	  touches.push(createTouch(event, 1));
	  if (offset) {
	    touches.push(createTouch(event, 2, offset));
	  }
	  touchEvent.touches = touchEvent.changedTouches = touchEvent.targetTouches = touches;
	  return target.dispatchEvent(touchEvent);
	};
	
	cancelEvent = function(event) {
	  event.preventDefault();
	  return event.stopPropagation();
	};
	
	TouchEmulator = (function(superClass) {
	  extend(TouchEmulator, superClass);
	
	  function TouchEmulator() {
	    this.mousemovePosition = bind(this.mousemovePosition, this);
	    this.mouseout = bind(this.mouseout, this);
	    this.mouseup = bind(this.mouseup, this);
	    this.mousemove = bind(this.mousemove, this);
	    this.mousedown = bind(this.mousedown, this);
	    this.keyup = bind(this.keyup, this);
	    this.keydown = bind(this.keydown, this);
	    var touchPointerInitialOffset;
	    this.touchPointerImage = "url('framer/images/cursor@2x.png')";
	    this.touchPointerImageActive = "url('framer/images/cursor-active@2x.png')";
	    this.touchPointerImageSize = 64;
	    this.touchPointerInitialOffset = {
	      x: 0,
	      y: 0
	    };
	    this.keyPinchCode = 18;
	    this.keyPanCode = 91;
	    this.context = new Framer.Context({
	      name: "TouchEmulator"
	    });
	    this.context._element.style.zIndex = 10000;
	    this.wrap = this.context.domEventManager.wrap;
	    this.wrap(document).addEventListener("mousedown", this.mousedown, true);
	    this.wrap(document).addEventListener("mousemove", this.mousemove, true);
	    this.wrap(document).addEventListener("mouseup", this.mouseup, true);
	    this.wrap(document).addEventListener("keydown", this.keydown, true);
	    this.wrap(document).addEventListener("keyup", this.keyup, true);
	    this.wrap(document).addEventListener("mouseout", this.mouseout, true);
	    this.isMouseDown = false;
	    this.isPinchKeyDown = false;
	    this.isPanKeyDown = false;
	    touchPointerInitialOffset = this.touchPointerInitialOffset;
	    this.context.run((function(_this) {
	      return function() {
	        _this.touchPointLayer = new Layer({
	          width: _this.touchPointerImageSize,
	          height: _this.touchPointerImageSize,
	          backgroundColor: null,
	          opacity: 0
	        });
	        return _this.touchPointLayer.style.backgroundImage = _this.touchPointerImage;
	      };
	    })(this));
	  }
	
	  TouchEmulator.prototype.destroy = function() {
	    this.context.reset();
	    return this.context = null;
	  };
	
	  TouchEmulator.prototype.keydown = function(event) {
	    if (event.keyCode === this.keyPinchCode) {
	      this.isPinchKeyDown = true;
	      this.startPoint = this.centerPoint = null;
	      this.showTouchCursor();
	      this.touchPointLayer.midX = this.point.x;
	      this.touchPointLayer.midY = this.point.y;
	    }
	    if (event.keyCode === this.keyPanCode) {
	      this.isPanKeyDown = true;
	      return cancelEvent(event);
	    }
	  };
	
	  TouchEmulator.prototype.keyup = function(event) {
	    if (event.keyCode === this.keyPinchCode) {
	      cancelEvent(event);
	      this.isPinchKeyDown = false;
	      this.hideTouchCursor();
	    }
	    if (event.keyCode === this.keyPanCode) {
	      cancelEvent(event);
	      if (this.touchPoint && this.point) {
	        this.centerPoint = Utils.pointCenter(this.touchPoint, this.point);
	        return this.isPanKeyDown = false;
	      }
	    }
	  };
	
	  TouchEmulator.prototype.mousedown = function(event) {
	    this.isMouseDown = true;
	    this.target = event.target;
	    if (this.isPinchKeyDown) {
	      dispatchTouchEvent("touchstart", this.target, event, this.touchPointDelta);
	    } else {
	      dispatchTouchEvent("touchstart", this.target, event);
	    }
	    return this.touchPointLayer.style.backgroundImage = this.touchPointerImageActive;
	  };
	
	  TouchEmulator.prototype.mousemove = function(event) {
	    this.point = {
	      x: event.pageX,
	      y: event.pageY
	    };
	    if (this.startPoint == null) {
	      this.startPoint = this.point;
	    }
	    if (this.centerPoint == null) {
	      this.centerPoint = this.point;
	    }
	    if (this.isPinchKeyDown && !this.isPanKeyDown) {
	      if (this.touchPointerInitialOffset && this.centerPoint) {
	        this.touchPoint = Utils.pointAdd(this.touchPointerInitialOffset, this.pinchPoint(this.point, this.centerPoint));
	        this.touchPointDelta = Utils.pointSubtract(this.point, this.touchPoint);
	      }
	    }
	    if (this.isPinchKeyDown && this.isPanKeyDown) {
	      if (this.touchPoint && this.touchPointDelta) {
	        this.touchPoint = this.panPoint(this.point, this.touchPointDelta);
	      }
	    }
	    if (this.isPinchKeyDown || this.isPanKeyDown) {
	      if (this.touchPoint) {
	        this.touchPointLayer.visible = true;
	        this.touchPointLayer.midX = this.touchPoint.x;
	        this.touchPointLayer.midY = this.touchPoint.y;
	      }
	    }
	    if (this.isMouseDown) {
	      if ((this.isPinchKeyDown || this.isPanKeyDown) && this.touchPointDelta) {
	        return dispatchTouchEvent("touchmove", this.target, event, this.touchPointDelta);
	      } else {
	        return dispatchTouchEvent("touchmove", this.target, event);
	      }
	    }
	  };
	
	  TouchEmulator.prototype.mouseup = function(event) {
	    if (this.isPinchKeyDown || this.isPanKeyDown) {
	      dispatchTouchEvent("touchend", this.target, event, this.touchPointDelta);
	    } else {
	      dispatchTouchEvent("touchend", this.target, event);
	    }
	    return this.endMultiTouch();
	  };
	
	  TouchEmulator.prototype.mouseout = function(event) {
	    var fromElement;
	    if (this.isMouseDown) {
	      return;
	    }
	    fromElement = event.relatedTarget || event.toElement;
	    if (!fromElement || fromElement.nodeName === "HTML") {
	      return this.endMultiTouch();
	    }
	  };
	
	  TouchEmulator.prototype.showTouchCursor = function() {
	    if (!this.point) {
	      this.point = {
	        x: event.pageX,
	        y: event.pageY
	      };
	    }
	    this.touchPointLayer.animateStop();
	    this.touchPointLayer.midX = this.point.x;
	    this.touchPointLayer.midY = this.point.y;
	    this.touchPointLayer.scale = 1.8;
	    return this.touchPointLayer.animate({
	      opacity: 1,
	      scale: 1,
	      options: {
	        time: 0.1,
	        curve: "ease-out"
	      }
	    });
	  };
	
	  TouchEmulator.prototype.hideTouchCursor = function() {
	    if (!(this.touchPointLayer.opacity > 0)) {
	      return;
	    }
	    this.touchPointLayer.animateStop();
	    return this.touchPointLayer.animate({
	      opacity: 0,
	      scale: 1.2,
	      options: {
	        time: 0.08
	      }
	    });
	  };
	
	  TouchEmulator.prototype.mousemovePosition = function(event) {
	    return this.point = {
	      x: event.pageX,
	      y: event.pageY
	    };
	  };
	
	  TouchEmulator.prototype.endMultiTouch = function() {
	    this.isMouseDown = false;
	    this.touchPointLayer.style.backgroundImage = this.touchPointerImage;
	    return this.hideTouchCursor();
	  };
	
	  TouchEmulator.prototype.pinchPoint = function(point, centerPoint) {
	    return Utils.pointSubtract(centerPoint, Utils.pointSubtract(point, centerPoint));
	  };
	
	  TouchEmulator.prototype.panPoint = function(point, offsetPoint) {
	    return Utils.pointSubtract(point, offsetPoint);
	  };
	
	  return TouchEmulator;
	
	})(BaseClass);
	
	touchEmulator = null;
	
	exports.enable = function() {
	  if (Utils.isTouch()) {
	    return;
	  }
	  if (touchEmulator == null) {
	    touchEmulator = new TouchEmulator();
	  }
	  return Events.enableEmulatedTouchEvents(true);
	};
	
	exports.disable = function() {
	  if (!touchEmulator) {
	    return;
	  }
	  touchEmulator.destroy();
	  touchEmulator = null;
	  return Events.enableEmulatedTouchEvents(false);
	};
	
	exports.reset = function() {
	  if (!touchEmulator) {
	    return;
	  }
	  return touchEmulator.endMultiTouch();
	};


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var Utils,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	Utils = __webpack_require__(4);
	
	exports.enable = function() {
	  var MobileScrollFixLayer, handleScrollingLayerTouchMove, handleScrollingLayerTouchStart;
	  document.ontouchmove = function(event) {
	    if (event.target === document.body) {
	      return event.preventDefault();
	    }
	  };
	  handleScrollingLayerTouchMove = function(event) {
	    return event.stopPropagation();
	  };
	  handleScrollingLayerTouchStart = function(event) {
	    var element, startTopScroll;
	    element = this._element;
	    startTopScroll = element.scrollTop;
	    if (startTopScroll <= 0) {
	      element.scrollTop = 1;
	    }
	    if (startTopScroll + element.offsetHeight >= element.scrollHeight) {
	      return element.scrollTop = element.scrollHeight - element.offsetHeight - 1;
	    }
	  };
	  MobileScrollFixLayer = (function(superClass) {
	    extend(MobileScrollFixLayer, superClass);
	
	    function MobileScrollFixLayer(options) {
	      this._updateScrollListeners = bind(this._updateScrollListeners, this);
	      MobileScrollFixLayer.__super__.constructor.call(this, options);
	      if (this.constructor.name === "Layer") {
	        this.on("change:scrollVertical", this._updateScrollListeners);
	        this._updateScrollListeners();
	      }
	    }
	
	    MobileScrollFixLayer.prototype._updateScrollListeners = function() {
	      if (this.scrollVertical === true) {
	        this.on("touchmove", handleScrollingLayerTouchMove);
	        return this.on("touchstart", handleScrollingLayerTouchStart);
	      } else {
	        this.off("touchmove", handleScrollingLayerTouchMove);
	        return this.off("touchstart", handleScrollingLayerTouchStart);
	      }
	    };
	
	    MobileScrollFixLayer.prototype.toInspect = function() {
	      if (this.constructor.name === "MobileScrollFixLayer") {
	        return MobileScrollFixLayer.__super__.toInspect.call(this, "Layer");
	      } else {
	        return MobileScrollFixLayer.__super__.toInspect.apply(this, arguments);
	      }
	    };
	
	    return MobileScrollFixLayer;
	
	  })(Framer.Layer);
	  return window.Layer = window.Framer.Layer = MobileScrollFixLayer;
	};


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass, Config, Context, ErrorDisplay, Layer, Utils, _context, _error, _errorDisplay,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	Utils = __webpack_require__(4);
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	Context = __webpack_require__(43).Context;
	
	Layer = __webpack_require__(13).Layer;
	
	_error = null;
	
	_context = null;
	
	Config = {};
	
	if (Utils.isMobile()) {
	  Config.height = 100;
	  Config.textInset = 20;
	  Config.fontSize = 32;
	} else {
	  Config.height = 40;
	  Config.textInset = 12;
	  Config.fontSize = 14;
	}
	
	ErrorDisplay = (function(superClass) {
	  extend(ErrorDisplay, superClass);
	
	  function ErrorDisplay() {
	    this.resize = bind(this.resize, this);
	    if (this._context == null) {
	      this._context = new Context({
	        name: "ErrorDisplay"
	      });
	    }
	    this._context.index = 1000;
	    this._context.run((function(_this) {
	      return function() {
	        Events.wrap(window).addEventListener("error", function(e) {
	          return _this.showError(e.message);
	        });
	        return Events.wrap(window).addEventListener("resize", function(e) {
	          return _this.resize();
	        });
	      };
	    })(this));
	  }
	
	  ErrorDisplay.prototype.createLayer = function() {
	    if (this._errorLayer) {
	      return this._errorLayer;
	    }
	    this._context.run((function(_this) {
	      return function() {
	        var error;
	        error = new Layer({
	          name: "error",
	          y: Align.bottom,
	          width: Canvas.width,
	          height: Config.height,
	          backgroundColor: "rgba(255, 0, 0, 1)"
	        });
	        error.text = new Layer({
	          name: "text",
	          parent: error,
	          size: Utils.frameInset(error, Config.textInset),
	          point: Align.center,
	          backgroundColor: null,
	          clip: true
	        });
	        error.text.style = {
	          font: Config.fontSize + "px/1em " + (Utils.deviceFont()),
	          lineHeight: (parseInt(error.text.height - 2)) + "px",
	          textAlign: "center",
	          wordWrap: "break-word",
	          textOverflow: "ellipsis"
	        };
	        error.onTap(function() {
	          var ref;
	          if ((ref = _this._errorLayer) != null) {
	            ref.destroy();
	          }
	          return _this._errorLayer = null;
	        });
	        _this._errorLayer = error;
	        return _this.resize();
	      };
	    })(this));
	    return this._errorLayer;
	  };
	
	  ErrorDisplay.prototype.resize = function() {
	    if (!this._errorLayer) {
	      return;
	    }
	    this._errorLayer.width = Canvas.width;
	    this._errorLayer.y = Canvas.height - this._errorLayer.height;
	    this._errorLayer.text.size = Utils.frameInset(this._errorLayer, Config.textInset);
	    return this._errorLayer.text.point = Align.center;
	  };
	
	  ErrorDisplay.prototype.showError = function(message) {
	    var animation, error;
	    error = this.createLayer();
	    error.scale = 1.1;
	    error.text.html = message;
	    return animation = error.animate({
	      scale: 1,
	      options: {
	        curve: "spring(800, 55, 10)"
	      }
	    });
	  };
	
	  ErrorDisplay.prototype.destroy = function() {
	    var ref;
	    return (ref = this._context) != null ? ref.destroy() : void 0;
	  };
	
	  return ErrorDisplay;
	
	})(BaseClass);
	
	_errorDisplay = null;
	
	exports.enable = function() {
	  if (_errorDisplay) {
	    return;
	  }
	  return _errorDisplay = new ErrorDisplay;
	};
	
	exports.disable = function() {
	  if (!_errorDisplay) {
	    return;
	  }
	  _errorDisplay.destroy();
	  return _errorDisplay = null;
	};


/***/ },
/* 61 */
/***/ function(module, exports) {

	var slice = [].slice;
	
	exports.enable = function(module) {
	  var ClassWrapper;
	  if (module == null) {
	    module = window;
	  }
	  ClassWrapper = function(Klass) {
	    return function() {
	      var args;
	      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	      return this.prototype = (function(func, args, ctor) {
	        ctor.prototype = func.prototype;
	        var child = new ctor, result = func.apply(child, args);
	        return Object(result) === result ? result : child;
	      })(Klass, args, function(){});
	    };
	  };
	  module.Frame = ClassWrapper(Framer.Frame);
	  module.Layer = ClassWrapper(Framer.Layer);
	  module.BackgroundLayer = ClassWrapper(Framer.BackgroundLayer);
	  module.VideoLayer = ClassWrapper(Framer.VideoLayer);
	  return module.Animation = ClassWrapper(Framer.Animation);
	};


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var Context, Hints, hints,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	Context = __webpack_require__(43).Context;
	
	Hints = (function() {
	  function Hints() {
	    this._handleUp = bind(this._handleUp, this);
	    this._handleDown = bind(this._handleDown, this);
	    this._context = new Framer.Context({
	      name: "Hints"
	    });
	    this._context.index = 10000;
	    this._context.run((function(_this) {
	      return function() {
	        var capture;
	        if (Utils.isTouch()) {
	          Events.wrap(document).addEventListener("touchstart", _this._handleDown, capture = true);
	          return Events.wrap(document).addEventListener("touchend", _this._handleUp, capture = true);
	        } else {
	          Events.wrap(document).addEventListener("mousedown", _this._handleDown, capture = true);
	          return Events.wrap(document).addEventListener("mouseup", _this._handleUp, capture = true);
	        }
	      };
	    })(this));
	  }
	
	  Hints.prototype._handleDown = function(event) {
	    if (this._isPreloading()) {
	      return;
	    }
	    return this._target = event.target;
	  };
	
	  Hints.prototype._handleUp = function(event) {
	    var context, i, layer, len, ref;
	    if (this._isPreloading()) {
	      return;
	    }
	    layer = Framer.CurrentContext.layerForElement(this._target);
	    if (!layer) {
	      ref = Context.all();
	      for (i = 0, len = ref.length; i < len; i++) {
	        context = ref[i];
	        if (context === Framer.DefaultContext) {
	          continue;
	        }
	        if (context === Framer.CurrentContext) {
	          continue;
	        }
	        if (context.layerForElement(this._target)) {
	          return;
	        }
	      }
	    }
	    if (layer && layer.willSeemToDoSomething()) {
	      return;
	    }
	    return this.showHints();
	  };
	
	  Hints.prototype._isPreloading = function() {
	    var ref;
	    return ((ref = Framer.Preloader) != null ? ref.isLoading : void 0) === true;
	  };
	
	  Hints.prototype.showHints = function() {
	    var context;
	    context = Framer.CurrentContext;
	    return this._context.run(function() {
	      return _.invokeMap(context.rootLayers, "_showHint");
	    });
	  };
	
	  Hints.prototype.destroy = function() {
	    return this._context.destroy();
	  };
	
	  return Hints;
	
	})();
	
	hints = null;
	
	exports.enable = function() {
	  return hints != null ? hints : hints = new Hints(Framer.CurrentContext);
	};
	
	exports.disable = function() {
	  if (!hints) {
	    return;
	  }
	  hints.destroy();
	  return hints = null;
	};
	
	exports.showHints = function() {
	  if (!hints) {
	    return;
	  }
	  return Utils.delay(0.5, function() {
	    return hints.showHints();
	  });
	};


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass, Context, Preloader,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	Context = __webpack_require__(43).Context;
	
	Preloader = (function(superClass) {
	  extend(Preloader, superClass);
	
	  function Preloader(options) {
	    if (options == null) {
	      options = {};
	    }
	    this._setupContext = bind(this._setupContext, this);
	    this._handleTimeout = bind(this._handleTimeout, this);
	    this._handleProgress = bind(this._handleProgress, this);
	    this._end = bind(this._end, this);
	    this.end = bind(this.end, this);
	    this._start = bind(this._start, this);
	    this.start = bind(this.start, this);
	    this.addPlayer = bind(this.addPlayer, this);
	    this.addImage = bind(this.addImage, this);
	    this.setLogo = bind(this.setLogo, this);
	    this._media = [];
	    this._mediaLoaded = [];
	    this._isLoading = false;
	    this.timeout = 30;
	    this.start();
	  }
	
	  Preloader.prototype.setupContext = function() {
	    this.context = new Context({
	      name: "Preloader"
	    });
	    return this.context.run(this._setupContext);
	  };
	
	  Preloader.define("progress", {
	    get: function() {
	      return this._mediaLoaded.length / this._media.length || 0;
	    }
	  });
	
	  Preloader.define("time", {
	    get: function() {
	      return (Date.now() - this._startTime) / 1000;
	    }
	  });
	
	  Preloader.define("isLoading", {
	    get: function() {
	      return this._isLoading;
	    }
	  });
	
	  Preloader.define("isReady", {
	    get: function() {
	      if (!this.isLoading) {
	        return false;
	      }
	      return this._mediaLoaded.length === this._media.length;
	    }
	  });
	
	  Preloader.prototype.setLogo = function(url) {
	    this._logo = url;
	    if (this.brand) {
	      return this.brand.style["background-image"] = "url('" + url + "')";
	    }
	  };
	
	  Preloader.prototype.addImagesFromContext = function(context) {
	    return _.map(context.layers, "image").map(this.addImage);
	  };
	
	  Preloader.prototype.addPlayersFromContext = function(context) {
	    return _.map(context.layers, "player").map(this.addPlayer);
	  };
	
	  Preloader.prototype.addImage = function(image) {
	    if (image && indexOf.call(this._media, image) < 0) {
	      this._media.push(image);
	      return Utils.loadImage(image, (function(_this) {
	        return function(error) {
	          _this._mediaLoaded.push(image);
	          return _this._handleProgress();
	        };
	      })(this));
	    }
	  };
	
	  Preloader.prototype.addPlayer = function(player) {
	    if (!(player && indexOf.call(this._media, player) < 0)) {
	      return;
	    }
	    if (!((player.src != null) && player.getAttribute('src') !== "undefined")) {
	      return;
	    }
	    if (!((player.readyState != null) && player.readyState < 3)) {
	      return;
	    }
	    this._media.push(player);
	    return Events.wrap(player).addEventListener("canplaythrough", (function(_this) {
	      return function() {
	        _this._mediaLoaded.push(player);
	        return _this._handleProgress();
	      };
	    })(this));
	  };
	
	  Preloader.prototype.start = function() {
	    if (this.isLoading) {
	      return;
	    }
	    this._isLoading = true;
	    this._startTime = Date.now();
	    this.emit("start");
	    this.setupContext();
	    return Utils.delay(0.2, this._start);
	  };
	
	  Preloader.prototype._start = function() {
	    Utils.delay(0.2, (function(_this) {
	      return function() {
	        return _this.cover.visible = true;
	      };
	    })(this));
	    this.addImagesFromContext(Framer.DefaultContext);
	    this.addImagesFromContext(Framer.CurrentContext);
	    this.addPlayersFromContext(Framer.DefaultContext);
	    this.addPlayersFromContext(Framer.CurrentContext);
	    if (!this._media.length) {
	      return this.end();
	    }
	    return Utils.delay(this.timeout, this._handleTimeout);
	  };
	
	  Preloader.prototype.end = function() {
	    if (!this.isLoading) {
	      return;
	    }
	    return this._end();
	  };
	
	  Preloader.prototype._end = function(animated) {
	    var finalize, ref, ref1;
	    if (animated == null) {
	      animated = true;
	    }
	    Framer.DefaultContext.visible = true;
	    finalize = (function(_this) {
	      return function() {
	        var ref;
	        _this.emit("end");
	        _this._isLoading = false;
	        return (ref = _this.context) != null ? ref.destroy() : void 0;
	      };
	    })(this);
	    if (((ref = this.cover) != null ? ref.visible : void 0) && animated) {
	      if ((ref1 = this.cover) != null) {
	        ref1.animate({
	          properties: {
	            opacity: 0
	          },
	          time: 0.13
	        });
	      }
	      return this.cover.onAnimationDidEnd(finalize);
	    } else {
	      return finalize();
	    }
	  };
	
	  Preloader.prototype._handleProgress = function() {
	    var ref;
	    this.emit("progress", this.progress);
	    if ((ref = this.progressIndicator) != null) {
	      ref.setProgress(this.progress);
	    }
	    if (this.isReady) {
	      return this._handleLoaded();
	    }
	  };
	
	  Preloader.prototype._handleLoaded = function() {
	    if (this.time > 0.5) {
	      return Utils.delay(0.2, this.end);
	    } else {
	      return this.end();
	    }
	  };
	
	  Preloader.prototype._handleTimeout = function() {
	    if (!this.isLoading) {
	      return;
	    }
	    console.warn("Preloader timeout, ending");
	    return this.end();
	  };
	
	  Preloader.prototype._setupContext = function() {
	    var layout, logoUrl;
	    this.cover = new Layer({
	      frame: Canvas,
	      backgroundColor: "white",
	      visible: false
	    });
	    this.progressIndicator = new CircularProgressComponent({
	      size: 160,
	      point: Align.center,
	      parent: this.cover
	    });
	    this.progressIndicator.railsColor = Color.grey(0, 0.1);
	    this.progressIndicator.progressColor = "rgb(75, 169, 248)";
	    this.progressIndicator.setProgress(this.progress);
	    this.brand = new Layer({
	      size: 96,
	      parent: this.cover,
	      backgroundColor: null,
	      style: {
	        backgroundSize: "50%"
	      }
	    });
	    if (Utils.isMobile()) {
	      this.progressIndicator.scale = 1.25;
	      this.brand.scale = 1.25;
	    }
	    if (this._logo) {
	      this.setLogo(this._logo);
	    } else {
	      logoUrl = "//resources.framerjs.com/static/images/preloader/framer-logo.png";
	      if (_.startsWith(window.location.href, "file://")) {
	        logoUrl = "http:" + logoUrl;
	      }
	      this.setLogo(logoUrl);
	    }
	    (layout = (function(_this) {
	      return function() {
	        _this.cover.frame = Canvas;
	        _this.progressIndicator.point = Align.center;
	        _this.brand.x = Align.center;
	        return _this.brand.y = Align.center(2);
	      };
	    })(this))();
	    return Canvas.onResize(layout);
	  };
	
	  return Preloader;
	
	})(BaseClass);
	
	exports.enable = function() {
	  return Framer.Preloader != null ? Framer.Preloader : Framer.Preloader = new Preloader();
	};
	
	exports.disable = function() {
	  if (!Framer.Preloader) {
	    return;
	  }
	  Framer.Preloader._end(false);
	  return Framer.Preloader = null;
	};
	
	exports.addImage = function(url) {
	  var ref;
	  return (ref = Framer.Preloader) != null ? ref.addImage(url) : void 0;
	};
	
	exports.setLogo = function(url) {
	  var ref;
	  return (ref = Framer.Preloader) != null ? ref.setLogo(url) : void 0;
	};


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass, Context, ShareComponent, ShareInfo, ShareInfoDisabled, _,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	_ = __webpack_require__(1)._;
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	Context = __webpack_require__(43).Context;
	
	ShareComponent = __webpack_require__(65).ShareComponent;
	
	ShareInfoDisabled = false;
	
	ShareInfo = (function(superClass) {
	  extend(ShareInfo, superClass);
	
	  function ShareInfo(options) {
	    var run;
	    if (options == null) {
	      options = {};
	    }
	    this.context = new Framer.Context({
	      name: "Sharing"
	    });
	    this.context.index = 20000;
	    run = (function(_this) {
	      return function() {
	        return _this.context.run(function() {
	          var share;
	          return share = new ShareComponent(Framer.Info);
	        });
	      };
	    })(this);
	    if (_.isEmpty(Framer.Info)) {
	      Utils.delay(0, run);
	    } else {
	      run();
	    }
	  }
	
	  ShareInfo.prototype.destroy = function() {
	    return this.context.destroy();
	  };
	
	  return ShareInfo;
	
	})(BaseClass);
	
	exports.enable = function() {
	  if (ShareInfoDisabled) {
	    return;
	  }
	  return Framer.ShareInfo != null ? Framer.ShareInfo : Framer.ShareInfo = new ShareInfo();
	};
	
	exports.disable = function(force) {
	  if (force == null) {
	    force = true;
	  }
	  ShareInfoDisabled = force;
	  if (!Framer.ShareInfo) {
	    return;
	  }
	  Framer.ShareInfo.destroy();
	  return Framer.ShareInfo = null;
	};


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var Button, ShareComponent, ShareLayer, _, css,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	_ = __webpack_require__(1)._;
	
	css = "@font-face {\n	font-family: \"Roboto\";\n	font-style: normal;\n	font-weight: 400;\n	src: local(\"Roboto\"), local(\"Roboto-Regular\"), url(\"//fonts.gstatic.com/s/roboto/v15/zN7GBFwfMP4uA6AR0HCoLQ.ttf\") format(\"truetype\");\n}\n@font-face {\n	font-family: \"Roboto\";\n	font-style: normal;\n	font-weight: 500;\n	src: local(\"Roboto Medium\"), local(\"Roboto-Medium\"), url(\"//fonts.gstatic.com/s/roboto/v15/RxZJdnzeo3R5zSexge8UUaCWcynf_cDxXwCLxiixG1c.ttf\") format(\"truetype\");\n}";
	
	Utils.insertCSS(css);
	
	ShareLayer = (function(superClass) {
	  extend(ShareLayer, superClass);
	
	  function ShareLayer(options) {
	    var defaultProps;
	    ShareLayer.__super__.constructor.call(this, options);
	    defaultProps = {
	      backgroundColor: null,
	      ignoreEvents: false,
	      style: {
	        fontFamily: "Roboto, Helvetica Neue, Helvetica, Arial, sans-serif",
	        textAlign: "left",
	        fontSize: "14px",
	        color: "#111",
	        lineHeight: "1",
	        webkitFontSmoothing: "antialiased"
	      }
	    };
	    if (options.parent) {
	      defaultProps.width = options.parent.width;
	    }
	    this.props = _.merge(defaultProps, options);
	  }
	
	  return ShareLayer;
	
	})(Layer);
	
	Button = (function(superClass) {
	  extend(Button, superClass);
	
	  function Button(options) {
	    var defaultProps;
	    Button.__super__.constructor.call(this, options);
	    options = _.defaults(options, {
	      newWindow: true
	    });
	    defaultProps = {
	      height: 33,
	      style: {
	        fontWeight: "500",
	        webkitUserSelect: "text",
	        borderRadius: 3,
	        textAlign: "center",
	        paddingTop: "9px"
	      }
	    };
	    this.props = _.merge(defaultProps, options);
	    this.states = {
	      hover: {
	        opacity: .8
	      },
	      full: {
	        opacity: 1
	      }
	    };
	    this.animationOptions = {
	      time: .3
	    };
	    this.onMouseOver(function() {
	      this.style.cursor = "pointer";
	      return this.animate("hover");
	    });
	    this.onMouseOut(function() {
	      return this.animate("full");
	    });
	    this.onTap(function() {
	      if (options.shareButton) {
	        return window.open(options.url, "Share", "width=560, height=714");
	      } else {
	        return window.open(options.url, "_blank");
	      }
	    });
	  }
	
	  return Button;
	
	})(ShareLayer);
	
	ShareComponent = (function() {
	  function ShareComponent(shareInfo) {
	    this.__calculateAvailableSpace = bind(this.__calculateAvailableSpace, this);
	    this._openIfEnoughSpace = bind(this._openIfEnoughSpace, this);
	    var projectId;
	    this.shareInfo = _.clone(shareInfo);
	    projectId = window.location.pathname.replace(/\//g, "");
	    document.title = this.shareInfo.title;
	    this.options = {
	      padding: 20,
	      width: 250,
	      minAvailableSpace: 300,
	      minAvailableSpaceFullScreen: 500,
	      maxDescriptionLength: 145,
	      id: projectId
	    };
	    this.state = typeof localStorage !== "undefined" && localStorage !== null ? localStorage.getItem("framerShareSheetState-" + this.options.id) : void 0;
	    this.options.fixed = !this.state ? false : true;
	    this._checkData();
	    if (!Utils.isMobile()) {
	      this.render();
	    }
	  }
	
	  ShareComponent.prototype.render = function() {
	    this._renderSheet();
	    this._renderCTA();
	    this._renderToggleButtons();
	    this._renderInfo();
	    if (this.shareInfo.description) {
	      this._renderDescription();
	    }
	    if (this.shareInfo.openInFramerURL && this.shareInfo.date) {
	      this._renderDate();
	    }
	    if (this.shareInfo.openInFramerURL) {
	      this._renderButtons();
	    }
	    this._updateHeight();
	    this.sheet.minHeight = this.sheet.maxHeight;
	    Utils.delay(.1, (function(_this) {
	      return function() {
	        _this._calculateAvailableSpace();
	        if (_this.state === "open") {
	          return _this._openSheet();
	        } else if (_this.state === "closed") {
	          return _this._closeSheet();
	        } else {
	          return _this._openIfEnoughSpace();
	        }
	      };
	    })(this));
	    return this._startListening();
	  };
	
	  ShareComponent.prototype._truncateCredential = function(str) {
	    var maxLength, maxLengthWithAvatar;
	    maxLength = 32;
	    maxLengthWithAvatar = 23;
	    str = _.escape(str);
	    if (this.shareInfo.twitter && str.length > maxLengthWithAvatar) {
	      str = _.truncate(str, {
	        "length": maxLengthWithAvatar
	      });
	    } else if (str.length > maxLength) {
	      str = _.truncate(str, {
	        "length": maxLength
	      });
	    }
	    return str;
	  };
	
	  ShareComponent.prototype._checkData = function() {
	    if (_.startsWith(this.shareInfo.twitter, "@")) {
	      this.shareInfo.twitter = _.trimStart(this.shareInfo.twitter, "@");
	    }
	    if (this.shareInfo.title) {
	      return this.shareInfo.title = this._truncateCredential(this.shareInfo.title);
	    }
	  };
	
	  ShareComponent.prototype._renderSheet = function() {
	    return this.sheet = new ShareLayer({
	      width: this.options.width,
	      clip: true,
	      ignoreEvents: false,
	      point: 10,
	      borderRadius: 4,
	      backgroundColor: "#FFF",
	      visible: false,
	      style: {
	        boxShadow: "0 0 0 1px rgba(0, 0, 0, .12), 0 1px 3px rgba(0, 0, 0, .08)"
	      }
	    });
	  };
	
	  ShareComponent.prototype._renderToggleButtons = function() {
	    var openLabel, openLogo;
	    this.open = new Layer({
	      height: 30,
	      width: 144,
	      point: this.sheet.point,
	      borderRadius: 4,
	      backgroundColor: "#FFF",
	      visible: false,
	      style: {
	        boxShadow: "0 0 0 1px rgba(0, 0, 0, .12), 0 1px 3px rgba(0, 0, 0, .08)"
	      }
	    });
	    openLogo = new Layer({
	      parent: this.open,
	      width: 10,
	      height: 15,
	      backgroundColor: null,
	      style: {
	        backgroundImage: "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAABGdBTUEAALGPC/xhBQAAANRJREFUSA2t1dENgjAQBuA7wqsuoEs5hi5Bu4RsoQs4jiygvtceCgRoubZ3f0JI2t5HAy3FtnMGABp/qQRJ0UR7UBMdQS10BmqgK1CKBkEJGgVL0U2wBGXBXBQPN+eoiAsi2OcJDTeu4gYM/f6xzfHeb9OhKXhPBqk6Bc0CU9BskEOLwC20GIyhIjCEisElWlODRv5LCuru8bF+gfFnSrtP2qYVXHcGEK3GLMn4vUNFdPooSugE0nwV0DmogK5BIRoGhSiVx3N5Gzi/kv7qcWTZQ2hivjMmakz6/b3iAAAAAElFTkSuQmCC')"
	      },
	      y: Align.center(1),
	      x: 10
	    });
	    openLabel = new ShareLayer({
	      parent: this.open,
	      width: this.open - 40,
	      height: 14,
	      x: 30,
	      y: Align.center(),
	      html: "Made with Framer",
	      style: {
	        fontWeight: "500",
	        fontSize: "13px"
	      }
	    });
	    this.close = new Layer({
	      parent: this.cta,
	      ignoreEvents: false,
	      size: 9,
	      point: 6,
	      backgroundColor: null,
	      style: {
	        backgroundImage: "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABGdBTUEAALGPC/xhBQAAAQxJREFUOBGt09sKgzAMBuB4Qr3Xe0Xf/4kUFXwB0QsFZdvfkWzWahEMuNm1/UjSznl9gh4I9wFDEQIty0J1XdO2bVYbRbRtS9M0yVqB+r5XE1VVXWJAmqahYRgIezgEyrKMoiiieZ7pDGNkHEcKgoDyPGeHBPI8j8qyPMV0pCgKCsNQIOezYHdq6BEyQmbIELjruqoczkRHoB0g/Liuq2o8YyjjCjmFMPGfGcbATJlgDiE9+g5/nygHmznQQ9/3eXj4NkJ6Y22nCfUA6QjKwWPDdpAJwRGjpKurscvoDOFm2O6ZZNR1nfWIdQz/TQ6BkiRRN/XqiLGJsTiOKU1TdswXUmZvvEhGN/YYl74B52DXxksJUvAAAAAASUVORK5CYII=')"
	      }
	    });
	    this._enableUserSelect(this.close);
	    this._showPointer(this.close);
	    return this._showPointer(this.open);
	  };
	
	  ShareComponent.prototype._renderCTA = function() {
	    var ctaLink, ctaLogo, ctaSlogan;
	    this.cta = new ShareLayer({
	      parent: this.sheet,
	      style: {
	        borderBottom: "1px solid #E8E8E8"
	      },
	      height: 118
	    });
	    ctaLogo = new Layer({
	      parent: this.cta,
	      width: 16,
	      height: 24,
	      x: Align.center(),
	      y: 20,
	      backgroundColor: null,
	      style: {
	        backgroundImage: "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAwCAYAAABwrHhvAAAABGdBTUEAALGPC/xhBQAAAShJREFUWAnF2MsNwjAMBmCngiPMgdiGMWAJ0iXoGB2APRALsACcAImAoaLqO3Fi21LU0+98iSKlrSkuzgLA/jNUyuCsmogvQBPxB2ghGgANRAcgjegFSCIGAVKIUYAEYhLAjfACcCK8AVyIIAAHIhiQGkECpESQAakQZlU+HDajVgYmP23mlp6nJqvcC9x+XT71AOiIQWTVQqIfVEQyAHUnkgIoiOSAUAQLIATBBvBFsAJ8EOyAKYQIYAwhBhhCiAL6EOKANiL6OsaG1MKrfHY+3nNwjv5/oFhGvdRkcFhYMCanriI29zsDioj6ECohagDupQKiCVBAdAHCiH6AIGIYIIQYBwggpgHMCD8AI8IfwIQIAzAhsG147W4WtteoL+vwSdsJRETWGylMpVP7hSF+AAAAAElFTkSuQmCC')"
	      }
	    });
	    ctaSlogan = new ShareLayer({
	      parent: this.cta,
	      y: ctaLogo.y + 36,
	      height: 30,
	      html: "Made with Framer",
	      style: {
	        textAlign: "center",
	        fontSize: "18px"
	      }
	    });
	    this._enableUserSelect(ctaSlogan);
	    return ctaLink = new Button({
	      url: "http://framerjs.com/?utm_source=share.framerjs.com&utm_medium=banner&utm_campaign=product",
	      parent: this.cta,
	      y: ctaSlogan.y + 24,
	      height: 16,
	      width: 120,
	      x: Align.center(),
	      html: "Try it for free now",
	      style: {
	        textAlign: "center",
	        color: "#00AAFF",
	        padding: 0
	      }
	    });
	  };
	
	  ShareComponent.prototype._renderInfo = function() {
	    var avatarBorder, fallbackTitle, name, ref, showAuthor;
	    this.info = new ShareLayer({
	      parent: this.sheet,
	      width: this.sheet.width - (this.options.padding * 2),
	      y: this.cta.maxY + 20,
	      x: 20
	    });
	    this.credentials = new ShareLayer({
	      parent: this.info,
	      height: 16
	    });
	    fallbackTitle = _.replace(typeof FramerStudioInfo !== "undefined" && FramerStudioInfo !== null ? FramerStudioInfo.documentTitle : void 0, /\.framer$/, "");
	    this.credentialsTitle = new ShareLayer({
	      parent: this.credentials,
	      height: 18,
	      html: this.shareInfo.title || fallbackTitle,
	      style: {
	        fontWeight: "500",
	        overflow: "hidden",
	        whiteSpace: "nowrap",
	        lineHeight: "1.3"
	      }
	    });
	    this._enableUserSelect(this.credentialsTitle);
	    if (this.shareInfo.twitter) {
	      this.credentialsTitle.width = this.credentials - 50;
	    }
	    showAuthor = (function(_this) {
	      return function(content) {
	        if (content == null) {
	          content = _this.shareInfo.author;
	        }
	        _this.credentials.height = 40;
	        _this.credentialsTitle.y = 3;
	        _this.credentialsAuthor = new ShareLayer({
	          parent: _this.credentials,
	          html: content,
	          y: _this.credentialsTitle.maxY,
	          height: 18,
	          style: {
	            color: "#808080",
	            overflow: "hidden",
	            whiteSpace: "nowrap",
	            lineHeight: "1.3"
	          }
	        });
	        _this._enableUserSelect(_this.credentialsAuthor);
	        if (_this.shareInfo.twitter) {
	          _this.credentialsAuthor.width = _this.credentials - 50;
	        }
	        return _this._showPointer(_this.credentialsAuthor);
	      };
	    })(this);
	    if (this.shareInfo.twitter) {
	      this.credentials.x = 50;
	      this.avatar = new Button({
	        url: "https://twitter.com/" + this.shareInfo.twitter,
	        size: 40,
	        parent: this.info,
	        borderRadius: 100
	      });
	      this.avatar.onImageLoadError((function(_this) {
	        return function() {
	          _this.credentials.x = 0;
	          return _this.avatar.destroy();
	        };
	      })(this));
	      this.avatar.image = "https://twitter.com/" + this.shareInfo.twitter + "/profile_image?size=bigger";
	      avatarBorder = new ShareLayer({
	        size: this.avatar.width - 2,
	        point: 1,
	        parent: this.avatar,
	        borderRadius: 100,
	        style: {
	          boxShadow: "0 0 0 1px rgba(0, 0, 0, .1)"
	        }
	      });
	      name = this.shareInfo.author ? this.shareInfo.author : "@" + this.shareInfo.twitter;
	      name = this._truncateCredential(name);
	      showAuthor("<a href='http://twitter.com/" + this.shareInfo.twitter + "' style='text-decoration: none; -webkit-user-select: auto;' target='_blank'>" + name + "</a>");
	      this.credentialsTitle.width = 155;
	      if ((ref = this.credentialsAuthor) != null) {
	        ref.width = 155;
	      }
	    }
	    if (this.shareInfo.author && !this.shareInfo.twitter) {
	      return showAuthor(this._truncateCredential(this.shareInfo.author));
	    }
	  };
	
	  ShareComponent.prototype._renderDate = function() {
	    var date, months, verticalPosition;
	    verticalPosition = this.description ? this.description.maxY : this.credentials.maxY;
	    date = new Date(this.shareInfo.date);
	    months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	    return this.date = new ShareLayer({
	      parent: this.info,
	      height: 10,
	      y: verticalPosition + 12,
	      html: "Shared on " + (date.getDate()) + " " + months[date.getMonth()] + " " + (date.getFullYear()),
	      style: {
	        textTransform: "uppercase",
	        fontSize: "11px",
	        color: "#999",
	        letterSpacing: ".2px"
	      }
	    });
	  };
	
	  ShareComponent.prototype._enableUserSelect = function(layer) {
	    if (!layer.html) {
	      layer.html = "";
	    }
	    layer._elementHTML.style["-webkit-user-select"] = "auto";
	    return layer._elementHTML.style["cursor"] = "auto";
	  };
	
	  ShareComponent.prototype._renderDescription = function() {
	    var descriptionStyle, parseDescription, showFullDescription;
	    parseDescription = function(text) {
	      var httpRegex, lineBreakRegex, removeAllTagsExceptBreaks, urlRegex, urlified;
	      urlRegex = /[-a-zA-Z0-9@:%_\+.~#?&\/\/=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)?/gi;
	      httpRegex = /^((http|https):\/\/)/;
	      lineBreakRegex = /(?:\r\n|\r|\n)/g;
	      removeAllTagsExceptBreaks = /<(?!br\s*\/?)[^>]+>/g;
	      text = _.escape(text);
	      text = _.trimEnd(text);
	      text = text.replace(lineBreakRegex, "<br>");
	      return urlified = text.replace(urlRegex, function(url) {
	        var href;
	        href = url;
	        if (!httpRegex.test(url)) {
	          href = "//" + url;
	        }
	        return "<a href='" + href + "' style='-webkit-user-select: auto' target='_blank'>" + url + "</a>";
	      });
	    };
	    this.description = new ShareLayer({
	      parent: this.info,
	      y: this.credentials.maxY + 10,
	      style: {
	        lineHeight: "1.5",
	        wordWrap: "break-word",
	        color: "#111"
	      }
	    });
	    descriptionStyle = {
	      fontSize: "14px",
	      fontFamily: "Roboto, Helvetica Neue, Helvetica, Arial, sans-serif",
	      lineHeight: "1.5",
	      wordWrap: "break-word"
	    };
	    this.descriptionSize = Utils.textSize(parseDescription(this.shareInfo.description), descriptionStyle, {
	      width: "" + this.description.width
	    });
	    showFullDescription = (function(_this) {
	      return function() {
	        var ref;
	        _this.options.truncatedDescription = false;
	        _this.description.height = _this.descriptionSize.height;
	        _this.description.html = parseDescription(_this.shareInfo.description);
	        if (_this.shareInfo.openInFramerURL) {
	          if ((ref = _this.date) != null) {
	            ref.y = _this.description.maxY + 12;
	          }
	          _this.buttons.y = (_this.date ? _this.date : _this.description).maxY + 18;
	        }
	        _this._updateHeight();
	        _this._calculateAvailableSpace();
	        return _this._enableUserSelect(_this.description);
	      };
	    })(this);
	    if (this.shareInfo.description.length > this.options.maxDescriptionLength) {
	      this.options.truncatedDescription = true;
	      this.options.shortDescription = _.truncate(this.shareInfo.description, {
	        "length": this.options.maxDescriptionLength,
	        "separator": " "
	      });
	      this.descriptionTruncatedSize = Utils.textSize(parseDescription(this.options.shortDescription), descriptionStyle, {
	        width: "" + this.description.width
	      });
	      this.description.height = this.descriptionTruncatedSize.height;
	      this.description.html = parseDescription(this.options.shortDescription);
	      this.description.once(Events.TapEnd, showFullDescription);
	      return this._showPointer(this.description);
	    } else {
	      this.description.height = this.descriptionSize.height;
	      this.description.html = parseDescription(this.shareInfo.description);
	      return this._enableUserSelect(this.description);
	    }
	  };
	
	  ShareComponent.prototype._renderButtons = function() {
	    var tweet, verticalPosition;
	    if (this.date) {
	      verticalPosition = this.date.maxY;
	    } else if (this.descripion) {
	      verticalPosition = this.descripion.maxY;
	    } else {
	      verticalPosition = this.credentials.maxY;
	    }
	    this.buttons = new ShareLayer({
	      height: 33,
	      parent: this.info,
	      y: verticalPosition + 16
	    });
	    this.buttonOpen = new Button({
	      url: this.shareInfo.openInFramerURL,
	      newWindow: false,
	      html: "Open in Framer",
	      color: "#FFF",
	      parent: this.buttons,
	      width: 139,
	      borderRadius: 3,
	      backgroundColor: "00AAFF"
	    });
	    this.buttonFacebook = new Button({
	      shareButton: true,
	      url: "https://www.facebook.com/sharer/sharer.php?u=" + window.location.href,
	      parent: this.buttons,
	      borderWidth: 1,
	      borderColor: "#D5D5D5",
	      width: 33,
	      x: this.buttonOpen.maxX + 6,
	      style: {
	        borderRadius: "3px 0 0 3px"
	      }
	    });
	    this.buttonFacebookIcon = new Layer({
	      parent: this.buttonFacebook,
	      width: 7,
	      height: 14,
	      point: Align.center(),
	      backgroundColor: null,
	      style: {
	        backgroundImage: "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAcCAYAAABRVo5BAAAABGdBTUEAALGPC/xhBQAAAO1JREFUOBFjZMABWltbJX///l0GlDYAYg1GRkZxIP3n////P4E0EyOQwABNTU05QAVtQMyLIQkVwNDY3Nzs9vfv3524NMDEmWAMED1z5kyuf//+zUEWw8VG0fjq1SsnoPNkcSlGFmdB5gA16SHzQWxgoPxnZma2UVNTOxkWFvYXJo+uUQwmAaOBhn2tqak5BuPDaBSnAhXJwySQaB4kNpyJohEoqgCXIcAgWyNjQ0PDfwKGY0gDA+w5uo0YirAJAMPiLFkagTaeIUsjExMTeTaCNGIkcmyBBRTDUEeWU0EBNqoRW7KBio0GDi0CBwAHJ0YrwGtXbwAAAABJRU5ErkJggg==')"
	      }
	    });
	    tweet = "";
	    if (this.shareInfo.twitter || this.shareInfo.author) {
	      if (this.shareInfo.twitter) {
	        tweet += "A prototype by @" + this.shareInfo.twitter + ". Design without limitations in @framerjs — ";
	      } else if (this.shareInfo.author) {
	        tweet += "A prototype by " + this.shareInfo.author + ". Design without limitations in @framerjs — ";
	      } else {
	        tweet += "A @framerjs prototype by @" + this.shareInfo.author + ". Design without limitations — ";
	      }
	    }
	    tweet += window.location.href;
	    tweet = encodeURIComponent(tweet);
	    this.buttonTwitter = new Button({
	      shareButton: true,
	      url: "https://twitter.com/home?status=" + tweet,
	      parent: this.buttons,
	      borderWidth: 1,
	      borderColor: "#D5D5D5",
	      width: 33,
	      x: this.buttonFacebook.maxX - 1,
	      style: {
	        borderRadius: "0 3px 3px 0"
	      }
	    });
	    return this.buttonTwitterIcon = new Layer({
	      parent: this.buttonTwitter,
	      width: 14,
	      height: 11,
	      point: Align.center(),
	      backgroundColor: null,
	      style: {
	        backgroundImage: "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAWCAYAAADTlvzyAAAABGdBTUEAALGPC/xhBQAAAr5JREFUSA2tlUloU1EUhpuhITFCAnUTR1zVgsQUF1pw4UbETUAq7tTiogUDKkiJSUjaTBvdFCliF5KVazdKigu3BYsjlEIcIOKEEgewTVoz+J2HCa8378UOuXC494z/O+e8e4+lZ4srk8kcq1arVywWyxChvI1Go8g573Q6p8Lh8IdmeOyO1uv1vZamYDN7MpnMABDB16r6A1qGLlut1gIfFOfsHhgYOK4BplKpq6APut3uS+Pj40uqsxGPzyg+M0Y6VQbYS4CHsfc3v+w5RueXl5efEuiw6qDy6XR6P5lNqXIT/hW2c4Dle3t7FzRA0N+JMYp+FE8mJydz1HyXSQCxOwe5zPSK3E+Gw9CFaDRa0AAB2a0zEtkIdS/Qo9tGGQN2Vmff8QjQfX6gQCKRmBNDrYe5XM5ZLBY/w3tNvF/g+BDdPM7zlUplGtDTJrZrxD6fzzE2NvanKbTLoVQqbaesN8k021QoewCAgMjK5bKi6syurKxI6VuAWkkR7iTgGRSPO7tvXEs1tum9tAwdDscXeuZHYdMru3Be9Xg8JX0cLUPu3lcyzOsV3TjT90V9/ySmBqgdrNbr7K2nSGRdWM/UGC1AftsFl8t1BINpvuytarhJ/p7q1wIUBY/tJzbpZVX4La4CSbT9hGsABYDsluhn/xbBJM4NqKHGaQPkPsqo+aUabpB/NDExcdfIpw0wHo+/ttlshzC+A72Bfhs5dpB9t9vtF830HechD/g+7uctnINmAfRyKvMNOknvZPoYLkNAgPbUarVreIzSz3VNBYA+0o4TVGjREOmf0MI0GMT4J7yDtzQIQBB+iH29r04d+xleq1gkEvnRCUx08rStks0Iu4ycA5DMO9n+tyoYzDJU07FYrO2CmzmvKWk2m/XTs1MAymQ4CO2AvGQgr73cUaH38LN9fX0PQqHQRn+onr9RuQfzn9jjeAAAAABJRU5ErkJggg==')"
	      }
	    });
	  };
	
	  ShareComponent.prototype._openIfEnoughSpace = function() {
	    if (this.availableSpace < this.threshold && !this.options.fixed) {
	      return this._closeSheet();
	    } else {
	      return this._openSheet();
	    }
	  };
	
	  ShareComponent.prototype._calculateAvailableSpace = _.debounce(function() {
	    return this.__calculateAvailableSpace();
	  }, 100, {
	    maxWait: 100
	  });
	
	  ShareComponent.prototype.__calculateAvailableSpace = function() {
	    var canvasHeight, device, verticalSpace;
	    device = Framer.Device;
	    this.threshold = this.options.minAvailableSpaceFullScreen;
	    this.availableSpace = Canvas.width;
	    if (device.deviceType !== "fullscreen") {
	      this.threshold = this.options.minAvailableSpace;
	      this.availableSpace = Screen.canvasFrame.x;
	    }
	    canvasHeight = Canvas.height - this.options.padding;
	    if (this.description && canvasHeight < this.sheet.maxHeight && canvasHeight > this.sheet.minHeight) {
	      this.sheet.height = canvasHeight;
	      verticalSpace = this.sheet.height - this.cta.height - this.credentials.height;
	      if (this.shareInfo.openInFramerURL) {
	        verticalSpace -= this.buttons.height;
	        verticalSpace -= this.date.height;
	        verticalSpace -= 95;
	      } else {
	        verticalSpace -= 36;
	      }
	      this.description.height = verticalSpace;
	      this.description.style.overflow = "scroll";
	      if (this.shareInfo.openInFramerURL) {
	        this.date.y = this.description.maxY + 12;
	        this.buttons.y = this.date.maxY + 18;
	      }
	    }
	    if (this.description && canvasHeight > this.sheet.maxHeight) {
	      this.sheet.height = this.sheet.maxHeight;
	      if (this.options.truncatedDescription) {
	        this.description.height = this.descriptionTruncatedSize.height;
	      } else {
	        this.description.height = this.descriptionSize.height;
	      }
	      this.description.style.overflow = "visible";
	      if (this.shareInfo.openInFramerURL) {
	        this.date.y = this.description.maxY + 12;
	        return this.buttons.y = this.date.maxY + 18;
	      }
	    }
	  };
	
	  ShareComponent.prototype._startListening = function() {
	    this._calculateAvailableSpace();
	    this.sheet.onMouseOver(function() {
	      return this.style = {
	        cursor: "default"
	      };
	    });
	    this.close.onClick((function(_this) {
	      return function() {
	        _this._closeSheet();
	        _this.options.fixed = true;
	        return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.setItem("framerShareSheetState-" + _this.options.id, "closed") : void 0;
	      };
	    })(this));
	    this.sheet.onTouchStart(function(event) {
	      return event.stopPropagation();
	    });
	    this.sheet.onTouchEnd(function(event) {
	      return event.stopPropagation();
	    });
	    this.sheet.onTouchMove(function(event) {
	      return event.stopPropagation();
	    });
	    this.open.onClick((function(_this) {
	      return function(event) {
	        event.stopPropagation();
	        _this._openSheet();
	        _this.options.fixed = true;
	        return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.setItem("framerShareSheetState-" + _this.options.id, "open") : void 0;
	      };
	    })(this));
	    return Canvas.onResize((function(_this) {
	      return function() {
	        _this._calculateAvailableSpace();
	        if (!_this.options.fixed) {
	          return _this._openIfEnoughSpace();
	        }
	      };
	    })(this));
	  };
	
	  ShareComponent.prototype._showPointer = function(layer) {
	    return layer.onMouseOver(function() {
	      return this.style = {
	        cursor: "pointer"
	      };
	    });
	  };
	
	  ShareComponent.prototype._updateHeight = function() {
	    this.credentials.height = this.credentials.contentFrame().height;
	    this.info.height = this.info.contentFrame().height;
	    this.sheet.height = this.sheet.contentFrame().height + this.options.padding;
	    return this.sheet.maxHeight = this.sheet.height;
	  };
	
	  ShareComponent.prototype._closeSheet = function() {
	    this.sheet.visible = false;
	    this.sheet.ignoreEvents = true;
	    this.open.visible = true;
	    return this.open.ignoreEvents = false;
	  };
	
	  ShareComponent.prototype._openSheet = function() {
	    this.sheet.visible = true;
	    this.sheet.ignoreEvents = false;
	    this.open.visible = false;
	    return this.open.ignoreEvents = true;
	  };
	
	  return ShareComponent;
	
	})();
	
	exports.ShareComponent = ShareComponent;


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var DOMEventManager, GestureInputDoubleTapTime, GestureInputEdgeSwipeDistance, GestureInputForceTapDesktop, GestureInputForceTapMobile, GestureInputForceTapMobilePollTime, GestureInputLongPressTime, GestureInputMinimumFingerDistance, GestureInputSwipeThreshold, GestureInputVelocityTime, Utils,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	Utils = __webpack_require__(4);
	
	GestureInputLongPressTime = 0.5;
	
	GestureInputDoubleTapTime = 0.25;
	
	GestureInputSwipeThreshold = 30;
	
	GestureInputEdgeSwipeDistance = 30;
	
	GestureInputVelocityTime = 0.1;
	
	GestureInputForceTapDesktop = MouseEvent.WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN;
	
	GestureInputForceTapMobile = 0.7;
	
	GestureInputForceTapMobilePollTime = 1 / 30;
	
	GestureInputMinimumFingerDistance = 30;
	
	DOMEventManager = __webpack_require__(44).DOMEventManager;
	
	exports.GestureInputRecognizer = (function() {
	  function GestureInputRecognizer() {
	    this._process = bind(this._process, this);
	    this.edgeswipedirectionend = bind(this.edgeswipedirectionend, this);
	    this.edgeswipedirectionstart = bind(this.edgeswipedirectionstart, this);
	    this.edgeswipedirection = bind(this.edgeswipedirection, this);
	    this.swipedirectionend = bind(this.swipedirectionend, this);
	    this.swipedirection = bind(this.swipedirection, this);
	    this.swipedirectionstart = bind(this.swipedirectionstart, this);
	    this.swipeend = bind(this.swipeend, this);
	    this.swipe = bind(this.swipe, this);
	    this.swipestart = bind(this.swipestart, this);
	    this.rotateend = bind(this.rotateend, this);
	    this.rotate = bind(this.rotate, this);
	    this.rotatestart = bind(this.rotatestart, this);
	    this.scaleend = bind(this.scaleend, this);
	    this.scale = bind(this.scale, this);
	    this.scalestart = bind(this.scalestart, this);
	    this.pinchend = bind(this.pinchend, this);
	    this.pinch = bind(this.pinch, this);
	    this.pinchstart = bind(this.pinchstart, this);
	    this.panright = bind(this.panright, this);
	    this.panleft = bind(this.panleft, this);
	    this.pandown = bind(this.pandown, this);
	    this.panup = bind(this.panup, this);
	    this.panend = bind(this.panend, this);
	    this.pan = bind(this.pan, this);
	    this.panstart = bind(this.panstart, this);
	    this.forcetapend = bind(this.forcetapend, this);
	    this.forcetapstart = bind(this.forcetapstart, this);
	    this.forcetapchange = bind(this.forcetapchange, this);
	    this._updateMacForce = bind(this._updateMacForce, this);
	    this._updateTouchForce = bind(this._updateTouchForce, this);
	    this.longpressend = bind(this.longpressend, this);
	    this.longpressstart = bind(this.longpressstart, this);
	    this.doubletap = bind(this.doubletap, this);
	    this.tapend = bind(this.tapend, this);
	    this.tapstart = bind(this.tapstart, this);
	    this.tap = bind(this.tap, this);
	    this.reset = bind(this.reset, this);
	    this.touchend = bind(this.touchend, this);
	    this.touchmove = bind(this.touchmove, this);
	    this.touchstart = bind(this.touchstart, this);
	    this.startTouch = bind(this.startTouch, this);
	    this.startMouse = bind(this.startMouse, this);
	    this.em = new DOMEventManager();
	    this.em.wrap(window).addEventListener("mousedown", this.startMouse);
	    this.em.wrap(window).addEventListener("touchstart", this.startTouch);
	    this.session = null;
	  }
	
	  GestureInputRecognizer.prototype.destroy = function() {
	    return this.em.removeAllListeners();
	  };
	
	  GestureInputRecognizer.prototype.cancel = function() {
	    window.clearTimeout(this.session.pressTimer);
	    return this.session = null;
	  };
	
	  GestureInputRecognizer.prototype.startMouse = function(event) {
	    if (this.session) {
	      return;
	    }
	    this.em.wrap(window).addEventListener("mousemove", this.touchmove);
	    this.em.wrap(window).addEventListener("mouseup", this.touchend);
	    return this.touchstart(event);
	  };
	
	  GestureInputRecognizer.prototype.startTouch = function(event) {
	    if (this.session) {
	      return;
	    }
	    this.em.wrap(window).addEventListener("touchmove", this.touchmove);
	    this.em.wrap(window).addEventListener("touchend", this.touchend);
	    return this.touchstart(event);
	  };
	
	  GestureInputRecognizer.prototype.touchstart = function(event) {
	    if (this.session) {
	      return;
	    }
	    this.em.wrap(window).addEventListener("webkitmouseforcechanged", this._updateMacForce);
	    this.session = {
	      startEvent: this._getGestureEvent(event),
	      lastEvent: null,
	      startMultiEvent: null,
	      startTime: Date.now(),
	      pressTimer: window.setTimeout(this.longpressstart, GestureInputLongPressTime * 1000),
	      started: {},
	      events: [],
	      eventCount: 0
	    };
	    event = this._getGestureEvent(event);
	    this.tapstart(event);
	    if (Date.now() - this.doubleTapTime < (GestureInputDoubleTapTime * 1000)) {
	      this.doubletap(event);
	    } else {
	      this.doubleTapTime = Date.now();
	    }
	    this._process(event);
	    if (Utils.isTouch()) {
	      return this._updateTouchForce();
	    }
	  };
	
	  GestureInputRecognizer.prototype.touchmove = function(event) {
	    return this._process(this._getGestureEvent(event));
	  };
	
	  GestureInputRecognizer.prototype.touchend = function(event) {
	    var eventName, ref, ref1, value;
	    if (event.touches != null) {
	      if (Utils.isTouch()) {
	        if (!(event.touches.length === 0)) {
	          return;
	        }
	      } else {
	        if (!(event.touches.length === event.changedTouches.length)) {
	          return;
	        }
	      }
	    }
	    this.em.wrap(window).removeEventListener("mousemove", this.touchmove);
	    this.em.wrap(window).removeEventListener("mouseup", this.touchend);
	    this.em.wrap(window).removeEventListener("touchmove", this.touchmove);
	    this.em.wrap(window).removeEventListener("touchend", this.touchend);
	    this.em.wrap(window).removeEventListener("webkitmouseforcechanged", this._updateMacForce);
	    event = this._getGestureEvent(event);
	    ref = this.session.started;
	    for (eventName in ref) {
	      value = ref[eventName];
	      if (value) {
	        this[eventName + "end"](event);
	      }
	    }
	    if (!((ref1 = this.session) != null ? ref1.startEvent : void 0)) {
	      this.tap(event);
	    } else if (this.session.startEvent.target === event.target) {
	      this.tap(event);
	    }
	    this.tapend(event);
	    return this.cancel();
	  };
	
	  GestureInputRecognizer.prototype.reset = function() {
	    if (!this.session) {
	      return;
	    }
	    return this.touchend(this.session.lastEvent);
	  };
	
	  GestureInputRecognizer.prototype.tap = function(event) {
	    return this._dispatchEvent("tap", event);
	  };
	
	  GestureInputRecognizer.prototype.tapstart = function(event) {
	    return this._dispatchEvent("tapstart", event);
	  };
	
	  GestureInputRecognizer.prototype.tapend = function(event) {
	    return this._dispatchEvent("tapend", event);
	  };
	
	  GestureInputRecognizer.prototype.doubletap = function(event) {
	    return this._dispatchEvent("doubletap", event);
	  };
	
	  GestureInputRecognizer.prototype.longpressstart = function() {
	    var event;
	    if (!this.session) {
	      return;
	    }
	    if (this.session.started.longpress) {
	      return;
	    }
	    event = this._getGestureEvent(this.session.startEvent);
	    this.session.started.longpress = event;
	    this._dispatchEvent("longpressstart", event);
	    return this._dispatchEvent("longpress", event);
	  };
	
	  GestureInputRecognizer.prototype.longpressend = function(event) {
	    return this._dispatchEvent("longpressend", event);
	  };
	
	  GestureInputRecognizer.prototype._updateTouchForce = function() {
	    var event, ref, ref1, ref2;
	    if (!((ref = this.session) != null ? (ref1 = ref.lastEvent) != null ? (ref2 = ref1.touches) != null ? ref2.length : void 0 : void 0 : void 0)) {
	      return;
	    }
	    this.session.force = this.session.lastEvent.touches[0].force || 0;
	    event = this._getGestureEvent(this.session.lastEvent);
	    this.forcetapchange(event);
	    if (this.session.force >= GestureInputForceTapMobile) {
	      this.forcetapstart(event);
	    } else {
	      this.forcetapend(event);
	    }
	    return setTimeout(this._updateTouchForce, GestureInputForceTapMobilePollTime);
	  };
	
	  GestureInputRecognizer.prototype._updateMacForce = function(event) {
	    if (!this.session) {
	      return;
	    }
	    this.session.force = Utils.modulate(event.webkitForce, [0, 3], [0, 1]);
	    this.forcetapchange(this._getGestureEvent(event));
	    if (event.webkitForce >= GestureInputForceTapDesktop) {
	      return this.forcetapstart(event);
	    } else {
	      return this.forcetapend(event);
	    }
	  };
	
	  GestureInputRecognizer.prototype.forcetapchange = function(event) {
	    return this._dispatchEvent("forcetapchange", event);
	  };
	
	  GestureInputRecognizer.prototype.forcetapstart = function(event) {
	    if (!this.session) {
	      return;
	    }
	    if (this.session.started.forcetap) {
	      return;
	    }
	    this.session.started.forcetap = event;
	    this._dispatchEvent("forcetapstart", event);
	    return this._dispatchEvent("forcetap", event);
	  };
	
	  GestureInputRecognizer.prototype.forcetapend = function(event) {
	    if (!this.session) {
	      return;
	    }
	    if (!this.session.started.forcetap) {
	      return;
	    }
	    this.session.started.forcetap = null;
	    return this._dispatchEvent("forcetapend", event);
	  };
	
	  GestureInputRecognizer.prototype.panstart = function(event) {
	    this.session.started.pan = event;
	    return this._dispatchEvent("panstart", event, this.session.started.pan.target);
	  };
	
	  GestureInputRecognizer.prototype.pan = function(event) {
	    var direction;
	    this._dispatchEvent("pan", event, this.session.started.pan.target);
	    direction = this._getDirection(event.delta);
	    if (direction) {
	      return this["pan" + direction](event);
	    }
	  };
	
	  GestureInputRecognizer.prototype.panend = function(event) {
	    this._dispatchEvent("panend", event, this.session.started.pan.target);
	    return this.session.started.pan = null;
	  };
	
	  GestureInputRecognizer.prototype.panup = function(event) {
	    return this._dispatchEvent("panup", event, this.session.started.pan.target);
	  };
	
	  GestureInputRecognizer.prototype.pandown = function(event) {
	    return this._dispatchEvent("pandown", event, this.session.started.pan.target);
	  };
	
	  GestureInputRecognizer.prototype.panleft = function(event) {
	    return this._dispatchEvent("panleft", event, this.session.started.pan.target);
	  };
	
	  GestureInputRecognizer.prototype.panright = function(event) {
	    return this._dispatchEvent("panright", event, this.session.started.pan.target);
	  };
	
	  GestureInputRecognizer.prototype.pinchstart = function(event) {
	    this.session.started.pinch = event;
	    this.scalestart(event, this.session.started.pinch.target);
	    this.rotatestart(event, this.session.started.pinch.target);
	    return this._dispatchEvent("pinchstart", event);
	  };
	
	  GestureInputRecognizer.prototype.pinch = function(event) {
	    this._dispatchEvent("pinch", event);
	    this.scale(event, this.session.started.pinch.target);
	    return this.rotate(event, this.session.started.pinch.target);
	  };
	
	  GestureInputRecognizer.prototype.pinchend = function(event) {
	    this._dispatchEvent("pinchend", event);
	    this.scaleend(event, this.session.started.pinch.target);
	    this.rotateend(event, this.session.started.pinch.target);
	    return this.session.started.pinch = null;
	  };
	
	  GestureInputRecognizer.prototype.scalestart = function(event) {
	    return this._dispatchEvent("scalestart", event);
	  };
	
	  GestureInputRecognizer.prototype.scale = function(event) {
	    return this._dispatchEvent("scale", event);
	  };
	
	  GestureInputRecognizer.prototype.scaleend = function(event) {
	    return this._dispatchEvent("scaleend", event);
	  };
	
	  GestureInputRecognizer.prototype.rotatestart = function(event) {
	    return this._dispatchEvent("rotatestart", event);
	  };
	
	  GestureInputRecognizer.prototype.rotate = function(event) {
	    return this._dispatchEvent("rotate", event);
	  };
	
	  GestureInputRecognizer.prototype.rotateend = function(event) {
	    return this._dispatchEvent("rotateend", event);
	  };
	
	  GestureInputRecognizer.prototype.swipestart = function(event) {
	    this._dispatchEvent("swipestart", event);
	    this.session.started.swipe = event;
	    return this.swipedirectionstart(event);
	  };
	
	  GestureInputRecognizer.prototype.swipe = function(event) {
	    this._dispatchEvent("swipe", event);
	    return this.swipedirection(event);
	  };
	
	  GestureInputRecognizer.prototype.swipeend = function(event) {
	    return this._dispatchEvent("swipeend", event);
	  };
	
	  GestureInputRecognizer.prototype.swipedirectionstart = function(event) {
	    var direction, ref, ref1, ref2, ref3, swipeEdge;
	    if (!event.offsetDirection) {
	      return;
	    }
	    if (this.session.started.swipedirection) {
	      return;
	    }
	    this.session.started.swipedirection = event;
	    direction = this.session.started.swipedirection.offsetDirection;
	    this._dispatchEvent("swipe" + direction + "start", event);
	    swipeEdge = this._edgeForSwipeDirection(direction);
	    if (swipeEdge === "top" && (0 < (ref = event.start.y) && ref < GestureInputEdgeSwipeDistance)) {
	      this.edgeswipedirectionstart(event);
	    }
	    if (swipeEdge === "right" && (Screen.width - GestureInputEdgeSwipeDistance < (ref1 = event.start.x) && ref1 < Screen.width)) {
	      this.edgeswipedirectionstart(event);
	    }
	    if (swipeEdge === "bottom" && (Screen.height - GestureInputEdgeSwipeDistance < (ref2 = event.start.y) && ref2 < Screen.height)) {
	      this.edgeswipedirectionstart(event);
	    }
	    if (swipeEdge === "left" && (0 < (ref3 = event.start.x) && ref3 < GestureInputEdgeSwipeDistance)) {
	      return this.edgeswipedirectionstart(event);
	    }
	  };
	
	  GestureInputRecognizer.prototype.swipedirection = function(event) {
	    var direction;
	    if (!this.session.started.swipedirection) {
	      return;
	    }
	    direction = this.session.started.swipedirection.offsetDirection;
	    this._dispatchEvent("swipe" + direction, event);
	    if (this.session.started.edgeswipedirection) {
	      return this.edgeswipedirection(event);
	    }
	  };
	
	  GestureInputRecognizer.prototype.swipedirectionend = function(event) {
	    var direction;
	    if (!this.session.started.swipedirection) {
	      return;
	    }
	    direction = this.session.started.swipedirection.offsetDirection;
	    return this._dispatchEvent("swipe" + direction + "end", event);
	  };
	
	  GestureInputRecognizer.prototype.edgeswipedirection = function(event) {
	    var swipeEdge;
	    swipeEdge = this._edgeForSwipeDirection(this.session.started.edgeswipedirection.offsetDirection);
	    Screen.emit("edgeswipe", this._createEvent("edgeswipe", event));
	    return Screen.emit("edgeswipe" + swipeEdge, this._createEvent("edgeswipe" + swipeEdge, event));
	  };
	
	  GestureInputRecognizer.prototype.edgeswipedirectionstart = function(event) {
	    var swipeEdge;
	    if (this.session.started.edgeswipedirection) {
	      return;
	    }
	    this.session.started.edgeswipedirection = event;
	    swipeEdge = this._edgeForSwipeDirection(this.session.started.edgeswipedirection.offsetDirection);
	    Screen.emit("edgeswipestart", this._createEvent("edgeswipestart", event));
	    return Screen.emit("edgeswipe" + swipeEdge + "start", this._createEvent("edgeswipe" + swipeEdge + "start", event));
	  };
	
	  GestureInputRecognizer.prototype.edgeswipedirectionend = function(event) {
	    var swipeEdge;
	    swipeEdge = this._edgeForSwipeDirection(this.session.started.edgeswipedirection.offsetDirection);
	    Screen.emit("edgeswipeend", this._createEvent("edgeswipeend", event));
	    return Screen.emit("edgeswipe" + swipeEdge + "end", this._createEvent("edgeswipe" + swipeEdge + "end", event));
	  };
	
	  GestureInputRecognizer.prototype._process = function(event) {
	    if (!this.session) {
	      return;
	    }
	    this.session.events.push(event);
	    event.eventCount = this.session.eventCount++;
	    if (Math.abs(event.delta.x) > 0 || Math.abs(event.delta.y) > 0) {
	      if (!this.session.started.pan) {
	        this.panstart(event);
	      } else {
	        this.pan(event);
	      }
	    }
	    if (this.session.started.pinch && event.fingers === 1) {
	      this.pinchend(event);
	    } else if (!this.session.started.pinch && event.fingers === 2) {
	      this.pinchstart(event);
	    } else if (this.session.started.pinch) {
	      this.pinch(event);
	    }
	    if (!this.session.started.swipe && (Math.abs(event.offset.x) > GestureInputSwipeThreshold || Math.abs(event.offset.y) > GestureInputSwipeThreshold)) {
	      this.swipestart(event);
	    } else if (this.session.started.swipe) {
	      this.swipe(event);
	    }
	    return this.session.lastEvent = event;
	  };
	
	  GestureInputRecognizer.prototype._getEventPoint = function(event) {
	    var ref;
	    if ((ref = event.touches) != null ? ref.length : void 0) {
	      return this._getTouchPoint(event, 0);
	    }
	    return {
	      x: event.pageX,
	      y: event.pageY
	    };
	  };
	
	  GestureInputRecognizer.prototype._getGestureEvent = function(event) {
	    var eventPoint, events, i, len, pointKey, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, touchPointA, touchPointB;
	    eventPoint = Utils.convertPointFromContext(this._getEventPoint(event), Framer.CurrentContext, true, true);
	    _.extend(event, {
	      time: Date.now(),
	      point: eventPoint,
	      start: eventPoint,
	      previous: eventPoint,
	      offset: {
	        x: 0,
	        y: 0
	      },
	      offsetTime: 0,
	      offsetAngle: 0,
	      offsetDirection: null,
	      delta: {
	        x: 0,
	        y: 0
	      },
	      deltaTime: 0,
	      deltaAngle: 0,
	      deltaDirection: null,
	      force: 0,
	      velocity: {
	        x: 0,
	        y: 0
	      },
	      fingers: ((ref = event.touches) != null ? ref.length : void 0) || 0,
	      touchCenter: eventPoint,
	      touchOffset: {
	        x: 0,
	        y: 0
	      },
	      touchDistance: 0,
	      scale: 1,
	      scaleDirection: null,
	      rotation: 0
	    });
	    if ((ref1 = this.session) != null ? ref1.startEvent : void 0) {
	      event.start = this.session.startEvent.point;
	      event.offset = Utils.pointSubtract(event.point, event.start);
	      event.offsetTime = event.time - this.session.startEvent.time;
	      event.offsetAngle = Utils.pointAngle(this.session.startEvent.point, event.point);
	      event.offsetDirection = this._getDirection(event.offset);
	      event.touchCenterStart = this.session.startEvent.touchCenter;
	    }
	    if ((ref2 = this.session) != null ? ref2.lastEvent : void 0) {
	      event.previous = this.session.lastEvent.point;
	      event.deltaTime = event.time - this.session.lastEvent.time;
	      event.delta = Utils.pointSubtract(event.point, this.session.lastEvent.point);
	      event.deltaAngle = Utils.pointAngle(event.point, this.session.lastEvent.point);
	      event.deltaDirection = this._getDirection(event.delta);
	    }
	    if (event.fingers > 1) {
	      touchPointA = this._getTouchPoint(event, 0);
	      touchPointB = this._getTouchPoint(event, 1);
	      event.touchCenter = Utils.pointCenter(touchPointB, touchPointA);
	      event.touchOffset = Utils.pointSubtract(touchPointB, touchPointA);
	      event.touchDistance = _.max([GestureInputMinimumFingerDistance, Utils.pointDistance(touchPointA, touchPointB)]);
	      event.rotation = Utils.pointAngle(touchPointA, touchPointB);
	    }
	    if ((ref3 = this.session) != null ? ref3.events : void 0) {
	      events = _.filter(this.session.events, function(e) {
	        if (e.eventCount === 0) {
	          return false;
	        }
	        return e.time > (event.time - (GestureInputVelocityTime * 1000));
	      });
	      event.velocity = this._getVelocity(events);
	    }
	    if ((ref4 = this.session) != null ? ref4.started.pinch : void 0) {
	      event.scale = event.touchDistance / this.session.started.pinch.touchDistance;
	      event.scaleDirection = this._getScaleDirection(event.scale - this.session.lastEvent.scale);
	      if (!event.scaleDirection && ((ref5 = this.session) != null ? ref5.lastEvent : void 0)) {
	        event.scaleDirection = this.session.lastEvent.scaleDirection;
	      }
	    }
	    if ((ref6 = this.session) != null ? ref6.lastEvent : void 0) {
	      if ((event.fingers !== (ref7 = this.session.lastEvent.fingers) && ref7 === 2)) {
	        event.delta = {
	          x: 0,
	          y: 0
	        };
	      }
	      if (event.fingers === 2 && this.session.lastEvent.fingers === 2) {
	        event.delta = Utils.pointSubtract(event.touchCenter, this.session.lastEvent.touchCenter);
	      }
	    }
	    if ((ref8 = this.session) != null ? ref8.lastEvent : void 0) {
	      if (this.session.force) {
	        event.force = this.session.force;
	      }
	    }
	    ref9 = ["point", "start", "previous", "offset", "delta", "velocity", "touchCenter", "touchOffset"];
	    for (i = 0, len = ref9.length; i < len; i++) {
	      pointKey = ref9[i];
	      event[pointKey + "X"] = event[pointKey].x;
	      event[pointKey + "Y"] = event[pointKey].y;
	    }
	    return event;
	  };
	
	  GestureInputRecognizer.prototype._getTouchPoint = function(event, index) {
	    var point;
	    return point = {
	      x: event.touches[index].pageX,
	      y: event.touches[index].pageY
	    };
	  };
	
	  GestureInputRecognizer.prototype._getDirection = function(offset) {
	    if (Math.abs(offset.x) > Math.abs(offset.y)) {
	      if (offset.x > 0) {
	        return "right";
	      }
	      if (offset.x < 0) {
	        return "left";
	      }
	    }
	    if (Math.abs(offset.x) < Math.abs(offset.y)) {
	      if (offset.y < 0) {
	        return "up";
	      }
	      if (offset.y > 0) {
	        return "down";
	      }
	    }
	    return null;
	  };
	
	  GestureInputRecognizer.prototype._edgeForSwipeDirection = function(direction) {
	    if (direction === "down") {
	      return "top";
	    }
	    if (direction === "left") {
	      return "right";
	    }
	    if (direction === "up") {
	      return "bottom";
	    }
	    if (direction === "right") {
	      return "left";
	    }
	    return null;
	  };
	
	  GestureInputRecognizer.prototype._getScaleDirection = function(offset) {
	    if (offset > 0) {
	      return "up";
	    }
	    if (offset < 0) {
	      return "down";
	    }
	    return null;
	  };
	
	  GestureInputRecognizer.prototype._createEvent = function(type, event) {
	    var k, touchEvent, v;
	    touchEvent = document.createEvent("MouseEvent");
	    touchEvent.initMouseEvent(type, true, true, window, event.detail, event.screenX, event.screenY, event.clientX, event.clientY, event.ctrlKey, event.shiftKey, event.altKey, event.metaKey, event.button, event.relatedTarget);
	    touchEvent.touches = event.touches;
	    touchEvent.changedTouches = event.touches;
	    touchEvent.targetTouches = event.touches;
	    for (k in event) {
	      v = event[k];
	      touchEvent[k] = v;
	    }
	    return touchEvent;
	  };
	
	  GestureInputRecognizer.prototype._dispatchEvent = function(type, event, target) {
	    var ref, ref1, touchEvent;
	    touchEvent = this._createEvent(type, event);
	    if (target == null) {
	      target = (ref = this.session) != null ? (ref1 = ref.startEvent) != null ? ref1.target : void 0 : void 0;
	    }
	    if (target == null) {
	      target = event.target;
	    }
	    return target.dispatchEvent(touchEvent);
	  };
	
	  GestureInputRecognizer.prototype._getVelocity = function(events) {
	    var current, first, time, velocity;
	    if (events.length < 2) {
	      return {
	        x: 0,
	        y: 0
	      };
	    }
	    current = events[events.length - 1];
	    first = events[0];
	    time = current.time - first.time;
	    velocity = {
	      x: (current.point.x - first.point.x) / time,
	      y: (current.point.y - first.point.y) / time
	    };
	    if (velocity.x === 2e308) {
	      velocity.x = 0;
	    }
	    if (velocity.y === 2e308) {
	      velocity.y = 0;
	    }
	    return velocity;
	  };
	
	  return GestureInputRecognizer;

	})();


/***/ },
/* 67 */
/***/ function(module, exports) {

	exports.date = 1487329035;
	
	exports.branch = "master";
	
	exports.hash = "8db1dc8";
	
	exports.build = 2503;
	
	exports.version = exports.branch + "/" + exports.hash;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var BaseClass, Canvas, Events,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseClass = __webpack_require__(6).BaseClass;
	
	Events = __webpack_require__(15).Events;
	
	Canvas = (function(superClass) {
	  extend(Canvas, superClass);
	
	  Canvas.define("width", {
	    get: function() {
	      return window.innerWidth;
	    }
	  });
	
	  Canvas.define("height", {
	    get: function() {
	      return window.innerHeight;
	    }
	  });
	
	  Canvas.define("size", {
	    get: function() {
	      return Utils.size(this);
	    }
	  });
	
	  Canvas.define("frame", {
	    get: function() {
	      return Utils.frame(this);
	    }
	  });
	
	  Canvas.define("backgroundColor", {
	    importable: false,
	    exportable: false,
	    get: function() {
	      return Framer.Device.background.backgroundColor;
	    },
	    set: function(value) {
	      return Framer.Device.background.backgroundColor = value;
	    }
	  });
	
	  Canvas.define("image", {
	    importable: false,
	    exportable: false,
	    get: function() {
	      return Framer.Device.background.image;
	    },
	    set: function(value) {
	      return Framer.Device.background.image = value;
	    }
	  });
	
	  function Canvas(options) {
	    if (options == null) {
	      options = {};
	    }
	    this._handleResize = bind(this._handleResize, this);
	    Canvas.__super__.constructor.call(this, options);
	    Events.wrap(window).addEventListener("resize", this._handleResize);
	  }
	
	  Canvas.prototype.onResize = function(cb) {
	    return this.on("resize", cb);
	  };
	
	  Canvas.prototype._handleResize = function(event) {
	    this.emit("resize");
	    this.emit("change:width");
	    this.emit("change:height");
	    this.emit("change:size");
	    return this.emit("change:frame");
	  };
	
	  Canvas.prototype.toInspect = function() {
	    return "<" + this.constructor.name + " " + this.width + "x" + this.height + ">";
	  };
	
	  Canvas.prototype.convertPointToLayer = function(point, layer) {
	    return Utils.convertPointFromContext(point, layer, true, true);
	  };
	
	  Canvas.prototype.convertPointToScreen = function(point) {
	    var ctx;
	    ctx = Framer.Device.context;
	    return Utils.convertPointFromContext(point, ctx, true, true);
	  };
	
	  return Canvas;
	
	})(BaseClass);
	
	exports.Canvas = Canvas;


/***/ }
/******/ ]);


// WEBPACK FOOTER //
// build/framer.js